/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import {
  Resolver as GraphCacheResolver,
  UpdateResolver as GraphCacheUpdateResolver,
  OptimisticMutationResolver as GraphCacheOptimisticMutationResolver,
  StorageAdapter as GraphCacheStorageAdapter,
} from '@urql/exchange-graphcache';
import { IntrospectionData } from '@urql/exchange-graphcache/dist/types/ast';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
};

export type AccountLocked = {
  readonly __typename?: 'AccountLocked';
  readonly message: Scalars['String'];
  readonly status: Scalars['Int'];
};

/** Error when a user has an active payment method */
export type ActivePaymentMethodError = UserError & {
  readonly __typename?: 'ActivePaymentMethodError';
  readonly errorMessage: Scalars['String'];
};

export type AddAddressInput = {
  readonly city: Scalars['String'];
  readonly country: Scalars['String'];
  readonly deliveryPreference: DeliveryPreferenceType;
  readonly googlePlaceId: Scalars['String'];
  readonly latitude: Scalars['Float'];
  readonly longitude: Scalars['Float'];
  readonly name?: InputMaybe<Scalars['String']>;
  readonly notes?: InputMaybe<Scalars['String']>;
  readonly secondaryStreet?: InputMaybe<Scalars['String']>;
  readonly state: Scalars['String'];
  readonly street: Scalars['String'];
  readonly zipCode: Scalars['String'];
};

export type AddAddressResponseUnion =
  | AddAddressSuccess
  | InvalidAddress
  | ValidationError;

export type AddAddressSuccess = {
  readonly __typename?: 'AddAddressSuccess';
  readonly address: Address;
};

export type AddLineItemBatchToCartInput = {
  readonly lineItems: ReadonlyArray<CartInput>;
};

export type AddLineItemToCartInput = {
  readonly additions: ReadonlyArray<IngredientModificationInput>;
  readonly customName?: InputMaybe<Scalars['String']>;
  readonly deliveryOrderDetails?: InputMaybe<DeliveryOrderDetailInput>;
  readonly mixedDressingDetails: ReadonlyArray<MixedDressingDetailsInput>;
  readonly productId: Scalars['ID'];
  readonly quantity: Scalars['Int'];
  readonly removals: ReadonlyArray<IngredientModificationInput>;
  readonly substitutions: ReadonlyArray<IngredientSubstitutionModificationInput>;
};

export type AddLineItemToCartResponseUnion =
  | AddLineItemToCartSuccess
  | MaxModificationsExceeded
  | RestaurantMaxDeliveryQuantityExceeded
  | RestaurantMaxQuantityExceeded
  | ValidationError;

export type AddLineItemToCartSuccess = {
  readonly __typename?: 'AddLineItemToCartSuccess';
  readonly cart: Order;
};

export type AddSubscriptionPaymentMethodResponseUnion =
  | AddSubscriptionPaymentMethodSuccessResponse
  | PaymentMethodAlreadyExistsError
  | UnknownUserError;

/** The result of adding a payment method to a subscription */
export type AddSubscriptionPaymentMethodSuccessResponse = {
  readonly __typename?: 'AddSubscriptionPaymentMethodSuccessResponse';
  /** Payment Method details */
  readonly creditCard: SubscriptionCreditCard;
  /** Payment Method Token */
  readonly paymentMethodToken: Scalars['String'];
};

export type Addons = {
  readonly __typename?: 'Addons';
  readonly products: ReadonlyArray<Product>;
};

export type Address = {
  readonly __typename?: 'Address';
  readonly city: Scalars['String'];
  readonly country: Scalars['String'];
  readonly deliveryPreference: DeliveryPreferenceType;
  readonly googlePlaceId: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly latitude: Scalars['Float'];
  readonly longitude: Scalars['Float'];
  readonly name: Maybe<Scalars['String']>;
  readonly notes: Maybe<Scalars['String']>;
  /** Address Line 2 */
  readonly secondaryStreet: Maybe<Scalars['String']>;
  readonly state: Scalars['String'];
  /** Address Line 1 */
  readonly street: Scalars['String'];
  readonly zipCode: Scalars['String'];
};

export enum ApplyRewardFailureCode {
  LoyaltyNotProcessed = 'LOYALTY_NOT_PROCESSED',
  LoyaltyProgramUnavailable = 'LOYALTY_PROGRAM_UNAVAILABLE',
  RewardExpired = 'REWARD_EXPIRED',
  RewardNotApplicable = 'REWARD_NOT_APPLICABLE',
  RewardNotFound = 'REWARD_NOT_FOUND',
}

export type ApplyRewardInput = {
  /** The ID of the order the reward is being applied to */
  readonly orderId: Scalars['ID'];
  /** The ID of the reward being applied to the order */
  readonly rewardId: Scalars['ID'];
};

export type ApplyRewardResponseUnion =
  | ApplyRewardSuccess
  | RewardNotApplied
  | ValidationError;

export type ApplyRewardSuccess = {
  readonly __typename?: 'ApplyRewardSuccess';
  readonly order: Order;
};

export type Asset = {
  readonly __typename?: 'Asset';
  readonly url: Scalars['String'];
};

export type AvailableWantedTime = {
  readonly __typename?: 'AvailableWantedTime';
  readonly time: Scalars['String'];
};

export type BaseProduct = {
  readonly __typename?: 'BaseProduct';
  readonly asset: Asset;
  readonly description: Scalars['String'];
  readonly heading: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly isDeepLinkingEnabled: Scalars['Boolean'];
  readonly isSeasonal: Scalars['Boolean'];
  readonly name: Scalars['String'];
  readonly slug: Scalars['String'];
  readonly subheading: Scalars['String'];
};

export type BillingAccount = {
  readonly __typename?: 'BillingAccount';
  readonly cardType: CardType;
  /** Computed display name containing card type and last 4 digits */
  readonly description: Scalars['String'];
  readonly expirationState: ExpirationState;
  readonly id: Scalars['ID'];
  readonly isDefault: Scalars['Boolean'];
  /** User-supplied alias */
  readonly nickname: Maybe<Scalars['String']>;
};

export enum BillingFrequencyType {
  Annually = 'ANNUALLY',
  Monthly = 'MONTHLY',
}

export enum BraintreeCardType {
  AmEx = 'AmEx',
  CarteBlanche = 'CarteBlanche',
  ChinaUnionPay = 'ChinaUnionPay',
  DinersClubInternational = 'DinersClubInternational',
  Discover = 'Discover',
  Elo = 'Elo',
  Jcb = 'JCB',
  Laser = 'Laser',
  Maestro = 'Maestro',
  MasterCard = 'MasterCard',
  Solo = 'Solo',
  Switch = 'Switch',
  UkMaestro = 'UKMaestro',
  Unknown = 'Unknown',
  Visa = 'Visa',
}

export type CanNotReorder = {
  readonly __typename?: 'CanNotReorder';
  readonly conflicts: ReadonlyArray<OrderConflict>;
  readonly message: Scalars['String'];
  readonly status: Scalars['Int'];
};

export type CancelSubscriptionAtCycleEndResponseUnion =
  | CancelSubscriptionAtCycleEndSuccessResponse
  | UnknownUserError;

export type CancelSubscriptionAtCycleEndSuccessResponse = {
  readonly __typename?: 'CancelSubscriptionAtCycleEndSuccessResponse';
  /** Canceled Subscription */
  readonly subscription: PaymentSubscription;
};

export type CancelSubscriptionForCustomerResponseUnion =
  | CancelSubscriptionForCustomerSuccessResponse
  | UnknownUserError;

export type CancelSubscriptionForCustomerSuccessResponse = {
  readonly __typename?: 'CancelSubscriptionForCustomerSuccessResponse';
  /** Indicates if the subscription was successfully cancelled */
  readonly success: Scalars['Boolean'];
};

export type CancelSubscriptionResponseUnion =
  | CancelSubscriptionSuccessResponse
  | UnknownUserError;

export type CancelSubscriptionSuccessResponse = {
  readonly __typename?: 'CancelSubscriptionSuccessResponse';
  /** Canceled Subscription */
  readonly subscription: PaymentSubscription;
};

export enum CardType {
  AmericanExpress = 'AMERICAN_EXPRESS',
  Amex = 'AMEX',
  Discover = 'DISCOVER',
  MasterCard = 'MASTER_CARD',
  Visa = 'VISA',
}

export type CartInput = {
  readonly additions: ReadonlyArray<IngredientModificationInput>;
  readonly customName?: InputMaybe<Scalars['String']>;
  readonly mixedDressingDetails: ReadonlyArray<MixedDressingDetailsInput>;
  readonly productId: Scalars['ID'];
  readonly quantity: Scalars['Int'];
  readonly removals: ReadonlyArray<IngredientModificationInput>;
  readonly substitutions: ReadonlyArray<IngredientSubstitutionModificationInput>;
};

/** A Challenge is a configured SessionM Campaign with the "is_challenge: true" flag set in the campaign custom payload */
export type Challenge = {
  readonly __typename?: 'Challenge';
  /** Field is integer representation of the total amount of times the challenge behavior was completed by the customer. */
  readonly achieved: Scalars['Float'];
  /** Field originates from SessionM Activity feed configuration message description. */
  readonly celebrationCopy: Scalars['String'];
  /** Field originates from SessionM Activity feed configuration message subheader. */
  readonly descriptiveTitle: Scalars['String'];
  readonly expirationDate: Scalars['DateTime'];
  /** Field is a number representation of the challenge goal. Ex. A two STEP challenge would have a goal of `2.` A SPEND $20 challenge would have a goal of `2000` */
  readonly goal: Scalars['Float'];
  /** Field is the SessionM campaign id */
  readonly id: Scalars['ID'];
  readonly legalTerms: Scalars['String'];
  /**  Field is `progress` divided by `goal` times 100. To be used to render progress bar. */
  readonly percentageCompleted: Scalars['Float'];
  readonly permalink: Scalars['String'];
  /** Field indicates the current count completed toward challenge goal. */
  readonly progress: Scalars['Float'];
  /** Field is copy to show on the challenge card to indicate progress. Determined by challenge status and progress fields. */
  readonly progressCopy: Scalars['String'];
  readonly status: ChallengeStatus;
  /** Field originates from SessionM Activity feed configuration message header. */
  readonly title: Scalars['String'];
};

/** Challenge celebration data originating from campaign information on SessionM. To be used to render challenge celebration messaging. */
export type ChallengeCelebration = {
  readonly __typename?: 'ChallengeCelebration';
  /** Field originates from SessionM Activity feed configuration message description. When a user has multiple rewards to be "celebrated" this field is hardcoded. */
  readonly celebrationCopy: Scalars['String'];
  /** Completed challenges ids */
  readonly challengesIds: ReadonlyArray<Scalars['String']>;
  /** Expiration date for reward. When a user has multiple rewards available to be "celebrated" this field will return null. */
  readonly expirationDate: Maybe<Scalars['DateTime']>;
  /** Field is hardcoded in challenges-svc */
  readonly rewardUsageDisclaimer: Scalars['String'];
  /** Field originates from SessionM Activity Feed configuration message header. When a user has multiple rewards available to be "celebrated" this field will return null. */
  readonly title: Maybe<Scalars['String']>;
};

/** Reward available to the customer */
export type ChallengeReward = {
  readonly __typename?: 'ChallengeReward';
  readonly expiresAt: Maybe<Scalars['DateTime']>;
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  /** The Premium reward is only available to a customer 1x every twelve hours. The redeemable field allows the UI to indicate whether the reward is currently available to be used. */
  readonly redeemable: Maybe<Scalars['Boolean']>;
  /** The Premium reward is only available to a customer 1x every twelve hours. The redeemableAt will populate if reward is not redeemable with the next available date. */
  readonly redeemableAt: Maybe<Scalars['DateTime']>;
  /** Type PREMIUM refers to Premium Subscription Reward, NON_PREMIUM rewards not associated with loyalty program */
  readonly rewardType: RewardType;
  /** Field references the offer terms and conditions configured in SessionM. If that field is not configured, returns the default SG terms url. */
  readonly terms: Scalars['String'];
};

/** NOT_STARTED = Customer is qualified for challenge, STARTED = Customer has opted in, IN_PROGRESS: challenge is in progress, COMPLETED: customer has completed the challenge */
export enum ChallengeStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Started = 'STARTED',
}

export enum ConflictType {
  DeliveryIneligible = 'DELIVERY_INELIGIBLE',
  IngredientUnavailable = 'INGREDIENT_UNAVAILABLE',
  NoConflict = 'NO_CONFLICT',
  ProductUnavailable = 'PRODUCT_UNAVAILABLE',
}

export type CourierDetails = {
  readonly __typename?: 'CourierDetails';
  readonly latitude: Maybe<Scalars['Float']>;
  readonly longitude: Maybe<Scalars['Float']>;
  readonly name: Maybe<Scalars['String']>;
  readonly phone: Maybe<Scalars['String']>;
};

/** Create Customer Loyalty Profile Result */
export type CreateLoyaltyProfileResult = {
  readonly __typename?: 'CreateLoyaltyProfileResult';
  /** External user id */
  readonly id: Scalars['ID'];
};

export type CreateSubscriptionResult = {
  readonly __typename?: 'CreateSubscriptionResult';
  /** First date that billing should happen */
  readonly firstBillingDate: Maybe<Scalars['DateTime']>;
  /** The ID of the subscription */
  readonly id: Scalars['ID'];
  /** The status of the subscription */
  readonly status: Scalars['String'];
  /** The amount that will be charged */
  readonly subscriptionAmount: Scalars['String'];
  /** Indicates if the subscription has trial period */
  readonly trialDuration: Scalars['Boolean'];
};

export type Credit = {
  readonly __typename?: 'Credit';
  readonly amount: Scalars['Float'];
  readonly createdAt: Scalars['String'];
  readonly description: Scalars['String'];
  readonly expiresAt: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly remainingAmount: Scalars['Float'];
  readonly title: Scalars['String'];
};

export enum CustomProductType {
  Bowl = 'BOWL',
  Plate = 'PLATE',
}

export type Customer = {
  readonly __typename?: 'Customer';
  readonly addresses: ReadonlyArray<Address>;
  /** The amount of credit available to the customer. Credit is applied after tax. */
  readonly availableCredit: Scalars['Int'];
  readonly billingAccounts: ReadonlyArray<BillingAccount>;
  readonly birthday: Maybe<Scalars['String']>;
  /** A detail list of available credits to the customer. */
  readonly credits: ReadonlyArray<Credit>;
  readonly email: Maybe<Scalars['String']>;
  readonly firstName: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly lastName: Maybe<Scalars['String']>;
  readonly phoneNumber: Maybe<Scalars['String']>;
  /** Level Up Payment Token for the customer, used to generate QR codes. */
  readonly qrCode: Scalars['String'];
  /** Level Up Share URL to be used when sharing by email. */
  readonly referralShareUrlEmail: Scalars['String'];
  /** Gravy-generated UUID used for analytics purposes */
  readonly trackingUuid: Maybe<Scalars['String']>;
  /** Whether or not the customer will use any available credit on their next transaction. */
  readonly useCredit: Scalars['Boolean'];
};

export type CustomerPass = {
  readonly __typename?: 'CustomerPass';
  readonly authenticationToken: Maybe<Scalars['String']>;
  readonly url: Maybe<Scalars['String']>;
};

export type DeleteAddressResponseUnion =
  | DeleteAddressSuccess
  | InvalidAddress
  | ValidationError;

export type DeleteAddressSuccess = {
  readonly __typename?: 'DeleteAddressSuccess';
  readonly success: Scalars['Boolean'];
};

export type DeleteBillingAccountInput = {
  /** Billing account id. */
  readonly id: Scalars['Float'];
};

export type DeleteBillingAccountResponse = {
  readonly __typename?: 'DeleteBillingAccountResponse';
  readonly success: Scalars['Boolean'];
};

export type DeleteSubscriptionPaymentMethodResponseUnion =
  | ActivePaymentMethodError
  | DeleteSubscriptionPaymentMethodSuccess
  | UnknownUserError;

/** The result of deleting a payment method from a subscription */
export type DeleteSubscriptionPaymentMethodSuccess = {
  readonly __typename?: 'DeleteSubscriptionPaymentMethodSuccess';
  /** Payment Methods */
  readonly creditCards: ReadonlyArray<SubscriptionCreditCard>;
};

export type DeliveryAlreadyInFlight = UserError & {
  readonly __typename?: 'DeliveryAlreadyInFlight';
  readonly errorMessage: Scalars['String'];
};

export type DeliveryOrderDetail = {
  readonly __typename?: 'DeliveryOrderDetail';
  readonly address: Address;
  /** Delivery Fee in cents */
  readonly deliveryFee: Scalars['Float'];
  /** Estimated delivery time for an delivery order, usually used as a range with +- 15mins offset. For outpost orders this is represented by the order "wantedTime". */
  readonly estimatedDeliveryTime: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly orderId: Scalars['ID'];
  /** Courier tip in cents */
  readonly tip: Scalars['Float'];
  readonly vendor: Scalars['String'];
  readonly vendorRestaurantId: Scalars['String'];
};

export type DeliveryOrderDetailInput = {
  readonly addressId: Scalars['ID'];
  readonly deliveryFee: Scalars['Float'];
  readonly tip: Scalars['Float'];
  readonly vendor: Scalars['String'];
  readonly vendorRestaurantId: Scalars['String'];
};

export enum DeliveryPreferenceType {
  Curbside = 'CURBSIDE',
  Door = 'DOOR',
  LeaveAtDoor = 'LEAVE_AT_DOOR',
}

export type DeliverySpecifyAddress = UserError & {
  readonly __typename?: 'DeliverySpecifyAddress';
  readonly errorMessage: Scalars['String'];
};

export type DietaryProperty = {
  readonly __typename?: 'DietaryProperty';
  readonly id: Scalars['ID'];
  readonly name: DietaryPropertyKind;
};

export enum DietaryPropertyKind {
  Dairy = 'DAIRY',
  Fish = 'FISH',
  Gluten = 'GLUTEN',
  Meat = 'MEAT',
  Nuts = 'NUTS',
  Soy = 'SOY',
}

/** Discount on payment plan */
export type Discount = {
  readonly __typename?: 'Discount';
  /** The quantity of the discount */
  readonly amount: Maybe<Scalars['String']>;
  /** The description of the discount */
  readonly description: Maybe<Scalars['String']>;
  /** Discount identifier */
  readonly id: Scalars['ID'];
  /** The name of the discount */
  readonly name: Scalars['ID'];
};

export enum DressingMode {
  Mixed = 'MIXED',
  NotDressable = 'NOT_DRESSABLE',
  OnTheSide = 'ON_THE_SIDE',
  Removed = 'REMOVED',
}

export enum DressingWeight {
  Heavy = 'HEAVY',
  Light = 'LIGHT',
  Medium = 'MEDIUM',
}

export type DropOffLocation = {
  readonly __typename?: 'DropOffLocation';
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
};

export type EditAddressInput = {
  readonly city: Scalars['String'];
  readonly country: Scalars['String'];
  readonly deliveryPreference: DeliveryPreferenceType;
  readonly googlePlaceId: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly latitude: Scalars['Float'];
  readonly longitude: Scalars['Float'];
  readonly name?: InputMaybe<Scalars['String']>;
  readonly notes?: InputMaybe<Scalars['String']>;
  readonly secondaryStreet?: InputMaybe<Scalars['String']>;
  readonly state: Scalars['String'];
  readonly street: Scalars['String'];
  readonly zipCode: Scalars['String'];
};

export type EditLineItemInCartInput = {
  readonly additions: ReadonlyArray<IngredientModificationInput>;
  readonly customName?: InputMaybe<Scalars['String']>;
  readonly lineItemId: Scalars['ID'];
  readonly mixedDressingDetails: ReadonlyArray<MixedDressingDetailsInput>;
  readonly productId: Scalars['ID'];
  readonly quantity: Scalars['Int'];
  readonly removals: ReadonlyArray<IngredientModificationInput>;
  readonly substitutions: ReadonlyArray<IngredientSubstitutionModificationInput>;
};

export type EditLineItemInCartResponseUnion =
  | EditLineItemInCartSuccess
  | MaxModificationsExceeded
  | RestaurantMaxDeliveryQuantityExceeded
  | RestaurantMaxQuantityExceeded
  | ValidationError;

export type EditLineItemInCartSuccess = {
  readonly __typename?: 'EditLineItemInCartSuccess';
  readonly cart: Order;
};

export type EstimateRange = {
  readonly __typename?: 'EstimateRange';
  readonly end: Scalars['Int'];
  readonly start: Scalars['Int'];
};

export enum ExpirationState {
  Expired = 'EXPIRED',
  Nearing = 'NEARING',
  Ok = 'OK',
}

export type FavoriteLineItemInput = {
  readonly favorited: Scalars['Boolean'];
  readonly lineItemId: Scalars['ID'];
  readonly productId: Scalars['ID'];
};

export type FavoritedLineItemsInput = {
  readonly page: Scalars['Int'];
};

export type FeedbackInput = {
  readonly id: Scalars['ID'];
  readonly isFeedbackComplete?: InputMaybe<Scalars['Boolean']>;
  readonly questionId: Scalars['ID'];
  readonly responseIds: ReadonlyArray<Scalars['ID']>;
};

export type FeedbackQuestion = {
  readonly __typename?: 'FeedbackQuestion';
  readonly id: Scalars['ID'];
  readonly responses: Maybe<ReadonlyArray<FeedbackResponse>>;
  readonly slug: Maybe<Scalars['String']>;
  readonly text: Maybe<Scalars['String']>;
};

export type FeedbackResponse = {
  readonly __typename?: 'FeedbackResponse';
  readonly id: Scalars['ID'];
  readonly text: Scalars['String'];
};

export type FeedbackSuccess = {
  readonly __typename?: 'FeedbackSuccess';
  readonly success: Scalars['Boolean'];
};

export type FieldValidationError = {
  readonly __typename?: 'FieldValidationError';
  readonly field: Scalars['String'];
  readonly message: Scalars['String'];
};

export enum FlattenedOrderStatuses {
  Completed = 'completed',
  Delivering = 'delivering',
  Failed = 'failed',
  Preparing = 'preparing',
  ReadyForCourier = 'readyForCourier',
  Received = 'received',
}

export type ForgotPasswordInput = {
  readonly email: Scalars['String'];
};

export type ForgotPasswordResponseUnion =
  | ForgotPasswordSuccess
  | ValidationError;

export type ForgotPasswordSuccess = {
  readonly __typename?: 'ForgotPasswordSuccess';
  readonly success: Scalars['Boolean'];
};

/** input argument for geo distance based location search querys */
export type GeoCoordinates = {
  readonly latitude: Scalars['Float'];
  readonly longitude: Scalars['Float'];
};

export enum GravyStatusType {
  ArrivedAtDropoff = 'ARRIVED_AT_DROPOFF',
  DeliveryCompleted = 'DELIVERY_COMPLETED',
  DeliveryFailed = 'DELIVERY_FAILED',
  KitchenCompleted = 'KITCHEN_COMPLETED',
  OrderCreated = 'ORDER_CREATED',
  OrderStatusFailed = 'ORDER_STATUS_FAILED',
  OrderStatusPreorderFailed = 'ORDER_STATUS_PREORDER_FAILED',
  OrderSubmitted = 'ORDER_SUBMITTED',
  SubmitFailed = 'SUBMIT_FAILED',
  Unknown = 'UNKNOWN',
}

export type Guest = {
  readonly __typename?: 'Guest';
  readonly email: Maybe<Scalars['String']>;
  readonly firstName: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly lastName: Maybe<Scalars['String']>;
};

/** Used to determine if the user has unseen challenges, meaning they haven't yet queried for the challenge. */
export type HasUnseenChallenges = {
  readonly __typename?: 'HasUnseenChallenges';
  readonly hasUnseenChallenges: Scalars['Boolean'];
};

export type InStoreOrder = {
  readonly __typename?: 'InStoreOrder';
  readonly id: Scalars['ID'];
  readonly wantedTime: Scalars['String'];
};

export type Ingredient = {
  readonly __typename?: 'Ingredient';
  readonly asset: Asset;
  readonly dietaryProperties: ReadonlyArray<DietaryProperty>;
  readonly id: Scalars['ID'];
  readonly kind: Maybe<IngredientKind>;
  readonly name: Scalars['String'];
};

export enum IngredientKind {
  Base = 'BASE',
  Dressing = 'DRESSING',
  Premium = 'PREMIUM',
  Topping = 'TOPPING',
}

export type IngredientModification = {
  readonly __typename?: 'IngredientModification';
  readonly additionCost: Scalars['Float'];
  readonly calories: Scalars['Float'];
  readonly ingredient: Ingredient;
  /** Asserts whether the ingredient modification is a "grain" type (like "rice," "quinoa," etc.) */
  readonly isGrain: Scalars['Boolean'];
  readonly kind: Maybe<Scalars['String']>;
  /** Is the modification able to be mixed-in to the salad, primarily used for dressings */
  readonly mixable: Scalars['Boolean'];
  readonly outOfStock: Scalars['Boolean'];
  readonly removalCost: Scalars['Float'];
  readonly subKind: Maybe<Scalars['String']>;
  readonly substitutionCost: Scalars['Float'];
};

export type IngredientModificationInput = {
  readonly ingredientId: Scalars['ID'];
};

export type IngredientModificationKind = {
  readonly __typename?: 'IngredientModificationKind';
  /** The kind allows multiple quantity selections for a modification. */
  readonly allowMultipleQuantity: Scalars['Boolean'];
  /** The number of free ingredient modifications that can be added of this kind. */
  readonly freeAggregateQuantity: Scalars['Int'];
  /** The maximum number of ingredient modifications that can be of this kind. */
  readonly maxAggregateQuantity: Scalars['Int'];
  /** The minimum number of ingredient modifications that can be of this kind. */
  readonly minAggregateQuantity: Scalars['Int'];
  readonly modifications: ReadonlyArray<IngredientModification>;
};

export type IngredientModifications = {
  readonly __typename?: 'IngredientModifications';
  readonly bases: IngredientModificationKind;
  readonly bread: IngredientModificationKind;
  readonly dressings: IngredientModificationKind;
  readonly premiums: IngredientModificationKind;
  readonly toppings: IngredientModificationKind;
};

export type IngredientSubstitutionModificationInput = {
  readonly addedIngredientId: Scalars['ID'];
  readonly removedIngredientId: Scalars['ID'];
};

export type InvalidAddress = {
  readonly __typename?: 'InvalidAddress';
  readonly message: Scalars['String'];
  readonly status: Scalars['Int'];
};

export type InvalidBillingAccount = UserError & {
  readonly __typename?: 'InvalidBillingAccount';
  readonly errorMessage: Scalars['String'];
  readonly message: Scalars['String'];
  readonly status: Scalars['Int'];
};

export type InvalidCredentials = {
  readonly __typename?: 'InvalidCredentials';
  readonly message: Scalars['String'];
  readonly status: Scalars['Int'];
};

export type InvalidCustomerPhone = UserError & {
  readonly __typename?: 'InvalidCustomerPhone';
  readonly errorMessage: Scalars['String'];
};

export type InvalidInput = {
  readonly __typename?: 'InvalidInput';
  readonly message: Scalars['String'];
  readonly status: Scalars['Int'];
};

export type InvalidOrder = {
  readonly __typename?: 'InvalidOrder';
  readonly message: Scalars['String'];
  readonly status: Scalars['Int'];
};

export type InvalidPostalCode = UserError & {
  readonly __typename?: 'InvalidPostalCode';
  readonly errorMessage: Scalars['String'];
};

export type InvalidPromoCode = {
  readonly __typename?: 'InvalidPromoCode';
  readonly message: Scalars['String'];
  readonly status: Scalars['Int'];
};

export type InvalidRegistrationCode = {
  readonly __typename?: 'InvalidRegistrationCode';
  readonly message: Scalars['String'];
  readonly status: Scalars['Int'];
};

export type InvalidSubmittedBillingAccount = UserError & {
  readonly __typename?: 'InvalidSubmittedBillingAccount';
  readonly errorMessage: Scalars['String'];
};

/** JWT token used to login a user in Kustomer */
export type Kustomer = {
  readonly __typename?: 'Kustomer';
  readonly token: Scalars['String'];
};

export type Ledger = {
  readonly __typename?: 'Ledger';
  /** Items that reduce the post-tax cost (i.e. total) of the order. */
  readonly credits: ReadonlyArray<LedgerItem>;
  /** Sum of all credits */
  readonly creditsTotal: Scalars['Int'];
  /** Items that reduce the pre-tax cost of the order, usually the result of applying offers. */
  readonly discounts: ReadonlyArray<LedgerItem>;
  /** Sum of all discounts */
  readonly discountsTotal: Scalars['Int'];
  readonly fees: ReadonlyArray<LedgerItem>;
  /** Sum of all fees */
  readonly feesTotal: Scalars['Int'];
  /** Sum of the cost of all line items. */
  readonly subtotal: Scalars['Int'];
  readonly tax: Scalars['Int'];
  /** Tip applied to order in cents */
  readonly tip: Scalars['Int'];
};

export type LedgerItem = {
  readonly __typename?: 'LedgerItem';
  readonly amount: Scalars['Int'];
  /** May be shown as a tooltip or flyout in clients */
  readonly description: Maybe<Scalars['String']>;
  readonly name: Scalars['String'];
};

export type LineItem = {
  readonly __typename?: 'LineItem';
  /** The ingredients that have been added on to the line item when compared to the product's default ingredients. */
  readonly addedIngredients: ReadonlyArray<Ingredient>;
  /** The total number of calories in the line item */
  readonly calories: Scalars['Int'];
  /** The per item cost multiplied by the quantity, in cents. */
  readonly cost: Scalars['Int'];
  /** The custom name for the line item that has been specified by the user. */
  readonly customName: Maybe<Scalars['String']>;
  /** Name of the customer who ordered this lineItem */
  readonly customerName: Scalars['String'];
  /** Dressing status, if the product is dressable. Otherwise NOT_DRESSABLE. */
  readonly dressingMode: DressingMode;
  /** Whether the line item is marked as favorite. */
  readonly favorited: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  /** The ingredients that make up the line item. These ingredients include any added or removed ingredients compared to the product's default ingredients. */
  readonly ingredients: ReadonlyArray<Ingredient>;
  /** Whether the line item has been customized. */
  readonly isCustom: Scalars['Boolean'];
  /** Information outlining which dressings are mixed into the line item and their associated weights. */
  readonly mixedDressingDetails: ReadonlyArray<MixedDressingDetails>;
  /** The per item cost of the product as configured, in cents. */
  readonly perItemCost: Scalars['Int'];
  /** The product associated with a line item. */
  readonly product: Product;
  /** The number of products in the line item. */
  readonly quantity: Scalars['Int'];
  /** The ingredients that have been removed from the line item when compared to the product's default ingredients. */
  readonly removedIngredients: ReadonlyArray<Ingredient>;
  readonly slug: Scalars['ID'];
};

export type LineItemBySlugInput = {
  readonly slug: Scalars['ID'];
};

export type LineItemInput = {
  readonly id: Scalars['ID'];
};

export type LineItemNotFound = {
  readonly __typename?: 'LineItemNotFound';
  readonly message: Scalars['String'];
  readonly status: Scalars['Int'];
};

export type LineItemResponseUnion =
  | LineItemNotFound
  | LineItemSuccess
  | ValidationError;

export type LineItemSuccess = {
  readonly __typename?: 'LineItemSuccess';
  readonly lineItem: LineItem;
};

export type Location = {
  readonly __typename?: 'Location';
  readonly estimateRange: EstimateRange;
  readonly restaurant: Restaurant;
  readonly status: LocationStatus;
  readonly vendor: Vendor;
};

export type LocationByAddressInput = {
  readonly address1?: InputMaybe<Scalars['String']>;
  readonly address2?: InputMaybe<Scalars['String']>;
  /** id for an address present in the current session. */
  readonly addressId?: InputMaybe<Scalars['ID']>;
  readonly city?: InputMaybe<Scalars['String']>;
  /** google places id used for delivery locations search */
  readonly googlePlaceId?: InputMaybe<Scalars['String']>;
  readonly lat?: InputMaybe<Scalars['Float']>;
  readonly lon?: InputMaybe<Scalars['Float']>;
  readonly state?: InputMaybe<Scalars['String']>;
  readonly zipcode?: InputMaybe<Scalars['Int']>;
};

export type LocationByAddressResponseUnion =
  | InvalidInput
  | Location
  | NoValidRestaurants
  | ValidationError;

/**
 * Combines search result meta for match score and with location data
 * Note:
 * - when allLocations are queried the score is 1.0 for every result
 * - for geo-distance queries the score is the distance from the base coodinates
 */
export type LocationSearchResult = {
  readonly __typename?: 'LocationSearchResult';
  readonly location: StoreLocation;
  readonly score: Scalars['Float'];
};

export enum LocationStatus {
  Closed = 'CLOSED',
  Invalid = 'INVALID',
  Open = 'OPEN',
}

export type LoginInput = {
  readonly email: Scalars['String'];
  readonly grecaptcha: Scalars['String'];
  readonly password: Scalars['String'];
};

export type LoginResponseUnion =
  | AccountLocked
  | InvalidCredentials
  | LoginSuccess
  | ValidationError;

export type LoginSuccess = {
  readonly __typename?: 'LoginSuccess';
  readonly csrf: Scalars['String'];
};

export type LogoutInput = {
  readonly customerId: Scalars['ID'];
};

export type LogoutResponseUnion = LogoutSuccess | ValidationError;

export type LogoutSuccess = {
  readonly __typename?: 'LogoutSuccess';
  readonly csrf: Scalars['String'];
};

/** Customer Loyalty Profile */
export type LoyaltyProfile = {
  readonly __typename?: 'LoyaltyProfile';
  /** External user id */
  readonly customerId: Scalars['ID'];
  /** Customer has subscribed before */
  readonly hasPaidTierHistory: Scalars['Boolean'];
  /** Date the loyalty profile was created */
  readonly joinDate: Scalars['DateTime'];
  /** Customer Tier */
  readonly tier: Maybe<Tier>;
  /** Customer Tier */
  readonly tierStatus: Maybe<TierStatus>;
};

export type MaxModificationsExceeded = {
  readonly __typename?: 'MaxModificationsExceeded';
  readonly message: Scalars['String'];
  readonly status: Scalars['Int'];
};

export type Menu = {
  readonly __typename?: 'Menu';
  readonly categories: ReadonlyArray<MenuCategory>;
  readonly id: Scalars['String'];
};

export type MenuCategory = {
  readonly __typename?: 'MenuCategory';
  readonly id: Scalars['ID'];
  readonly isCustom: Scalars['Boolean'];
  readonly name: Scalars['String'];
  readonly products: ReadonlyArray<Product>;
};

export type MenuCollection = {
  readonly __typename?: 'MenuCollection';
  readonly color: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly primaryDescription: Scalars['String'];
  readonly primaryImageUrl: Scalars['String'];
  readonly primaryTitle: Scalars['String'];
  readonly products: ReadonlyArray<Product>;
  readonly secondaryDescription: Maybe<Scalars['String']>;
  readonly secondaryTitle: Maybe<Scalars['String']>;
};

export type MinimumDeliverySubtotalNotMet = UserError & {
  readonly __typename?: 'MinimumDeliverySubtotalNotMet';
  readonly errorMessage: Scalars['String'];
  readonly message: Scalars['String'];
  readonly status: Scalars['Int'];
};

export type MixedDressingDetails = {
  readonly __typename?: 'MixedDressingDetails';
  readonly ingredientId: Scalars['ID'];
  readonly weight: DressingWeight;
};

export type MixedDressingDetailsInput = {
  readonly ingredientId: Scalars['ID'];
  readonly weight: DressingWeight;
};

export type Mutation = {
  readonly __typename?: 'Mutation';
  /** Adds an address to the customer's list of addresses. */
  readonly addAddress: AddAddressResponseUnion;
  readonly addLineItemBatchToCart: AddLineItemToCartResponseUnion;
  readonly addLineItemToCart: AddLineItemToCartResponseUnion;
  /** Add a payment method to a subscription */
  readonly addSubscriptionPaymentMethod: AddSubscriptionPaymentMethodResponseUnion;
  readonly applyReward: ApplyRewardResponseUnion;
  /** Cancel a subscription */
  readonly cancelSubscription: CancelSubscriptionResponseUnion;
  /** Cancel a subscription at cycle end */
  readonly cancelSubscriptionAtCycleEnd: CancelSubscriptionAtCycleEndResponseUnion;
  /** Vendor endpoint to cancel subscription, requires bearer auth token */
  readonly cancelSubscriptionForCustomer: CancelSubscriptionForCustomerResponseUnion;
  /** Takes a challenge ID (a.k.a. SessionM campaign ID) as an argument and opts customer into the identified challenge.  Returns the challenge details upon success. If an error occurs, the error field will be populated in the response: errors[0].message = modal title, errors[0].extension.detailedMessage = modal description/friendly message detailing what went wrong */
  readonly challengeOptIn: Challenge;
  /** Creates loyalty profile. New profiles are added to the free tier (1) by default if a tierId is not provided. */
  readonly createLoyaltyProfile: CreateLoyaltyProfileResult;
  readonly createPaymentSubscriptionProfile: PaymentSubscriptionProfile;
  /** Create a subscription */
  readonly createSubscription: CreateSubscriptionResult;
  /** Removes an address from the customer's list of addresses. */
  readonly deleteAddress: DeleteAddressResponseUnion;
  /** Deletes an existing billing account. */
  readonly deleteBillingAccount: DeleteBillingAccountResponse;
  readonly editLineItemInCart: EditLineItemInCartResponseUnion;
  /** Favorites a Line Item. */
  readonly favoriteLineItem: LineItem;
  /** Handle user password recovery. */
  readonly forgotPassword: ForgotPasswordResponseUnion;
  /** Logs the user in. */
  readonly login: LoginResponseUnion;
  /** Logs the user out. */
  readonly logout: LogoutResponseUnion;
  /** Opts into the free tier. */
  readonly optInFreeTier: Scalars['Boolean'];
  /** Opts out of loyalty program. */
  readonly optOutLoyalty: Scalars['Boolean'];
  /** Opts a user out of loyalty. Requires a bearer auth token */
  readonly optOutLoyaltyForCustomer: Scalars['Boolean'];
  /** Registers a new user. */
  readonly register: RegisterResponseUnion;
  readonly registerGuest: Maybe<RegisterGuestResponseUnion>;
  /** Rejoin a previously canceled subscription */
  readonly rejoinSubscription: RejoinSubscriptionResponseUnion;
  readonly removeFromCart: RemoveFromCartResponseUnion;
  readonly removeReward: RemoveRewardResponseUnion;
  /** Remove a payment method from a subscription */
  readonly removeSubscriptionPaymentMethod: DeleteSubscriptionPaymentMethodResponseUnion;
  /** @deprecated Deprecated in favor of the "reorderOrder" mutation. */
  readonly reorder: ReorderResponseUnion;
  readonly reorderLineItem: ReorderResponseUnion;
  readonly reorderOrder: ReorderResponseUnion;
  readonly requestAccountDeletion: Maybe<RequestAccountDeletionResponseUnion>;
  /** Resend registration verification code. */
  readonly resendVerificationCode: ResendVerificationCodeResponseUnion;
  /**
   * Submits a new billing account, using the braintree nonce.
   *       Will fail with an InvalidBillingAccountException if the credit card is invalid/expired.
   *       Will fail with an InvalidPostalCodeException if the postal code is invalid.
   *       Will fail with a TooManyRequestsException if too many failed attempts are made.
   */
  readonly submitBraintreeBillingAccount: SubmitBraintreeBillingAccountResponseUnion;
  readonly submitFeedback: FeedbackSuccess;
  readonly submitInStoreFeedback: FeedbackSuccess;
  /** Submits an order, paid for using one of the customer's existing billing accounts. */
  readonly submitOrderUsingBillingAccount: SubmitOrderUsingBillingAccountResponseUnion;
  /** Submits an order paid for via a separate workflow i.e. marketplace. */
  readonly submitOrderWithPaymentMethod: SubmitOrderWithPaymentMethodResponseUnion;
  /** Submits a gift card code. */
  readonly submitPromoCode: SubmitPromoCodeResponseUnion;
  /** Submits code to SessionM. If unsuccessful, code is submitted to LevelUp. */
  readonly submitPromoOrGiftCardCode: SubmitPromoCodeOrGiftCardResponseUnion;
  /** Updates an address form the customer's list of addresses. */
  readonly updateAddress: UpdateAddressResponseUnion;
  /** Updates an existing billing account. */
  readonly updateBillingAccount: UpdateBillingAccountResponse;
  readonly updateCustomer: Maybe<UpdateCustomerResponse>;
  readonly updateKioskCustomer: Maybe<UpdateKioskCustomerResponse>;
  /** Update the payment method for a subscription */
  readonly updateSubscriptionPaymentMethod: UpdateSubscriptionPaymentMethodSuccessResponse;
  /** Sets whether to use credit on next purchase. */
  readonly updateUseCredit: UpdateUseCreditResponse;
  /** Verify a newly registered user. */
  readonly verifyRegistration: VerifyRegistrationUnion;
};

export type MutationAddAddressArgs = {
  input: AddAddressInput;
};

export type MutationAddLineItemBatchToCartArgs = {
  input: AddLineItemBatchToCartInput;
};

export type MutationAddLineItemToCartArgs = {
  input: AddLineItemToCartInput;
};

export type MutationAddSubscriptionPaymentMethodArgs = {
  paymentNonce: Scalars['String'];
};

export type MutationApplyRewardArgs = {
  input: ApplyRewardInput;
};

export type MutationCancelSubscriptionArgs = {
  subscriptionId: Scalars['String'];
};

export type MutationCancelSubscriptionAtCycleEndArgs = {
  subscriptionId: Scalars['String'];
};

export type MutationCancelSubscriptionForCustomerArgs = {
  uuid: Scalars['String'];
};

export type MutationChallengeOptInArgs = {
  challengeId: Scalars['String'];
};

export type MutationCreateLoyaltyProfileArgs = {
  tierId?: InputMaybe<Scalars['ID']>;
};

export type MutationCreateSubscriptionArgs = {
  paymentId?: InputMaybe<Scalars['String']>;
  planId: Scalars['String'];
  token?: InputMaybe<Scalars['String']>;
};

export type MutationDeleteAddressArgs = {
  addressId: Scalars['ID'];
};

export type MutationDeleteBillingAccountArgs = {
  input: DeleteBillingAccountInput;
};

export type MutationEditLineItemInCartArgs = {
  input: EditLineItemInCartInput;
};

export type MutationFavoriteLineItemArgs = {
  input: FavoriteLineItemInput;
};

export type MutationForgotPasswordArgs = {
  input: ForgotPasswordInput;
};

export type MutationLoginArgs = {
  input: LoginInput;
};

export type MutationLogoutArgs = {
  input: LogoutInput;
};

export type MutationOptOutLoyaltyForCustomerArgs = {
  uuid: Scalars['String'];
};

export type MutationRegisterArgs = {
  input: RegisterInput;
};

export type MutationRegisterGuestArgs = {
  input: RegisterGuestInput;
};

export type MutationRejoinSubscriptionArgs = {
  subscriptionId: Scalars['String'];
};

export type MutationRemoveFromCartArgs = {
  input: RemoveFromCartInput;
};

export type MutationRemoveRewardArgs = {
  input: RemoveRewardInput;
};

export type MutationRemoveSubscriptionPaymentMethodArgs = {
  paymentMethodId: Scalars['String'];
};

export type MutationReorderArgs = {
  input: ReorderInput;
};

export type MutationReorderLineItemArgs = {
  input: ReorderInput;
};

export type MutationReorderOrderArgs = {
  input: ReorderInput;
};

export type MutationResendVerificationCodeArgs = {
  input: ResendVerificationCodeInput;
};

export type MutationSubmitBraintreeBillingAccountArgs = {
  input: SubmitBraintreeBillingAccountInput;
};

export type MutationSubmitFeedbackArgs = {
  input: FeedbackInput;
};

export type MutationSubmitInStoreFeedbackArgs = {
  input: FeedbackInput;
};

export type MutationSubmitOrderUsingBillingAccountArgs = {
  input: SubmitOrderUsingBillingAccountInput;
};

export type MutationSubmitOrderWithPaymentMethodArgs = {
  input: SubmitOrderWithPaymentMethodInput;
};

export type MutationSubmitPromoCodeArgs = {
  input: SubmitPromoCodeInput;
};

export type MutationSubmitPromoOrGiftCardCodeArgs = {
  input: SubmitPromoOrGiftCardCodeInput;
};

export type MutationUpdateAddressArgs = {
  input: EditAddressInput;
};

export type MutationUpdateBillingAccountArgs = {
  input: UpdateBillingAccountInput;
};

export type MutationUpdateCustomerArgs = {
  input: UpdateCustomerInput;
};

export type MutationUpdateKioskCustomerArgs = {
  input: UpdateKioskCustomerInput;
};

export type MutationUpdateSubscriptionPaymentMethodArgs = {
  paymentMethodId: Scalars['String'];
  subscriptionId: Scalars['String'];
};

export type MutationUpdateUseCreditArgs = {
  useCredit: Scalars['Boolean'];
};

export type MutationVerifyRegistrationArgs = {
  input: VerifyRegistrationInput;
};

export type NoValidRestaurants = {
  readonly __typename?: 'NoValidRestaurants';
  readonly message: Scalars['String'];
  readonly status: Scalars['Int'];
};

export type Order = {
  readonly __typename?: 'Order';
  readonly asset: Asset;
  readonly availableWantedTimes: ReadonlyArray<AvailableWantedTime>;
  /** Whether or not this order belongs to a restaurant with support for tracking the orders with a QSR system. This is always true for delivery orders, for pickup or outpost, it checks the tracking status of the restaurant. This flag affects what we should the customer in the order status feature. */
  readonly canTrackOrderStatus: Scalars['Boolean'];
  readonly deliveryOrderDetail: Maybe<DeliveryOrderDetail>;
  readonly description: Scalars['String'];
  readonly dropoffLocation: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly includeUtensils: Scalars['Boolean'];
  /** Whether or not this order is an inflight order, this is done by checking the session.inFlightOrderId on a field resolver. */
  readonly isInFlight: Scalars['Boolean'];
  /** Whether or not this order is an inflight delivery order, this is done by checking the session.inFlightDeliveryOrderId on a field resolver. */
  readonly isInFlightDelivery: Scalars['Boolean'];
  /** Whether or not this order is pending the feedback from "rate your order". */
  readonly isPendingFeedback: Scalars['Boolean'];
  readonly ledger: Ledger;
  readonly lineItems: ReadonlyArray<LineItem>;
  readonly orderType: OrderType;
  readonly restaurant: Restaurant;
  readonly total: Maybe<Scalars['Int']>;
  /** Used by customers to reference the order when speaking to our support team. */
  readonly vendorId: Scalars['String'];
  readonly wantedTime: Scalars['String'];
};

export type OrderConflict = {
  readonly __typename?: 'OrderConflict';
  readonly product: Product;
  /** Reorder conflict type */
  readonly type: ConflictType;
  readonly unavailableIngredients: ReadonlyArray<Ingredient>;
};

export type OrderStatus = {
  readonly __typename?: 'OrderStatus';
  readonly courierDetails: Maybe<CourierDetails>;
  readonly customerId: Scalars['ID'];
  /** Flattened list of order statuses, which collapses the different per order type order statuses into a standard list. */
  readonly flattenedOrderStatus: FlattenedOrderStatuses;
  readonly gravyStatus: GravyStatusType;
  readonly gravyUpdatedAt: Scalars['String'];
  readonly order: Order;
  readonly orderOccasion: Scalars['String'];
  /** Raw list of order statuses, each status comes with the order type and there are multiple variants per each step. */
  readonly orderStatus: Scalars['String'];
};

export type OrderStatusResponseUnion = InvalidOrder | OrderStatus;

export enum OrderType {
  Delivery = 'DELIVERY',
  InStore = 'IN_STORE',
  Pickup = 'PICKUP',
}

export type OrdersInput = {
  readonly page: Scalars['Int'];
  readonly take: Scalars['Int'];
};

export type OrdersResponseSuccess = {
  readonly __typename?: 'OrdersResponseSuccess';
  readonly orders: ReadonlyArray<Order>;
  readonly pagination: Pagination;
};

export type OrdersResponseUnion = OrdersResponseSuccess | ValidationError;

export type Pagination = {
  readonly __typename?: 'Pagination';
  /** Last available page. */
  readonly last: Scalars['Int'];
  /** The page requested. */
  readonly page: Scalars['Int'];
  /** Items per page. */
  readonly take: Scalars['Int'];
  /** Total number of items available. */
  readonly total: Scalars['Int'];
};

/** Payment method already exists */
export type PaymentMethodAlreadyExistsError = UserError & {
  readonly __typename?: 'PaymentMethodAlreadyExistsError';
  readonly errorMessage: Scalars['String'];
};

export enum PaymentMethods {
  PayInStore = 'PAY_IN_STORE',
  Prepaid = 'PREPAID',
}

/** Payment Plan */
export type PaymentPlan = {
  readonly __typename?: 'PaymentPlan';
  /** ID of plan from Braintree */
  readonly braintreePlanId: Scalars['ID'];
  /** Tier plan belongs to */
  readonly tier: Tier;
};

/** Customer Subscription object */
export type PaymentSubscription = {
  readonly __typename?: 'PaymentSubscription';
  readonly balance: Scalars['String'];
  readonly billingHistory: ReadonlyArray<SubscriptionTransactions>;
  readonly billingPeriodEndDate: Maybe<Scalars['String']>;
  readonly billingPeriodStartDate: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['String'];
  /** The ID of the subscription */
  readonly id: Scalars['ID'];
  readonly nextBillingDate: Scalars['String'];
  readonly nextBillingPeriodAmount: Scalars['String'];
  readonly paidThroughDate: Maybe<Scalars['DateTime']>;
  readonly planId: Scalars['String'];
  readonly price: Maybe<Scalars['String']>;
  readonly status: Scalars['String'];
};

/** Braintree Customer Payment Subscription Profile */
export type PaymentSubscriptionProfile = {
  readonly __typename?: 'PaymentSubscriptionProfile';
  readonly creditCards: Maybe<ReadonlyArray<SubscriptionCreditCard>>;
  readonly id: Scalars['ID'];
};

export type Product = {
  readonly __typename?: 'Product';
  readonly asset: Asset;
  readonly calories: Scalars['Int'];
  readonly categoryId: Scalars['String'];
  readonly categoryName: Scalars['String'];
  /** Base cost, in cents */
  readonly cost: Scalars['Int'];
  /** If a product is custom, this field provides the type of that product, otherwise the field will be null. Clients must only use this field for cosmetic purposes; for example, displaying a custom product card on the menu page. */
  readonly customType: Maybe<CustomProductType>;
  readonly description: Scalars['String'];
  readonly dietaryProperties: ReadonlyArray<DietaryProperty>;
  readonly id: Scalars['ID'];
  readonly ingredientModifications: IngredientModifications;
  readonly ingredients: ReadonlyArray<Ingredient>;
  readonly isCustom: Scalars['Boolean'];
  readonly isModifiable: Scalars['Boolean'];
  readonly isSalad: Scalars['Boolean'];
  readonly label: Maybe<ProductLabel>;
  /** The total number of additions, removals, and substitutions that are allowed to be modified for this product */
  readonly maxModifications: Scalars['Int'];
  readonly name: Scalars['String'];
  readonly outOfStock: Scalars['Boolean'];
  readonly restaurant: Restaurant;
  readonly restaurantId: Scalars['ID'];
  readonly slug: Scalars['String'];
  readonly throttleItem: Scalars['Boolean'];
};

export type ProductLabel = {
  readonly __typename?: 'ProductLabel';
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
};

export type ProductUnavailable = UserError & {
  readonly __typename?: 'ProductUnavailable';
  readonly errorMessage: Scalars['String'];
  readonly message: Scalars['String'];
  readonly status: Scalars['Int'];
};

export type Query = {
  readonly __typename?: 'Query';
  readonly addons: Addons;
  readonly address: Maybe<Address>;
  /** Returns all sweetgreen locations (that aren't hidden etc) */
  readonly allLocations: Maybe<ReadonlyArray<Maybe<LocationSearchResult>>>;
  readonly baseProduct: Maybe<BaseProduct>;
  readonly cart: Maybe<Order>;
  /** Returns the challenge celebration details available for a customer from newly completed challenges. If multiple challenges have been newly completed, returns hardcoded description and disclaimer with no title or expirationDate. Returns null if customer has already viewed celebration messaging. */
  readonly challengeCelebration: Maybe<ChallengeCelebration>;
  /** Returns all eligible rewards available to the customer */
  readonly challengeRewards: ReadonlyArray<ChallengeReward>;
  /** Returns customers eligible challenges */
  readonly challenges: ReadonlyArray<Challenge>;
  readonly currentCustomer: Maybe<Customer>;
  /** Pass card for scan to pay, usually for adding to apple wallet */
  readonly customerPass: Maybe<CustomerPass>;
  readonly favoritedLineItems: ReadonlyArray<LineItem>;
  readonly feedbackQuestions: ReadonlyArray<FeedbackQuestion>;
  /** Returns all plans associated to tierId */
  readonly fetchPlansByTierId: Maybe<ReadonlyArray<PaymentPlan>>;
  readonly getSubscriptions: ReadonlyArray<PaymentSubscription>;
  /** Returns a boolean indicating if user has any unseen challenges */
  readonly hasUnseenChallenges: HasUnseenChallenges;
  readonly inStoreFeedbackQuestions: ReadonlyArray<FeedbackQuestion>;
  readonly inStoreOrderLastPendingFeedback: Maybe<InStoreOrder>;
  /** Kustomer JWT token used to login the user in Kustomer */
  readonly kustomerToken: Maybe<Kustomer>;
  readonly lineItem: Maybe<LineItemResponseUnion>;
  readonly lineItemBySlug: Maybe<LineItemResponseUnion>;
  readonly locationByAddress: LocationByAddressResponseUnion;
  /** Returns loyalty profile */
  readonly loyaltyProfile: Maybe<LoyaltyProfile>;
  readonly menuCollection: MenuCollection;
  readonly menuCollections: ReadonlyArray<MenuCollection>;
  readonly order: Order;
  readonly orderLastPendingFeedback: Maybe<Order>;
  readonly orderStatus: Maybe<OrderStatusResponseUnion>;
  readonly orders: OrdersResponseUnion;
  /** Returns a payment subscription profile matching the customer uuid provided */
  readonly paymentSubscriptionProfile: Maybe<PaymentSubscriptionProfile>;
  readonly product: Product;
  readonly productForRestaurant: Maybe<Product>;
  readonly restaurant: Restaurant;
  readonly restaurantCapacity: RestaurantCapacity;
  readonly rewards: ReadonlyArray<Reward>;
  /** Returns all sweetgreen locations within topLeft and bottomRight map coordinates~ */
  readonly searchLocationsByBoundingBox: Maybe<
    ReadonlyArray<Maybe<LocationSearchResult>>
  >;
  /** Returns the sweetgreen location matching the entityId */
  readonly searchLocationsByEntityId: Maybe<
    ReadonlyArray<Maybe<LocationSearchResult>>
  >;
  /** Returns sweetgreen locations by string weighted by keyword match */
  readonly searchLocationsByString: Maybe<
    ReadonlyArray<Maybe<LocationSearchResult>>
  >;
  /**
   * Returns all sweetgreen locations within a given kilometer radius, in ascending
   * order of proximity
   */
  readonly searchLocationsInKilometerRadius: Maybe<
    ReadonlyArray<Maybe<LocationSearchResult>>
  >;
  /**
   * Returns all sweetgreen locations within a given kilometer radius, in ascending
   * order of proximity
   */
  readonly searchLocationsInMeterRadius: Maybe<
    ReadonlyArray<Maybe<LocationSearchResult>>
  >;
  /**
   * Returns all sweetgreen locations within a given mile radius, in ascending
   * order of proximity
   */
  readonly searchLocationsInMileRadius: Maybe<
    ReadonlyArray<Maybe<LocationSearchResult>>
  >;
  readonly session: Session;
  /** Returns a subscription plan matching the billing frequency provided, using 1 for monthly or 12 for annually */
  readonly subscriptionPlanByBillingFrequency: Maybe<SubscriptionPlan>;
  /** Returns a subscription plan matching the planId provided */
  readonly subscriptionPlanById: Maybe<SubscriptionPlan>;
  /** Returns an array of subscription plans matching the planIds provided */
  readonly subscriptionPlansByIds: Maybe<ReadonlyArray<SubscriptionPlan>>;
};

export type QueryAddressArgs = {
  addressId: Scalars['ID'];
};

export type QueryAllLocationsArgs = {
  showHidden?: InputMaybe<Scalars['Boolean']>;
};

export type QueryBaseProductArgs = {
  slug: Scalars['String'];
};

export type QueryFavoritedLineItemsArgs = {
  input: FavoritedLineItemsInput;
};

export type QueryFeedbackQuestionsArgs = {
  orderId: Scalars['ID'];
};

export type QueryFetchPlansByTierIdArgs = {
  tierId: Scalars['ID'];
};

export type QueryGetSubscriptionsArgs = {
  status?: InputMaybe<ReadonlyArray<SubscriptionStatus>>;
};

export type QueryInStoreFeedbackQuestionsArgs = {
  orderId: Scalars['ID'];
};

export type QueryLineItemArgs = {
  input: LineItemInput;
};

export type QueryLineItemBySlugArgs = {
  input: LineItemBySlugInput;
};

export type QueryLocationByAddressArgs = {
  input: LocationByAddressInput;
};

export type QueryMenuCollectionArgs = {
  id: Scalars['ID'];
};

export type QueryMenuCollectionsArgs = {
  menuId: Scalars['ID'];
};

export type QueryOrderArgs = {
  orderId: Scalars['ID'];
};

export type QueryOrderStatusArgs = {
  orderId?: InputMaybe<Scalars['ID']>;
};

export type QueryOrdersArgs = {
  input: OrdersInput;
};

export type QueryProductArgs = {
  id: Scalars['ID'];
};

export type QueryProductForRestaurantArgs = {
  baseProductSlug: Scalars['String'];
  restaurantId: Scalars['String'];
};

export type QueryRestaurantArgs = {
  id: Scalars['ID'];
};

export type QueryRestaurantCapacityArgs = {
  endTime?: InputMaybe<Scalars['String']>;
  minimumLineItemCapacity?: InputMaybe<Scalars['Int']>;
  restaurantId: Scalars['ID'];
  startTime?: InputMaybe<Scalars['String']>;
};

export type QuerySearchLocationsByBoundingBoxArgs = {
  bottomRight: GeoCoordinates;
  showHidden?: InputMaybe<Scalars['Boolean']>;
  topLeft: GeoCoordinates;
};

export type QuerySearchLocationsByEntityIdArgs = {
  entityId: Scalars['String'];
};

export type QuerySearchLocationsByStringArgs = {
  searchString: Scalars['String'];
  showHidden?: InputMaybe<Scalars['Boolean']>;
};

export type QuerySearchLocationsInKilometerRadiusArgs = {
  latLong: GeoCoordinates;
  radius?: InputMaybe<Scalars['Float']>;
  showHidden?: InputMaybe<Scalars['Boolean']>;
};

export type QuerySearchLocationsInMeterRadiusArgs = {
  latLong: GeoCoordinates;
  radius?: InputMaybe<Scalars['Float']>;
  showHidden?: InputMaybe<Scalars['Boolean']>;
};

export type QuerySearchLocationsInMileRadiusArgs = {
  latLong: GeoCoordinates;
  radius?: InputMaybe<Scalars['Float']>;
  showHidden?: InputMaybe<Scalars['Boolean']>;
};

export type QuerySubscriptionPlanByBillingFrequencyArgs = {
  billingFrequency: BillingFrequencyType;
};

export type QuerySubscriptionPlanByIdArgs = {
  planId: Scalars['ID'];
};

export type QuerySubscriptionPlansByIdsArgs = {
  planIds: ReadonlyArray<Scalars['ID']>;
};

export type RegisterGuestFailed = {
  readonly __typename?: 'RegisterGuestFailed';
  readonly message: Scalars['String'];
  readonly status: Scalars['Int'];
};

export type RegisterGuestInput = {
  readonly email?: InputMaybe<Scalars['String']>;
  readonly firstName: Scalars['String'];
  readonly lastName: Scalars['String'];
};

export type RegisterGuestResponseUnion =
  | RegisterGuestFailed
  | RegisterGuestSuccess
  | ValidationError;

export type RegisterGuestSuccess = {
  readonly __typename?: 'RegisterGuestSuccess';
  readonly csrf: Scalars['String'];
  /** Guest details. */
  readonly guest: Guest;
};

export type RegisterInput = {
  /** Must be in YYYY-MM-DD format. */
  readonly birthday?: InputMaybe<Scalars['String']>;
  readonly email: Scalars['String'];
  readonly firstName: Scalars['String'];
  readonly grecaptcha: Scalars['String'];
  readonly lastName: Scalars['String'];
  readonly password: Scalars['String'];
  /** Must be a valid US phone number, exactly 10 digits with no formatting. */
  readonly phoneNumber: Scalars['String'];
};

export type RegisterResponseUnion = RegisterSuccess | ValidationError;

export type RegisterSuccess = {
  readonly __typename?: 'RegisterSuccess';
  readonly success: Scalars['Boolean'];
};

export type RejoinSubscriptionResponseUnion =
  | RejoinSubscriptionSuccessResponse
  | SubscriptionCannotBeReactivatedError
  | UnknownUserError;

export type RejoinSubscriptionSuccessResponse = {
  readonly __typename?: 'RejoinSubscriptionSuccessResponse';
  /** Rejoined Subscription */
  readonly subscription: PaymentSubscription;
};

export type RemoveFromCartInput = {
  readonly lineItemId: Scalars['ID'];
};

export type RemoveFromCartResponseUnion =
  | RemoveFromCartSuccess
  | ValidationError;

export type RemoveFromCartSuccess = {
  readonly __typename?: 'RemoveFromCartSuccess';
  readonly cart: Order;
  readonly success: Scalars['Boolean'];
};

export type RemoveRewardInput = {
  /** The ID of the order the reward is being removed from */
  readonly orderId: Scalars['ID'];
};

export type RemoveRewardResponseUnion =
  | RemoveRewardSuccess
  | RewardNotRemoved
  | ValidationError;

export type RemoveRewardSuccess = {
  readonly __typename?: 'RemoveRewardSuccess';
  readonly order: Order;
};

export type ReorderConflict = {
  readonly __typename?: 'ReorderConflict';
  readonly conflicts: ReadonlyArray<OrderConflict>;
  /** Indicates if all products in the order are unavailable */
  readonly isNothingAvailable: Scalars['Boolean'];
};

export type ReorderInput = {
  readonly deliveryOrderDetails?: InputMaybe<DeliveryOrderDetailInput>;
  readonly destinationRestaurantId: Scalars['ID'];
  readonly id: Scalars['ID'];
  /** Ignore order conflicts and submit reorder */
  readonly ignoreConflicts?: InputMaybe<Scalars['Boolean']>;
};

export type ReorderResponseUnion =
  | CanNotReorder
  | ReorderConflict
  | ReorderSuccess
  | RestaurantMaxDeliveryQuantityExceeded
  | RestaurantMaxQuantityExceeded
  | ValidationError;

export type ReorderSuccess = {
  readonly __typename?: 'ReorderSuccess';
  readonly cart: Order;
  /** Indicates if the reorder supports mixing */
  readonly isMixingSupported: Scalars['Boolean'];
};

export type RequestAccountDeletionFailed = {
  readonly __typename?: 'RequestAccountDeletionFailed';
  readonly message: Scalars['String'];
  readonly status: Scalars['Int'];
};

export type RequestAccountDeletionResponseUnion =
  | RequestAccountDeletionFailed
  | RequestAccountDeletionSuccess;

export type RequestAccountDeletionSuccess = {
  readonly __typename?: 'RequestAccountDeletionSuccess';
  readonly success: Scalars['Boolean'];
};

export type ResendVerificationCodeInput = {
  readonly email: Scalars['String'];
  readonly grecaptcha: Scalars['String'];
};

export type ResendVerificationCodeResponseUnion =
  | ResendVerificationCodeSuccess
  | ValidationError;

export type ResendVerificationCodeSuccess = {
  readonly __typename?: 'ResendVerificationCodeSuccess';
  readonly success: Scalars['Boolean'];
};

export type Restaurant = {
  readonly __typename?: 'Restaurant';
  readonly address: Scalars['String'];
  readonly asset: Asset;
  /** Some outposts have multiple shelves within them (say, on different floors), and allow customers to select one */
  readonly availableDropOffLocations: ReadonlyArray<DropOffLocation>;
  readonly city: Scalars['String'];
  readonly deliveryFee: Scalars['Int'];
  readonly deliveryMinSubtotal: Scalars['Float'];
  readonly flexMessage: Maybe<Scalars['String']>;
  readonly hours: RestaurantHours;
  readonly id: Scalars['ID'];
  readonly isAcceptingOrders: Scalars['Boolean'];
  readonly isOutpost: Scalars['Boolean'];
  readonly latitude: Scalars['Float'];
  readonly longitude: Scalars['Float'];
  readonly menu: Menu;
  readonly name: Scalars['String'];
  readonly notAcceptingOrdersReason: Scalars['String'];
  readonly phone: Scalars['String'];
  readonly slug: Scalars['String'];
  readonly state: Scalars['String'];
  readonly zipCode: Scalars['String'];
};

export type RestaurantCapacity = {
  readonly __typename?: 'RestaurantCapacity';
  /** available capacity slots */
  readonly availableWantedTimes: ReadonlyArray<RestaurantCapacitySlot>;
  readonly restaurantAddress: Scalars['String'];
  readonly restaurantHours: Scalars['String'];
  readonly restaurantId: Scalars['ID'];
};

export type RestaurantCapacitySlot = {
  readonly __typename?: 'RestaurantCapacitySlot';
  readonly availableLineItems: Scalars['Float'];
  readonly formatted: Scalars['String'];
  readonly maxLineItems: Scalars['Float'];
  readonly original: Scalars['String'];
};

export type RestaurantHours = {
  readonly __typename?: 'RestaurantHours';
  readonly formatted: Maybe<Scalars['String']>;
};

export type RestaurantIsNotAcceptingOrders = UserError & {
  readonly __typename?: 'RestaurantIsNotAcceptingOrders';
  readonly errorMessage: Scalars['String'];
  readonly message: Scalars['String'];
  readonly status: Scalars['Int'];
};

export type RestaurantMaxDeliveryQuantityExceeded = {
  readonly __typename?: 'RestaurantMaxDeliveryQuantityExceeded';
  readonly conflicts: ReadonlyArray<OrderConflict>;
  readonly message: Scalars['String'];
  readonly status: Scalars['Int'];
};

export type RestaurantMaxQuantityExceeded = {
  readonly __typename?: 'RestaurantMaxQuantityExceeded';
  readonly conflicts: ReadonlyArray<OrderConflict>;
  readonly message: Scalars['String'];
  readonly status: Scalars['Int'];
};

/** Entity contributes to the Rewards entity in Monograph with fields provided by Challenges SVC */
export type Reward = {
  readonly __typename?: 'Reward';
  /** Date the reward expires */
  readonly expirationDate: Maybe<Scalars['String']>;
  /** SessionM Offer ID - Not direct match to ID in Reward entity in Monograph but included in the serialized value */
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  /** If true, reward can be used and UI should allow it to be selected on the bag */
  readonly redeemable: Scalars['Boolean'];
  /** If redeemable is false, this will populate with the next timestamp in UTC when the offer can be used. */
  readonly redeemableAt: Maybe<Scalars['DateTime']>;
  readonly rewardType: RewardType;
};

/** Indicates that adding, removing, or validating a reward failed and that an error should be shown to the customer. The end result is always that the cart's current reward is cleared; clients should update their internal state to reflect this. */
export type RewardNotApplied = {
  readonly __typename?: 'RewardNotApplied';
  /** Provides more detail about the reason reward application failed. Clients should map these to customer-facing error messages, with a generic default for an unrecognized value. */
  readonly failureCode: ApplyRewardFailureCode;
  readonly message: Scalars['String'];
  readonly status: Scalars['Int'];
};

export type RewardNotRemoved = {
  readonly __typename?: 'RewardNotRemoved';
  /** Provides more detail about the reason reward removal failed. Clients should map these to customer-facing error messages, with a generic default for an unrecognized value. */
  readonly failureCode: Scalars['String'];
  readonly message: Scalars['String'];
  readonly status: Scalars['Int'];
};

export type RewardNotValidated = UserError & {
  readonly __typename?: 'RewardNotValidated';
  readonly errorMessage: Scalars['String'];
  readonly failureCode: ValidateRewardFailureCode;
  readonly message: Scalars['String'];
  readonly status: Scalars['Int'];
};

/** PREMIUM = Reward is part of loyalty program, NON_PREMIUM = Reward is outcome of challenge/other outlet but not loyalty program */
export enum RewardType {
  NonPremium = 'NON_PREMIUM',
  Premium = 'PREMIUM',
}

export type Session = {
  readonly __typename?: 'Session';
  readonly cart: Maybe<Order>;
  readonly csrf: Scalars['String'];
  /** ID of the order currently in-flight, restricted to delivery orders. */
  readonly inFlightDeliveryOrderId: Maybe<Scalars['ID']>;
  /** ID of the order currently in-flight. */
  readonly inFlightOrderId: Maybe<Scalars['ID']>;
  readonly isLoggedIn: Scalars['Boolean'];
};

/** Reduced version of Restaurant, with fields required for location search. */
export type StoreLocation = {
  readonly __typename?: 'StoreLocation';
  readonly acceptingOrders: Scalars['Boolean'];
  readonly address: Scalars['String'];
  readonly city: Scalars['String'];
  readonly comingSoon: Maybe<Scalars['Boolean']>;
  readonly crossStreet: Maybe<Scalars['String']>;
  readonly enabled: Scalars['Boolean'];
  readonly entityId: Maybe<Scalars['ID']>;
  readonly flexMessage: Maybe<Scalars['String']>;
  readonly hidden: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly imageUrl: Scalars['String'];
  readonly isOutpost: Maybe<Scalars['Boolean']>;
  readonly latitude: Scalars['Float'];
  readonly longitude: Scalars['Float'];
  readonly menuId: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly notAcceptingOrdersReason: Maybe<Scalars['String']>;
  readonly oloId: Scalars['ID'];
  readonly phone: Maybe<Scalars['String']>;
  readonly pickupInstructions: Maybe<Scalars['String']>;
  readonly regionId: Maybe<Scalars['ID']>;
  readonly showWarningDialog: Scalars['Boolean'];
  readonly slug: Scalars['String'];
  readonly state: Scalars['String'];
  readonly storeHours: Maybe<Scalars['String']>;
  readonly warningDialogDescription: Maybe<Scalars['String']>;
  readonly warningDialogTimeout: Maybe<Scalars['Float']>;
  readonly warningDialogTitle: Maybe<Scalars['String']>;
  readonly zipCode: Scalars['String'];
};

export type SubmitBraintreeBillingAccountInput = {
  /** Whether or not to make this credit card the default payment method. */
  readonly isDefault: Scalars['Boolean'];
  /** Optional nickname for this credit card. */
  readonly nickname?: InputMaybe<Scalars['String']>;
  /** Nonce generated by Braintree. */
  readonly nonce: Scalars['String'];
};

export type SubmitBraintreeBillingAccountResponseUnion =
  | InvalidPostalCode
  | InvalidSubmittedBillingAccount
  | SubmitBraintreeBillingAccountSuccessResponse
  | TooManyRequests;

export type SubmitBraintreeBillingAccountSuccessResponse = {
  readonly __typename?: 'SubmitBraintreeBillingAccountSuccessResponse';
  readonly billingAccount: BillingAccount;
};

export type SubmitGiftCardCodeSuccess = {
  readonly __typename?: 'SubmitGiftCardCodeSuccess';
  /** Total credit after applying gift card */
  readonly totalCredit: Scalars['Float'];
};

export type SubmitOrderUsingBillingAccountInput = {
  /** Customer's saved LevelUp billing account */
  readonly billingAccountId: Scalars['ID'];
  /** Shortcut for updating the customer's contact number */
  readonly contactNumber?: InputMaybe<Scalars['String']>;
  readonly deliveryOrderDetail?: InputMaybe<DeliveryOrderDetailInput>;
  /** Selected from restaurant.availableDropoffLocations, if it exists */
  readonly dropoffLocationId?: InputMaybe<Scalars['ID']>;
  readonly includeUtensils?: InputMaybe<Scalars['Boolean']>;
  readonly orderId: Scalars['ID'];
  /** Whether or not to apply the customer's available credit towards the transaction */
  readonly useCredit: Scalars['Boolean'];
  /** The time at which the customer expects to receive their order, selected from order.availableWantedTimes */
  readonly wantedTime: Scalars['String'];
};

export type SubmitOrderUsingBillingAccountResponseUnion =
  | DeliveryAlreadyInFlight
  | DeliverySpecifyAddress
  | InvalidBillingAccount
  | InvalidCustomerPhone
  | MinimumDeliverySubtotalNotMet
  | ProductUnavailable
  | RestaurantIsNotAcceptingOrders
  | RewardNotValidated
  | SubmitOrderUsingBillingAccountSuccess
  | TimeslotUnavailable
  | ValidationError;

export type SubmitOrderUsingBillingAccountSuccess = {
  readonly __typename?: 'SubmitOrderUsingBillingAccountSuccess';
  readonly customer: Customer;
  readonly order: Order;
};

export type SubmitOrderWithPaymentMethodInput = {
  readonly includeUtensils?: InputMaybe<Scalars['Boolean']>;
  readonly orderId: Scalars['ID'];
  /** the order type to be submitted, ie: pickup */
  readonly orderType: Scalars['String'];
  /** the order payment method, ie: prepaid or cash */
  readonly paymentMethod: PaymentMethods;
  /** The time at which the customer expects to receive their order, selected from order.availableWantedTimes */
  readonly wantedTime: Scalars['String'];
};

export type SubmitOrderWithPaymentMethodResponseUnion =
  | MinimumDeliverySubtotalNotMet
  | SubmitOrderWithPaymentMethodSuccess
  | TimeslotUnavailable
  | ValidationError;

export type SubmitOrderWithPaymentMethodSuccess = {
  readonly __typename?: 'SubmitOrderWithPaymentMethodSuccess';
  readonly order: Order;
};

export type SubmitPromoCodeInput = {
  /** LevelUp gift card code. */
  readonly code: Scalars['String'];
};

export type SubmitPromoCodeOrGiftCardResponseUnion =
  | InvalidPromoCode
  | SubmitGiftCardCodeSuccess
  | SubmitPromoCodeSuccessV2
  | ValidationError;

export type SubmitPromoCodeResponseUnion =
  | InvalidPromoCode
  | SubmitPromoCodeSuccess
  | ValidationError;

export type SubmitPromoCodeSuccess = {
  readonly __typename?: 'SubmitPromoCodeSuccess';
  /** LevelUp loyalty id associated with promo code. */
  readonly loyaltyId: Scalars['Float'];
};

export type SubmitPromoCodeSuccessV2 = {
  readonly __typename?: 'SubmitPromoCodeSuccessV2';
  /** Placeholder value that always returns true. Use `__typename` to identify success */
  readonly placeholder: Scalars['Boolean'];
};

export type SubmitPromoOrGiftCardCodeInput = {
  /** Promotion or gift card code */
  readonly code: Scalars['String'];
};

/** Error when a user is trying to rejoin a subscription that is already canceled */
export type SubscriptionCannotBeReactivatedError = UserError & {
  readonly __typename?: 'SubscriptionCannotBeReactivatedError';
  readonly errorMessage: Scalars['String'];
};

export type SubscriptionCreditCard = {
  readonly __typename?: 'SubscriptionCreditCard';
  readonly cardType: BraintreeCardType;
  readonly expirationMonth: Maybe<Scalars['String']>;
  readonly expirationYear: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly isActive: Scalars['Boolean'];
  readonly lastFour: Scalars['String'];
};

/** Customer Subscription Plan */
export type SubscriptionPlan = {
  readonly __typename?: 'SubscriptionPlan';
  /** The value that specifies the day of the month that the Braintree gateway will charge the subscription each billing cycle */
  readonly billingDayOfMonth: Scalars['String'];
  /** Specifies the billing interval of the plan in months */
  readonly billingFrequency: Scalars['String'];
  /** The date/time the plan was created in UTC format */
  readonly createdAt: Scalars['String'];
  /** The currency for the transaction */
  readonly currencyIsoCode: Scalars['String'];
  /** The description of the plan */
  readonly description: Maybe<Scalars['String']>;
  /** The plan identifier */
  readonly discounts: Maybe<ReadonlyArray<Discount>>;
  /** The plan identifier */
  readonly id: Scalars['String'];
  /** The name of the plan */
  readonly name: Scalars['String'];
  /** The base price for the plan */
  readonly price: Scalars['String'];
};

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Expired = 'EXPIRED',
  PastDue = 'PAST_DUE',
  Pending = 'PENDING',
}

export type SubscriptionTransactions = {
  readonly __typename?: 'SubscriptionTransactions';
  readonly amount: Scalars['String'];
  readonly creditCard: SubscriptionCreditCard;
  readonly date: Scalars['DateTime'];
  readonly id: Scalars['ID'];
  readonly refund: Scalars['Boolean'];
};

/** Loyalty Tier */
export type Tier = {
  readonly __typename?: 'Tier';
  /** Loyalty Tier Display Name */
  readonly displayName: Scalars['String'];
  /** Tier ID */
  readonly id: Scalars['ID'];
  /** Loyalty Tier Name */
  readonly name: TierName;
  /** Next tier */
  readonly nextTier: Maybe<Tier>;
  /** Tier Group */
  readonly tierGroup: TierGroup;
};

/** Tier Group */
export type TierGroup = {
  readonly __typename?: 'TierGroup';
  /** Tier Group ID */
  readonly id: Scalars['ID'];
  /** Tier Group Name */
  readonly name: Scalars['ID'];
};

export enum TierName {
  OptedOut = 'OPTED_OUT',
  Sweetpass = 'SWEETPASS',
  SweetpassPlus = 'SWEETPASS_PLUS',
}

/** Loyalty Tier */
export type TierStatus = {
  readonly __typename?: 'TierStatus';
  /** Tier ID */
  readonly id: Scalars['ID'];
  /** Tier Status Name */
  readonly name: TierStatusName;
};

export enum TierStatusName {
  Active = 'ACTIVE',
  CancellationPending = 'CANCELLATION_PENDING',
  Processing = 'PROCESSING',
}

export type TimeslotUnavailable = UserError & {
  readonly __typename?: 'TimeslotUnavailable';
  readonly errorMessage: Scalars['String'];
  readonly message: Scalars['String'];
  readonly status: Scalars['Int'];
};

export type TooManyRequests = UserError & {
  readonly __typename?: 'TooManyRequests';
  readonly errorMessage: Scalars['String'];
};

/** Generic user error */
export type UnknownUserError = UserError & {
  readonly __typename?: 'UnknownUserError';
  readonly errorMessage: Scalars['String'];
};

export type UpdateAddressResponseUnion =
  | InvalidAddress
  | UpdateAddressSuccess
  | ValidationError;

export type UpdateAddressSuccess = {
  readonly __typename?: 'UpdateAddressSuccess';
  readonly address: Address;
};

export type UpdateBillingAccountInput = {
  /** Billing account id. */
  readonly id: Scalars['Float'];
  /** Whether or not to make this credit card the default payment method. */
  readonly isDefault: Scalars['Boolean'];
  /** Optional nickname for this credit card. */
  readonly nickname?: InputMaybe<Scalars['String']>;
};

export type UpdateBillingAccountResponse = {
  readonly __typename?: 'UpdateBillingAccountResponse';
  readonly billingAccount: BillingAccount;
};

export type UpdateCustomerInput = {
  readonly birthday?: InputMaybe<Scalars['String']>;
  readonly contactNumber?: InputMaybe<Scalars['String']>;
  readonly firstName?: InputMaybe<Scalars['String']>;
  readonly lastName?: InputMaybe<Scalars['String']>;
  readonly password?: InputMaybe<Scalars['String']>;
};

export type UpdateCustomerResponse = {
  readonly __typename?: 'UpdateCustomerResponse';
  readonly customer: Customer;
};

export type UpdateKioskCustomerInput = {
  readonly contactNumber?: InputMaybe<Scalars['String']>;
  readonly email?: InputMaybe<Scalars['String']>;
  readonly firstName?: InputMaybe<Scalars['String']>;
  readonly lastName?: InputMaybe<Scalars['String']>;
};

export type UpdateKioskCustomerResponse = {
  readonly __typename?: 'UpdateKioskCustomerResponse';
  readonly customer: Customer;
};

export type UpdateSubscriptionPaymentMethodSuccessResponse = {
  readonly __typename?: 'UpdateSubscriptionPaymentMethodSuccessResponse';
  /** Updated Subscription */
  readonly subscription: PaymentSubscription;
};

export type UpdateUseCreditResponse = {
  readonly __typename?: 'UpdateUseCreditResponse';
  readonly customer: Customer;
};

export type UserError = {
  readonly errorMessage: Scalars['String'];
};

export enum ValidateRewardFailureCode {
  LoyaltyNotProcessed = 'LOYALTY_NOT_PROCESSED',
  LoyaltyProgramUnavailable = 'LOYALTY_PROGRAM_UNAVAILABLE',
  RewardExpired = 'REWARD_EXPIRED',
  RewardNotApplicable = 'REWARD_NOT_APPLICABLE',
}

export type ValidationError = {
  readonly __typename?: 'ValidationError';
  readonly fieldErrors: ReadonlyArray<FieldValidationError>;
  readonly message: Scalars['String'];
  readonly status: Scalars['Int'];
};

export type Vendor = {
  readonly __typename?: 'Vendor';
  readonly name: Scalars['String'];
  readonly restaurantId: Scalars['String'];
};

export type VerifyRegistrationInput = {
  readonly code: Scalars['String'];
  readonly email: Scalars['String'];
};

export type VerifyRegistrationSuccess = {
  readonly __typename?: 'VerifyRegistrationSuccess';
  readonly csrf: Scalars['String'];
  readonly customer: Customer;
};

export type VerifyRegistrationUnion =
  | InvalidRegistrationCode
  | ValidationError
  | VerifyRegistrationSuccess;

export type CustomerNameQueryVariables = Exact<{ [key: string]: never }>;

export type CustomerNameQuery = {
  readonly __typename?: 'Query';
  readonly currentCustomer: {
    readonly __typename?: 'Customer';
    readonly id: string;
    readonly firstName: string | null;
  } | null;
};

export type AddAddressMutationVariables = Exact<{
  input: AddAddressInput;
}>;

export type AddAddressMutation = {
  readonly __typename?: 'Mutation';
  readonly addAddress:
    | {
        readonly __typename: 'AddAddressSuccess';
        readonly address: {
          readonly __typename?: 'Address';
          readonly id: string;
          readonly street: string;
          readonly secondaryStreet: string | null;
          readonly name: string | null;
          readonly city: string;
          readonly state: string;
          readonly zipCode: string;
          readonly country: string;
          readonly deliveryPreference: DeliveryPreferenceType;
          readonly googlePlaceId: string;
          readonly latitude: number;
          readonly longitude: number;
          readonly notes: string | null;
        };
      }
    | {
        readonly __typename: 'InvalidAddress';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export type UpdateAddressMutationVariables = Exact<{
  input: EditAddressInput;
}>;

export type UpdateAddressMutation = {
  readonly __typename?: 'Mutation';
  readonly updateAddress:
    | {
        readonly __typename: 'InvalidAddress';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'UpdateAddressSuccess';
        readonly address: {
          readonly __typename?: 'Address';
          readonly id: string;
          readonly street: string;
          readonly secondaryStreet: string | null;
          readonly name: string | null;
          readonly city: string;
          readonly state: string;
          readonly zipCode: string;
          readonly country: string;
          readonly deliveryPreference: DeliveryPreferenceType;
          readonly googlePlaceId: string;
          readonly latitude: number;
          readonly longitude: number;
          readonly notes: string | null;
        };
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export type DeleteAddressMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteAddressMutation = {
  readonly __typename?: 'Mutation';
  readonly deleteAddress:
    | { readonly __typename: 'DeleteAddressSuccess'; readonly success: boolean }
    | {
        readonly __typename: 'InvalidAddress';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export type CartLedgerFragment = {
  readonly __typename?: 'Ledger';
  readonly tax: number;
  readonly subtotal: number;
  readonly feesTotal: number;
  readonly discountsTotal: number;
  readonly creditsTotal: number;
  readonly tip: number;
  readonly discounts: ReadonlyArray<{
    readonly __typename?: 'LedgerItem';
    readonly name: string;
    readonly amount: number;
    readonly description: string | null;
  }>;
  readonly credits: ReadonlyArray<{
    readonly __typename?: 'LedgerItem';
    readonly name: string;
    readonly amount: number;
    readonly description: string | null;
  }>;
  readonly fees: ReadonlyArray<{
    readonly __typename?: 'LedgerItem';
    readonly name: string;
    readonly amount: number;
    readonly description: string | null;
  }>;
};

export type CartLineItemFragment = {
  readonly __typename?: 'LineItem';
  readonly id: string;
  readonly slug: string;
  readonly quantity: number;
  readonly cost: number;
  readonly customName: string | null;
  readonly perItemCost: number;
  readonly favorited: boolean;
  readonly isCustom: boolean;
  readonly dressingMode: DressingMode;
  readonly addedIngredients: ReadonlyArray<{
    readonly __typename?: 'Ingredient';
    readonly id: string;
    readonly name: string;
    readonly kind: IngredientKind | null;
    readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
  }>;
  readonly removedIngredients: ReadonlyArray<{
    readonly __typename?: 'Ingredient';
    readonly id: string;
    readonly name: string;
    readonly kind: IngredientKind | null;
    readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
  }>;
  readonly product: {
    readonly __typename?: 'Product';
    readonly id: string;
    readonly name: string;
    readonly slug: string;
    readonly isCustom: boolean;
    readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
    readonly ingredients: ReadonlyArray<{
      readonly __typename?: 'Ingredient';
      readonly id: string;
      readonly name: string;
      readonly kind: IngredientKind | null;
    }>;
  };
  readonly mixedDressingDetails: ReadonlyArray<{
    readonly __typename?: 'MixedDressingDetails';
    readonly ingredientId: string;
    readonly weight: DressingWeight;
  }>;
};

export type CartRestaurantFragment = {
  readonly __typename?: 'Restaurant';
  readonly id: string;
  readonly slug: string;
  readonly name: string;
  readonly city: string;
  readonly state: string;
  readonly address: string;
  readonly zipCode: string;
  readonly isOutpost: boolean;
  readonly deliveryMinSubtotal: number;
  readonly availableDropOffLocations: ReadonlyArray<{
    readonly __typename?: 'DropOffLocation';
    readonly id: string;
    readonly name: string;
  }>;
  readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
};

export type AvailableWantedTimeFragment = {
  readonly __typename?: 'AvailableWantedTime';
  readonly time: string;
};

export type DeliveryOrderDetailFragment = {
  readonly __typename?: 'DeliveryOrderDetail';
  readonly id: string;
  readonly tip: number;
  readonly deliveryFee: number;
  readonly vendor: string;
  readonly orderId: string;
  readonly vendorRestaurantId: string;
  readonly estimatedDeliveryTime: string | null;
  readonly address: {
    readonly __typename?: 'Address';
    readonly id: string;
    readonly street: string;
    readonly secondaryStreet: string | null;
    readonly city: string;
    readonly state: string;
    readonly country: string;
    readonly zipCode: string;
    readonly deliveryPreference: DeliveryPreferenceType;
    readonly googlePlaceId: string;
    readonly latitude: number;
    readonly longitude: number;
    readonly name: string | null;
    readonly notes: string | null;
  };
};

export type CartDataFragment = {
  readonly __typename?: 'Order';
  readonly id: string;
  readonly orderType: OrderType;
  readonly ledger: {
    readonly __typename?: 'Ledger';
    readonly tax: number;
    readonly subtotal: number;
    readonly feesTotal: number;
    readonly discountsTotal: number;
    readonly creditsTotal: number;
    readonly tip: number;
    readonly discounts: ReadonlyArray<{
      readonly __typename?: 'LedgerItem';
      readonly name: string;
      readonly amount: number;
      readonly description: string | null;
    }>;
    readonly credits: ReadonlyArray<{
      readonly __typename?: 'LedgerItem';
      readonly name: string;
      readonly amount: number;
      readonly description: string | null;
    }>;
    readonly fees: ReadonlyArray<{
      readonly __typename?: 'LedgerItem';
      readonly name: string;
      readonly amount: number;
      readonly description: string | null;
    }>;
  };
  readonly lineItems: ReadonlyArray<{
    readonly __typename?: 'LineItem';
    readonly id: string;
    readonly slug: string;
    readonly quantity: number;
    readonly cost: number;
    readonly customName: string | null;
    readonly perItemCost: number;
    readonly favorited: boolean;
    readonly isCustom: boolean;
    readonly dressingMode: DressingMode;
    readonly addedIngredients: ReadonlyArray<{
      readonly __typename?: 'Ingredient';
      readonly id: string;
      readonly name: string;
      readonly kind: IngredientKind | null;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
    }>;
    readonly removedIngredients: ReadonlyArray<{
      readonly __typename?: 'Ingredient';
      readonly id: string;
      readonly name: string;
      readonly kind: IngredientKind | null;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
    }>;
    readonly product: {
      readonly __typename?: 'Product';
      readonly id: string;
      readonly name: string;
      readonly slug: string;
      readonly isCustom: boolean;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      readonly ingredients: ReadonlyArray<{
        readonly __typename?: 'Ingredient';
        readonly id: string;
        readonly name: string;
        readonly kind: IngredientKind | null;
      }>;
    };
    readonly mixedDressingDetails: ReadonlyArray<{
      readonly __typename?: 'MixedDressingDetails';
      readonly ingredientId: string;
      readonly weight: DressingWeight;
    }>;
  }>;
  readonly restaurant: {
    readonly __typename?: 'Restaurant';
    readonly id: string;
    readonly slug: string;
    readonly name: string;
    readonly city: string;
    readonly state: string;
    readonly address: string;
    readonly zipCode: string;
    readonly isOutpost: boolean;
    readonly deliveryMinSubtotal: number;
    readonly availableDropOffLocations: ReadonlyArray<{
      readonly __typename?: 'DropOffLocation';
      readonly id: string;
      readonly name: string;
    }>;
    readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
  };
  readonly availableWantedTimes: ReadonlyArray<{
    readonly __typename?: 'AvailableWantedTime';
    readonly time: string;
  }>;
  readonly deliveryOrderDetail: {
    readonly __typename?: 'DeliveryOrderDetail';
    readonly id: string;
    readonly tip: number;
    readonly deliveryFee: number;
    readonly vendor: string;
    readonly orderId: string;
    readonly vendorRestaurantId: string;
    readonly estimatedDeliveryTime: string | null;
    readonly address: {
      readonly __typename?: 'Address';
      readonly id: string;
      readonly street: string;
      readonly secondaryStreet: string | null;
      readonly city: string;
      readonly state: string;
      readonly country: string;
      readonly zipCode: string;
      readonly deliveryPreference: DeliveryPreferenceType;
      readonly googlePlaceId: string;
      readonly latitude: number;
      readonly longitude: number;
      readonly name: string | null;
      readonly notes: string | null;
    };
  } | null;
};

export type CartQueryVariables = Exact<{ [key: string]: never }>;

export type CartQuery = {
  readonly __typename?: 'Query';
  readonly cart: {
    readonly __typename?: 'Order';
    readonly id: string;
    readonly orderType: OrderType;
    readonly ledger: {
      readonly __typename?: 'Ledger';
      readonly tax: number;
      readonly subtotal: number;
      readonly feesTotal: number;
      readonly discountsTotal: number;
      readonly creditsTotal: number;
      readonly tip: number;
      readonly discounts: ReadonlyArray<{
        readonly __typename?: 'LedgerItem';
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
      readonly credits: ReadonlyArray<{
        readonly __typename?: 'LedgerItem';
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
      readonly fees: ReadonlyArray<{
        readonly __typename?: 'LedgerItem';
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
    };
    readonly lineItems: ReadonlyArray<{
      readonly __typename?: 'LineItem';
      readonly id: string;
      readonly slug: string;
      readonly quantity: number;
      readonly cost: number;
      readonly customName: string | null;
      readonly perItemCost: number;
      readonly favorited: boolean;
      readonly isCustom: boolean;
      readonly dressingMode: DressingMode;
      readonly addedIngredients: ReadonlyArray<{
        readonly __typename?: 'Ingredient';
        readonly id: string;
        readonly name: string;
        readonly kind: IngredientKind | null;
        readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      }>;
      readonly removedIngredients: ReadonlyArray<{
        readonly __typename?: 'Ingredient';
        readonly id: string;
        readonly name: string;
        readonly kind: IngredientKind | null;
        readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      }>;
      readonly product: {
        readonly __typename?: 'Product';
        readonly id: string;
        readonly name: string;
        readonly slug: string;
        readonly isCustom: boolean;
        readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
        readonly ingredients: ReadonlyArray<{
          readonly __typename?: 'Ingredient';
          readonly id: string;
          readonly name: string;
          readonly kind: IngredientKind | null;
        }>;
      };
      readonly mixedDressingDetails: ReadonlyArray<{
        readonly __typename?: 'MixedDressingDetails';
        readonly ingredientId: string;
        readonly weight: DressingWeight;
      }>;
    }>;
    readonly restaurant: {
      readonly __typename?: 'Restaurant';
      readonly id: string;
      readonly slug: string;
      readonly name: string;
      readonly city: string;
      readonly state: string;
      readonly address: string;
      readonly zipCode: string;
      readonly isOutpost: boolean;
      readonly deliveryMinSubtotal: number;
      readonly availableDropOffLocations: ReadonlyArray<{
        readonly __typename?: 'DropOffLocation';
        readonly id: string;
        readonly name: string;
      }>;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
    };
    readonly availableWantedTimes: ReadonlyArray<{
      readonly __typename?: 'AvailableWantedTime';
      readonly time: string;
    }>;
    readonly deliveryOrderDetail: {
      readonly __typename?: 'DeliveryOrderDetail';
      readonly id: string;
      readonly tip: number;
      readonly deliveryFee: number;
      readonly vendor: string;
      readonly orderId: string;
      readonly vendorRestaurantId: string;
      readonly estimatedDeliveryTime: string | null;
      readonly address: {
        readonly __typename?: 'Address';
        readonly id: string;
        readonly street: string;
        readonly secondaryStreet: string | null;
        readonly city: string;
        readonly state: string;
        readonly country: string;
        readonly zipCode: string;
        readonly deliveryPreference: DeliveryPreferenceType;
        readonly googlePlaceId: string;
        readonly latitude: number;
        readonly longitude: number;
        readonly name: string | null;
        readonly notes: string | null;
      };
    } | null;
  } | null;
};

export type AddLineItemToCartSuccessFieldsFragment = {
  readonly __typename?: 'AddLineItemToCartSuccess';
  readonly cart: {
    readonly __typename?: 'Order';
    readonly id: string;
    readonly orderType: OrderType;
    readonly ledger: {
      readonly __typename?: 'Ledger';
      readonly tax: number;
      readonly subtotal: number;
      readonly feesTotal: number;
      readonly discountsTotal: number;
      readonly creditsTotal: number;
      readonly tip: number;
      readonly discounts: ReadonlyArray<{
        readonly __typename?: 'LedgerItem';
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
      readonly credits: ReadonlyArray<{
        readonly __typename?: 'LedgerItem';
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
      readonly fees: ReadonlyArray<{
        readonly __typename?: 'LedgerItem';
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
    };
    readonly lineItems: ReadonlyArray<{
      readonly __typename?: 'LineItem';
      readonly id: string;
      readonly slug: string;
      readonly quantity: number;
      readonly cost: number;
      readonly customName: string | null;
      readonly perItemCost: number;
      readonly favorited: boolean;
      readonly isCustom: boolean;
      readonly dressingMode: DressingMode;
      readonly addedIngredients: ReadonlyArray<{
        readonly __typename?: 'Ingredient';
        readonly id: string;
        readonly name: string;
        readonly kind: IngredientKind | null;
        readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      }>;
      readonly removedIngredients: ReadonlyArray<{
        readonly __typename?: 'Ingredient';
        readonly id: string;
        readonly name: string;
        readonly kind: IngredientKind | null;
        readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      }>;
      readonly product: {
        readonly __typename?: 'Product';
        readonly id: string;
        readonly name: string;
        readonly slug: string;
        readonly isCustom: boolean;
        readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
        readonly ingredients: ReadonlyArray<{
          readonly __typename?: 'Ingredient';
          readonly id: string;
          readonly name: string;
          readonly kind: IngredientKind | null;
        }>;
      };
      readonly mixedDressingDetails: ReadonlyArray<{
        readonly __typename?: 'MixedDressingDetails';
        readonly ingredientId: string;
        readonly weight: DressingWeight;
      }>;
    }>;
    readonly restaurant: {
      readonly __typename?: 'Restaurant';
      readonly id: string;
      readonly slug: string;
      readonly name: string;
      readonly city: string;
      readonly state: string;
      readonly address: string;
      readonly zipCode: string;
      readonly isOutpost: boolean;
      readonly deliveryMinSubtotal: number;
      readonly availableDropOffLocations: ReadonlyArray<{
        readonly __typename?: 'DropOffLocation';
        readonly id: string;
        readonly name: string;
      }>;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
    };
    readonly availableWantedTimes: ReadonlyArray<{
      readonly __typename?: 'AvailableWantedTime';
      readonly time: string;
    }>;
    readonly deliveryOrderDetail: {
      readonly __typename?: 'DeliveryOrderDetail';
      readonly id: string;
      readonly tip: number;
      readonly deliveryFee: number;
      readonly vendor: string;
      readonly orderId: string;
      readonly vendorRestaurantId: string;
      readonly estimatedDeliveryTime: string | null;
      readonly address: {
        readonly __typename?: 'Address';
        readonly id: string;
        readonly street: string;
        readonly secondaryStreet: string | null;
        readonly city: string;
        readonly state: string;
        readonly country: string;
        readonly zipCode: string;
        readonly deliveryPreference: DeliveryPreferenceType;
        readonly googlePlaceId: string;
        readonly latitude: number;
        readonly longitude: number;
        readonly name: string | null;
        readonly notes: string | null;
      };
    } | null;
  };
};

export type EditLineItemInCartSuccessFieldsFragment = {
  readonly __typename?: 'EditLineItemInCartSuccess';
  readonly cart: {
    readonly __typename?: 'Order';
    readonly id: string;
    readonly orderType: OrderType;
    readonly ledger: {
      readonly __typename?: 'Ledger';
      readonly tax: number;
      readonly subtotal: number;
      readonly feesTotal: number;
      readonly discountsTotal: number;
      readonly creditsTotal: number;
      readonly tip: number;
      readonly discounts: ReadonlyArray<{
        readonly __typename?: 'LedgerItem';
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
      readonly credits: ReadonlyArray<{
        readonly __typename?: 'LedgerItem';
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
      readonly fees: ReadonlyArray<{
        readonly __typename?: 'LedgerItem';
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
    };
    readonly lineItems: ReadonlyArray<{
      readonly __typename?: 'LineItem';
      readonly id: string;
      readonly slug: string;
      readonly quantity: number;
      readonly cost: number;
      readonly customName: string | null;
      readonly perItemCost: number;
      readonly favorited: boolean;
      readonly isCustom: boolean;
      readonly dressingMode: DressingMode;
      readonly addedIngredients: ReadonlyArray<{
        readonly __typename?: 'Ingredient';
        readonly id: string;
        readonly name: string;
        readonly kind: IngredientKind | null;
        readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      }>;
      readonly removedIngredients: ReadonlyArray<{
        readonly __typename?: 'Ingredient';
        readonly id: string;
        readonly name: string;
        readonly kind: IngredientKind | null;
        readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      }>;
      readonly product: {
        readonly __typename?: 'Product';
        readonly id: string;
        readonly name: string;
        readonly slug: string;
        readonly isCustom: boolean;
        readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
        readonly ingredients: ReadonlyArray<{
          readonly __typename?: 'Ingredient';
          readonly id: string;
          readonly name: string;
          readonly kind: IngredientKind | null;
        }>;
      };
      readonly mixedDressingDetails: ReadonlyArray<{
        readonly __typename?: 'MixedDressingDetails';
        readonly ingredientId: string;
        readonly weight: DressingWeight;
      }>;
    }>;
    readonly restaurant: {
      readonly __typename?: 'Restaurant';
      readonly id: string;
      readonly slug: string;
      readonly name: string;
      readonly city: string;
      readonly state: string;
      readonly address: string;
      readonly zipCode: string;
      readonly isOutpost: boolean;
      readonly deliveryMinSubtotal: number;
      readonly availableDropOffLocations: ReadonlyArray<{
        readonly __typename?: 'DropOffLocation';
        readonly id: string;
        readonly name: string;
      }>;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
    };
    readonly availableWantedTimes: ReadonlyArray<{
      readonly __typename?: 'AvailableWantedTime';
      readonly time: string;
    }>;
    readonly deliveryOrderDetail: {
      readonly __typename?: 'DeliveryOrderDetail';
      readonly id: string;
      readonly tip: number;
      readonly deliveryFee: number;
      readonly vendor: string;
      readonly orderId: string;
      readonly vendorRestaurantId: string;
      readonly estimatedDeliveryTime: string | null;
      readonly address: {
        readonly __typename?: 'Address';
        readonly id: string;
        readonly street: string;
        readonly secondaryStreet: string | null;
        readonly city: string;
        readonly state: string;
        readonly country: string;
        readonly zipCode: string;
        readonly deliveryPreference: DeliveryPreferenceType;
        readonly googlePlaceId: string;
        readonly latitude: number;
        readonly longitude: number;
        readonly name: string | null;
        readonly notes: string | null;
      };
    } | null;
  };
};

export type RemoveFromCartSuccessFieldsFragment = {
  readonly __typename?: 'RemoveFromCartSuccess';
  readonly cart: {
    readonly __typename?: 'Order';
    readonly id: string;
    readonly orderType: OrderType;
    readonly ledger: {
      readonly __typename?: 'Ledger';
      readonly tax: number;
      readonly subtotal: number;
      readonly feesTotal: number;
      readonly discountsTotal: number;
      readonly creditsTotal: number;
      readonly tip: number;
      readonly discounts: ReadonlyArray<{
        readonly __typename?: 'LedgerItem';
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
      readonly credits: ReadonlyArray<{
        readonly __typename?: 'LedgerItem';
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
      readonly fees: ReadonlyArray<{
        readonly __typename?: 'LedgerItem';
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
    };
    readonly lineItems: ReadonlyArray<{
      readonly __typename?: 'LineItem';
      readonly id: string;
      readonly slug: string;
      readonly quantity: number;
      readonly cost: number;
      readonly customName: string | null;
      readonly perItemCost: number;
      readonly favorited: boolean;
      readonly isCustom: boolean;
      readonly dressingMode: DressingMode;
      readonly addedIngredients: ReadonlyArray<{
        readonly __typename?: 'Ingredient';
        readonly id: string;
        readonly name: string;
        readonly kind: IngredientKind | null;
        readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      }>;
      readonly removedIngredients: ReadonlyArray<{
        readonly __typename?: 'Ingredient';
        readonly id: string;
        readonly name: string;
        readonly kind: IngredientKind | null;
        readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      }>;
      readonly product: {
        readonly __typename?: 'Product';
        readonly id: string;
        readonly name: string;
        readonly slug: string;
        readonly isCustom: boolean;
        readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
        readonly ingredients: ReadonlyArray<{
          readonly __typename?: 'Ingredient';
          readonly id: string;
          readonly name: string;
          readonly kind: IngredientKind | null;
        }>;
      };
      readonly mixedDressingDetails: ReadonlyArray<{
        readonly __typename?: 'MixedDressingDetails';
        readonly ingredientId: string;
        readonly weight: DressingWeight;
      }>;
    }>;
    readonly restaurant: {
      readonly __typename?: 'Restaurant';
      readonly id: string;
      readonly slug: string;
      readonly name: string;
      readonly city: string;
      readonly state: string;
      readonly address: string;
      readonly zipCode: string;
      readonly isOutpost: boolean;
      readonly deliveryMinSubtotal: number;
      readonly availableDropOffLocations: ReadonlyArray<{
        readonly __typename?: 'DropOffLocation';
        readonly id: string;
        readonly name: string;
      }>;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
    };
    readonly availableWantedTimes: ReadonlyArray<{
      readonly __typename?: 'AvailableWantedTime';
      readonly time: string;
    }>;
    readonly deliveryOrderDetail: {
      readonly __typename?: 'DeliveryOrderDetail';
      readonly id: string;
      readonly tip: number;
      readonly deliveryFee: number;
      readonly vendor: string;
      readonly orderId: string;
      readonly vendorRestaurantId: string;
      readonly estimatedDeliveryTime: string | null;
      readonly address: {
        readonly __typename?: 'Address';
        readonly id: string;
        readonly street: string;
        readonly secondaryStreet: string | null;
        readonly city: string;
        readonly state: string;
        readonly country: string;
        readonly zipCode: string;
        readonly deliveryPreference: DeliveryPreferenceType;
        readonly googlePlaceId: string;
        readonly latitude: number;
        readonly longitude: number;
        readonly name: string | null;
        readonly notes: string | null;
      };
    } | null;
  };
};

export type RestaurantMaxQuantityExceededFieldsFragment = {
  readonly __typename?: 'RestaurantMaxQuantityExceeded';
  readonly message: string;
  readonly status: number;
};

export type MaxModificationsExceededFieldsFragment = {
  readonly __typename?: 'MaxModificationsExceeded';
  readonly message: string;
  readonly status: number;
};

export type RestaurantMaxDeliveryQuantityExceededFieldsFragment = {
  readonly __typename?: 'RestaurantMaxDeliveryQuantityExceeded';
  readonly message: string;
  readonly status: number;
};

export type AddLineItemToCartMutationVariables = Exact<{
  input: AddLineItemToCartInput;
}>;

export type AddLineItemToCartMutation = {
  readonly __typename?: 'Mutation';
  readonly addLineItemToCart:
    | {
        readonly __typename: 'AddLineItemToCartSuccess';
        readonly cart: {
          readonly __typename?: 'Order';
          readonly id: string;
          readonly orderType: OrderType;
          readonly ledger: {
            readonly __typename?: 'Ledger';
            readonly tax: number;
            readonly subtotal: number;
            readonly feesTotal: number;
            readonly discountsTotal: number;
            readonly creditsTotal: number;
            readonly tip: number;
            readonly discounts: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly credits: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly fees: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
          };
          readonly lineItems: ReadonlyArray<{
            readonly __typename?: 'LineItem';
            readonly id: string;
            readonly slug: string;
            readonly quantity: number;
            readonly cost: number;
            readonly customName: string | null;
            readonly perItemCost: number;
            readonly favorited: boolean;
            readonly isCustom: boolean;
            readonly dressingMode: DressingMode;
            readonly addedIngredients: ReadonlyArray<{
              readonly __typename?: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: IngredientKind | null;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
            }>;
            readonly removedIngredients: ReadonlyArray<{
              readonly __typename?: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: IngredientKind | null;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
            }>;
            readonly product: {
              readonly __typename?: 'Product';
              readonly id: string;
              readonly name: string;
              readonly slug: string;
              readonly isCustom: boolean;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
              readonly ingredients: ReadonlyArray<{
                readonly __typename?: 'Ingredient';
                readonly id: string;
                readonly name: string;
                readonly kind: IngredientKind | null;
              }>;
            };
            readonly mixedDressingDetails: ReadonlyArray<{
              readonly __typename?: 'MixedDressingDetails';
              readonly ingredientId: string;
              readonly weight: DressingWeight;
            }>;
          }>;
          readonly restaurant: {
            readonly __typename?: 'Restaurant';
            readonly id: string;
            readonly slug: string;
            readonly name: string;
            readonly city: string;
            readonly state: string;
            readonly address: string;
            readonly zipCode: string;
            readonly isOutpost: boolean;
            readonly deliveryMinSubtotal: number;
            readonly availableDropOffLocations: ReadonlyArray<{
              readonly __typename?: 'DropOffLocation';
              readonly id: string;
              readonly name: string;
            }>;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
          };
          readonly availableWantedTimes: ReadonlyArray<{
            readonly __typename?: 'AvailableWantedTime';
            readonly time: string;
          }>;
          readonly deliveryOrderDetail: {
            readonly __typename?: 'DeliveryOrderDetail';
            readonly id: string;
            readonly tip: number;
            readonly deliveryFee: number;
            readonly vendor: string;
            readonly orderId: string;
            readonly vendorRestaurantId: string;
            readonly estimatedDeliveryTime: string | null;
            readonly address: {
              readonly __typename?: 'Address';
              readonly id: string;
              readonly street: string;
              readonly secondaryStreet: string | null;
              readonly city: string;
              readonly state: string;
              readonly country: string;
              readonly zipCode: string;
              readonly deliveryPreference: DeliveryPreferenceType;
              readonly googlePlaceId: string;
              readonly latitude: number;
              readonly longitude: number;
              readonly name: string | null;
              readonly notes: string | null;
            };
          } | null;
        };
      }
    | {
        readonly __typename: 'MaxModificationsExceeded';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'RestaurantMaxDeliveryQuantityExceeded';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'RestaurantMaxQuantityExceeded';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export type EditLineItemInCartMutationVariables = Exact<{
  input: EditLineItemInCartInput;
}>;

export type EditLineItemInCartMutation = {
  readonly __typename?: 'Mutation';
  readonly editLineItemInCart:
    | {
        readonly __typename: 'EditLineItemInCartSuccess';
        readonly cart: {
          readonly __typename?: 'Order';
          readonly id: string;
          readonly orderType: OrderType;
          readonly ledger: {
            readonly __typename?: 'Ledger';
            readonly tax: number;
            readonly subtotal: number;
            readonly feesTotal: number;
            readonly discountsTotal: number;
            readonly creditsTotal: number;
            readonly tip: number;
            readonly discounts: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly credits: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly fees: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
          };
          readonly lineItems: ReadonlyArray<{
            readonly __typename?: 'LineItem';
            readonly id: string;
            readonly slug: string;
            readonly quantity: number;
            readonly cost: number;
            readonly customName: string | null;
            readonly perItemCost: number;
            readonly favorited: boolean;
            readonly isCustom: boolean;
            readonly dressingMode: DressingMode;
            readonly addedIngredients: ReadonlyArray<{
              readonly __typename?: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: IngredientKind | null;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
            }>;
            readonly removedIngredients: ReadonlyArray<{
              readonly __typename?: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: IngredientKind | null;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
            }>;
            readonly product: {
              readonly __typename?: 'Product';
              readonly id: string;
              readonly name: string;
              readonly slug: string;
              readonly isCustom: boolean;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
              readonly ingredients: ReadonlyArray<{
                readonly __typename?: 'Ingredient';
                readonly id: string;
                readonly name: string;
                readonly kind: IngredientKind | null;
              }>;
            };
            readonly mixedDressingDetails: ReadonlyArray<{
              readonly __typename?: 'MixedDressingDetails';
              readonly ingredientId: string;
              readonly weight: DressingWeight;
            }>;
          }>;
          readonly restaurant: {
            readonly __typename?: 'Restaurant';
            readonly id: string;
            readonly slug: string;
            readonly name: string;
            readonly city: string;
            readonly state: string;
            readonly address: string;
            readonly zipCode: string;
            readonly isOutpost: boolean;
            readonly deliveryMinSubtotal: number;
            readonly availableDropOffLocations: ReadonlyArray<{
              readonly __typename?: 'DropOffLocation';
              readonly id: string;
              readonly name: string;
            }>;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
          };
          readonly availableWantedTimes: ReadonlyArray<{
            readonly __typename?: 'AvailableWantedTime';
            readonly time: string;
          }>;
          readonly deliveryOrderDetail: {
            readonly __typename?: 'DeliveryOrderDetail';
            readonly id: string;
            readonly tip: number;
            readonly deliveryFee: number;
            readonly vendor: string;
            readonly orderId: string;
            readonly vendorRestaurantId: string;
            readonly estimatedDeliveryTime: string | null;
            readonly address: {
              readonly __typename?: 'Address';
              readonly id: string;
              readonly street: string;
              readonly secondaryStreet: string | null;
              readonly city: string;
              readonly state: string;
              readonly country: string;
              readonly zipCode: string;
              readonly deliveryPreference: DeliveryPreferenceType;
              readonly googlePlaceId: string;
              readonly latitude: number;
              readonly longitude: number;
              readonly name: string | null;
              readonly notes: string | null;
            };
          } | null;
        };
      }
    | {
        readonly __typename: 'MaxModificationsExceeded';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'RestaurantMaxDeliveryQuantityExceeded';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'RestaurantMaxQuantityExceeded';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export type RemoveFromCartMutationVariables = Exact<{
  input: RemoveFromCartInput;
}>;

export type RemoveFromCartMutation = {
  readonly __typename?: 'Mutation';
  readonly removeFromCart:
    | {
        readonly __typename: 'RemoveFromCartSuccess';
        readonly cart: {
          readonly __typename?: 'Order';
          readonly id: string;
          readonly orderType: OrderType;
          readonly ledger: {
            readonly __typename?: 'Ledger';
            readonly tax: number;
            readonly subtotal: number;
            readonly feesTotal: number;
            readonly discountsTotal: number;
            readonly creditsTotal: number;
            readonly tip: number;
            readonly discounts: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly credits: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly fees: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
          };
          readonly lineItems: ReadonlyArray<{
            readonly __typename?: 'LineItem';
            readonly id: string;
            readonly slug: string;
            readonly quantity: number;
            readonly cost: number;
            readonly customName: string | null;
            readonly perItemCost: number;
            readonly favorited: boolean;
            readonly isCustom: boolean;
            readonly dressingMode: DressingMode;
            readonly addedIngredients: ReadonlyArray<{
              readonly __typename?: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: IngredientKind | null;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
            }>;
            readonly removedIngredients: ReadonlyArray<{
              readonly __typename?: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: IngredientKind | null;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
            }>;
            readonly product: {
              readonly __typename?: 'Product';
              readonly id: string;
              readonly name: string;
              readonly slug: string;
              readonly isCustom: boolean;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
              readonly ingredients: ReadonlyArray<{
                readonly __typename?: 'Ingredient';
                readonly id: string;
                readonly name: string;
                readonly kind: IngredientKind | null;
              }>;
            };
            readonly mixedDressingDetails: ReadonlyArray<{
              readonly __typename?: 'MixedDressingDetails';
              readonly ingredientId: string;
              readonly weight: DressingWeight;
            }>;
          }>;
          readonly restaurant: {
            readonly __typename?: 'Restaurant';
            readonly id: string;
            readonly slug: string;
            readonly name: string;
            readonly city: string;
            readonly state: string;
            readonly address: string;
            readonly zipCode: string;
            readonly isOutpost: boolean;
            readonly deliveryMinSubtotal: number;
            readonly availableDropOffLocations: ReadonlyArray<{
              readonly __typename?: 'DropOffLocation';
              readonly id: string;
              readonly name: string;
            }>;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
          };
          readonly availableWantedTimes: ReadonlyArray<{
            readonly __typename?: 'AvailableWantedTime';
            readonly time: string;
          }>;
          readonly deliveryOrderDetail: {
            readonly __typename?: 'DeliveryOrderDetail';
            readonly id: string;
            readonly tip: number;
            readonly deliveryFee: number;
            readonly vendor: string;
            readonly orderId: string;
            readonly vendorRestaurantId: string;
            readonly estimatedDeliveryTime: string | null;
            readonly address: {
              readonly __typename?: 'Address';
              readonly id: string;
              readonly street: string;
              readonly secondaryStreet: string | null;
              readonly city: string;
              readonly state: string;
              readonly country: string;
              readonly zipCode: string;
              readonly deliveryPreference: DeliveryPreferenceType;
              readonly googlePlaceId: string;
              readonly latitude: number;
              readonly longitude: number;
              readonly name: string | null;
              readonly notes: string | null;
            };
          } | null;
        };
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export type AddonsQueryVariables = Exact<{ [key: string]: never }>;

export type AddonsQuery = {
  readonly __typename?: 'Query';
  readonly addons: {
    readonly __typename?: 'Addons';
    readonly products: ReadonlyArray<{
      readonly __typename?: 'Product';
      readonly id: string;
      readonly name: string;
      readonly cost: number;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
    }>;
  };
};

export type ChallengeCelebrationQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ChallengeCelebrationQuery = {
  readonly __typename?: 'Query';
  readonly challengeCelebration: {
    readonly __typename?: 'ChallengeCelebration';
    readonly title: string | null;
    readonly celebrationCopy: string;
    readonly rewardUsageDisclaimer: string;
    readonly expirationDate: any | null;
    readonly challengesIds: ReadonlyArray<string>;
  } | null;
};

export type SubmitBraintreeBillingAccountMutationVariables = Exact<{
  input: SubmitBraintreeBillingAccountInput;
}>;

export type SubmitBraintreeBillingAccountMutation = {
  readonly __typename?: 'Mutation';
  readonly submitBraintreeBillingAccount:
    | {
        readonly __typename: 'InvalidPostalCode';
        readonly errorMessage: string;
      }
    | {
        readonly __typename: 'InvalidSubmittedBillingAccount';
        readonly errorMessage: string;
      }
    | {
        readonly __typename: 'SubmitBraintreeBillingAccountSuccessResponse';
        readonly billingAccount: {
          readonly __typename?: 'BillingAccount';
          readonly id: string;
          readonly description: string;
          readonly nickname: string | null;
          readonly isDefault: boolean;
          readonly cardType: CardType;
          readonly expirationState: ExpirationState;
        };
      }
    | { readonly __typename: 'TooManyRequests'; readonly errorMessage: string };
};

export type UpdateBillingAccountMutationVariables = Exact<{
  input: UpdateBillingAccountInput;
}>;

export type UpdateBillingAccountMutation = {
  readonly __typename?: 'Mutation';
  readonly updateBillingAccount: {
    readonly __typename?: 'UpdateBillingAccountResponse';
    readonly billingAccount: {
      readonly __typename?: 'BillingAccount';
      readonly id: string;
      readonly description: string;
      readonly nickname: string | null;
      readonly isDefault: boolean;
      readonly cardType: CardType;
      readonly expirationState: ExpirationState;
    };
  };
};

export type DeleteBillingAccountMutationVariables = Exact<{
  input: DeleteBillingAccountInput;
}>;

export type DeleteBillingAccountMutation = {
  readonly __typename?: 'Mutation';
  readonly deleteBillingAccount: {
    readonly __typename?: 'DeleteBillingAccountResponse';
    readonly success: boolean;
  };
};

export type PickupOutpostRestaurantNameQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type PickupOutpostRestaurantNameQuery = {
  readonly __typename?: 'Query';
  readonly restaurant: {
    readonly __typename?: 'Restaurant';
    readonly id: string;
    readonly name: string;
  };
};

export type ActiveCartDeliveryDetailsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ActiveCartDeliveryDetailsQuery = {
  readonly __typename?: 'Query';
  readonly cart: {
    readonly __typename?: 'Order';
    readonly id: string;
    readonly deliveryOrderDetail: {
      readonly __typename?: 'DeliveryOrderDetail';
      readonly id: string;
      readonly address: {
        readonly __typename?: 'Address';
        readonly id: string;
        readonly googlePlaceId: string;
        readonly name: string | null;
      };
    } | null;
  } | null;
};

export type AddDeliveryAddressMutationVariables = Exact<{
  input: AddAddressInput;
}>;

export type AddDeliveryAddressMutation = {
  readonly __typename?: 'Mutation';
  readonly addAddress:
    | {
        readonly __typename: 'AddAddressSuccess';
        readonly address: {
          readonly __typename?: 'Address';
          readonly id: string;
          readonly street: string;
          readonly secondaryStreet: string | null;
          readonly name: string | null;
          readonly city: string;
          readonly state: string;
          readonly zipCode: string;
          readonly country: string;
          readonly deliveryPreference: DeliveryPreferenceType;
          readonly googlePlaceId: string;
          readonly latitude: number;
          readonly longitude: number;
          readonly notes: string | null;
        };
      }
    | {
        readonly __typename: 'InvalidAddress';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export type CustomerAddressesQueryVariables = Exact<{ [key: string]: never }>;

export type CustomerAddressesQuery = {
  readonly __typename?: 'Query';
  readonly currentCustomer: {
    readonly __typename?: 'Customer';
    readonly id: string;
    readonly addresses: ReadonlyArray<{
      readonly __typename?: 'Address';
      readonly id: string;
      readonly street: string;
      readonly secondaryStreet: string | null;
      readonly city: string;
      readonly state: string;
      readonly country: string;
      readonly zipCode: string;
      readonly deliveryPreference: DeliveryPreferenceType;
      readonly googlePlaceId: string;
      readonly latitude: number;
      readonly longitude: number;
      readonly name: string | null;
      readonly notes: string | null;
    }>;
  } | null;
};

export type DeliveryLocationByAddressQueryVariables = Exact<{
  input: LocationByAddressInput;
}>;

export type DeliveryLocationByAddressQuery = {
  readonly __typename?: 'Query';
  readonly locationByAddress:
    | { readonly __typename: 'InvalidInput' }
    | {
        readonly __typename: 'Location';
        readonly status: LocationStatus;
        readonly restaurant: {
          readonly __typename?: 'Restaurant';
          readonly id: string;
          readonly name: string;
          readonly slug: string;
          readonly phone: string;
          readonly flexMessage: string | null;
          readonly deliveryFee: number;
        };
        readonly estimateRange: {
          readonly __typename?: 'EstimateRange';
          readonly start: number;
          readonly end: number;
        };
        readonly vendor: {
          readonly __typename?: 'Vendor';
          readonly name: string;
          readonly restaurantId: string;
        };
      }
    | { readonly __typename: 'NoValidRestaurants' }
    | { readonly __typename: 'ValidationError' };
};

export type LastPlacedOrderDeliveryDetailsQueryVariables = Exact<{
  input: OrdersInput;
}>;

export type LastPlacedOrderDeliveryDetailsQuery = {
  readonly __typename?: 'Query';
  readonly orders:
    | {
        readonly __typename: 'OrdersResponseSuccess';
        readonly orders: ReadonlyArray<{
          readonly __typename?: 'Order';
          readonly id: string;
          readonly deliveryOrderDetail: {
            readonly __typename?: 'DeliveryOrderDetail';
            readonly id: string;
            readonly address: {
              readonly __typename?: 'Address';
              readonly id: string;
              readonly googlePlaceId: string;
              readonly name: string | null;
            };
          } | null;
        }>;
      }
    | { readonly __typename?: 'ValidationError' };
};

export type LocationsSearchByAreaQueryVariables = Exact<{
  topLeft: GeoCoordinates;
  bottomRight: GeoCoordinates;
  showHidden?: InputMaybe<Scalars['Boolean']>;
}>;

export type LocationsSearchByAreaQuery = {
  readonly __typename?: 'Query';
  readonly searchLocationsByBoundingBox: ReadonlyArray<{
    readonly __typename?: 'LocationSearchResult';
    readonly location: {
      readonly __typename?: 'StoreLocation';
      readonly id: string;
      readonly name: string;
      readonly latitude: number;
      readonly longitude: number;
      readonly slug: string;
      readonly address: string;
      readonly city: string;
      readonly state: string;
      readonly zipCode: string;
      readonly isOutpost: boolean | null;
      readonly phone: string | null;
      readonly storeHours: string | null;
      readonly flexMessage: string | null;
      readonly enabled: boolean;
      readonly acceptingOrders: boolean;
      readonly notAcceptingOrdersReason: string | null;
      readonly imageUrl: string;
      readonly hidden: boolean;
      readonly showWarningDialog: boolean;
      readonly warningDialogDescription: string | null;
      readonly warningDialogTimeout: number | null;
      readonly warningDialogTitle: string | null;
    };
  } | null> | null;
};

export type LocationsSearchBySearchStringQueryVariables = Exact<{
  searchString: Scalars['String'];
  showHidden?: InputMaybe<Scalars['Boolean']>;
}>;

export type LocationsSearchBySearchStringQuery = {
  readonly __typename?: 'Query';
  readonly searchLocationsByString: ReadonlyArray<{
    readonly __typename?: 'LocationSearchResult';
    readonly score: number;
    readonly location: {
      readonly __typename?: 'StoreLocation';
      readonly id: string;
      readonly name: string;
      readonly latitude: number;
      readonly longitude: number;
      readonly slug: string;
      readonly address: string;
      readonly city: string;
      readonly state: string;
      readonly zipCode: string;
      readonly isOutpost: boolean | null;
      readonly phone: string | null;
      readonly storeHours: string | null;
      readonly flexMessage: string | null;
      readonly enabled: boolean;
      readonly acceptingOrders: boolean;
      readonly notAcceptingOrdersReason: string | null;
      readonly imageUrl: string;
      readonly hidden: boolean;
      readonly showWarningDialog: boolean;
      readonly warningDialogDescription: string | null;
      readonly warningDialogTimeout: number | null;
      readonly warningDialogTitle: string | null;
    };
  } | null> | null;
};

export type MenuCollectionsQueryVariables = Exact<{
  menuId: Scalars['ID'];
}>;

export type MenuCollectionsQuery = {
  readonly __typename?: 'Query';
  readonly menuCollections: ReadonlyArray<{
    readonly __typename?: 'MenuCollection';
    readonly id: string;
    readonly color: string;
    readonly primaryImageUrl: string;
    readonly primaryTitle: string;
    readonly primaryDescription: string;
  }>;
};

export type SweetpassInfoForAccountDeletionQueryVariables = Exact<{
  [key: string]: never;
}>;

export type SweetpassInfoForAccountDeletionQuery = {
  readonly __typename?: 'Query';
  readonly loyaltyProfile: {
    readonly __typename?: 'LoyaltyProfile';
    readonly customerId: string;
    readonly tier: {
      readonly __typename?: 'Tier';
      readonly id: string;
      readonly name: TierName;
    } | null;
    readonly tierStatus: {
      readonly __typename?: 'TierStatus';
      readonly id: string;
      readonly name: TierStatusName;
    } | null;
  } | null;
  readonly getSubscriptions: ReadonlyArray<{
    readonly __typename?: 'PaymentSubscription';
    readonly id: string;
    readonly nextBillingDate: string;
  }>;
};

export type RequestAccountDeletionMutationVariables = Exact<{
  [key: string]: never;
}>;

export type RequestAccountDeletionMutation = {
  readonly __typename?: 'Mutation';
  readonly requestAccountDeletion:
    | { readonly __typename?: 'RequestAccountDeletionFailed' }
    | {
        readonly __typename: 'RequestAccountDeletionSuccess';
        readonly success: boolean;
      }
    | null;
};

export type CustomerQueryVariables = Exact<{ [key: string]: never }>;

export type CustomerQuery = {
  readonly __typename?: 'Query';
  readonly currentCustomer: {
    readonly __typename?: 'Customer';
    readonly id: string;
    readonly trackingUuid: string | null;
    readonly firstName: string | null;
    readonly lastName: string | null;
    readonly phoneNumber: string | null;
    readonly email: string | null;
    readonly qrCode: string;
    readonly useCredit: boolean;
    readonly availableCredit: number;
    readonly addresses: ReadonlyArray<{
      readonly __typename?: 'Address';
      readonly id: string;
      readonly street: string;
      readonly secondaryStreet: string | null;
      readonly name: string | null;
      readonly city: string;
      readonly state: string;
      readonly zipCode: string;
      readonly country: string;
      readonly deliveryPreference: DeliveryPreferenceType;
      readonly googlePlaceId: string;
      readonly latitude: number;
      readonly longitude: number;
      readonly notes: string | null;
    }>;
    readonly billingAccounts: ReadonlyArray<{
      readonly __typename?: 'BillingAccount';
      readonly id: string;
      readonly description: string;
      readonly nickname: string | null;
      readonly isDefault: boolean;
      readonly cardType: CardType;
      readonly expirationState: ExpirationState;
    }>;
    readonly credits: ReadonlyArray<{
      readonly __typename?: 'Credit';
      readonly id: string;
      readonly title: string;
      readonly description: string;
      readonly amount: number;
      readonly remainingAmount: number;
      readonly createdAt: string;
      readonly expiresAt: string | null;
    }>;
  } | null;
};

export type ChallengeRewardDataFragment = {
  readonly __typename?: 'ChallengeReward';
  readonly id: string;
  readonly name: string;
  readonly expiresAt: any | null;
  readonly terms: string;
  readonly rewardType: RewardType;
  readonly redeemable: boolean | null;
  readonly redeemableAt: any | null;
};

export type ChallengeRewardsQueryVariables = Exact<{ [key: string]: never }>;

export type ChallengeRewardsQuery = {
  readonly __typename?: 'Query';
  readonly challengeRewards: ReadonlyArray<{
    readonly __typename?: 'ChallengeReward';
    readonly id: string;
    readonly name: string;
    readonly expiresAt: any | null;
    readonly terms: string;
    readonly rewardType: RewardType;
    readonly redeemable: boolean | null;
    readonly redeemableAt: any | null;
  }>;
};

export type ChallengeDataFragment = {
  readonly __typename?: 'Challenge';
  readonly achieved: number;
  readonly celebrationCopy: string;
  readonly descriptiveTitle: string;
  readonly expirationDate: any;
  readonly goal: number;
  readonly id: string;
  readonly legalTerms: string;
  readonly percentageCompleted: number;
  readonly permalink: string;
  readonly progress: number;
  readonly progressCopy: string;
  readonly status: ChallengeStatus;
  readonly title: string;
};

export type ChallengesQueryVariables = Exact<{ [key: string]: never }>;

export type ChallengesQuery = {
  readonly __typename?: 'Query';
  readonly challenges: ReadonlyArray<{
    readonly __typename?: 'Challenge';
    readonly achieved: number;
    readonly celebrationCopy: string;
    readonly descriptiveTitle: string;
    readonly expirationDate: any;
    readonly goal: number;
    readonly id: string;
    readonly legalTerms: string;
    readonly percentageCompleted: number;
    readonly permalink: string;
    readonly progress: number;
    readonly progressCopy: string;
    readonly status: ChallengeStatus;
    readonly title: string;
  }>;
};

export type ChallengeOptInMutationVariables = Exact<{
  challengeId: Scalars['String'];
}>;

export type ChallengeOptInMutation = {
  readonly __typename?: 'Mutation';
  readonly challengeOptIn: {
    readonly __typename?: 'Challenge';
    readonly achieved: number;
    readonly celebrationCopy: string;
    readonly descriptiveTitle: string;
    readonly expirationDate: any;
    readonly goal: number;
    readonly id: string;
    readonly legalTerms: string;
    readonly percentageCompleted: number;
    readonly permalink: string;
    readonly progress: number;
    readonly progressCopy: string;
    readonly status: ChallengeStatus;
    readonly title: string;
  };
};

export type HasUnseenChallengesQueryVariables = Exact<{ [key: string]: never }>;

export type HasUnseenChallengesQuery = {
  readonly __typename?: 'Query';
  readonly hasUnseenChallenges: {
    readonly __typename?: 'HasUnseenChallenges';
    readonly hasUnseenChallenges: boolean;
  };
};

export type RewardsDataFragment = {
  readonly __typename?: 'Reward';
  readonly id: string;
  readonly name: string;
  readonly expirationDate: string | null;
  readonly rewardType: RewardType;
  readonly redeemable: boolean;
  readonly redeemableAt: any | null;
};

export type RewardsQueryVariables = Exact<{ [key: string]: never }>;

export type RewardsQuery = {
  readonly __typename?: 'Query';
  readonly rewards: ReadonlyArray<{
    readonly __typename?: 'Reward';
    readonly id: string;
    readonly name: string;
    readonly expirationDate: string | null;
    readonly rewardType: RewardType;
    readonly redeemable: boolean;
    readonly redeemableAt: any | null;
  }>;
};

export type RewardNotAppliedFieldsFragment = {
  readonly __typename?: 'RewardNotApplied';
  readonly message: string;
  readonly status: number;
  readonly failureCode: ApplyRewardFailureCode;
};

export type RewardNotRemovedFieldsFragment = {
  readonly __typename?: 'RewardNotRemoved';
  readonly message: string;
  readonly status: number;
};

export type ApplyRewardMutationVariables = Exact<{
  input: ApplyRewardInput;
}>;

export type ApplyRewardMutation = {
  readonly __typename?: 'Mutation';
  readonly applyReward:
    | {
        readonly __typename: 'ApplyRewardSuccess';
        readonly order: {
          readonly __typename?: 'Order';
          readonly id: string;
          readonly orderType: OrderType;
          readonly ledger: {
            readonly __typename?: 'Ledger';
            readonly tax: number;
            readonly subtotal: number;
            readonly feesTotal: number;
            readonly discountsTotal: number;
            readonly creditsTotal: number;
            readonly tip: number;
            readonly discounts: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly credits: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly fees: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
          };
          readonly lineItems: ReadonlyArray<{
            readonly __typename?: 'LineItem';
            readonly id: string;
            readonly slug: string;
            readonly quantity: number;
            readonly cost: number;
            readonly customName: string | null;
            readonly perItemCost: number;
            readonly favorited: boolean;
            readonly isCustom: boolean;
            readonly dressingMode: DressingMode;
            readonly addedIngredients: ReadonlyArray<{
              readonly __typename?: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: IngredientKind | null;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
            }>;
            readonly removedIngredients: ReadonlyArray<{
              readonly __typename?: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: IngredientKind | null;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
            }>;
            readonly product: {
              readonly __typename?: 'Product';
              readonly id: string;
              readonly name: string;
              readonly slug: string;
              readonly isCustom: boolean;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
              readonly ingredients: ReadonlyArray<{
                readonly __typename?: 'Ingredient';
                readonly id: string;
                readonly name: string;
                readonly kind: IngredientKind | null;
              }>;
            };
            readonly mixedDressingDetails: ReadonlyArray<{
              readonly __typename?: 'MixedDressingDetails';
              readonly ingredientId: string;
              readonly weight: DressingWeight;
            }>;
          }>;
          readonly restaurant: {
            readonly __typename?: 'Restaurant';
            readonly id: string;
            readonly slug: string;
            readonly name: string;
            readonly city: string;
            readonly state: string;
            readonly address: string;
            readonly zipCode: string;
            readonly isOutpost: boolean;
            readonly deliveryMinSubtotal: number;
            readonly availableDropOffLocations: ReadonlyArray<{
              readonly __typename?: 'DropOffLocation';
              readonly id: string;
              readonly name: string;
            }>;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
          };
          readonly availableWantedTimes: ReadonlyArray<{
            readonly __typename?: 'AvailableWantedTime';
            readonly time: string;
          }>;
          readonly deliveryOrderDetail: {
            readonly __typename?: 'DeliveryOrderDetail';
            readonly id: string;
            readonly tip: number;
            readonly deliveryFee: number;
            readonly vendor: string;
            readonly orderId: string;
            readonly vendorRestaurantId: string;
            readonly estimatedDeliveryTime: string | null;
            readonly address: {
              readonly __typename?: 'Address';
              readonly id: string;
              readonly street: string;
              readonly secondaryStreet: string | null;
              readonly city: string;
              readonly state: string;
              readonly country: string;
              readonly zipCode: string;
              readonly deliveryPreference: DeliveryPreferenceType;
              readonly googlePlaceId: string;
              readonly latitude: number;
              readonly longitude: number;
              readonly name: string | null;
              readonly notes: string | null;
            };
          } | null;
        };
      }
    | {
        readonly __typename: 'RewardNotApplied';
        readonly message: string;
        readonly status: number;
        readonly failureCode: ApplyRewardFailureCode;
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export type RemoveRewardMutationVariables = Exact<{
  input: RemoveRewardInput;
}>;

export type RemoveRewardMutation = {
  readonly __typename?: 'Mutation';
  readonly removeReward:
    | {
        readonly __typename: 'RemoveRewardSuccess';
        readonly order: {
          readonly __typename?: 'Order';
          readonly id: string;
          readonly orderType: OrderType;
          readonly ledger: {
            readonly __typename?: 'Ledger';
            readonly tax: number;
            readonly subtotal: number;
            readonly feesTotal: number;
            readonly discountsTotal: number;
            readonly creditsTotal: number;
            readonly tip: number;
            readonly discounts: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly credits: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly fees: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
          };
          readonly lineItems: ReadonlyArray<{
            readonly __typename?: 'LineItem';
            readonly id: string;
            readonly slug: string;
            readonly quantity: number;
            readonly cost: number;
            readonly customName: string | null;
            readonly perItemCost: number;
            readonly favorited: boolean;
            readonly isCustom: boolean;
            readonly dressingMode: DressingMode;
            readonly addedIngredients: ReadonlyArray<{
              readonly __typename?: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: IngredientKind | null;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
            }>;
            readonly removedIngredients: ReadonlyArray<{
              readonly __typename?: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: IngredientKind | null;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
            }>;
            readonly product: {
              readonly __typename?: 'Product';
              readonly id: string;
              readonly name: string;
              readonly slug: string;
              readonly isCustom: boolean;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
              readonly ingredients: ReadonlyArray<{
                readonly __typename?: 'Ingredient';
                readonly id: string;
                readonly name: string;
                readonly kind: IngredientKind | null;
              }>;
            };
            readonly mixedDressingDetails: ReadonlyArray<{
              readonly __typename?: 'MixedDressingDetails';
              readonly ingredientId: string;
              readonly weight: DressingWeight;
            }>;
          }>;
          readonly restaurant: {
            readonly __typename?: 'Restaurant';
            readonly id: string;
            readonly slug: string;
            readonly name: string;
            readonly city: string;
            readonly state: string;
            readonly address: string;
            readonly zipCode: string;
            readonly isOutpost: boolean;
            readonly deliveryMinSubtotal: number;
            readonly availableDropOffLocations: ReadonlyArray<{
              readonly __typename?: 'DropOffLocation';
              readonly id: string;
              readonly name: string;
            }>;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
          };
          readonly availableWantedTimes: ReadonlyArray<{
            readonly __typename?: 'AvailableWantedTime';
            readonly time: string;
          }>;
          readonly deliveryOrderDetail: {
            readonly __typename?: 'DeliveryOrderDetail';
            readonly id: string;
            readonly tip: number;
            readonly deliveryFee: number;
            readonly vendor: string;
            readonly orderId: string;
            readonly vendorRestaurantId: string;
            readonly estimatedDeliveryTime: string | null;
            readonly address: {
              readonly __typename?: 'Address';
              readonly id: string;
              readonly street: string;
              readonly secondaryStreet: string | null;
              readonly city: string;
              readonly state: string;
              readonly country: string;
              readonly zipCode: string;
              readonly deliveryPreference: DeliveryPreferenceType;
              readonly googlePlaceId: string;
              readonly latitude: number;
              readonly longitude: number;
              readonly name: string | null;
              readonly notes: string | null;
            };
          } | null;
        };
      }
    | {
        readonly __typename: 'RewardNotRemoved';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export type CurrentCustomerQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentCustomerQuery = {
  readonly __typename?: 'Query';
  readonly currentCustomer: {
    readonly __typename?: 'Customer';
    readonly id: string;
    readonly trackingUuid: string | null;
    readonly firstName: string | null;
    readonly lastName: string | null;
    readonly phoneNumber: string | null;
    readonly email: string | null;
    readonly qrCode: string;
    readonly useCredit: boolean;
    readonly availableCredit: number;
    readonly addresses: ReadonlyArray<{
      readonly __typename?: 'Address';
      readonly id: string;
      readonly street: string;
      readonly secondaryStreet: string | null;
      readonly name: string | null;
      readonly city: string;
      readonly state: string;
      readonly zipCode: string;
      readonly country: string;
      readonly deliveryPreference: DeliveryPreferenceType;
      readonly googlePlaceId: string;
      readonly latitude: number;
      readonly longitude: number;
      readonly notes: string | null;
    }>;
    readonly billingAccounts: ReadonlyArray<{
      readonly __typename?: 'BillingAccount';
      readonly id: string;
      readonly description: string;
      readonly nickname: string | null;
      readonly isDefault: boolean;
      readonly cardType: CardType;
      readonly expirationState: ExpirationState;
    }>;
    readonly credits: ReadonlyArray<{
      readonly __typename?: 'Credit';
      readonly id: string;
      readonly title: string;
      readonly description: string;
      readonly amount: number;
      readonly remainingAmount: number;
      readonly createdAt: string;
      readonly expiresAt: string | null;
    }>;
  } | null;
};

export type UpdateUseCreditMutationVariables = Exact<{
  useCredit: Scalars['Boolean'];
}>;

export type UpdateUseCreditMutation = {
  readonly __typename?: 'Mutation';
  readonly updateUseCredit: {
    readonly __typename?: 'UpdateUseCreditResponse';
    readonly customer: {
      readonly __typename?: 'Customer';
      readonly id: string;
      readonly useCredit: boolean;
    };
  };
};

export type SuccessfulForgotPasswordFieldsFragment = {
  readonly __typename?: 'ForgotPasswordSuccess';
  readonly success: boolean;
};

export type ValidationErrorFieldsFragment = {
  readonly __typename?: 'ValidationError';
  readonly message: string;
  readonly status: number;
  readonly fieldErrors: ReadonlyArray<{
    readonly __typename?: 'FieldValidationError';
    readonly field: string;
    readonly message: string;
  }>;
};

export type ForgotPasswordMutationVariables = Exact<{
  input: ForgotPasswordInput;
}>;

export type ForgotPasswordMutation = {
  readonly __typename?: 'Mutation';
  readonly forgotPassword:
    | {
        readonly __typename: 'ForgotPasswordSuccess';
        readonly success: boolean;
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export type SuccessfulLoginFieldsFragment = {
  readonly __typename?: 'LoginSuccess';
  readonly csrf: string;
};

export type InvalidCredentialsFieldsFragment = {
  readonly __typename?: 'InvalidCredentials';
  readonly message: string;
  readonly status: number;
};

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;

export type LoginMutation = {
  readonly __typename?: 'Mutation';
  readonly login:
    | { readonly __typename: 'AccountLocked' }
    | {
        readonly __typename: 'InvalidCredentials';
        readonly message: string;
        readonly status: number;
      }
    | { readonly __typename: 'LoginSuccess'; readonly csrf: string }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export type SuccessfulLogoutFieldsFragment = {
  readonly __typename?: 'LogoutSuccess';
  readonly csrf: string;
};

export type LogoutMutationVariables = Exact<{
  input: LogoutInput;
}>;

export type LogoutMutation = {
  readonly __typename?: 'Mutation';
  readonly logout:
    | { readonly __typename: 'LogoutSuccess'; readonly csrf: string }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export type SuccessfulRegisterFieldsFragment = {
  readonly __typename?: 'RegisterSuccess';
  readonly success: boolean;
};

export type RegisterMutationVariables = Exact<{
  input: RegisterInput;
}>;

export type RegisterMutation = {
  readonly __typename?: 'Mutation';
  readonly register:
    | { readonly __typename: 'RegisterSuccess'; readonly success: boolean }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export type ResendVerificationCodeSuccessFieldsFragment = {
  readonly __typename?: 'ResendVerificationCodeSuccess';
  readonly success: boolean;
};

export type ResendVerificationCodeMutationVariables = Exact<{
  input: ResendVerificationCodeInput;
}>;

export type ResendVerificationCodeMutation = {
  readonly __typename?: 'Mutation';
  readonly resendVerificationCode:
    | {
        readonly __typename: 'ResendVerificationCodeSuccess';
        readonly success: boolean;
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export type VerifyRegistrationSuccessFieldsFragment = {
  readonly __typename?: 'VerifyRegistrationSuccess';
  readonly csrf: string;
  readonly customer: {
    readonly __typename?: 'Customer';
    readonly id: string;
    readonly trackingUuid: string | null;
    readonly firstName: string | null;
    readonly lastName: string | null;
    readonly phoneNumber: string | null;
    readonly email: string | null;
    readonly qrCode: string;
    readonly useCredit: boolean;
    readonly availableCredit: number;
    readonly addresses: ReadonlyArray<{
      readonly __typename?: 'Address';
      readonly id: string;
      readonly street: string;
      readonly secondaryStreet: string | null;
      readonly name: string | null;
      readonly city: string;
      readonly state: string;
      readonly zipCode: string;
      readonly country: string;
      readonly deliveryPreference: DeliveryPreferenceType;
      readonly googlePlaceId: string;
      readonly latitude: number;
      readonly longitude: number;
      readonly notes: string | null;
    }>;
    readonly billingAccounts: ReadonlyArray<{
      readonly __typename?: 'BillingAccount';
      readonly id: string;
      readonly description: string;
      readonly nickname: string | null;
      readonly isDefault: boolean;
      readonly cardType: CardType;
      readonly expirationState: ExpirationState;
    }>;
    readonly credits: ReadonlyArray<{
      readonly __typename?: 'Credit';
      readonly id: string;
      readonly title: string;
      readonly description: string;
      readonly amount: number;
      readonly remainingAmount: number;
      readonly createdAt: string;
      readonly expiresAt: string | null;
    }>;
  };
};

export type InvalidRegistrationCodeFieldsFragment = {
  readonly __typename?: 'InvalidRegistrationCode';
  readonly message: string;
  readonly status: number;
};

export type VerifyRegistrationMutationVariables = Exact<{
  input: VerifyRegistrationInput;
}>;

export type VerifyRegistrationMutation = {
  readonly __typename?: 'Mutation';
  readonly verifyRegistration:
    | {
        readonly __typename: 'InvalidRegistrationCode';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      }
    | {
        readonly __typename: 'VerifyRegistrationSuccess';
        readonly csrf: string;
        readonly customer: {
          readonly __typename?: 'Customer';
          readonly id: string;
          readonly trackingUuid: string | null;
          readonly firstName: string | null;
          readonly lastName: string | null;
          readonly phoneNumber: string | null;
          readonly email: string | null;
          readonly qrCode: string;
          readonly useCredit: boolean;
          readonly availableCredit: number;
          readonly addresses: ReadonlyArray<{
            readonly __typename?: 'Address';
            readonly id: string;
            readonly street: string;
            readonly secondaryStreet: string | null;
            readonly name: string | null;
            readonly city: string;
            readonly state: string;
            readonly zipCode: string;
            readonly country: string;
            readonly deliveryPreference: DeliveryPreferenceType;
            readonly googlePlaceId: string;
            readonly latitude: number;
            readonly longitude: number;
            readonly notes: string | null;
          }>;
          readonly billingAccounts: ReadonlyArray<{
            readonly __typename?: 'BillingAccount';
            readonly id: string;
            readonly description: string;
            readonly nickname: string | null;
            readonly isDefault: boolean;
            readonly cardType: CardType;
            readonly expirationState: ExpirationState;
          }>;
          readonly credits: ReadonlyArray<{
            readonly __typename?: 'Credit';
            readonly id: string;
            readonly title: string;
            readonly description: string;
            readonly amount: number;
            readonly remainingAmount: number;
            readonly createdAt: string;
            readonly expiresAt: string | null;
          }>;
        };
      };
};

export type OrdersQueryVariables = Exact<{
  input: OrdersInput;
}>;

export type OrdersQuery = {
  readonly __typename?: 'Query';
  readonly orders:
    | {
        readonly __typename: 'OrdersResponseSuccess';
        readonly orders: ReadonlyArray<{
          readonly __typename?: 'Order';
          readonly id: string;
          readonly description: string;
          readonly orderType: OrderType;
          readonly total: number | null;
          readonly asset: {
            readonly __typename?: 'Asset';
            readonly url: string;
          };
          readonly lineItems: ReadonlyArray<{
            readonly __typename?: 'LineItem';
            readonly id: string;
            readonly quantity: number;
            readonly customName: string | null;
            readonly isCustom: boolean;
            readonly product: {
              readonly __typename?: 'Product';
              readonly id: string;
              readonly name: string;
              readonly isCustom: boolean;
              readonly categoryName: string;
            };
          }>;
          readonly restaurant: {
            readonly __typename?: 'Restaurant';
            readonly id: string;
            readonly name: string;
            readonly city: string;
            readonly state: string;
            readonly address: string;
            readonly zipCode: string;
            readonly isOutpost: boolean;
            readonly slug: string;
          };
          readonly deliveryOrderDetail: {
            readonly __typename?: 'DeliveryOrderDetail';
            readonly id: string;
            readonly tip: number;
            readonly deliveryFee: number;
            readonly vendor: string;
            readonly orderId: string;
            readonly vendorRestaurantId: string;
            readonly estimatedDeliveryTime: string | null;
            readonly address: {
              readonly __typename?: 'Address';
              readonly id: string;
              readonly street: string;
              readonly secondaryStreet: string | null;
              readonly city: string;
              readonly state: string;
              readonly country: string;
              readonly zipCode: string;
              readonly deliveryPreference: DeliveryPreferenceType;
              readonly googlePlaceId: string;
              readonly latitude: number;
              readonly longitude: number;
              readonly name: string | null;
              readonly notes: string | null;
            };
          } | null;
        }>;
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export type BillingAccountFragment = {
  readonly __typename?: 'BillingAccount';
  readonly id: string;
  readonly description: string;
  readonly nickname: string | null;
  readonly isDefault: boolean;
  readonly cardType: CardType;
  readonly expirationState: ExpirationState;
};

export type AddressFragment = {
  readonly __typename?: 'Address';
  readonly id: string;
  readonly street: string;
  readonly secondaryStreet: string | null;
  readonly name: string | null;
  readonly city: string;
  readonly state: string;
  readonly zipCode: string;
  readonly country: string;
  readonly deliveryPreference: DeliveryPreferenceType;
  readonly googlePlaceId: string;
  readonly latitude: number;
  readonly longitude: number;
  readonly notes: string | null;
};

export type CustomerCreditsFragment = {
  readonly __typename?: 'Credit';
  readonly id: string;
  readonly title: string;
  readonly description: string;
  readonly amount: number;
  readonly remainingAmount: number;
  readonly createdAt: string;
  readonly expiresAt: string | null;
};

export type CustomerDataFragment = {
  readonly __typename?: 'Customer';
  readonly id: string;
  readonly trackingUuid: string | null;
  readonly firstName: string | null;
  readonly lastName: string | null;
  readonly phoneNumber: string | null;
  readonly email: string | null;
  readonly qrCode: string;
  readonly useCredit: boolean;
  readonly availableCredit: number;
  readonly addresses: ReadonlyArray<{
    readonly __typename?: 'Address';
    readonly id: string;
    readonly street: string;
    readonly secondaryStreet: string | null;
    readonly name: string | null;
    readonly city: string;
    readonly state: string;
    readonly zipCode: string;
    readonly country: string;
    readonly deliveryPreference: DeliveryPreferenceType;
    readonly googlePlaceId: string;
    readonly latitude: number;
    readonly longitude: number;
    readonly notes: string | null;
  }>;
  readonly billingAccounts: ReadonlyArray<{
    readonly __typename?: 'BillingAccount';
    readonly id: string;
    readonly description: string;
    readonly nickname: string | null;
    readonly isDefault: boolean;
    readonly cardType: CardType;
    readonly expirationState: ExpirationState;
  }>;
  readonly credits: ReadonlyArray<{
    readonly __typename?: 'Credit';
    readonly id: string;
    readonly title: string;
    readonly description: string;
    readonly amount: number;
    readonly remainingAmount: number;
    readonly createdAt: string;
    readonly expiresAt: string | null;
  }>;
};

export type CreateLoyaltyProfileQueryVariables = Exact<{
  [key: string]: never;
}>;

export type CreateLoyaltyProfileQuery = {
  readonly __typename?: 'Query';
  readonly loyaltyProfile: {
    readonly __typename?: 'LoyaltyProfile';
    readonly customerId: string;
  } | null;
};

export type GetCustomerCreditQueryVariables = Exact<{ [key: string]: never }>;

export type GetCustomerCreditQuery = {
  readonly __typename?: 'Query';
  readonly currentCustomer: {
    readonly __typename?: 'Customer';
    readonly id: string;
    readonly availableCredit: number;
    readonly useCredit: boolean;
    readonly credits: ReadonlyArray<{
      readonly __typename?: 'Credit';
      readonly id: string;
      readonly title: string;
      readonly description: string;
      readonly amount: number;
      readonly remainingAmount: number;
      readonly createdAt: string;
      readonly expiresAt: string | null;
    }>;
  } | null;
};

export type DeliveryInFlightQueryVariables = Exact<{
  input: OrdersInput;
}>;

export type DeliveryInFlightQuery = {
  readonly __typename?: 'Query';
  readonly orders:
    | {
        readonly __typename: 'OrdersResponseSuccess';
        readonly orders: ReadonlyArray<{
          readonly __typename?: 'Order';
          readonly id: string;
          readonly isInFlightDelivery: boolean;
        }>;
      }
    | { readonly __typename: 'ValidationError' };
};

export type InStoreOrderLastPendingFeedbackQueryVariables = Exact<{
  [key: string]: never;
}>;

export type InStoreOrderLastPendingFeedbackQuery = {
  readonly __typename?: 'Query';
  readonly inStoreOrderLastPendingFeedback: {
    readonly __typename?: 'InStoreOrder';
    readonly id: string;
    readonly wantedTime: string;
  } | null;
};

export type InvalidPromoCodeFieldsFragment = {
  readonly __typename?: 'InvalidPromoCode';
  readonly message: string;
  readonly status: number;
};

export type SubmitPromoCodeMutationVariables = Exact<{
  input: SubmitPromoCodeInput;
}>;

export type SubmitPromoCodeMutation = {
  readonly __typename?: 'Mutation';
  readonly submitPromoCode:
    | {
        readonly __typename: 'InvalidPromoCode';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'SubmitPromoCodeSuccess';
        readonly loyaltyId: number;
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export type SubmitPromoOrGiftCardCodeMutationVariables = Exact<{
  input: SubmitPromoOrGiftCardCodeInput;
}>;

export type SubmitPromoOrGiftCardCodeMutation = {
  readonly __typename?: 'Mutation';
  readonly submitPromoOrGiftCardCode:
    | {
        readonly __typename: 'InvalidPromoCode';
        readonly message: string;
        readonly status: number;
      }
    | { readonly __typename: 'SubmitGiftCardCodeSuccess' }
    | { readonly __typename: 'SubmitPromoCodeSuccessV2' }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export type GetSessionQueryVariables = Exact<{ [key: string]: never }>;

export type GetSessionQuery = {
  readonly __typename?: 'Query';
  readonly session: {
    readonly __typename?: 'Session';
    readonly csrf: string;
    readonly isLoggedIn: boolean;
  };
};

export type GetSweetpassTierQueryVariables = Exact<{ [key: string]: never }>;

export type GetSweetpassTierQuery = {
  readonly __typename?: 'Query';
  readonly loyaltyProfile: {
    readonly __typename?: 'LoyaltyProfile';
    readonly customerId: string;
    readonly joinDate: any;
    readonly tier: {
      readonly __typename?: 'Tier';
      readonly id: string;
      readonly name: TierName;
      readonly nextTier: {
        readonly __typename?: 'Tier';
        readonly id: string;
        readonly name: TierName;
      } | null;
    } | null;
  } | null;
};

export type KustomerTokenQueryVariables = Exact<{ [key: string]: never }>;

export type KustomerTokenQuery = {
  readonly __typename?: 'Query';
  readonly kustomerToken: {
    readonly __typename?: 'Kustomer';
    readonly token: string;
  } | null;
};

export type CheckoutBillingAccountFragment = {
  readonly __typename?: 'BillingAccount';
  readonly id: string;
  readonly description: string;
  readonly nickname: string | null;
  readonly isDefault: boolean;
  readonly cardType: CardType;
};

export type RewardNotValidatedFieldsFragment = {
  readonly __typename?: 'RewardNotValidated';
  readonly message: string;
  readonly status: number;
  readonly failureCode: ValidateRewardFailureCode;
};

export type ProductUnavailableFieldsFragment = {
  readonly __typename?: 'ProductUnavailable';
  readonly message: string;
  readonly status: number;
};

export type RestaurantIsNotAcceptingOrdersFieldsFragment = {
  readonly __typename?: 'RestaurantIsNotAcceptingOrders';
  readonly message: string;
  readonly status: number;
};

export type SubmitOrderMutationVariables = Exact<{
  input: SubmitOrderUsingBillingAccountInput;
}>;

export type SubmitOrderMutation = {
  readonly __typename?: 'Mutation';
  readonly submitOrderUsingBillingAccount:
    | { readonly __typename: 'DeliveryAlreadyInFlight' }
    | { readonly __typename: 'DeliverySpecifyAddress' }
    | { readonly __typename: 'InvalidBillingAccount' }
    | { readonly __typename: 'InvalidCustomerPhone' }
    | { readonly __typename: 'MinimumDeliverySubtotalNotMet' }
    | {
        readonly __typename: 'ProductUnavailable';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'RestaurantIsNotAcceptingOrders';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'RewardNotValidated';
        readonly message: string;
        readonly status: number;
        readonly failureCode: ValidateRewardFailureCode;
      }
    | {
        readonly __typename: 'SubmitOrderUsingBillingAccountSuccess';
        readonly order: { readonly __typename?: 'Order'; readonly id: string };
      }
    | { readonly __typename: 'TimeslotUnavailable' }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export type GetAvailableWantedTimesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetAvailableWantedTimesQuery = {
  readonly __typename?: 'Query';
  readonly cart: {
    readonly __typename?: 'Order';
    readonly id: string;
    readonly availableWantedTimes: ReadonlyArray<{
      readonly __typename?: 'AvailableWantedTime';
      readonly time: string;
    }>;
  } | null;
};

export type DeliveryEstimateQueryVariables = Exact<{
  input: LocationByAddressInput;
}>;

export type DeliveryEstimateQuery = {
  readonly __typename?: 'Query';
  readonly locationByAddress:
    | { readonly __typename: 'InvalidInput' }
    | {
        readonly __typename: 'Location';
        readonly estimateRange: {
          readonly __typename?: 'EstimateRange';
          readonly start: number;
          readonly end: number;
        };
      }
    | { readonly __typename: 'NoValidRestaurants' }
    | { readonly __typename: 'ValidationError' };
};

export type AddressQueryVariables = Exact<{
  addressId: Scalars['ID'];
}>;

export type AddressQuery = {
  readonly __typename?: 'Query';
  readonly address: {
    readonly __typename?: 'Address';
    readonly id: string;
    readonly street: string;
    readonly secondaryStreet: string | null;
    readonly city: string;
    readonly state: string;
    readonly country: string;
    readonly zipCode: string;
    readonly deliveryPreference: DeliveryPreferenceType;
    readonly googlePlaceId: string;
    readonly latitude: number;
    readonly longitude: number;
    readonly name: string | null;
    readonly notes: string | null;
  } | null;
};

export type DeliveryRestaurantQueryVariables = Exact<{
  input: LocationByAddressInput;
}>;

export type DeliveryRestaurantQuery = {
  readonly __typename?: 'Query';
  readonly locationByAddress:
    | { readonly __typename: 'InvalidInput' }
    | {
        readonly __typename: 'Location';
        readonly status: LocationStatus;
        readonly restaurant: {
          readonly __typename?: 'Restaurant';
          readonly id: string;
          readonly slug: string;
          readonly name: string;
          readonly city: string;
          readonly state: string;
          readonly zipCode: string;
          readonly address: string;
          readonly phone: string;
          readonly isOutpost: boolean;
          readonly isAcceptingOrders: boolean;
          readonly notAcceptingOrdersReason: string;
          readonly deliveryFee: number;
          readonly flexMessage: string | null;
          readonly hours: {
            readonly __typename?: 'RestaurantHours';
            readonly formatted: string | null;
          };
          readonly menu: {
            readonly __typename?: 'Menu';
            readonly id: string;
            readonly categories: ReadonlyArray<{
              readonly __typename?: 'MenuCategory';
              readonly id: string;
              readonly name: string;
              readonly isCustom: boolean;
              readonly products: ReadonlyArray<{
                readonly __typename?: 'Product';
                readonly calories: number;
                readonly categoryId: string;
                readonly cost: number;
                readonly description: string;
                readonly id: string;
                readonly isModifiable: boolean;
                readonly isCustom: boolean;
                readonly customType: CustomProductType | null;
                readonly isSalad: boolean;
                readonly name: string;
                readonly outOfStock: boolean;
                readonly restaurantId: string;
                readonly slug: string;
                readonly throttleItem: boolean;
                readonly asset: {
                  readonly __typename?: 'Asset';
                  readonly url: string;
                };
                readonly ingredients: ReadonlyArray<{
                  readonly __typename?: 'Ingredient';
                  readonly id: string;
                  readonly name: string;
                  readonly asset: {
                    readonly __typename?: 'Asset';
                    readonly url: string;
                  };
                }>;
                readonly label: {
                  readonly __typename?: 'ProductLabel';
                  readonly id: string;
                  readonly name: string;
                } | null;
                readonly dietaryProperties: ReadonlyArray<{
                  readonly __typename?: 'DietaryProperty';
                  readonly id: string;
                  readonly name: DietaryPropertyKind;
                }>;
              }>;
            }>;
          };
        };
        readonly estimateRange: {
          readonly __typename?: 'EstimateRange';
          readonly start: number;
          readonly end: number;
        };
        readonly vendor: {
          readonly __typename?: 'Vendor';
          readonly name: string;
          readonly restaurantId: string;
        };
      }
    | { readonly __typename: 'NoValidRestaurants' }
    | { readonly __typename: 'ValidationError' };
};

export type FavoritesQueryVariables = Exact<{
  input: FavoritedLineItemsInput;
}>;

export type FavoritesQuery = {
  readonly __typename?: 'Query';
  readonly favoritedLineItems: ReadonlyArray<{
    readonly __typename?: 'LineItem';
    readonly id: string;
    readonly slug: string;
    readonly customName: string | null;
    readonly quantity: number;
    readonly cost: number;
    readonly perItemCost: number;
    readonly dressingMode: DressingMode;
    readonly product: {
      readonly __typename?: 'Product';
      readonly id: string;
      readonly name: string;
      readonly calories: number;
      readonly cost: number;
      readonly isCustom: boolean;
      readonly description: string;
      readonly label: {
        readonly __typename?: 'ProductLabel';
        readonly id: string;
        readonly name: string;
      } | null;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      readonly restaurant: {
        readonly __typename?: 'Restaurant';
        readonly id: string;
      };
      readonly dietaryProperties: ReadonlyArray<{
        readonly __typename?: 'DietaryProperty';
        readonly id: string;
        readonly name: DietaryPropertyKind;
      }>;
    };
    readonly ingredients: ReadonlyArray<{
      readonly __typename?: 'Ingredient';
      readonly id: string;
      readonly name: string;
    }>;
    readonly addedIngredients: ReadonlyArray<{
      readonly __typename?: 'Ingredient';
      readonly id: string;
      readonly name: string;
    }>;
    readonly removedIngredients: ReadonlyArray<{
      readonly __typename?: 'Ingredient';
      readonly id: string;
      readonly name: string;
    }>;
    readonly mixedDressingDetails: ReadonlyArray<{
      readonly __typename?: 'MixedDressingDetails';
      readonly ingredientId: string;
      readonly weight: DressingWeight;
    }>;
  }>;
};

export type GetOrderStatusQueryVariables = Exact<{ [key: string]: never }>;

export type GetOrderStatusQuery = {
  readonly __typename?: 'Query';
  readonly orderStatus:
    | { readonly __typename?: 'InvalidOrder' }
    | {
        readonly __typename?: 'OrderStatus';
        readonly flattenedOrderStatus: FlattenedOrderStatuses;
        readonly order: {
          readonly __typename?: 'Order';
          readonly id: string;
          readonly wantedTime: string;
          readonly orderType: OrderType;
          readonly canTrackOrderStatus: boolean;
          readonly isPendingFeedback: boolean;
          readonly dropoffLocation: string | null;
          readonly restaurant: {
            readonly __typename?: 'Restaurant';
            readonly id: string;
            readonly name: string;
            readonly isOutpost: boolean;
          };
          readonly deliveryOrderDetail: {
            readonly __typename?: 'DeliveryOrderDetail';
            readonly estimatedDeliveryTime: string | null;
            readonly address: {
              readonly __typename?: 'Address';
              readonly id: string;
              readonly name: string | null;
            };
          } | null;
        };
      }
    | null;
};

export type GetOrderStatusFieldsFragment = {
  readonly __typename?: 'OrderStatus';
  readonly flattenedOrderStatus: FlattenedOrderStatuses;
  readonly order: {
    readonly __typename?: 'Order';
    readonly id: string;
    readonly wantedTime: string;
    readonly orderType: OrderType;
    readonly canTrackOrderStatus: boolean;
    readonly isPendingFeedback: boolean;
    readonly dropoffLocation: string | null;
    readonly restaurant: {
      readonly __typename?: 'Restaurant';
      readonly id: string;
      readonly name: string;
      readonly isOutpost: boolean;
    };
    readonly deliveryOrderDetail: {
      readonly __typename?: 'DeliveryOrderDetail';
      readonly estimatedDeliveryTime: string | null;
      readonly address: {
        readonly __typename?: 'Address';
        readonly id: string;
        readonly name: string | null;
      };
    } | null;
  };
};

export type LocationByAddressQueryVariables = Exact<{
  input: LocationByAddressInput;
}>;

export type LocationByAddressQuery = {
  readonly __typename?: 'Query';
  readonly locationByAddress:
    | { readonly __typename: 'InvalidInput' }
    | {
        readonly __typename: 'Location';
        readonly status: LocationStatus;
        readonly restaurant: {
          readonly __typename?: 'Restaurant';
          readonly id: string;
          readonly name: string;
          readonly slug: string;
        };
        readonly estimateRange: {
          readonly __typename?: 'EstimateRange';
          readonly start: number;
          readonly end: number;
        };
        readonly vendor: {
          readonly __typename?: 'Vendor';
          readonly name: string;
          readonly restaurantId: string;
        };
      }
    | { readonly __typename: 'NoValidRestaurants' }
    | { readonly __typename: 'ValidationError' };
};

export type SearchLocationsByBoundingBoxQueryVariables = Exact<{
  topLeft: GeoCoordinates;
  bottomRight: GeoCoordinates;
  showHidden?: InputMaybe<Scalars['Boolean']>;
}>;

export type SearchLocationsByBoundingBoxQuery = {
  readonly __typename?: 'Query';
  readonly searchLocationsByBoundingBox: ReadonlyArray<{
    readonly __typename?: 'LocationSearchResult';
    readonly location: {
      readonly __typename?: 'StoreLocation';
      readonly id: string;
      readonly name: string;
      readonly address: string;
      readonly city: string;
      readonly state: string;
      readonly zipCode: string;
      readonly isOutpost: boolean | null;
      readonly phone: string | null;
      readonly storeHours: string | null;
      readonly flexMessage: string | null;
      readonly enabled: boolean;
      readonly acceptingOrders: boolean;
      readonly notAcceptingOrdersReason: string | null;
      readonly imageUrl: string;
      readonly hidden: boolean;
      readonly showWarningDialog: boolean;
      readonly warningDialogDescription: string | null;
      readonly warningDialogTimeout: number | null;
      readonly warningDialogTitle: string | null;
      readonly lat: number;
      readonly lng: number;
      readonly restaurantSlug: string;
    };
  } | null> | null;
};

export type SearchLocationsByStringQueryVariables = Exact<{
  searchString: Scalars['String'];
  showHidden?: InputMaybe<Scalars['Boolean']>;
}>;

export type SearchLocationsByStringQuery = {
  readonly __typename?: 'Query';
  readonly searchLocationsByString: ReadonlyArray<{
    readonly __typename?: 'LocationSearchResult';
    readonly score: number;
    readonly location: {
      readonly __typename?: 'StoreLocation';
      readonly id: string;
      readonly name: string;
      readonly address: string;
      readonly city: string;
      readonly state: string;
      readonly zipCode: string;
      readonly isOutpost: boolean | null;
      readonly phone: string | null;
      readonly storeHours: string | null;
      readonly flexMessage: string | null;
      readonly enabled: boolean;
      readonly acceptingOrders: boolean;
      readonly notAcceptingOrdersReason: string | null;
      readonly imageUrl: string;
      readonly hidden: boolean;
      readonly showWarningDialog: boolean;
      readonly warningDialogDescription: string | null;
      readonly warningDialogTimeout: number | null;
      readonly warningDialogTitle: string | null;
      readonly lat: number;
      readonly lng: number;
      readonly restaurantSlug: string;
    };
  } | null> | null;
};

export type LogInCustomerSuccessfulLoginFieldsFragment = {
  readonly __typename?: 'LoginSuccess';
  readonly csrf: string;
};

export type LogInCustomerInvalidCredentialsFieldsFragment = {
  readonly __typename?: 'InvalidCredentials';
  readonly message: string;
  readonly status: number;
};

export type LogInCustomerMutationVariables = Exact<{
  input: LoginInput;
}>;

export type LogInCustomerMutation = {
  readonly __typename?: 'Mutation';
  readonly login:
    | { readonly __typename: 'AccountLocked' }
    | {
        readonly __typename: 'InvalidCredentials';
        readonly message: string;
        readonly status: number;
      }
    | { readonly __typename: 'LoginSuccess'; readonly csrf: string }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export type MenuCollectionProductFragment = {
  readonly __typename?: 'Product';
  readonly id: string;
  readonly slug: string;
  readonly name: string;
  readonly description: string;
  readonly calories: number;
  readonly cost: number;
  readonly restaurantId: string;
  readonly label: {
    readonly __typename?: 'ProductLabel';
    readonly id: string;
    readonly name: string;
  } | null;
  readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
  readonly dietaryProperties: ReadonlyArray<{
    readonly __typename?: 'DietaryProperty';
    readonly id: string;
    readonly name: DietaryPropertyKind;
  }>;
  readonly ingredients: ReadonlyArray<{
    readonly __typename?: 'Ingredient';
    readonly id: string;
    readonly name: string;
  }>;
};

export type MenuCollectionQueryVariables = Exact<{
  collectionId: Scalars['ID'];
}>;

export type MenuCollectionQuery = {
  readonly __typename?: 'Query';
  readonly menuCollection: {
    readonly __typename?: 'MenuCollection';
    readonly id: string;
    readonly color: string;
    readonly primaryImageUrl: string;
    readonly primaryTitle: string;
    readonly primaryDescription: string;
    readonly products: ReadonlyArray<{
      readonly __typename?: 'Product';
      readonly id: string;
      readonly slug: string;
      readonly name: string;
      readonly description: string;
      readonly calories: number;
      readonly cost: number;
      readonly restaurantId: string;
      readonly label: {
        readonly __typename?: 'ProductLabel';
        readonly id: string;
        readonly name: string;
      } | null;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      readonly dietaryProperties: ReadonlyArray<{
        readonly __typename?: 'DietaryProperty';
        readonly id: string;
        readonly name: DietaryPropertyKind;
      }>;
      readonly ingredients: ReadonlyArray<{
        readonly __typename?: 'Ingredient';
        readonly id: string;
        readonly name: string;
      }>;
    }>;
  };
};

export type MenuCartQueryVariables = Exact<{ [key: string]: never }>;

export type MenuCartQuery = {
  readonly __typename?: 'Query';
  readonly cart: {
    readonly __typename?: 'Order';
    readonly id: string;
    readonly lineItems: ReadonlyArray<{
      readonly __typename?: 'LineItem';
      readonly id: string;
    }>;
    readonly restaurant: {
      readonly __typename?: 'Restaurant';
      readonly id: string;
    };
  } | null;
};

export type CategoryProductFragment = {
  readonly __typename?: 'Product';
  readonly calories: number;
  readonly categoryId: string;
  readonly cost: number;
  readonly description: string;
  readonly id: string;
  readonly isModifiable: boolean;
  readonly isCustom: boolean;
  readonly customType: CustomProductType | null;
  readonly isSalad: boolean;
  readonly name: string;
  readonly outOfStock: boolean;
  readonly restaurantId: string;
  readonly slug: string;
  readonly throttleItem: boolean;
  readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
  readonly ingredients: ReadonlyArray<{
    readonly __typename?: 'Ingredient';
    readonly id: string;
    readonly name: string;
    readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
  }>;
  readonly label: {
    readonly __typename?: 'ProductLabel';
    readonly id: string;
    readonly name: string;
  } | null;
  readonly dietaryProperties: ReadonlyArray<{
    readonly __typename?: 'DietaryProperty';
    readonly id: string;
    readonly name: DietaryPropertyKind;
  }>;
};

export type CategoryFragment = {
  readonly __typename?: 'MenuCategory';
  readonly id: string;
  readonly name: string;
  readonly isCustom: boolean;
  readonly products: ReadonlyArray<{
    readonly __typename?: 'Product';
    readonly calories: number;
    readonly categoryId: string;
    readonly cost: number;
    readonly description: string;
    readonly id: string;
    readonly isModifiable: boolean;
    readonly isCustom: boolean;
    readonly customType: CustomProductType | null;
    readonly isSalad: boolean;
    readonly name: string;
    readonly outOfStock: boolean;
    readonly restaurantId: string;
    readonly slug: string;
    readonly throttleItem: boolean;
    readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
    readonly ingredients: ReadonlyArray<{
      readonly __typename?: 'Ingredient';
      readonly id: string;
      readonly name: string;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
    }>;
    readonly label: {
      readonly __typename?: 'ProductLabel';
      readonly id: string;
      readonly name: string;
    } | null;
    readonly dietaryProperties: ReadonlyArray<{
      readonly __typename?: 'DietaryProperty';
      readonly id: string;
      readonly name: DietaryPropertyKind;
    }>;
  }>;
};

export type RestaurantMenuFragment = {
  readonly __typename?: 'Restaurant';
  readonly id: string;
  readonly slug: string;
  readonly name: string;
  readonly city: string;
  readonly state: string;
  readonly zipCode: string;
  readonly address: string;
  readonly phone: string;
  readonly isOutpost: boolean;
  readonly isAcceptingOrders: boolean;
  readonly notAcceptingOrdersReason: string;
  readonly deliveryFee: number;
  readonly flexMessage: string | null;
  readonly hours: {
    readonly __typename?: 'RestaurantHours';
    readonly formatted: string | null;
  };
  readonly menu: {
    readonly __typename?: 'Menu';
    readonly id: string;
    readonly categories: ReadonlyArray<{
      readonly __typename?: 'MenuCategory';
      readonly id: string;
      readonly name: string;
      readonly isCustom: boolean;
      readonly products: ReadonlyArray<{
        readonly __typename?: 'Product';
        readonly calories: number;
        readonly categoryId: string;
        readonly cost: number;
        readonly description: string;
        readonly id: string;
        readonly isModifiable: boolean;
        readonly isCustom: boolean;
        readonly customType: CustomProductType | null;
        readonly isSalad: boolean;
        readonly name: string;
        readonly outOfStock: boolean;
        readonly restaurantId: string;
        readonly slug: string;
        readonly throttleItem: boolean;
        readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
        readonly ingredients: ReadonlyArray<{
          readonly __typename?: 'Ingredient';
          readonly id: string;
          readonly name: string;
          readonly asset: {
            readonly __typename?: 'Asset';
            readonly url: string;
          };
        }>;
        readonly label: {
          readonly __typename?: 'ProductLabel';
          readonly id: string;
          readonly name: string;
        } | null;
        readonly dietaryProperties: ReadonlyArray<{
          readonly __typename?: 'DietaryProperty';
          readonly id: string;
          readonly name: DietaryPropertyKind;
        }>;
      }>;
    }>;
  };
};

export type RestaurantQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type RestaurantQuery = {
  readonly __typename?: 'Query';
  readonly restaurant: {
    readonly __typename?: 'Restaurant';
    readonly id: string;
    readonly slug: string;
    readonly name: string;
    readonly city: string;
    readonly state: string;
    readonly zipCode: string;
    readonly address: string;
    readonly phone: string;
    readonly isOutpost: boolean;
    readonly isAcceptingOrders: boolean;
    readonly notAcceptingOrdersReason: string;
    readonly deliveryFee: number;
    readonly flexMessage: string | null;
    readonly hours: {
      readonly __typename?: 'RestaurantHours';
      readonly formatted: string | null;
    };
    readonly menu: {
      readonly __typename?: 'Menu';
      readonly id: string;
      readonly categories: ReadonlyArray<{
        readonly __typename?: 'MenuCategory';
        readonly id: string;
        readonly name: string;
        readonly isCustom: boolean;
        readonly products: ReadonlyArray<{
          readonly __typename?: 'Product';
          readonly calories: number;
          readonly categoryId: string;
          readonly cost: number;
          readonly description: string;
          readonly id: string;
          readonly isModifiable: boolean;
          readonly isCustom: boolean;
          readonly customType: CustomProductType | null;
          readonly isSalad: boolean;
          readonly name: string;
          readonly outOfStock: boolean;
          readonly restaurantId: string;
          readonly slug: string;
          readonly throttleItem: boolean;
          readonly asset: {
            readonly __typename?: 'Asset';
            readonly url: string;
          };
          readonly ingredients: ReadonlyArray<{
            readonly __typename?: 'Ingredient';
            readonly id: string;
            readonly name: string;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
          }>;
          readonly label: {
            readonly __typename?: 'ProductLabel';
            readonly id: string;
            readonly name: string;
          } | null;
          readonly dietaryProperties: ReadonlyArray<{
            readonly __typename?: 'DietaryProperty';
            readonly id: string;
            readonly name: DietaryPropertyKind;
          }>;
        }>;
      }>;
    };
  };
};

export type MenuRedirectQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type MenuRedirectQuery = {
  readonly __typename?: 'Query';
  readonly restaurant: {
    readonly __typename?: 'Restaurant';
    readonly id: string;
  };
};

export type BaseProductQueryVariables = Exact<{
  slug: Scalars['String'];
}>;

export type BaseProductQuery = {
  readonly __typename?: 'Query';
  readonly baseProduct: {
    readonly __typename: 'BaseProduct';
    readonly id: string;
    readonly name: string;
    readonly description: string;
    readonly heading: string;
    readonly subheading: string;
    readonly isSeasonal: boolean;
    readonly isDeepLinkingEnabled: boolean;
    readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
  } | null;
};

export type BaseProductDataFragment = {
  readonly __typename?: 'BaseProduct';
  readonly id: string;
  readonly name: string;
  readonly description: string;
  readonly heading: string;
  readonly subheading: string;
  readonly isSeasonal: boolean;
  readonly isDeepLinkingEnabled: boolean;
  readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
};

export type OrderProductRestaurantQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type OrderProductRestaurantQuery = {
  readonly __typename?: 'Query';
  readonly restaurant: {
    readonly __typename?: 'Restaurant';
    readonly id: string;
    readonly name: string;
    readonly latitude: number;
    readonly longitude: number;
    readonly slug: string;
    readonly address: string;
    readonly city: string;
    readonly state: string;
    readonly zipCode: string;
    readonly isOutpost: boolean;
    readonly phone: string;
    readonly flexMessage: string | null;
    readonly isAcceptingOrders: boolean;
    readonly notAcceptingOrdersReason: string;
    readonly hours: {
      readonly __typename?: 'RestaurantHours';
      readonly formatted: string | null;
    };
    readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
  };
};

export type OrderProductRestaurantDataFragment = {
  readonly __typename?: 'Restaurant';
  readonly id: string;
  readonly name: string;
  readonly latitude: number;
  readonly longitude: number;
  readonly slug: string;
  readonly address: string;
  readonly city: string;
  readonly state: string;
  readonly zipCode: string;
  readonly isOutpost: boolean;
  readonly phone: string;
  readonly flexMessage: string | null;
  readonly isAcceptingOrders: boolean;
  readonly notAcceptingOrdersReason: string;
  readonly hours: {
    readonly __typename?: 'RestaurantHours';
    readonly formatted: string | null;
  };
  readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
};

export type ProductForRestaurantQueryVariables = Exact<{
  baseProductSlug: Scalars['String'];
  restaurantId: Scalars['String'];
}>;

export type ProductForRestaurantQuery = {
  readonly __typename?: 'Query';
  readonly productForRestaurant: {
    readonly __typename?: 'Product';
    readonly id: string;
    readonly slug: string;
  } | null;
};

export type OrderStatusQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type OrderStatusQuery = {
  readonly __typename?: 'Query';
  readonly orderStatus:
    | { readonly __typename: 'InvalidOrder'; readonly message: string }
    | {
        readonly __typename: 'OrderStatus';
        readonly gravyStatus: GravyStatusType;
        readonly gravyUpdatedAt: string;
        readonly orderOccasion: string;
        readonly orderStatus: string;
        readonly flattenedOrderStatus: FlattenedOrderStatuses;
        readonly courierDetails: {
          readonly __typename?: 'CourierDetails';
          readonly name: string | null;
          readonly phone: string | null;
          readonly latitude: number | null;
          readonly longitude: number | null;
        } | null;
        readonly order: {
          readonly __typename?: 'Order';
          readonly id: string;
          readonly description: string;
          readonly dropoffLocation: string | null;
          readonly orderType: OrderType;
          readonly total: number | null;
          readonly canTrackOrderStatus: boolean;
          readonly isPendingFeedback: boolean;
          readonly wantedTime: string;
          readonly vendorId: string;
          readonly restaurant: {
            readonly __typename?: 'Restaurant';
            readonly id: string;
            readonly city: string;
            readonly state: string;
            readonly zipCode: string;
            readonly name: string;
            readonly address: string;
            readonly slug: string;
            readonly latitude: number;
            readonly longitude: number;
            readonly isOutpost: boolean;
            readonly phone: string;
            readonly availableDropOffLocations: ReadonlyArray<{
              readonly __typename?: 'DropOffLocation';
              readonly id: string;
              readonly name: string;
            }>;
          };
          readonly ledger: {
            readonly __typename?: 'Ledger';
            readonly tax: number;
            readonly subtotal: number;
            readonly feesTotal: number;
            readonly discountsTotal: number;
            readonly creditsTotal: number;
            readonly tip: number;
            readonly discounts: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly credits: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly fees: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
          };
          readonly lineItems: ReadonlyArray<{
            readonly __typename?: 'LineItem';
            readonly calories: number;
            readonly id: string;
            readonly slug: string;
            readonly quantity: number;
            readonly cost: number;
            readonly customName: string | null;
            readonly perItemCost: number;
            readonly favorited: boolean;
            readonly isCustom: boolean;
            readonly dressingMode: DressingMode;
            readonly addedIngredients: ReadonlyArray<{
              readonly __typename?: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: IngredientKind | null;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
            }>;
            readonly removedIngredients: ReadonlyArray<{
              readonly __typename?: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: IngredientKind | null;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
            }>;
            readonly product: {
              readonly __typename?: 'Product';
              readonly id: string;
              readonly name: string;
              readonly slug: string;
              readonly isCustom: boolean;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
              readonly ingredients: ReadonlyArray<{
                readonly __typename?: 'Ingredient';
                readonly id: string;
                readonly name: string;
                readonly kind: IngredientKind | null;
              }>;
            };
            readonly mixedDressingDetails: ReadonlyArray<{
              readonly __typename?: 'MixedDressingDetails';
              readonly ingredientId: string;
              readonly weight: DressingWeight;
            }>;
          }>;
          readonly deliveryOrderDetail: {
            readonly __typename?: 'DeliveryOrderDetail';
            readonly id: string;
            readonly tip: number;
            readonly deliveryFee: number;
            readonly vendor: string;
            readonly orderId: string;
            readonly vendorRestaurantId: string;
            readonly estimatedDeliveryTime: string | null;
            readonly address: {
              readonly __typename?: 'Address';
              readonly id: string;
              readonly street: string;
              readonly secondaryStreet: string | null;
              readonly city: string;
              readonly state: string;
              readonly country: string;
              readonly zipCode: string;
              readonly deliveryPreference: DeliveryPreferenceType;
              readonly googlePlaceId: string;
              readonly latitude: number;
              readonly longitude: number;
              readonly name: string | null;
              readonly notes: string | null;
            };
          } | null;
        };
      }
    | null;
};

export type OrderStatusPollingQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type OrderStatusPollingQuery = {
  readonly __typename?: 'Query';
  readonly orderStatus:
    | { readonly __typename: 'InvalidOrder'; readonly message: string }
    | {
        readonly __typename: 'OrderStatus';
        readonly flattenedOrderStatus: FlattenedOrderStatuses;
        readonly courierDetails: {
          readonly __typename?: 'CourierDetails';
          readonly name: string | null;
          readonly phone: string | null;
          readonly latitude: number | null;
          readonly longitude: number | null;
        } | null;
        readonly order: {
          readonly __typename?: 'Order';
          readonly id: string;
          readonly wantedTime: string;
        };
      }
    | null;
};

export type FavoriteLineItemMutationVariables = Exact<{
  input: FavoriteLineItemInput;
}>;

export type FavoriteLineItemMutation = {
  readonly __typename?: 'Mutation';
  readonly favoriteLineItem: {
    readonly __typename?: 'LineItem';
    readonly id: string;
    readonly favorited: boolean;
  };
};

export type OrderHistoryQueryVariables = Exact<{
  input: OrdersInput;
}>;

export type OrderHistoryQuery = {
  readonly __typename?: 'Query';
  readonly orders:
    | {
        readonly __typename: 'OrdersResponseSuccess';
        readonly orders: ReadonlyArray<{
          readonly __typename?: 'Order';
          readonly id: string;
          readonly orderType: OrderType;
          readonly wantedTime: string;
          readonly description: string;
          readonly total: number | null;
          readonly lineItems: ReadonlyArray<{
            readonly __typename?: 'LineItem';
            readonly id: string;
            readonly customName: string | null;
            readonly isCustom: boolean;
            readonly product: {
              readonly __typename?: 'Product';
              readonly id: string;
              readonly name: string;
              readonly isCustom: boolean;
              readonly categoryName: string;
            };
          }>;
          readonly asset: {
            readonly __typename?: 'Asset';
            readonly url: string;
          };
          readonly restaurant: {
            readonly __typename?: 'Restaurant';
            readonly id: string;
            readonly name: string;
            readonly isOutpost: boolean;
          };
          readonly deliveryOrderDetail: {
            readonly __typename?: 'DeliveryOrderDetail';
            readonly id: string;
            readonly address: {
              readonly __typename?: 'Address';
              readonly id: string;
              readonly name: string | null;
            };
          } | null;
        }>;
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export type PdpLineItemDetailsFragment = {
  readonly __typename?: 'LineItem';
  readonly id: string;
  readonly quantity: number;
  readonly isCustom: boolean;
  readonly customName: string | null;
  readonly ingredients: ReadonlyArray<{
    readonly __typename?: 'Ingredient';
    readonly id: string;
    readonly name: string;
    readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
    readonly dietaryProperties: ReadonlyArray<{
      readonly __typename?: 'DietaryProperty';
      readonly id: string;
      readonly name: DietaryPropertyKind;
    }>;
  }>;
  readonly mixedDressingDetails: ReadonlyArray<{
    readonly __typename?: 'MixedDressingDetails';
    readonly ingredientId: string;
    readonly weight: DressingWeight;
  }>;
};

export type LineItemSuccessFieldsFragment = {
  readonly __typename?: 'LineItemSuccess';
  readonly lineItem: {
    readonly __typename?: 'LineItem';
    readonly id: string;
    readonly quantity: number;
    readonly isCustom: boolean;
    readonly customName: string | null;
    readonly ingredients: ReadonlyArray<{
      readonly __typename?: 'Ingredient';
      readonly id: string;
      readonly name: string;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      readonly dietaryProperties: ReadonlyArray<{
        readonly __typename?: 'DietaryProperty';
        readonly id: string;
        readonly name: DietaryPropertyKind;
      }>;
    }>;
    readonly mixedDressingDetails: ReadonlyArray<{
      readonly __typename?: 'MixedDressingDetails';
      readonly ingredientId: string;
      readonly weight: DressingWeight;
    }>;
  };
};

export type LineItemNotFoundFieldsFragment = {
  readonly __typename?: 'LineItemNotFound';
  readonly message: string;
  readonly status: number;
};

export type GetLineItemQueryVariables = Exact<{
  input: LineItemInput;
}>;

export type GetLineItemQuery = {
  readonly __typename?: 'Query';
  readonly getLineItem:
    | {
        readonly __typename: 'LineItemNotFound';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'LineItemSuccess';
        readonly lineItem: {
          readonly __typename?: 'LineItem';
          readonly id: string;
          readonly quantity: number;
          readonly isCustom: boolean;
          readonly customName: string | null;
          readonly ingredients: ReadonlyArray<{
            readonly __typename?: 'Ingredient';
            readonly id: string;
            readonly name: string;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
            readonly dietaryProperties: ReadonlyArray<{
              readonly __typename?: 'DietaryProperty';
              readonly id: string;
              readonly name: DietaryPropertyKind;
            }>;
          }>;
          readonly mixedDressingDetails: ReadonlyArray<{
            readonly __typename?: 'MixedDressingDetails';
            readonly ingredientId: string;
            readonly weight: DressingWeight;
          }>;
        };
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      }
    | null;
};

export type ProductIngredientFragment = {
  readonly __typename?: 'Ingredient';
  readonly id: string;
  readonly name: string;
  readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
  readonly dietaryProperties: ReadonlyArray<{
    readonly __typename?: 'DietaryProperty';
    readonly id: string;
    readonly name: DietaryPropertyKind;
  }>;
};

export type IngredientModificationFragment = {
  readonly __typename?: 'IngredientModification';
  readonly calories: number;
  readonly removalCost: number;
  readonly additionCost: number;
  readonly substitutionCost: number;
  readonly kind: string | null;
  readonly subKind: string | null;
  readonly outOfStock: boolean;
  readonly mixable: boolean;
  readonly isGrain: boolean;
  readonly ingredient: {
    readonly __typename?: 'Ingredient';
    readonly id: string;
    readonly name: string;
    readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
    readonly dietaryProperties: ReadonlyArray<{
      readonly __typename?: 'DietaryProperty';
      readonly id: string;
      readonly name: DietaryPropertyKind;
    }>;
  };
};

export type IngredientModificationKindFragment = {
  readonly __typename?: 'IngredientModificationKind';
  readonly minAggregateQuantity: number;
  readonly maxAggregateQuantity: number;
  readonly freeAggregateQuantity: number;
  readonly allowMultipleQuantity: boolean;
  readonly modifications: ReadonlyArray<{
    readonly __typename?: 'IngredientModification';
    readonly calories: number;
    readonly removalCost: number;
    readonly additionCost: number;
    readonly substitutionCost: number;
    readonly kind: string | null;
    readonly subKind: string | null;
    readonly outOfStock: boolean;
    readonly mixable: boolean;
    readonly isGrain: boolean;
    readonly ingredient: {
      readonly __typename?: 'Ingredient';
      readonly id: string;
      readonly name: string;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      readonly dietaryProperties: ReadonlyArray<{
        readonly __typename?: 'DietaryProperty';
        readonly id: string;
        readonly name: DietaryPropertyKind;
      }>;
    };
  }>;
};

export type ProductDetailsFragment = {
  readonly __typename?: 'Product';
  readonly id: string;
  readonly slug: string;
  readonly restaurantId: string;
  readonly name: string;
  readonly categoryId: string;
  readonly description: string;
  readonly cost: number;
  readonly calories: number;
  readonly outOfStock: boolean;
  readonly throttleItem: boolean;
  readonly maxModifications: number;
  readonly isModifiable: boolean;
  readonly isCustom: boolean;
  readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
  readonly restaurant: {
    readonly __typename?: 'Restaurant';
    readonly id: string;
    readonly isOutpost: boolean;
  };
  readonly dietaryProperties: ReadonlyArray<{
    readonly __typename?: 'DietaryProperty';
    readonly id: string;
    readonly name: DietaryPropertyKind;
  }>;
  readonly ingredients: ReadonlyArray<{
    readonly __typename?: 'Ingredient';
    readonly id: string;
    readonly name: string;
    readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
    readonly dietaryProperties: ReadonlyArray<{
      readonly __typename?: 'DietaryProperty';
      readonly id: string;
      readonly name: DietaryPropertyKind;
    }>;
  }>;
  readonly ingredientModifications: {
    readonly __typename?: 'IngredientModifications';
    readonly bases: {
      readonly __typename?: 'IngredientModificationKind';
      readonly minAggregateQuantity: number;
      readonly maxAggregateQuantity: number;
      readonly freeAggregateQuantity: number;
      readonly allowMultipleQuantity: boolean;
      readonly modifications: ReadonlyArray<{
        readonly __typename?: 'IngredientModification';
        readonly calories: number;
        readonly removalCost: number;
        readonly additionCost: number;
        readonly substitutionCost: number;
        readonly kind: string | null;
        readonly subKind: string | null;
        readonly outOfStock: boolean;
        readonly mixable: boolean;
        readonly isGrain: boolean;
        readonly ingredient: {
          readonly __typename?: 'Ingredient';
          readonly id: string;
          readonly name: string;
          readonly asset: {
            readonly __typename?: 'Asset';
            readonly url: string;
          };
          readonly dietaryProperties: ReadonlyArray<{
            readonly __typename?: 'DietaryProperty';
            readonly id: string;
            readonly name: DietaryPropertyKind;
          }>;
        };
      }>;
    };
    readonly toppings: {
      readonly __typename?: 'IngredientModificationKind';
      readonly minAggregateQuantity: number;
      readonly maxAggregateQuantity: number;
      readonly freeAggregateQuantity: number;
      readonly allowMultipleQuantity: boolean;
      readonly modifications: ReadonlyArray<{
        readonly __typename?: 'IngredientModification';
        readonly calories: number;
        readonly removalCost: number;
        readonly additionCost: number;
        readonly substitutionCost: number;
        readonly kind: string | null;
        readonly subKind: string | null;
        readonly outOfStock: boolean;
        readonly mixable: boolean;
        readonly isGrain: boolean;
        readonly ingredient: {
          readonly __typename?: 'Ingredient';
          readonly id: string;
          readonly name: string;
          readonly asset: {
            readonly __typename?: 'Asset';
            readonly url: string;
          };
          readonly dietaryProperties: ReadonlyArray<{
            readonly __typename?: 'DietaryProperty';
            readonly id: string;
            readonly name: DietaryPropertyKind;
          }>;
        };
      }>;
    };
    readonly premiums: {
      readonly __typename?: 'IngredientModificationKind';
      readonly minAggregateQuantity: number;
      readonly maxAggregateQuantity: number;
      readonly freeAggregateQuantity: number;
      readonly allowMultipleQuantity: boolean;
      readonly modifications: ReadonlyArray<{
        readonly __typename?: 'IngredientModification';
        readonly calories: number;
        readonly removalCost: number;
        readonly additionCost: number;
        readonly substitutionCost: number;
        readonly kind: string | null;
        readonly subKind: string | null;
        readonly outOfStock: boolean;
        readonly mixable: boolean;
        readonly isGrain: boolean;
        readonly ingredient: {
          readonly __typename?: 'Ingredient';
          readonly id: string;
          readonly name: string;
          readonly asset: {
            readonly __typename?: 'Asset';
            readonly url: string;
          };
          readonly dietaryProperties: ReadonlyArray<{
            readonly __typename?: 'DietaryProperty';
            readonly id: string;
            readonly name: DietaryPropertyKind;
          }>;
        };
      }>;
    };
    readonly dressings: {
      readonly __typename?: 'IngredientModificationKind';
      readonly minAggregateQuantity: number;
      readonly maxAggregateQuantity: number;
      readonly freeAggregateQuantity: number;
      readonly allowMultipleQuantity: boolean;
      readonly modifications: ReadonlyArray<{
        readonly __typename?: 'IngredientModification';
        readonly calories: number;
        readonly removalCost: number;
        readonly additionCost: number;
        readonly substitutionCost: number;
        readonly kind: string | null;
        readonly subKind: string | null;
        readonly outOfStock: boolean;
        readonly mixable: boolean;
        readonly isGrain: boolean;
        readonly ingredient: {
          readonly __typename?: 'Ingredient';
          readonly id: string;
          readonly name: string;
          readonly asset: {
            readonly __typename?: 'Asset';
            readonly url: string;
          };
          readonly dietaryProperties: ReadonlyArray<{
            readonly __typename?: 'DietaryProperty';
            readonly id: string;
            readonly name: DietaryPropertyKind;
          }>;
        };
      }>;
    };
    readonly bread: {
      readonly __typename?: 'IngredientModificationKind';
      readonly minAggregateQuantity: number;
      readonly maxAggregateQuantity: number;
      readonly freeAggregateQuantity: number;
      readonly allowMultipleQuantity: boolean;
      readonly modifications: ReadonlyArray<{
        readonly __typename?: 'IngredientModification';
        readonly calories: number;
        readonly removalCost: number;
        readonly additionCost: number;
        readonly substitutionCost: number;
        readonly kind: string | null;
        readonly subKind: string | null;
        readonly outOfStock: boolean;
        readonly mixable: boolean;
        readonly isGrain: boolean;
        readonly ingredient: {
          readonly __typename?: 'Ingredient';
          readonly id: string;
          readonly name: string;
          readonly asset: {
            readonly __typename?: 'Asset';
            readonly url: string;
          };
          readonly dietaryProperties: ReadonlyArray<{
            readonly __typename?: 'DietaryProperty';
            readonly id: string;
            readonly name: DietaryPropertyKind;
          }>;
        };
      }>;
    };
  };
};

export type GetProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetProductQuery = {
  readonly __typename?: 'Query';
  readonly product: {
    readonly __typename?: 'Product';
    readonly id: string;
    readonly slug: string;
    readonly restaurantId: string;
    readonly name: string;
    readonly categoryId: string;
    readonly description: string;
    readonly cost: number;
    readonly calories: number;
    readonly outOfStock: boolean;
    readonly throttleItem: boolean;
    readonly maxModifications: number;
    readonly isModifiable: boolean;
    readonly isCustom: boolean;
    readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
    readonly restaurant: {
      readonly __typename?: 'Restaurant';
      readonly id: string;
      readonly isOutpost: boolean;
    };
    readonly dietaryProperties: ReadonlyArray<{
      readonly __typename?: 'DietaryProperty';
      readonly id: string;
      readonly name: DietaryPropertyKind;
    }>;
    readonly ingredients: ReadonlyArray<{
      readonly __typename?: 'Ingredient';
      readonly id: string;
      readonly name: string;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      readonly dietaryProperties: ReadonlyArray<{
        readonly __typename?: 'DietaryProperty';
        readonly id: string;
        readonly name: DietaryPropertyKind;
      }>;
    }>;
    readonly ingredientModifications: {
      readonly __typename?: 'IngredientModifications';
      readonly bases: {
        readonly __typename?: 'IngredientModificationKind';
        readonly minAggregateQuantity: number;
        readonly maxAggregateQuantity: number;
        readonly freeAggregateQuantity: number;
        readonly allowMultipleQuantity: boolean;
        readonly modifications: ReadonlyArray<{
          readonly __typename?: 'IngredientModification';
          readonly calories: number;
          readonly removalCost: number;
          readonly additionCost: number;
          readonly substitutionCost: number;
          readonly kind: string | null;
          readonly subKind: string | null;
          readonly outOfStock: boolean;
          readonly mixable: boolean;
          readonly isGrain: boolean;
          readonly ingredient: {
            readonly __typename?: 'Ingredient';
            readonly id: string;
            readonly name: string;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
            readonly dietaryProperties: ReadonlyArray<{
              readonly __typename?: 'DietaryProperty';
              readonly id: string;
              readonly name: DietaryPropertyKind;
            }>;
          };
        }>;
      };
      readonly toppings: {
        readonly __typename?: 'IngredientModificationKind';
        readonly minAggregateQuantity: number;
        readonly maxAggregateQuantity: number;
        readonly freeAggregateQuantity: number;
        readonly allowMultipleQuantity: boolean;
        readonly modifications: ReadonlyArray<{
          readonly __typename?: 'IngredientModification';
          readonly calories: number;
          readonly removalCost: number;
          readonly additionCost: number;
          readonly substitutionCost: number;
          readonly kind: string | null;
          readonly subKind: string | null;
          readonly outOfStock: boolean;
          readonly mixable: boolean;
          readonly isGrain: boolean;
          readonly ingredient: {
            readonly __typename?: 'Ingredient';
            readonly id: string;
            readonly name: string;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
            readonly dietaryProperties: ReadonlyArray<{
              readonly __typename?: 'DietaryProperty';
              readonly id: string;
              readonly name: DietaryPropertyKind;
            }>;
          };
        }>;
      };
      readonly premiums: {
        readonly __typename?: 'IngredientModificationKind';
        readonly minAggregateQuantity: number;
        readonly maxAggregateQuantity: number;
        readonly freeAggregateQuantity: number;
        readonly allowMultipleQuantity: boolean;
        readonly modifications: ReadonlyArray<{
          readonly __typename?: 'IngredientModification';
          readonly calories: number;
          readonly removalCost: number;
          readonly additionCost: number;
          readonly substitutionCost: number;
          readonly kind: string | null;
          readonly subKind: string | null;
          readonly outOfStock: boolean;
          readonly mixable: boolean;
          readonly isGrain: boolean;
          readonly ingredient: {
            readonly __typename?: 'Ingredient';
            readonly id: string;
            readonly name: string;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
            readonly dietaryProperties: ReadonlyArray<{
              readonly __typename?: 'DietaryProperty';
              readonly id: string;
              readonly name: DietaryPropertyKind;
            }>;
          };
        }>;
      };
      readonly dressings: {
        readonly __typename?: 'IngredientModificationKind';
        readonly minAggregateQuantity: number;
        readonly maxAggregateQuantity: number;
        readonly freeAggregateQuantity: number;
        readonly allowMultipleQuantity: boolean;
        readonly modifications: ReadonlyArray<{
          readonly __typename?: 'IngredientModification';
          readonly calories: number;
          readonly removalCost: number;
          readonly additionCost: number;
          readonly substitutionCost: number;
          readonly kind: string | null;
          readonly subKind: string | null;
          readonly outOfStock: boolean;
          readonly mixable: boolean;
          readonly isGrain: boolean;
          readonly ingredient: {
            readonly __typename?: 'Ingredient';
            readonly id: string;
            readonly name: string;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
            readonly dietaryProperties: ReadonlyArray<{
              readonly __typename?: 'DietaryProperty';
              readonly id: string;
              readonly name: DietaryPropertyKind;
            }>;
          };
        }>;
      };
      readonly bread: {
        readonly __typename?: 'IngredientModificationKind';
        readonly minAggregateQuantity: number;
        readonly maxAggregateQuantity: number;
        readonly freeAggregateQuantity: number;
        readonly allowMultipleQuantity: boolean;
        readonly modifications: ReadonlyArray<{
          readonly __typename?: 'IngredientModification';
          readonly calories: number;
          readonly removalCost: number;
          readonly additionCost: number;
          readonly substitutionCost: number;
          readonly kind: string | null;
          readonly subKind: string | null;
          readonly outOfStock: boolean;
          readonly mixable: boolean;
          readonly isGrain: boolean;
          readonly ingredient: {
            readonly __typename?: 'Ingredient';
            readonly id: string;
            readonly name: string;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
            readonly dietaryProperties: ReadonlyArray<{
              readonly __typename?: 'DietaryProperty';
              readonly id: string;
              readonly name: DietaryPropertyKind;
            }>;
          };
        }>;
      };
    };
  };
};

export type UpdateCustomerProfileMutationVariables = Exact<{
  input: UpdateCustomerInput;
}>;

export type UpdateCustomerProfileMutation = {
  readonly __typename?: 'Mutation';
  readonly updateCustomer: {
    readonly __typename?: 'UpdateCustomerResponse';
    readonly customer: {
      readonly __typename: 'Customer';
      readonly id: string;
      readonly firstName: string | null;
      readonly lastName: string | null;
      readonly email: string | null;
      readonly phoneNumber: string | null;
      readonly birthday: string | null;
    };
  } | null;
};

export type CustomerProfileFieldsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type CustomerProfileFieldsQuery = {
  readonly __typename?: 'Query';
  readonly currentCustomer: {
    readonly __typename: 'Customer';
    readonly id: string;
    readonly firstName: string | null;
    readonly lastName: string | null;
    readonly email: string | null;
    readonly phoneNumber: string | null;
    readonly birthday: string | null;
  } | null;
};

export type FeedbackQuestionsQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;

export type FeedbackQuestionsQuery = {
  readonly __typename?: 'Query';
  readonly feedbackQuestions: ReadonlyArray<{
    readonly __typename?: 'FeedbackQuestion';
    readonly id: string;
    readonly text: string | null;
    readonly slug: string | null;
    readonly responses: ReadonlyArray<{
      readonly __typename?: 'FeedbackResponse';
      readonly id: string;
      readonly text: string;
    }> | null;
  }>;
};

export type InStoreFeedbackQuestionsQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;

export type InStoreFeedbackQuestionsQuery = {
  readonly __typename?: 'Query';
  readonly inStoreFeedbackQuestions: ReadonlyArray<{
    readonly __typename?: 'FeedbackQuestion';
    readonly id: string;
    readonly text: string | null;
    readonly slug: string | null;
    readonly responses: ReadonlyArray<{
      readonly __typename?: 'FeedbackResponse';
      readonly id: string;
      readonly text: string;
    }> | null;
  }>;
};

export type FeedbackOrderStatusQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;

export type FeedbackOrderStatusQuery = {
  readonly __typename?: 'Query';
  readonly orderStatus:
    | { readonly __typename: 'InvalidOrder' }
    | {
        readonly __typename: 'OrderStatus';
        readonly order: {
          readonly __typename?: 'Order';
          readonly id: string;
          readonly orderType: OrderType;
          readonly wantedTime: string;
          readonly description: string;
          readonly restaurant: {
            readonly __typename?: 'Restaurant';
            readonly id: string;
            readonly slug: string;
            readonly name: string;
          };
          readonly lineItems: ReadonlyArray<{
            readonly __typename?: 'LineItem';
            readonly id: string;
            readonly quantity: number;
            readonly customName: string | null;
            readonly product: {
              readonly __typename?: 'Product';
              readonly id: string;
              readonly name: string;
              readonly slug: string;
            };
          }>;
        };
      }
    | null;
};

export type SubmitFeedbackMutationVariables = Exact<{
  input: FeedbackInput;
}>;

export type SubmitFeedbackMutation = {
  readonly __typename?: 'Mutation';
  readonly submitFeedback: {
    readonly __typename?: 'FeedbackSuccess';
    readonly success: boolean;
  };
};

export type SubmitInStoreFeedbackMutationVariables = Exact<{
  input: FeedbackInput;
}>;

export type SubmitInStoreFeedbackMutation = {
  readonly __typename?: 'Mutation';
  readonly submitInStoreFeedback: {
    readonly __typename?: 'FeedbackSuccess';
    readonly success: boolean;
  };
};

export type ReferralShareUrlQueryVariables = Exact<{ [key: string]: never }>;

export type ReferralShareUrlQuery = {
  readonly __typename?: 'Query';
  readonly currentCustomer: {
    readonly __typename?: 'Customer';
    readonly id: string;
    readonly referralShareUrlEmail: string;
  } | null;
};

export type ReorderOrderMutationVariables = Exact<{
  input: ReorderInput;
}>;

export type ReorderOrderMutation = {
  readonly __typename?: 'Mutation';
  readonly reorderOrder:
    | {
        readonly __typename: 'CanNotReorder';
        readonly message: string;
        readonly conflicts: ReadonlyArray<{
          readonly __typename?: 'OrderConflict';
          readonly type: ConflictType;
          readonly product: {
            readonly __typename?: 'Product';
            readonly id: string;
            readonly name: string;
            readonly calories: number;
            readonly cost: number;
            readonly description: string;
            readonly label: {
              readonly __typename?: 'ProductLabel';
              readonly name: string;
            } | null;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
            readonly dietaryProperties: ReadonlyArray<{
              readonly __typename?: 'DietaryProperty';
              readonly id: string;
              readonly name: DietaryPropertyKind;
            }>;
          };
          readonly unavailableIngredients: ReadonlyArray<{
            readonly __typename?: 'Ingredient';
            readonly name: string;
          }>;
        }>;
      }
    | {
        readonly __typename: 'ReorderConflict';
        readonly isNothingAvailable: boolean;
        readonly conflicts: ReadonlyArray<{
          readonly __typename?: 'OrderConflict';
          readonly type: ConflictType;
          readonly product: {
            readonly __typename?: 'Product';
            readonly id: string;
            readonly name: string;
            readonly calories: number;
            readonly cost: number;
            readonly description: string;
            readonly label: {
              readonly __typename?: 'ProductLabel';
              readonly name: string;
            } | null;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
            readonly dietaryProperties: ReadonlyArray<{
              readonly __typename?: 'DietaryProperty';
              readonly id: string;
              readonly name: DietaryPropertyKind;
            }>;
          };
          readonly unavailableIngredients: ReadonlyArray<{
            readonly __typename?: 'Ingredient';
            readonly name: string;
          }>;
        }>;
      }
    | {
        readonly __typename: 'ReorderSuccess';
        readonly isMixingSupported: boolean;
        readonly cart: {
          readonly __typename?: 'Order';
          readonly id: string;
          readonly orderType: OrderType;
          readonly ledger: {
            readonly __typename?: 'Ledger';
            readonly tax: number;
            readonly subtotal: number;
            readonly feesTotal: number;
            readonly discountsTotal: number;
            readonly creditsTotal: number;
            readonly tip: number;
            readonly discounts: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly credits: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly fees: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
          };
          readonly lineItems: ReadonlyArray<{
            readonly __typename?: 'LineItem';
            readonly id: string;
            readonly slug: string;
            readonly quantity: number;
            readonly cost: number;
            readonly customName: string | null;
            readonly perItemCost: number;
            readonly favorited: boolean;
            readonly isCustom: boolean;
            readonly dressingMode: DressingMode;
            readonly addedIngredients: ReadonlyArray<{
              readonly __typename?: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: IngredientKind | null;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
            }>;
            readonly removedIngredients: ReadonlyArray<{
              readonly __typename?: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: IngredientKind | null;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
            }>;
            readonly product: {
              readonly __typename?: 'Product';
              readonly id: string;
              readonly name: string;
              readonly slug: string;
              readonly isCustom: boolean;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
              readonly ingredients: ReadonlyArray<{
                readonly __typename?: 'Ingredient';
                readonly id: string;
                readonly name: string;
                readonly kind: IngredientKind | null;
              }>;
            };
            readonly mixedDressingDetails: ReadonlyArray<{
              readonly __typename?: 'MixedDressingDetails';
              readonly ingredientId: string;
              readonly weight: DressingWeight;
            }>;
          }>;
          readonly restaurant: {
            readonly __typename?: 'Restaurant';
            readonly id: string;
            readonly slug: string;
            readonly name: string;
            readonly city: string;
            readonly state: string;
            readonly address: string;
            readonly zipCode: string;
            readonly isOutpost: boolean;
            readonly deliveryMinSubtotal: number;
            readonly availableDropOffLocations: ReadonlyArray<{
              readonly __typename?: 'DropOffLocation';
              readonly id: string;
              readonly name: string;
            }>;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
          };
          readonly availableWantedTimes: ReadonlyArray<{
            readonly __typename?: 'AvailableWantedTime';
            readonly time: string;
          }>;
          readonly deliveryOrderDetail: {
            readonly __typename?: 'DeliveryOrderDetail';
            readonly id: string;
            readonly tip: number;
            readonly deliveryFee: number;
            readonly vendor: string;
            readonly orderId: string;
            readonly vendorRestaurantId: string;
            readonly estimatedDeliveryTime: string | null;
            readonly address: {
              readonly __typename?: 'Address';
              readonly id: string;
              readonly street: string;
              readonly secondaryStreet: string | null;
              readonly city: string;
              readonly state: string;
              readonly country: string;
              readonly zipCode: string;
              readonly deliveryPreference: DeliveryPreferenceType;
              readonly googlePlaceId: string;
              readonly latitude: number;
              readonly longitude: number;
              readonly name: string | null;
              readonly notes: string | null;
            };
          } | null;
        };
      }
    | {
        readonly __typename: 'RestaurantMaxDeliveryQuantityExceeded';
        readonly message: string;
        readonly conflicts: ReadonlyArray<{
          readonly __typename?: 'OrderConflict';
          readonly type: ConflictType;
          readonly product: {
            readonly __typename?: 'Product';
            readonly id: string;
            readonly name: string;
            readonly calories: number;
            readonly cost: number;
            readonly description: string;
            readonly label: {
              readonly __typename?: 'ProductLabel';
              readonly name: string;
            } | null;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
            readonly dietaryProperties: ReadonlyArray<{
              readonly __typename?: 'DietaryProperty';
              readonly id: string;
              readonly name: DietaryPropertyKind;
            }>;
          };
          readonly unavailableIngredients: ReadonlyArray<{
            readonly __typename?: 'Ingredient';
            readonly name: string;
          }>;
        }>;
      }
    | {
        readonly __typename: 'RestaurantMaxQuantityExceeded';
        readonly message: string;
        readonly conflicts: ReadonlyArray<{
          readonly __typename?: 'OrderConflict';
          readonly type: ConflictType;
          readonly product: {
            readonly __typename?: 'Product';
            readonly id: string;
            readonly name: string;
            readonly calories: number;
            readonly cost: number;
            readonly description: string;
            readonly label: {
              readonly __typename?: 'ProductLabel';
              readonly name: string;
            } | null;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
            readonly dietaryProperties: ReadonlyArray<{
              readonly __typename?: 'DietaryProperty';
              readonly id: string;
              readonly name: DietaryPropertyKind;
            }>;
          };
          readonly unavailableIngredients: ReadonlyArray<{
            readonly __typename?: 'Ingredient';
            readonly name: string;
          }>;
        }>;
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export type ReorderLineItemMutationVariables = Exact<{
  input: ReorderInput;
}>;

export type ReorderLineItemMutation = {
  readonly __typename?: 'Mutation';
  readonly reorderLineItem:
    | {
        readonly __typename: 'CanNotReorder';
        readonly message: string;
        readonly conflicts: ReadonlyArray<{
          readonly __typename?: 'OrderConflict';
          readonly type: ConflictType;
          readonly product: {
            readonly __typename?: 'Product';
            readonly id: string;
            readonly name: string;
            readonly calories: number;
            readonly cost: number;
            readonly description: string;
            readonly label: {
              readonly __typename?: 'ProductLabel';
              readonly name: string;
            } | null;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
            readonly dietaryProperties: ReadonlyArray<{
              readonly __typename?: 'DietaryProperty';
              readonly id: string;
              readonly name: DietaryPropertyKind;
            }>;
          };
          readonly unavailableIngredients: ReadonlyArray<{
            readonly __typename?: 'Ingredient';
            readonly name: string;
          }>;
        }>;
      }
    | {
        readonly __typename: 'ReorderConflict';
        readonly isNothingAvailable: boolean;
        readonly conflicts: ReadonlyArray<{
          readonly __typename?: 'OrderConflict';
          readonly type: ConflictType;
          readonly product: {
            readonly __typename?: 'Product';
            readonly id: string;
            readonly name: string;
            readonly calories: number;
            readonly cost: number;
            readonly description: string;
            readonly label: {
              readonly __typename?: 'ProductLabel';
              readonly name: string;
            } | null;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
            readonly dietaryProperties: ReadonlyArray<{
              readonly __typename?: 'DietaryProperty';
              readonly id: string;
              readonly name: DietaryPropertyKind;
            }>;
          };
          readonly unavailableIngredients: ReadonlyArray<{
            readonly __typename?: 'Ingredient';
            readonly name: string;
          }>;
        }>;
      }
    | {
        readonly __typename: 'ReorderSuccess';
        readonly isMixingSupported: boolean;
        readonly cart: {
          readonly __typename?: 'Order';
          readonly id: string;
          readonly orderType: OrderType;
          readonly ledger: {
            readonly __typename?: 'Ledger';
            readonly tax: number;
            readonly subtotal: number;
            readonly feesTotal: number;
            readonly discountsTotal: number;
            readonly creditsTotal: number;
            readonly tip: number;
            readonly discounts: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly credits: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly fees: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
          };
          readonly lineItems: ReadonlyArray<{
            readonly __typename?: 'LineItem';
            readonly id: string;
            readonly slug: string;
            readonly quantity: number;
            readonly cost: number;
            readonly customName: string | null;
            readonly perItemCost: number;
            readonly favorited: boolean;
            readonly isCustom: boolean;
            readonly dressingMode: DressingMode;
            readonly addedIngredients: ReadonlyArray<{
              readonly __typename?: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: IngredientKind | null;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
            }>;
            readonly removedIngredients: ReadonlyArray<{
              readonly __typename?: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: IngredientKind | null;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
            }>;
            readonly product: {
              readonly __typename?: 'Product';
              readonly id: string;
              readonly name: string;
              readonly slug: string;
              readonly isCustom: boolean;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
              readonly ingredients: ReadonlyArray<{
                readonly __typename?: 'Ingredient';
                readonly id: string;
                readonly name: string;
                readonly kind: IngredientKind | null;
              }>;
            };
            readonly mixedDressingDetails: ReadonlyArray<{
              readonly __typename?: 'MixedDressingDetails';
              readonly ingredientId: string;
              readonly weight: DressingWeight;
            }>;
          }>;
          readonly restaurant: {
            readonly __typename?: 'Restaurant';
            readonly id: string;
            readonly slug: string;
            readonly name: string;
            readonly city: string;
            readonly state: string;
            readonly address: string;
            readonly zipCode: string;
            readonly isOutpost: boolean;
            readonly deliveryMinSubtotal: number;
            readonly availableDropOffLocations: ReadonlyArray<{
              readonly __typename?: 'DropOffLocation';
              readonly id: string;
              readonly name: string;
            }>;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
          };
          readonly availableWantedTimes: ReadonlyArray<{
            readonly __typename?: 'AvailableWantedTime';
            readonly time: string;
          }>;
          readonly deliveryOrderDetail: {
            readonly __typename?: 'DeliveryOrderDetail';
            readonly id: string;
            readonly tip: number;
            readonly deliveryFee: number;
            readonly vendor: string;
            readonly orderId: string;
            readonly vendorRestaurantId: string;
            readonly estimatedDeliveryTime: string | null;
            readonly address: {
              readonly __typename?: 'Address';
              readonly id: string;
              readonly street: string;
              readonly secondaryStreet: string | null;
              readonly city: string;
              readonly state: string;
              readonly country: string;
              readonly zipCode: string;
              readonly deliveryPreference: DeliveryPreferenceType;
              readonly googlePlaceId: string;
              readonly latitude: number;
              readonly longitude: number;
              readonly name: string | null;
              readonly notes: string | null;
            };
          } | null;
        };
      }
    | {
        readonly __typename: 'RestaurantMaxDeliveryQuantityExceeded';
        readonly message: string;
        readonly conflicts: ReadonlyArray<{
          readonly __typename?: 'OrderConflict';
          readonly type: ConflictType;
          readonly product: {
            readonly __typename?: 'Product';
            readonly id: string;
            readonly name: string;
            readonly calories: number;
            readonly cost: number;
            readonly description: string;
            readonly label: {
              readonly __typename?: 'ProductLabel';
              readonly name: string;
            } | null;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
            readonly dietaryProperties: ReadonlyArray<{
              readonly __typename?: 'DietaryProperty';
              readonly id: string;
              readonly name: DietaryPropertyKind;
            }>;
          };
          readonly unavailableIngredients: ReadonlyArray<{
            readonly __typename?: 'Ingredient';
            readonly name: string;
          }>;
        }>;
      }
    | {
        readonly __typename: 'RestaurantMaxQuantityExceeded';
        readonly message: string;
        readonly conflicts: ReadonlyArray<{
          readonly __typename?: 'OrderConflict';
          readonly type: ConflictType;
          readonly product: {
            readonly __typename?: 'Product';
            readonly id: string;
            readonly name: string;
            readonly calories: number;
            readonly cost: number;
            readonly description: string;
            readonly label: {
              readonly __typename?: 'ProductLabel';
              readonly name: string;
            } | null;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
            readonly dietaryProperties: ReadonlyArray<{
              readonly __typename?: 'DietaryProperty';
              readonly id: string;
              readonly name: DietaryPropertyKind;
            }>;
          };
          readonly unavailableIngredients: ReadonlyArray<{
            readonly __typename?: 'Ingredient';
            readonly name: string;
          }>;
        }>;
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export type ReorderSuccessResponseFragment = {
  readonly __typename?: 'ReorderSuccess';
  readonly isMixingSupported: boolean;
  readonly cart: {
    readonly __typename?: 'Order';
    readonly id: string;
    readonly orderType: OrderType;
    readonly ledger: {
      readonly __typename?: 'Ledger';
      readonly tax: number;
      readonly subtotal: number;
      readonly feesTotal: number;
      readonly discountsTotal: number;
      readonly creditsTotal: number;
      readonly tip: number;
      readonly discounts: ReadonlyArray<{
        readonly __typename?: 'LedgerItem';
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
      readonly credits: ReadonlyArray<{
        readonly __typename?: 'LedgerItem';
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
      readonly fees: ReadonlyArray<{
        readonly __typename?: 'LedgerItem';
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
    };
    readonly lineItems: ReadonlyArray<{
      readonly __typename?: 'LineItem';
      readonly id: string;
      readonly slug: string;
      readonly quantity: number;
      readonly cost: number;
      readonly customName: string | null;
      readonly perItemCost: number;
      readonly favorited: boolean;
      readonly isCustom: boolean;
      readonly dressingMode: DressingMode;
      readonly addedIngredients: ReadonlyArray<{
        readonly __typename?: 'Ingredient';
        readonly id: string;
        readonly name: string;
        readonly kind: IngredientKind | null;
        readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      }>;
      readonly removedIngredients: ReadonlyArray<{
        readonly __typename?: 'Ingredient';
        readonly id: string;
        readonly name: string;
        readonly kind: IngredientKind | null;
        readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      }>;
      readonly product: {
        readonly __typename?: 'Product';
        readonly id: string;
        readonly name: string;
        readonly slug: string;
        readonly isCustom: boolean;
        readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
        readonly ingredients: ReadonlyArray<{
          readonly __typename?: 'Ingredient';
          readonly id: string;
          readonly name: string;
          readonly kind: IngredientKind | null;
        }>;
      };
      readonly mixedDressingDetails: ReadonlyArray<{
        readonly __typename?: 'MixedDressingDetails';
        readonly ingredientId: string;
        readonly weight: DressingWeight;
      }>;
    }>;
    readonly restaurant: {
      readonly __typename?: 'Restaurant';
      readonly id: string;
      readonly slug: string;
      readonly name: string;
      readonly city: string;
      readonly state: string;
      readonly address: string;
      readonly zipCode: string;
      readonly isOutpost: boolean;
      readonly deliveryMinSubtotal: number;
      readonly availableDropOffLocations: ReadonlyArray<{
        readonly __typename?: 'DropOffLocation';
        readonly id: string;
        readonly name: string;
      }>;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
    };
    readonly availableWantedTimes: ReadonlyArray<{
      readonly __typename?: 'AvailableWantedTime';
      readonly time: string;
    }>;
    readonly deliveryOrderDetail: {
      readonly __typename?: 'DeliveryOrderDetail';
      readonly id: string;
      readonly tip: number;
      readonly deliveryFee: number;
      readonly vendor: string;
      readonly orderId: string;
      readonly vendorRestaurantId: string;
      readonly estimatedDeliveryTime: string | null;
      readonly address: {
        readonly __typename?: 'Address';
        readonly id: string;
        readonly street: string;
        readonly secondaryStreet: string | null;
        readonly city: string;
        readonly state: string;
        readonly country: string;
        readonly zipCode: string;
        readonly deliveryPreference: DeliveryPreferenceType;
        readonly googlePlaceId: string;
        readonly latitude: number;
        readonly longitude: number;
        readonly name: string | null;
        readonly notes: string | null;
      };
    } | null;
  };
};

export type ConflictFragment = {
  readonly __typename?: 'OrderConflict';
  readonly type: ConflictType;
  readonly product: {
    readonly __typename?: 'Product';
    readonly id: string;
    readonly name: string;
    readonly calories: number;
    readonly cost: number;
    readonly description: string;
    readonly label: {
      readonly __typename?: 'ProductLabel';
      readonly name: string;
    } | null;
    readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
    readonly dietaryProperties: ReadonlyArray<{
      readonly __typename?: 'DietaryProperty';
      readonly id: string;
      readonly name: DietaryPropertyKind;
    }>;
  };
  readonly unavailableIngredients: ReadonlyArray<{
    readonly __typename?: 'Ingredient';
    readonly name: string;
  }>;
};

export type ReorderConflictResponseFragment = {
  readonly __typename?: 'ReorderConflict';
  readonly isNothingAvailable: boolean;
  readonly conflicts: ReadonlyArray<{
    readonly __typename?: 'OrderConflict';
    readonly type: ConflictType;
    readonly product: {
      readonly __typename?: 'Product';
      readonly id: string;
      readonly name: string;
      readonly calories: number;
      readonly cost: number;
      readonly description: string;
      readonly label: {
        readonly __typename?: 'ProductLabel';
        readonly name: string;
      } | null;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      readonly dietaryProperties: ReadonlyArray<{
        readonly __typename?: 'DietaryProperty';
        readonly id: string;
        readonly name: DietaryPropertyKind;
      }>;
    };
    readonly unavailableIngredients: ReadonlyArray<{
      readonly __typename?: 'Ingredient';
      readonly name: string;
    }>;
  }>;
};

export type RestaurantMaxDeliveryQuantityExceededResponseFragment = {
  readonly __typename?: 'RestaurantMaxDeliveryQuantityExceeded';
  readonly message: string;
  readonly conflicts: ReadonlyArray<{
    readonly __typename?: 'OrderConflict';
    readonly type: ConflictType;
    readonly product: {
      readonly __typename?: 'Product';
      readonly id: string;
      readonly name: string;
      readonly calories: number;
      readonly cost: number;
      readonly description: string;
      readonly label: {
        readonly __typename?: 'ProductLabel';
        readonly name: string;
      } | null;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      readonly dietaryProperties: ReadonlyArray<{
        readonly __typename?: 'DietaryProperty';
        readonly id: string;
        readonly name: DietaryPropertyKind;
      }>;
    };
    readonly unavailableIngredients: ReadonlyArray<{
      readonly __typename?: 'Ingredient';
      readonly name: string;
    }>;
  }>;
};

export type RestaurantMaxQuantityExceededResponseFragment = {
  readonly __typename?: 'RestaurantMaxQuantityExceeded';
  readonly message: string;
  readonly conflicts: ReadonlyArray<{
    readonly __typename?: 'OrderConflict';
    readonly type: ConflictType;
    readonly product: {
      readonly __typename?: 'Product';
      readonly id: string;
      readonly name: string;
      readonly calories: number;
      readonly cost: number;
      readonly description: string;
      readonly label: {
        readonly __typename?: 'ProductLabel';
        readonly name: string;
      } | null;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      readonly dietaryProperties: ReadonlyArray<{
        readonly __typename?: 'DietaryProperty';
        readonly id: string;
        readonly name: DietaryPropertyKind;
      }>;
    };
    readonly unavailableIngredients: ReadonlyArray<{
      readonly __typename?: 'Ingredient';
      readonly name: string;
    }>;
  }>;
};

export type CanNotReorderResponseFragment = {
  readonly __typename?: 'CanNotReorder';
  readonly message: string;
  readonly conflicts: ReadonlyArray<{
    readonly __typename?: 'OrderConflict';
    readonly type: ConflictType;
    readonly product: {
      readonly __typename?: 'Product';
      readonly id: string;
      readonly name: string;
      readonly calories: number;
      readonly cost: number;
      readonly description: string;
      readonly label: {
        readonly __typename?: 'ProductLabel';
        readonly name: string;
      } | null;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      readonly dietaryProperties: ReadonlyArray<{
        readonly __typename?: 'DietaryProperty';
        readonly id: string;
        readonly name: DietaryPropertyKind;
      }>;
    };
    readonly unavailableIngredients: ReadonlyArray<{
      readonly __typename?: 'Ingredient';
      readonly name: string;
    }>;
  }>;
};

export type ValidationErrorResponseFragment = {
  readonly __typename?: 'ValidationError';
  readonly message: string;
  readonly status: number;
  readonly fieldErrors: ReadonlyArray<{
    readonly __typename?: 'FieldValidationError';
    readonly field: string;
    readonly message: string;
  }>;
};

export type ReorderRestaurantQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type ReorderRestaurantQuery = {
  readonly __typename?: 'Query';
  readonly restaurant: {
    readonly __typename?: 'Restaurant';
    readonly id: string;
    readonly name: string;
    readonly latitude: number;
    readonly longitude: number;
    readonly slug: string;
    readonly address: string;
    readonly city: string;
    readonly state: string;
    readonly zipCode: string;
    readonly isOutpost: boolean;
    readonly phone: string;
    readonly flexMessage: string | null;
    readonly isAcceptingOrders: boolean;
    readonly notAcceptingOrdersReason: string;
    readonly hours: {
      readonly __typename?: 'RestaurantHours';
      readonly formatted: string | null;
    };
    readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
  };
};

export type ReorderRestaurantRequiredDataFragment = {
  readonly __typename?: 'Restaurant';
  readonly id: string;
  readonly name: string;
  readonly latitude: number;
  readonly longitude: number;
  readonly slug: string;
  readonly address: string;
  readonly city: string;
  readonly state: string;
  readonly zipCode: string;
  readonly isOutpost: boolean;
  readonly phone: string;
  readonly flexMessage: string | null;
  readonly isAcceptingOrders: boolean;
  readonly notAcceptingOrdersReason: string;
  readonly hours: {
    readonly __typename?: 'RestaurantHours';
    readonly formatted: string | null;
  };
  readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
};

export type ReorderRestaurantDataQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type ReorderRestaurantDataQuery = {
  readonly __typename?: 'Query';
  readonly restaurant: {
    readonly __typename?: 'Restaurant';
    readonly id: string;
    readonly slug: string;
    readonly name: string;
    readonly isOutpost: boolean;
    readonly deliveryFee: number;
  };
};

export type ReorderDeliveryRestaurantDataQueryVariables = Exact<{
  input: LocationByAddressInput;
}>;

export type ReorderDeliveryRestaurantDataQuery = {
  readonly __typename?: 'Query';
  readonly locationByAddress:
    | { readonly __typename: 'InvalidInput' }
    | {
        readonly __typename: 'Location';
        readonly restaurant: {
          readonly __typename?: 'Restaurant';
          readonly id: string;
          readonly slug: string;
          readonly name: string;
          readonly isOutpost: boolean;
          readonly deliveryFee: number;
        };
        readonly vendor: {
          readonly __typename?: 'Vendor';
          readonly name: string;
          readonly restaurantId: string;
        };
      }
    | { readonly __typename: 'NoValidRestaurants' }
    | { readonly __typename: 'ValidationError' };
};

export type ReorderDeliveryAddressDataQueryVariables = Exact<{
  addressId: Scalars['ID'];
}>;

export type ReorderDeliveryAddressDataQuery = {
  readonly __typename?: 'Query';
  readonly address: {
    readonly __typename?: 'Address';
    readonly id: string;
    readonly name: string | null;
  } | null;
};

export type ScanToPayBillingAccountsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ScanToPayBillingAccountsQuery = {
  readonly __typename?: 'Query';
  readonly currentCustomer: {
    readonly __typename?: 'Customer';
    readonly id: string;
    readonly billingAccounts: ReadonlyArray<{
      readonly __typename?: 'BillingAccount';
      readonly id: string;
      readonly description: string;
      readonly nickname: string | null;
      readonly isDefault: boolean;
      readonly cardType: CardType;
      readonly expirationState: ExpirationState;
    }>;
  } | null;
};

export type CustomerPassQueryVariables = Exact<{ [key: string]: never }>;

export type CustomerPassQuery = {
  readonly __typename?: 'Query';
  readonly customerPass: {
    readonly __typename?: 'CustomerPass';
    readonly authenticationToken: string | null;
    readonly url: string | null;
  } | null;
};

export type GetSharedLineItemQueryVariables = Exact<{
  input: LineItemBySlugInput;
}>;

export type GetSharedLineItemQuery = {
  readonly __typename?: 'Query';
  readonly lineItemBySlug:
    | {
        readonly __typename: 'LineItemNotFound';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'LineItemSuccess';
        readonly lineItem: {
          readonly __typename?: 'LineItem';
          readonly id: string;
          readonly slug: string;
          readonly quantity: number;
          readonly customName: string | null;
          readonly customerName: string;
          readonly isCustom: boolean;
          readonly dressingMode: DressingMode;
          readonly product: {
            readonly __typename?: 'Product';
            readonly id: string;
            readonly name: string;
            readonly calories: number;
            readonly cost: number;
            readonly isCustom: boolean;
            readonly description: string;
            readonly label: {
              readonly __typename?: 'ProductLabel';
              readonly id: string;
              readonly name: string;
            } | null;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
            readonly dietaryProperties: ReadonlyArray<{
              readonly __typename?: 'DietaryProperty';
              readonly id: string;
              readonly name: DietaryPropertyKind;
            }>;
            readonly restaurant: {
              readonly __typename?: 'Restaurant';
              readonly id: string;
              readonly slug: string;
              readonly name: string;
            };
          };
        };
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      }
    | null;
};

export type GetBillingHistoryQueryVariables = Exact<{ [key: string]: never }>;

export type GetBillingHistoryQuery = {
  readonly __typename?: 'Query';
  readonly getSubscriptions: ReadonlyArray<{
    readonly __typename?: 'PaymentSubscription';
    readonly id: string;
    readonly status: string;
    readonly nextBillingDate: string;
    readonly paidThroughDate: any | null;
    readonly billingHistory: ReadonlyArray<{
      readonly __typename?: 'SubscriptionTransactions';
      readonly id: string;
      readonly date: any;
      readonly amount: string;
      readonly refund: boolean;
      readonly creditCard: {
        readonly __typename?: 'SubscriptionCreditCard';
        readonly id: string;
        readonly cardType: BraintreeCardType;
        readonly lastFour: string;
      };
    }>;
  }>;
};

export type AddSubscriptionPaymentMethodMutationVariables = Exact<{
  nonce: Scalars['String'];
}>;

export type AddSubscriptionPaymentMethodMutation = {
  readonly __typename?: 'Mutation';
  readonly addSubscriptionPaymentMethod:
    | {
        readonly __typename: 'AddSubscriptionPaymentMethodSuccessResponse';
        readonly paymentMethodToken: string;
        readonly creditCard: {
          readonly __typename?: 'SubscriptionCreditCard';
          readonly id: string;
          readonly cardType: BraintreeCardType;
          readonly lastFour: string;
          readonly expirationMonth: string | null;
          readonly expirationYear: string | null;
          readonly isActive: boolean;
        };
      }
    | {
        readonly __typename: 'PaymentMethodAlreadyExistsError';
        readonly errorMessage: string;
      }
    | {
        readonly __typename: 'UnknownUserError';
        readonly errorMessage: string;
      };
};

export type RemoveSubscriptionPaymentMethodMutationVariables = Exact<{
  paymentMethodId: Scalars['String'];
}>;

export type RemoveSubscriptionPaymentMethodMutation = {
  readonly __typename?: 'Mutation';
  readonly removeSubscriptionPaymentMethod:
    | {
        readonly __typename: 'ActivePaymentMethodError';
        readonly errorMessage: string;
      }
    | {
        readonly __typename: 'DeleteSubscriptionPaymentMethodSuccess';
        readonly creditCards: ReadonlyArray<{
          readonly __typename: 'SubscriptionCreditCard';
          readonly id: string;
          readonly cardType: BraintreeCardType;
          readonly lastFour: string;
        }>;
      }
    | {
        readonly __typename: 'UnknownUserError';
        readonly errorMessage: string;
      };
};

export type GetPaymentSubscriptionProfileQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetPaymentSubscriptionProfileQuery = {
  readonly __typename?: 'Query';
  readonly paymentSubscriptionProfile: {
    readonly __typename?: 'PaymentSubscriptionProfile';
    readonly id: string;
    readonly creditCards: ReadonlyArray<{
      readonly __typename?: 'SubscriptionCreditCard';
      readonly id: string;
      readonly cardType: BraintreeCardType;
      readonly lastFour: string;
    }> | null;
  } | null;
};

export type SubscribeMutationVariables = Exact<{
  token?: InputMaybe<Scalars['String']>;
  planId: Scalars['String'];
  paymentId?: InputMaybe<Scalars['String']>;
}>;

export type SubscribeMutation = {
  readonly __typename?: 'Mutation';
  readonly createSubscription: {
    readonly __typename?: 'CreateSubscriptionResult';
    readonly id: string;
    readonly trialDuration: boolean;
    readonly status: string;
    readonly firstBillingDate: any | null;
    readonly subscriptionAmount: string;
  };
};

export type CancelSubscriptionAtCycleEndMutationVariables = Exact<{
  subscriptionId: Scalars['String'];
}>;

export type CancelSubscriptionAtCycleEndMutation = {
  readonly __typename?: 'Mutation';
  readonly cancelSubscriptionAtCycleEnd:
    | {
        readonly __typename?: 'CancelSubscriptionAtCycleEndSuccessResponse';
        readonly subscription: {
          readonly __typename?: 'PaymentSubscription';
          readonly id: string;
          readonly paidThroughDate: any | null;
        };
      }
    | { readonly __typename?: 'UnknownUserError' };
};

export type GetSweetpassMembershipQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetSweetpassMembershipQuery = {
  readonly __typename?: 'Query';
  readonly loyaltyProfile: {
    readonly __typename?: 'LoyaltyProfile';
    readonly customerId: string;
    readonly joinDate: any;
    readonly hasPaidTierHistory: boolean;
    readonly tierStatus: {
      readonly __typename?: 'TierStatus';
      readonly id: string;
      readonly name: TierStatusName;
    } | null;
    readonly tier: {
      readonly __typename?: 'Tier';
      readonly id: string;
      readonly name: TierName;
      readonly nextTier: {
        readonly __typename?: 'Tier';
        readonly id: string;
        readonly name: TierName;
      } | null;
    } | null;
  } | null;
  readonly getSubscriptions: ReadonlyArray<{
    readonly __typename?: 'PaymentSubscription';
    readonly id: string;
    readonly paidThroughDate: any | null;
    readonly nextBillingDate: string;
    readonly nextBillingPeriodAmount: string;
  }>;
  readonly paymentSubscriptionProfile: {
    readonly __typename?: 'PaymentSubscriptionProfile';
    readonly id: string;
    readonly creditCards: ReadonlyArray<{
      readonly __typename?: 'SubscriptionCreditCard';
      readonly id: string;
      readonly cardType: BraintreeCardType;
      readonly lastFour: string;
      readonly expirationMonth: string | null;
      readonly expirationYear: string | null;
      readonly isActive: boolean;
    }> | null;
  } | null;
};

export type RejoinSubscriptionMutationVariables = Exact<{
  subscriptionId: Scalars['String'];
}>;

export type RejoinSubscriptionMutation = {
  readonly __typename?: 'Mutation';
  readonly rejoinSubscription:
    | {
        readonly __typename: 'RejoinSubscriptionSuccessResponse';
        readonly subscription: {
          readonly __typename?: 'PaymentSubscription';
          readonly id: string;
          readonly status: string;
        };
      }
    | {
        readonly __typename: 'SubscriptionCannotBeReactivatedError';
        readonly errorMessage: string;
      }
    | {
        readonly __typename: 'UnknownUserError';
        readonly errorMessage: string;
      };
};

export type UpdateSubscriptionPaymentMethodMutationVariables = Exact<{
  subscriptionId: Scalars['String'];
  paymentMethodId: Scalars['String'];
}>;

export type UpdateSubscriptionPaymentMethodMutation = {
  readonly __typename?: 'Mutation';
  readonly updateSubscriptionPaymentMethod: {
    readonly __typename: 'UpdateSubscriptionPaymentMethodSuccessResponse';
    readonly subscription: {
      readonly __typename?: 'PaymentSubscription';
      readonly id: string;
    };
  };
};

export type GetSubscriptionPaymentMethodQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetSubscriptionPaymentMethodQuery = {
  readonly __typename?: 'Query';
  readonly getSubscriptions: ReadonlyArray<{
    readonly __typename?: 'PaymentSubscription';
    readonly id: string;
  }>;
  readonly paymentSubscriptionProfile: {
    readonly __typename?: 'PaymentSubscriptionProfile';
    readonly id: string;
    readonly creditCards: ReadonlyArray<{
      readonly __typename?: 'SubscriptionCreditCard';
      readonly id: string;
      readonly cardType: BraintreeCardType;
      readonly lastFour: string;
      readonly expirationYear: string | null;
      readonly expirationMonth: string | null;
      readonly isActive: boolean;
    }> | null;
  } | null;
};

export type FetchPlansByTierIdQueryVariables = Exact<{
  tierId: Scalars['ID'];
}>;

export type FetchPlansByTierIdQuery = {
  readonly __typename?: 'Query';
  readonly fetchPlansByTierId: ReadonlyArray<{
    readonly __typename?: 'PaymentPlan';
    readonly braintreePlanId: string;
  }> | null;
};

export type OptInUserMutationVariables = Exact<{ [key: string]: never }>;

export type OptInUserMutation = {
  readonly __typename?: 'Mutation';
  readonly optInFreeTier: boolean;
};

export const CartLedgerFragmentDoc = gql`
  fragment CartLedger on Ledger {
    tax
    subtotal
    feesTotal
    discountsTotal
    creditsTotal
    tip
    discounts {
      name
      amount
      description
    }
    credits {
      name
      amount
      description
    }
    fees {
      name
      amount
      description
    }
  }
`;
export const CartLineItemFragmentDoc = gql`
  fragment CartLineItem on LineItem {
    id
    slug
    quantity
    cost
    customName
    perItemCost
    favorited
    isCustom
    addedIngredients {
      id
      name
      kind
      asset {
        url
      }
    }
    removedIngredients {
      id
      name
      kind
      asset {
        url
      }
    }
    product {
      id
      name
      slug
      isCustom
      asset {
        url
      }
      ingredients {
        id
        name
        kind
      }
    }
    mixedDressingDetails {
      ingredientId
      weight
    }
    dressingMode
  }
`;
export const CartRestaurantFragmentDoc = gql`
  fragment CartRestaurant on Restaurant {
    id
    slug
    name
    city
    state
    address
    zipCode
    isOutpost
    deliveryMinSubtotal
    isOutpost
    availableDropOffLocations {
      id
      name
    }
    asset {
      url
    }
  }
`;
export const AvailableWantedTimeFragmentDoc = gql`
  fragment AvailableWantedTime on AvailableWantedTime {
    time
  }
`;
export const DeliveryOrderDetailFragmentDoc = gql`
  fragment DeliveryOrderDetail on DeliveryOrderDetail {
    id
    tip
    deliveryFee
    vendor
    orderId
    vendorRestaurantId
    estimatedDeliveryTime
    address {
      id
      street
      secondaryStreet
      city
      state
      country
      zipCode
      deliveryPreference
      googlePlaceId
      latitude
      longitude
      name
      notes
    }
  }
`;
export const CartDataFragmentDoc = gql`
  fragment CartData on Order {
    id
    orderType
    ledger {
      ...CartLedger
    }
    lineItems {
      ...CartLineItem
    }
    restaurant {
      ...CartRestaurant
    }
    availableWantedTimes {
      ...AvailableWantedTime
    }
    deliveryOrderDetail {
      ...DeliveryOrderDetail
    }
  }
  ${CartLedgerFragmentDoc}
  ${CartLineItemFragmentDoc}
  ${CartRestaurantFragmentDoc}
  ${AvailableWantedTimeFragmentDoc}
  ${DeliveryOrderDetailFragmentDoc}
`;
export const AddLineItemToCartSuccessFieldsFragmentDoc = gql`
  fragment AddLineItemToCartSuccessFields on AddLineItemToCartSuccess {
    cart {
      ...CartData
    }
  }
  ${CartDataFragmentDoc}
`;
export const EditLineItemInCartSuccessFieldsFragmentDoc = gql`
  fragment EditLineItemInCartSuccessFields on EditLineItemInCartSuccess {
    cart {
      ...CartData
    }
  }
  ${CartDataFragmentDoc}
`;
export const RemoveFromCartSuccessFieldsFragmentDoc = gql`
  fragment RemoveFromCartSuccessFields on RemoveFromCartSuccess {
    cart {
      ...CartData
    }
  }
  ${CartDataFragmentDoc}
`;
export const RestaurantMaxQuantityExceededFieldsFragmentDoc = gql`
  fragment RestaurantMaxQuantityExceededFields on RestaurantMaxQuantityExceeded {
    message
    status
  }
`;
export const MaxModificationsExceededFieldsFragmentDoc = gql`
  fragment MaxModificationsExceededFields on MaxModificationsExceeded {
    message
    status
  }
`;
export const RestaurantMaxDeliveryQuantityExceededFieldsFragmentDoc = gql`
  fragment RestaurantMaxDeliveryQuantityExceededFields on RestaurantMaxDeliveryQuantityExceeded {
    message
    status
  }
`;
export const ChallengeRewardDataFragmentDoc = gql`
  fragment ChallengeRewardData on ChallengeReward {
    id
    name
    expiresAt
    terms
    rewardType
    redeemable
    redeemableAt
  }
`;
export const ChallengeDataFragmentDoc = gql`
  fragment ChallengeData on Challenge {
    achieved
    celebrationCopy
    descriptiveTitle
    expirationDate
    goal
    id
    legalTerms
    percentageCompleted
    permalink
    progress
    progressCopy
    status
    title
  }
`;
export const RewardsDataFragmentDoc = gql`
  fragment RewardsData on Reward {
    id
    name
    expirationDate
    rewardType
    redeemable
    redeemableAt
  }
`;
export const RewardNotAppliedFieldsFragmentDoc = gql`
  fragment RewardNotAppliedFields on RewardNotApplied {
    message
    status
    failureCode
  }
`;
export const RewardNotRemovedFieldsFragmentDoc = gql`
  fragment RewardNotRemovedFields on RewardNotRemoved {
    message
    status
  }
`;
export const SuccessfulForgotPasswordFieldsFragmentDoc = gql`
  fragment SuccessfulForgotPasswordFields on ForgotPasswordSuccess {
    success
  }
`;
export const ValidationErrorFieldsFragmentDoc = gql`
  fragment ValidationErrorFields on ValidationError {
    message
    status
    fieldErrors {
      field
      message
    }
  }
`;
export const SuccessfulLoginFieldsFragmentDoc = gql`
  fragment SuccessfulLoginFields on LoginSuccess {
    csrf
  }
`;
export const InvalidCredentialsFieldsFragmentDoc = gql`
  fragment InvalidCredentialsFields on InvalidCredentials {
    message
    status
  }
`;
export const SuccessfulLogoutFieldsFragmentDoc = gql`
  fragment SuccessfulLogoutFields on LogoutSuccess {
    csrf
  }
`;
export const SuccessfulRegisterFieldsFragmentDoc = gql`
  fragment SuccessfulRegisterFields on RegisterSuccess {
    success
  }
`;
export const ResendVerificationCodeSuccessFieldsFragmentDoc = gql`
  fragment ResendVerificationCodeSuccessFields on ResendVerificationCodeSuccess {
    success
  }
`;
export const AddressFragmentDoc = gql`
  fragment address on Address {
    id
    street
    secondaryStreet
    name
    city
    state
    zipCode
    country
    deliveryPreference
    googlePlaceId
    latitude
    longitude
    notes
  }
`;
export const BillingAccountFragmentDoc = gql`
  fragment billingAccount on BillingAccount {
    id
    description
    nickname
    isDefault
    cardType
    expirationState
  }
`;
export const CustomerCreditsFragmentDoc = gql`
  fragment customerCredits on Credit {
    id
    title
    description
    amount
    remainingAmount
    createdAt
    expiresAt
  }
`;
export const CustomerDataFragmentDoc = gql`
  fragment CustomerData on Customer {
    id
    trackingUuid
    firstName
    lastName
    phoneNumber
    email
    qrCode
    addresses {
      ...address
    }
    billingAccounts {
      ...billingAccount
    }
    useCredit
    availableCredit
    credits {
      ...customerCredits
    }
  }
  ${AddressFragmentDoc}
  ${BillingAccountFragmentDoc}
  ${CustomerCreditsFragmentDoc}
`;
export const VerifyRegistrationSuccessFieldsFragmentDoc = gql`
  fragment VerifyRegistrationSuccessFields on VerifyRegistrationSuccess {
    csrf
    customer {
      ...CustomerData
    }
  }
  ${CustomerDataFragmentDoc}
`;
export const InvalidRegistrationCodeFieldsFragmentDoc = gql`
  fragment InvalidRegistrationCodeFields on InvalidRegistrationCode {
    message
    status
  }
`;
export const InvalidPromoCodeFieldsFragmentDoc = gql`
  fragment InvalidPromoCodeFields on InvalidPromoCode {
    message
    status
  }
`;
export const CheckoutBillingAccountFragmentDoc = gql`
  fragment CheckoutBillingAccount on BillingAccount {
    id
    description
    nickname
    isDefault
    cardType
  }
`;
export const RewardNotValidatedFieldsFragmentDoc = gql`
  fragment RewardNotValidatedFields on RewardNotValidated {
    message
    status
    failureCode
  }
`;
export const ProductUnavailableFieldsFragmentDoc = gql`
  fragment ProductUnavailableFields on ProductUnavailable {
    message
    status
  }
`;
export const RestaurantIsNotAcceptingOrdersFieldsFragmentDoc = gql`
  fragment RestaurantIsNotAcceptingOrdersFields on RestaurantIsNotAcceptingOrders {
    message
    status
  }
`;
export const GetOrderStatusFieldsFragmentDoc = gql`
  fragment GetOrderStatusFields on OrderStatus {
    flattenedOrderStatus
    order {
      id
      wantedTime
      orderType
      canTrackOrderStatus
      isPendingFeedback
      dropoffLocation
      restaurant {
        id
        name
        isOutpost
      }
      deliveryOrderDetail {
        estimatedDeliveryTime
        address {
          id
          name
        }
      }
    }
  }
`;
export const LogInCustomerSuccessfulLoginFieldsFragmentDoc = gql`
  fragment LogInCustomerSuccessfulLoginFields on LoginSuccess {
    csrf
  }
`;
export const LogInCustomerInvalidCredentialsFieldsFragmentDoc = gql`
  fragment LogInCustomerInvalidCredentialsFields on InvalidCredentials {
    message
    status
  }
`;
export const MenuCollectionProductFragmentDoc = gql`
  fragment MenuCollectionProduct on Product {
    id
    slug
    name
    description
    calories
    cost
    restaurantId
    label {
      id
      name
    }
    asset {
      url
    }
    dietaryProperties {
      id
      name
    }
    ingredients {
      id
      name
    }
  }
`;
export const CategoryProductFragmentDoc = gql`
  fragment CategoryProduct on Product {
    asset {
      url
    }
    calories
    categoryId
    cost
    description
    id
    ingredients {
      asset {
        url
      }
      id
      name
    }
    isModifiable
    isCustom
    customType
    isSalad
    label {
      id
      name
    }
    dietaryProperties {
      id
      name
    }
    name
    outOfStock
    restaurantId
    slug
    throttleItem
  }
`;
export const CategoryFragmentDoc = gql`
  fragment Category on MenuCategory {
    id
    name
    isCustom
    products {
      ...CategoryProduct
    }
  }
  ${CategoryProductFragmentDoc}
`;
export const RestaurantMenuFragmentDoc = gql`
  fragment RestaurantMenu on Restaurant {
    id
    slug
    name
    city
    state
    zipCode
    address
    phone
    isOutpost
    hours {
      formatted
    }
    isAcceptingOrders
    notAcceptingOrdersReason
    deliveryFee
    flexMessage
    menu {
      id
      categories {
        ...Category
      }
    }
  }
  ${CategoryFragmentDoc}
`;
export const BaseProductDataFragmentDoc = gql`
  fragment BaseProductData on BaseProduct {
    id
    name
    description
    heading
    subheading
    isSeasonal
    isDeepLinkingEnabled
    asset {
      url
    }
  }
`;
export const OrderProductRestaurantDataFragmentDoc = gql`
  fragment OrderProductRestaurantData on Restaurant {
    id
    name
    latitude
    longitude
    slug
    address
    city
    state
    zipCode
    isOutpost
    phone
    hours {
      formatted
    }
    flexMessage
    isAcceptingOrders
    notAcceptingOrdersReason
    asset {
      url
    }
  }
`;
export const PdpLineItemDetailsFragmentDoc = gql`
  fragment PDPLineItemDetails on LineItem {
    id
    quantity
    isCustom
    customName
    ingredients {
      id
      name
      asset {
        url
      }
      dietaryProperties {
        id
        name
      }
    }
    mixedDressingDetails {
      ingredientId
      weight
    }
  }
`;
export const LineItemSuccessFieldsFragmentDoc = gql`
  fragment LineItemSuccessFields on LineItemSuccess {
    lineItem {
      ...PDPLineItemDetails
    }
  }
  ${PdpLineItemDetailsFragmentDoc}
`;
export const LineItemNotFoundFieldsFragmentDoc = gql`
  fragment LineItemNotFoundFields on LineItemNotFound {
    message
    status
  }
`;
export const ProductIngredientFragmentDoc = gql`
  fragment ProductIngredient on Ingredient {
    id
    name
    asset {
      url
    }
    dietaryProperties {
      id
      name
    }
  }
`;
export const IngredientModificationFragmentDoc = gql`
  fragment IngredientModification on IngredientModification {
    calories
    removalCost
    additionCost
    substitutionCost
    kind
    subKind
    outOfStock
    ingredient {
      ...ProductIngredient
    }
    mixable
    isGrain
  }
  ${ProductIngredientFragmentDoc}
`;
export const IngredientModificationKindFragmentDoc = gql`
  fragment IngredientModificationKind on IngredientModificationKind {
    minAggregateQuantity
    maxAggregateQuantity
    freeAggregateQuantity
    allowMultipleQuantity
    modifications {
      ...IngredientModification
    }
  }
  ${IngredientModificationFragmentDoc}
`;
export const ProductDetailsFragmentDoc = gql`
  fragment ProductDetails on Product {
    id
    slug
    restaurantId
    name
    categoryId
    description
    cost
    calories
    outOfStock
    throttleItem
    maxModifications
    isModifiable
    isCustom
    asset {
      url
    }
    restaurant {
      id
      isOutpost
    }
    dietaryProperties {
      id
      name
    }
    ingredients {
      ...ProductIngredient
    }
    ingredientModifications {
      bases {
        ...IngredientModificationKind
      }
      toppings {
        ...IngredientModificationKind
      }
      premiums {
        ...IngredientModificationKind
      }
      dressings {
        ...IngredientModificationKind
      }
      bread {
        ...IngredientModificationKind
      }
    }
  }
  ${ProductIngredientFragmentDoc}
  ${IngredientModificationKindFragmentDoc}
`;
export const ReorderSuccessResponseFragmentDoc = gql`
  fragment ReorderSuccessResponse on ReorderSuccess {
    cart {
      ...CartData
    }
    isMixingSupported
  }
  ${CartDataFragmentDoc}
`;
export const ConflictFragmentDoc = gql`
  fragment Conflict on OrderConflict {
    type
    product {
      id
      name
      calories
      cost
      label {
        name
      }
      description
      asset {
        url
      }
      dietaryProperties {
        id
        name
      }
    }
    unavailableIngredients {
      name
    }
  }
`;
export const ReorderConflictResponseFragmentDoc = gql`
  fragment ReorderConflictResponse on ReorderConflict {
    isNothingAvailable
    conflicts {
      ...Conflict
    }
  }
  ${ConflictFragmentDoc}
`;
export const RestaurantMaxDeliveryQuantityExceededResponseFragmentDoc = gql`
  fragment RestaurantMaxDeliveryQuantityExceededResponse on RestaurantMaxDeliveryQuantityExceeded {
    message
    conflicts {
      ...Conflict
    }
  }
  ${ConflictFragmentDoc}
`;
export const RestaurantMaxQuantityExceededResponseFragmentDoc = gql`
  fragment RestaurantMaxQuantityExceededResponse on RestaurantMaxQuantityExceeded {
    message
    conflicts {
      ...Conflict
    }
  }
  ${ConflictFragmentDoc}
`;
export const CanNotReorderResponseFragmentDoc = gql`
  fragment CanNotReorderResponse on CanNotReorder {
    message
    conflicts {
      ...Conflict
    }
  }
  ${ConflictFragmentDoc}
`;
export const ValidationErrorResponseFragmentDoc = gql`
  fragment ValidationErrorResponse on ValidationError {
    message
    status
    fieldErrors {
      field
      message
    }
  }
`;
export const ReorderRestaurantRequiredDataFragmentDoc = gql`
  fragment ReorderRestaurantRequiredData on Restaurant {
    id
    name
    latitude
    longitude
    slug
    address
    city
    state
    zipCode
    isOutpost
    phone
    hours {
      formatted
    }
    flexMessage
    isAcceptingOrders
    notAcceptingOrdersReason
    asset {
      url
    }
  }
`;
export const CustomerNameDocument = gql`
  query customerName {
    currentCustomer {
      id
      firstName
    }
  }
`;

export function useCustomerNameQuery(
  options?: Omit<Urql.UseQueryArgs<CustomerNameQueryVariables>, 'query'>,
) {
  return Urql.useQuery<CustomerNameQuery, CustomerNameQueryVariables>({
    query: CustomerNameDocument,
    ...options,
  });
}
export const AddAddressDocument = gql`
  mutation addAddress($input: AddAddressInput!) {
    addAddress(input: $input) {
      __typename
      ... on AddAddressSuccess {
        address {
          id
          ...address
        }
      }
      ... on ValidationError {
        ...ValidationErrorResponse
      }
      ... on InvalidAddress {
        message
        status
      }
    }
  }
  ${AddressFragmentDoc}
  ${ValidationErrorResponseFragmentDoc}
`;

export function useAddAddressMutation() {
  return Urql.useMutation<AddAddressMutation, AddAddressMutationVariables>(
    AddAddressDocument,
  );
}
export const UpdateAddressDocument = gql`
  mutation updateAddress($input: EditAddressInput!) {
    updateAddress(input: $input) {
      __typename
      ... on UpdateAddressSuccess {
        address {
          id
          ...address
        }
      }
      ... on ValidationError {
        ...ValidationErrorResponse
      }
      ... on InvalidAddress {
        message
        status
      }
    }
  }
  ${AddressFragmentDoc}
  ${ValidationErrorResponseFragmentDoc}
`;

export function useUpdateAddressMutation() {
  return Urql.useMutation<
    UpdateAddressMutation,
    UpdateAddressMutationVariables
  >(UpdateAddressDocument);
}
export const DeleteAddressDocument = gql`
  mutation deleteAddress($id: ID!) {
    deleteAddress(addressId: $id) {
      __typename
      ... on DeleteAddressSuccess {
        success
      }
      ... on ValidationError {
        ...ValidationErrorResponse
      }
      ... on InvalidAddress {
        message
        status
      }
    }
  }
  ${ValidationErrorResponseFragmentDoc}
`;

export function useDeleteAddressMutation() {
  return Urql.useMutation<
    DeleteAddressMutation,
    DeleteAddressMutationVariables
  >(DeleteAddressDocument);
}
export const CartDocument = gql`
  query Cart {
    cart {
      ...CartData
    }
  }
  ${CartDataFragmentDoc}
`;

export function useCartQuery(
  options?: Omit<Urql.UseQueryArgs<CartQueryVariables>, 'query'>,
) {
  return Urql.useQuery<CartQuery, CartQueryVariables>({
    query: CartDocument,
    ...options,
  });
}
export const AddLineItemToCartDocument = gql`
  mutation AddLineItemToCart($input: AddLineItemToCartInput!) {
    addLineItemToCart(input: $input) {
      __typename
      ...AddLineItemToCartSuccessFields
      ...RestaurantMaxQuantityExceededFields
      ...RestaurantMaxDeliveryQuantityExceededFields
      ...MaxModificationsExceededFields
      ...ValidationErrorFields
    }
  }
  ${AddLineItemToCartSuccessFieldsFragmentDoc}
  ${RestaurantMaxQuantityExceededFieldsFragmentDoc}
  ${RestaurantMaxDeliveryQuantityExceededFieldsFragmentDoc}
  ${MaxModificationsExceededFieldsFragmentDoc}
  ${ValidationErrorFieldsFragmentDoc}
`;

export function useAddLineItemToCartMutation() {
  return Urql.useMutation<
    AddLineItemToCartMutation,
    AddLineItemToCartMutationVariables
  >(AddLineItemToCartDocument);
}
export const EditLineItemInCartDocument = gql`
  mutation EditLineItemInCart($input: EditLineItemInCartInput!) {
    editLineItemInCart(input: $input) {
      __typename
      ...EditLineItemInCartSuccessFields
      ...RestaurantMaxQuantityExceededFields
      ...RestaurantMaxDeliveryQuantityExceededFields
      ...MaxModificationsExceededFields
      ...ValidationErrorFields
    }
  }
  ${EditLineItemInCartSuccessFieldsFragmentDoc}
  ${RestaurantMaxQuantityExceededFieldsFragmentDoc}
  ${RestaurantMaxDeliveryQuantityExceededFieldsFragmentDoc}
  ${MaxModificationsExceededFieldsFragmentDoc}
  ${ValidationErrorFieldsFragmentDoc}
`;

export function useEditLineItemInCartMutation() {
  return Urql.useMutation<
    EditLineItemInCartMutation,
    EditLineItemInCartMutationVariables
  >(EditLineItemInCartDocument);
}
export const RemoveFromCartDocument = gql`
  mutation RemoveFromCart($input: RemoveFromCartInput!) {
    removeFromCart(input: $input) {
      __typename
      ...RemoveFromCartSuccessFields
      ...ValidationErrorFields
    }
  }
  ${RemoveFromCartSuccessFieldsFragmentDoc}
  ${ValidationErrorFieldsFragmentDoc}
`;

export function useRemoveFromCartMutation() {
  return Urql.useMutation<
    RemoveFromCartMutation,
    RemoveFromCartMutationVariables
  >(RemoveFromCartDocument);
}
export const AddonsDocument = gql`
  query addons {
    addons {
      products {
        id
        name
        cost
        asset {
          url
        }
      }
    }
  }
`;

export function useAddonsQuery(
  options?: Omit<Urql.UseQueryArgs<AddonsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<AddonsQuery, AddonsQueryVariables>({
    query: AddonsDocument,
    ...options,
  });
}
export const ChallengeCelebrationDocument = gql`
  query ChallengeCelebration {
    challengeCelebration {
      title
      celebrationCopy
      rewardUsageDisclaimer
      expirationDate
      challengesIds
    }
  }
`;

export function useChallengeCelebrationQuery(
  options?: Omit<
    Urql.UseQueryArgs<ChallengeCelebrationQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    ChallengeCelebrationQuery,
    ChallengeCelebrationQueryVariables
  >({ query: ChallengeCelebrationDocument, ...options });
}
export const SubmitBraintreeBillingAccountDocument = gql`
  mutation submitBraintreeBillingAccount(
    $input: SubmitBraintreeBillingAccountInput!
  ) {
    submitBraintreeBillingAccount(input: $input) {
      __typename
      ... on UserError {
        errorMessage
      }
      ... on SubmitBraintreeBillingAccountSuccessResponse {
        billingAccount {
          id
          description
          nickname
          isDefault
          cardType
          expirationState
        }
      }
    }
  }
`;

export function useSubmitBraintreeBillingAccountMutation() {
  return Urql.useMutation<
    SubmitBraintreeBillingAccountMutation,
    SubmitBraintreeBillingAccountMutationVariables
  >(SubmitBraintreeBillingAccountDocument);
}
export const UpdateBillingAccountDocument = gql`
  mutation updateBillingAccount($input: UpdateBillingAccountInput!) {
    updateBillingAccount(input: $input) {
      billingAccount {
        id
        description
        nickname
        isDefault
        cardType
        expirationState
      }
    }
  }
`;

export function useUpdateBillingAccountMutation() {
  return Urql.useMutation<
    UpdateBillingAccountMutation,
    UpdateBillingAccountMutationVariables
  >(UpdateBillingAccountDocument);
}
export const DeleteBillingAccountDocument = gql`
  mutation deleteBillingAccount($input: DeleteBillingAccountInput!) {
    deleteBillingAccount(input: $input) {
      success
    }
  }
`;

export function useDeleteBillingAccountMutation() {
  return Urql.useMutation<
    DeleteBillingAccountMutation,
    DeleteBillingAccountMutationVariables
  >(DeleteBillingAccountDocument);
}
export const PickupOutpostRestaurantNameDocument = gql`
  query PickupOutpostRestaurantName($id: ID!) {
    restaurant(id: $id) {
      id
      name
    }
  }
`;

export function usePickupOutpostRestaurantNameQuery(
  options: Omit<
    Urql.UseQueryArgs<PickupOutpostRestaurantNameQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    PickupOutpostRestaurantNameQuery,
    PickupOutpostRestaurantNameQueryVariables
  >({ query: PickupOutpostRestaurantNameDocument, ...options });
}
export const ActiveCartDeliveryDetailsDocument = gql`
  query ActiveCartDeliveryDetails {
    cart {
      id
      deliveryOrderDetail {
        id
        address {
          id
          googlePlaceId
          name
        }
      }
    }
  }
`;

export function useActiveCartDeliveryDetailsQuery(
  options?: Omit<
    Urql.UseQueryArgs<ActiveCartDeliveryDetailsQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    ActiveCartDeliveryDetailsQuery,
    ActiveCartDeliveryDetailsQueryVariables
  >({ query: ActiveCartDeliveryDetailsDocument, ...options });
}
export const AddDeliveryAddressDocument = gql`
  mutation addDeliveryAddress($input: AddAddressInput!) {
    addAddress(input: $input) {
      __typename
      ... on AddAddressSuccess {
        address {
          id
          ...address
        }
      }
      ... on ValidationError {
        ...ValidationErrorResponse
      }
      ... on InvalidAddress {
        message
        status
      }
    }
  }
  ${AddressFragmentDoc}
  ${ValidationErrorResponseFragmentDoc}
`;

export function useAddDeliveryAddressMutation() {
  return Urql.useMutation<
    AddDeliveryAddressMutation,
    AddDeliveryAddressMutationVariables
  >(AddDeliveryAddressDocument);
}
export const CustomerAddressesDocument = gql`
  query CustomerAddresses {
    currentCustomer {
      id
      addresses {
        id
        street
        secondaryStreet
        city
        state
        country
        zipCode
        deliveryPreference
        googlePlaceId
        latitude
        longitude
        name
        notes
      }
    }
  }
`;

export function useCustomerAddressesQuery(
  options?: Omit<Urql.UseQueryArgs<CustomerAddressesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<CustomerAddressesQuery, CustomerAddressesQueryVariables>(
    { query: CustomerAddressesDocument, ...options },
  );
}
export const DeliveryLocationByAddressDocument = gql`
  query DeliveryLocationByAddress($input: LocationByAddressInput!) {
    locationByAddress(input: $input) {
      __typename
      ... on Location {
        restaurant {
          id
          name
          slug
          phone
          flexMessage
          deliveryFee
        }
        estimateRange {
          start
          end
        }
        vendor {
          name
          restaurantId
        }
        status
      }
    }
  }
`;

export function useDeliveryLocationByAddressQuery(
  options: Omit<
    Urql.UseQueryArgs<DeliveryLocationByAddressQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    DeliveryLocationByAddressQuery,
    DeliveryLocationByAddressQueryVariables
  >({ query: DeliveryLocationByAddressDocument, ...options });
}
export const LastPlacedOrderDeliveryDetailsDocument = gql`
  query LastPlacedOrderDeliveryDetails($input: OrdersInput!) {
    orders(input: $input) {
      ... on OrdersResponseSuccess {
        __typename
        orders {
          id
          deliveryOrderDetail {
            id
            address {
              id
              googlePlaceId
              name
            }
          }
        }
      }
    }
  }
`;

export function useLastPlacedOrderDeliveryDetailsQuery(
  options: Omit<
    Urql.UseQueryArgs<LastPlacedOrderDeliveryDetailsQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    LastPlacedOrderDeliveryDetailsQuery,
    LastPlacedOrderDeliveryDetailsQueryVariables
  >({ query: LastPlacedOrderDeliveryDetailsDocument, ...options });
}
export const LocationsSearchByAreaDocument = gql`
  query LocationsSearchByArea(
    $topLeft: GeoCoordinates!
    $bottomRight: GeoCoordinates!
    $showHidden: Boolean
  ) {
    searchLocationsByBoundingBox(
      topLeft: $topLeft
      bottomRight: $bottomRight
      showHidden: $showHidden
    ) {
      location {
        id
        name
        latitude
        longitude
        slug
        address
        city
        state
        zipCode
        isOutpost
        phone
        storeHours
        flexMessage
        enabled
        acceptingOrders
        notAcceptingOrdersReason
        imageUrl
        hidden
        showWarningDialog
        warningDialogDescription
        warningDialogTimeout
        warningDialogTitle
      }
    }
  }
`;

export function useLocationsSearchByAreaQuery(
  options: Omit<
    Urql.UseQueryArgs<LocationsSearchByAreaQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    LocationsSearchByAreaQuery,
    LocationsSearchByAreaQueryVariables
  >({ query: LocationsSearchByAreaDocument, ...options });
}
export const LocationsSearchBySearchStringDocument = gql`
  query LocationsSearchBySearchString(
    $searchString: String!
    $showHidden: Boolean
  ) {
    searchLocationsByString(
      searchString: $searchString
      showHidden: $showHidden
    ) {
      score
      location {
        id
        name
        latitude
        longitude
        slug
        address
        city
        state
        zipCode
        isOutpost
        phone
        storeHours
        flexMessage
        enabled
        acceptingOrders
        notAcceptingOrdersReason
        imageUrl
        hidden
        showWarningDialog
        warningDialogDescription
        warningDialogTimeout
        warningDialogTitle
      }
    }
  }
`;

export function useLocationsSearchBySearchStringQuery(
  options: Omit<
    Urql.UseQueryArgs<LocationsSearchBySearchStringQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    LocationsSearchBySearchStringQuery,
    LocationsSearchBySearchStringQueryVariables
  >({ query: LocationsSearchBySearchStringDocument, ...options });
}
export const MenuCollectionsDocument = gql`
  query MenuCollections($menuId: ID!) {
    menuCollections(menuId: $menuId) {
      id
      color
      primaryImageUrl
      primaryTitle
      primaryDescription
    }
  }
`;

export function useMenuCollectionsQuery(
  options: Omit<Urql.UseQueryArgs<MenuCollectionsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<MenuCollectionsQuery, MenuCollectionsQueryVariables>({
    query: MenuCollectionsDocument,
    ...options,
  });
}
export const SweetpassInfoForAccountDeletionDocument = gql`
  query SweetpassInfoForAccountDeletion {
    loyaltyProfile {
      customerId
      tier {
        id
        name
      }
      tierStatus {
        id
        name
      }
    }
    getSubscriptions(status: [ACTIVE]) {
      id
      nextBillingDate
    }
  }
`;

export function useSweetpassInfoForAccountDeletionQuery(
  options?: Omit<
    Urql.UseQueryArgs<SweetpassInfoForAccountDeletionQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    SweetpassInfoForAccountDeletionQuery,
    SweetpassInfoForAccountDeletionQueryVariables
  >({ query: SweetpassInfoForAccountDeletionDocument, ...options });
}
export const RequestAccountDeletionDocument = gql`
  mutation RequestAccountDeletion {
    requestAccountDeletion {
      ... on RequestAccountDeletionSuccess {
        success
        __typename
      }
    }
  }
`;

export function useRequestAccountDeletionMutation() {
  return Urql.useMutation<
    RequestAccountDeletionMutation,
    RequestAccountDeletionMutationVariables
  >(RequestAccountDeletionDocument);
}
export const CustomerDocument = gql`
  query customer {
    currentCustomer {
      ...CustomerData
    }
  }
  ${CustomerDataFragmentDoc}
`;

export function useCustomerQuery(
  options?: Omit<Urql.UseQueryArgs<CustomerQueryVariables>, 'query'>,
) {
  return Urql.useQuery<CustomerQuery, CustomerQueryVariables>({
    query: CustomerDocument,
    ...options,
  });
}
export const ChallengeRewardsDocument = gql`
  query ChallengeRewards {
    challengeRewards {
      ...ChallengeRewardData
    }
  }
  ${ChallengeRewardDataFragmentDoc}
`;

export function useChallengeRewardsQuery(
  options?: Omit<Urql.UseQueryArgs<ChallengeRewardsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ChallengeRewardsQuery, ChallengeRewardsQueryVariables>({
    query: ChallengeRewardsDocument,
    ...options,
  });
}
export const ChallengesDocument = gql`
  query Challenges {
    challenges {
      ...ChallengeData
    }
  }
  ${ChallengeDataFragmentDoc}
`;

export function useChallengesQuery(
  options?: Omit<Urql.UseQueryArgs<ChallengesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ChallengesQuery, ChallengesQueryVariables>({
    query: ChallengesDocument,
    ...options,
  });
}
export const ChallengeOptInDocument = gql`
  mutation challengeOptIn($challengeId: String!) {
    challengeOptIn(challengeId: $challengeId) {
      ...ChallengeData
    }
  }
  ${ChallengeDataFragmentDoc}
`;

export function useChallengeOptInMutation() {
  return Urql.useMutation<
    ChallengeOptInMutation,
    ChallengeOptInMutationVariables
  >(ChallengeOptInDocument);
}
export const HasUnseenChallengesDocument = gql`
  query HasUnseenChallenges {
    hasUnseenChallenges {
      hasUnseenChallenges
    }
  }
`;

export function useHasUnseenChallengesQuery(
  options?: Omit<Urql.UseQueryArgs<HasUnseenChallengesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    HasUnseenChallengesQuery,
    HasUnseenChallengesQueryVariables
  >({ query: HasUnseenChallengesDocument, ...options });
}
export const RewardsDocument = gql`
  query Rewards {
    rewards {
      ...RewardsData
    }
  }
  ${RewardsDataFragmentDoc}
`;

export function useRewardsQuery(
  options?: Omit<Urql.UseQueryArgs<RewardsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<RewardsQuery, RewardsQueryVariables>({
    query: RewardsDocument,
    ...options,
  });
}
export const ApplyRewardDocument = gql`
  mutation applyReward($input: ApplyRewardInput!) {
    applyReward(input: $input) {
      __typename
      ... on ApplyRewardSuccess {
        order {
          ...CartData
        }
      }
      ...ValidationErrorFields
      ...RewardNotAppliedFields
    }
  }
  ${CartDataFragmentDoc}
  ${ValidationErrorFieldsFragmentDoc}
  ${RewardNotAppliedFieldsFragmentDoc}
`;

export function useApplyRewardMutation() {
  return Urql.useMutation<ApplyRewardMutation, ApplyRewardMutationVariables>(
    ApplyRewardDocument,
  );
}
export const RemoveRewardDocument = gql`
  mutation removeReward($input: RemoveRewardInput!) {
    removeReward(input: $input) {
      __typename
      ... on RemoveRewardSuccess {
        order {
          ...CartData
        }
      }
      ...ValidationErrorFields
      ...RewardNotRemovedFields
    }
  }
  ${CartDataFragmentDoc}
  ${ValidationErrorFieldsFragmentDoc}
  ${RewardNotRemovedFieldsFragmentDoc}
`;

export function useRemoveRewardMutation() {
  return Urql.useMutation<RemoveRewardMutation, RemoveRewardMutationVariables>(
    RemoveRewardDocument,
  );
}
export const CurrentCustomerDocument = gql`
  query currentCustomer {
    currentCustomer {
      ...CustomerData
    }
  }
  ${CustomerDataFragmentDoc}
`;

export function useCurrentCustomerQuery(
  options?: Omit<Urql.UseQueryArgs<CurrentCustomerQueryVariables>, 'query'>,
) {
  return Urql.useQuery<CurrentCustomerQuery, CurrentCustomerQueryVariables>({
    query: CurrentCustomerDocument,
    ...options,
  });
}
export const UpdateUseCreditDocument = gql`
  mutation updateUseCredit($useCredit: Boolean!) {
    updateUseCredit(useCredit: $useCredit) {
      customer {
        id
        useCredit
      }
    }
  }
`;

export function useUpdateUseCreditMutation() {
  return Urql.useMutation<
    UpdateUseCreditMutation,
    UpdateUseCreditMutationVariables
  >(UpdateUseCreditDocument);
}
export const ForgotPasswordDocument = gql`
  mutation ForgotPassword($input: ForgotPasswordInput!) {
    forgotPassword(input: $input) {
      __typename
      ...SuccessfulForgotPasswordFields
      ...ValidationErrorFields
    }
  }
  ${SuccessfulForgotPasswordFieldsFragmentDoc}
  ${ValidationErrorFieldsFragmentDoc}
`;

export function useForgotPasswordMutation() {
  return Urql.useMutation<
    ForgotPasswordMutation,
    ForgotPasswordMutationVariables
  >(ForgotPasswordDocument);
}
export const LoginDocument = gql`
  mutation Login($input: LoginInput!) {
    login(input: $input) {
      __typename
      ...SuccessfulLoginFields
      ...InvalidCredentialsFields
      ...ValidationErrorFields
    }
  }
  ${SuccessfulLoginFieldsFragmentDoc}
  ${InvalidCredentialsFieldsFragmentDoc}
  ${ValidationErrorFieldsFragmentDoc}
`;

export function useLoginMutation() {
  return Urql.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument);
}
export const LogoutDocument = gql`
  mutation Logout($input: LogoutInput!) {
    logout(input: $input) {
      __typename
      ...SuccessfulLogoutFields
      ...ValidationErrorFields
    }
  }
  ${SuccessfulLogoutFieldsFragmentDoc}
  ${ValidationErrorFieldsFragmentDoc}
`;

export function useLogoutMutation() {
  return Urql.useMutation<LogoutMutation, LogoutMutationVariables>(
    LogoutDocument,
  );
}
export const RegisterDocument = gql`
  mutation Register($input: RegisterInput!) {
    register(input: $input) {
      __typename
      ...SuccessfulRegisterFields
      ...ValidationErrorFields
    }
  }
  ${SuccessfulRegisterFieldsFragmentDoc}
  ${ValidationErrorFieldsFragmentDoc}
`;

export function useRegisterMutation() {
  return Urql.useMutation<RegisterMutation, RegisterMutationVariables>(
    RegisterDocument,
  );
}
export const ResendVerificationCodeDocument = gql`
  mutation ResendVerificationCode($input: ResendVerificationCodeInput!) {
    resendVerificationCode(input: $input) {
      __typename
      ...ResendVerificationCodeSuccessFields
      ...ValidationErrorFields
    }
  }
  ${ResendVerificationCodeSuccessFieldsFragmentDoc}
  ${ValidationErrorFieldsFragmentDoc}
`;

export function useResendVerificationCodeMutation() {
  return Urql.useMutation<
    ResendVerificationCodeMutation,
    ResendVerificationCodeMutationVariables
  >(ResendVerificationCodeDocument);
}
export const VerifyRegistrationDocument = gql`
  mutation VerifyRegistration($input: VerifyRegistrationInput!) {
    verifyRegistration(input: $input) {
      __typename
      ...VerifyRegistrationSuccessFields
      ...InvalidRegistrationCodeFields
      ...ValidationErrorFields
    }
  }
  ${VerifyRegistrationSuccessFieldsFragmentDoc}
  ${InvalidRegistrationCodeFieldsFragmentDoc}
  ${ValidationErrorFieldsFragmentDoc}
`;

export function useVerifyRegistrationMutation() {
  return Urql.useMutation<
    VerifyRegistrationMutation,
    VerifyRegistrationMutationVariables
  >(VerifyRegistrationDocument);
}
export const OrdersDocument = gql`
  query orders($input: OrdersInput!) {
    orders(input: $input) {
      __typename
      ... on OrdersResponseSuccess {
        orders {
          id
          description
          orderType
          total
          asset {
            url
          }
          lineItems {
            id
            quantity
            customName
            isCustom
            product {
              id
              name
              isCustom
              categoryName
            }
          }
          restaurant {
            id
            name
            city
            state
            address
            zipCode
            isOutpost
            slug
          }
          deliveryOrderDetail {
            ...DeliveryOrderDetail
          }
        }
      }
      ...ValidationErrorFields
    }
  }
  ${DeliveryOrderDetailFragmentDoc}
  ${ValidationErrorFieldsFragmentDoc}
`;

export function useOrdersQuery(
  options: Omit<Urql.UseQueryArgs<OrdersQueryVariables>, 'query'>,
) {
  return Urql.useQuery<OrdersQuery, OrdersQueryVariables>({
    query: OrdersDocument,
    ...options,
  });
}
export const CreateLoyaltyProfileDocument = gql`
  query CreateLoyaltyProfile {
    loyaltyProfile {
      customerId
    }
  }
`;

export function useCreateLoyaltyProfileQuery(
  options?: Omit<
    Urql.UseQueryArgs<CreateLoyaltyProfileQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    CreateLoyaltyProfileQuery,
    CreateLoyaltyProfileQueryVariables
  >({ query: CreateLoyaltyProfileDocument, ...options });
}
export const GetCustomerCreditDocument = gql`
  query getCustomerCredit {
    currentCustomer {
      id
      availableCredit
      useCredit
      credits {
        ...customerCredits
      }
    }
  }
  ${CustomerCreditsFragmentDoc}
`;

export function useGetCustomerCreditQuery(
  options?: Omit<Urql.UseQueryArgs<GetCustomerCreditQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetCustomerCreditQuery, GetCustomerCreditQueryVariables>(
    { query: GetCustomerCreditDocument, ...options },
  );
}
export const DeliveryInFlightDocument = gql`
  query deliveryInFlight($input: OrdersInput!) {
    orders(input: $input) {
      __typename
      ... on OrdersResponseSuccess {
        orders {
          id
          isInFlightDelivery
        }
      }
    }
  }
`;

export function useDeliveryInFlightQuery(
  options: Omit<Urql.UseQueryArgs<DeliveryInFlightQueryVariables>, 'query'>,
) {
  return Urql.useQuery<DeliveryInFlightQuery, DeliveryInFlightQueryVariables>({
    query: DeliveryInFlightDocument,
    ...options,
  });
}
export const InStoreOrderLastPendingFeedbackDocument = gql`
  query InStoreOrderLastPendingFeedback {
    inStoreOrderLastPendingFeedback {
      id
      wantedTime
    }
  }
`;

export function useInStoreOrderLastPendingFeedbackQuery(
  options?: Omit<
    Urql.UseQueryArgs<InStoreOrderLastPendingFeedbackQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    InStoreOrderLastPendingFeedbackQuery,
    InStoreOrderLastPendingFeedbackQueryVariables
  >({ query: InStoreOrderLastPendingFeedbackDocument, ...options });
}
export const SubmitPromoCodeDocument = gql`
  mutation SubmitPromoCode($input: SubmitPromoCodeInput!) {
    submitPromoCode(input: $input) {
      __typename
      ... on SubmitPromoCodeSuccess {
        loyaltyId
      }
      ...ValidationErrorFields
      ...InvalidPromoCodeFields
    }
  }
  ${ValidationErrorFieldsFragmentDoc}
  ${InvalidPromoCodeFieldsFragmentDoc}
`;

export function useSubmitPromoCodeMutation() {
  return Urql.useMutation<
    SubmitPromoCodeMutation,
    SubmitPromoCodeMutationVariables
  >(SubmitPromoCodeDocument);
}
export const SubmitPromoOrGiftCardCodeDocument = gql`
  mutation SubmitPromoOrGiftCardCode($input: SubmitPromoOrGiftCardCodeInput!) {
    submitPromoOrGiftCardCode(input: $input) {
      __typename
      ...ValidationErrorFields
      ...InvalidPromoCodeFields
    }
  }
  ${ValidationErrorFieldsFragmentDoc}
  ${InvalidPromoCodeFieldsFragmentDoc}
`;

export function useSubmitPromoOrGiftCardCodeMutation() {
  return Urql.useMutation<
    SubmitPromoOrGiftCardCodeMutation,
    SubmitPromoOrGiftCardCodeMutationVariables
  >(SubmitPromoOrGiftCardCodeDocument);
}
export const GetSessionDocument = gql`
  query getSession {
    session {
      csrf
      isLoggedIn
    }
  }
`;

export function useGetSessionQuery(
  options?: Omit<Urql.UseQueryArgs<GetSessionQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetSessionQuery, GetSessionQueryVariables>({
    query: GetSessionDocument,
    ...options,
  });
}
export const GetSweetpassTierDocument = gql`
  query GetSweetpassTier {
    loyaltyProfile {
      customerId
      joinDate
      tier {
        id
        name
        nextTier {
          id
          name
        }
      }
    }
  }
`;

export function useGetSweetpassTierQuery(
  options?: Omit<Urql.UseQueryArgs<GetSweetpassTierQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetSweetpassTierQuery, GetSweetpassTierQueryVariables>({
    query: GetSweetpassTierDocument,
    ...options,
  });
}
export const KustomerTokenDocument = gql`
  query KustomerToken {
    kustomerToken {
      token
    }
  }
`;

export function useKustomerTokenQuery(
  options?: Omit<Urql.UseQueryArgs<KustomerTokenQueryVariables>, 'query'>,
) {
  return Urql.useQuery<KustomerTokenQuery, KustomerTokenQueryVariables>({
    query: KustomerTokenDocument,
    ...options,
  });
}
export const SubmitOrderDocument = gql`
  mutation SubmitOrder($input: SubmitOrderUsingBillingAccountInput!) {
    submitOrderUsingBillingAccount(input: $input) {
      __typename
      ... on SubmitOrderUsingBillingAccountSuccess {
        order {
          id
        }
      }
      ...ValidationErrorFields
      ...RewardNotValidatedFields
      ...ProductUnavailableFields
      ...RestaurantIsNotAcceptingOrdersFields
    }
  }
  ${ValidationErrorFieldsFragmentDoc}
  ${RewardNotValidatedFieldsFragmentDoc}
  ${ProductUnavailableFieldsFragmentDoc}
  ${RestaurantIsNotAcceptingOrdersFieldsFragmentDoc}
`;

export function useSubmitOrderMutation() {
  return Urql.useMutation<SubmitOrderMutation, SubmitOrderMutationVariables>(
    SubmitOrderDocument,
  );
}
export const GetAvailableWantedTimesDocument = gql`
  query getAvailableWantedTimes {
    cart {
      id
      availableWantedTimes {
        time
      }
    }
  }
`;

export function useGetAvailableWantedTimesQuery(
  options?: Omit<
    Urql.UseQueryArgs<GetAvailableWantedTimesQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    GetAvailableWantedTimesQuery,
    GetAvailableWantedTimesQueryVariables
  >({ query: GetAvailableWantedTimesDocument, ...options });
}
export const DeliveryEstimateDocument = gql`
  query DeliveryEstimate($input: LocationByAddressInput!) {
    locationByAddress(input: $input) {
      __typename
      ... on Location {
        estimateRange {
          start
          end
        }
      }
    }
  }
`;

export function useDeliveryEstimateQuery(
  options: Omit<Urql.UseQueryArgs<DeliveryEstimateQueryVariables>, 'query'>,
) {
  return Urql.useQuery<DeliveryEstimateQuery, DeliveryEstimateQueryVariables>({
    query: DeliveryEstimateDocument,
    ...options,
  });
}
export const AddressDocument = gql`
  query Address($addressId: ID!) {
    address(addressId: $addressId) {
      id
      street
      secondaryStreet
      city
      state
      country
      zipCode
      deliveryPreference
      googlePlaceId
      latitude
      longitude
      name
      notes
    }
  }
`;

export function useAddressQuery(
  options: Omit<Urql.UseQueryArgs<AddressQueryVariables>, 'query'>,
) {
  return Urql.useQuery<AddressQuery, AddressQueryVariables>({
    query: AddressDocument,
    ...options,
  });
}
export const DeliveryRestaurantDocument = gql`
  query DeliveryRestaurant($input: LocationByAddressInput!) {
    locationByAddress(input: $input) {
      __typename
      ... on Location {
        restaurant {
          ...RestaurantMenu
        }
        estimateRange {
          start
          end
        }
        vendor {
          name
          restaurantId
        }
        status
      }
    }
  }
  ${RestaurantMenuFragmentDoc}
`;

export function useDeliveryRestaurantQuery(
  options: Omit<Urql.UseQueryArgs<DeliveryRestaurantQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    DeliveryRestaurantQuery,
    DeliveryRestaurantQueryVariables
  >({ query: DeliveryRestaurantDocument, ...options });
}
export const FavoritesDocument = gql`
  query favorites($input: FavoritedLineItemsInput!) {
    favoritedLineItems(input: $input) {
      id
      slug
      customName
      quantity
      cost
      perItemCost
      product {
        id
        name
        calories
        cost
        isCustom
        label {
          id
          name
        }
        description
        asset {
          url
        }
        restaurant {
          id
        }
        dietaryProperties {
          id
          name
        }
      }
      ingredients {
        id
        name
      }
      addedIngredients {
        id
        name
      }
      removedIngredients {
        id
        name
      }
      mixedDressingDetails {
        ingredientId
        weight
      }
      dressingMode
    }
  }
`;

export function useFavoritesQuery(
  options: Omit<Urql.UseQueryArgs<FavoritesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<FavoritesQuery, FavoritesQueryVariables>({
    query: FavoritesDocument,
    ...options,
  });
}
export const GetOrderStatusDocument = gql`
  query GetOrderStatus {
    orderStatus {
      ...GetOrderStatusFields
    }
  }
  ${GetOrderStatusFieldsFragmentDoc}
`;

export function useGetOrderStatusQuery(
  options?: Omit<Urql.UseQueryArgs<GetOrderStatusQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetOrderStatusQuery, GetOrderStatusQueryVariables>({
    query: GetOrderStatusDocument,
    ...options,
  });
}
export const LocationByAddressDocument = gql`
  query LocationByAddress($input: LocationByAddressInput!) {
    locationByAddress(input: $input) {
      __typename
      ... on Location {
        restaurant {
          id
          name
          slug
        }
        estimateRange {
          start
          end
        }
        vendor {
          name
          restaurantId
        }
        status
      }
    }
  }
`;

export function useLocationByAddressQuery(
  options: Omit<Urql.UseQueryArgs<LocationByAddressQueryVariables>, 'query'>,
) {
  return Urql.useQuery<LocationByAddressQuery, LocationByAddressQueryVariables>(
    { query: LocationByAddressDocument, ...options },
  );
}
export const SearchLocationsByBoundingBoxDocument = gql`
  query SearchLocationsByBoundingBox(
    $topLeft: GeoCoordinates!
    $bottomRight: GeoCoordinates!
    $showHidden: Boolean
  ) {
    searchLocationsByBoundingBox(
      topLeft: $topLeft
      bottomRight: $bottomRight
      showHidden: $showHidden
    ) {
      location {
        id
        name
        lat: latitude
        lng: longitude
        restaurantSlug: slug
        address
        city
        state
        zipCode
        isOutpost
        phone
        storeHours
        flexMessage
        enabled
        acceptingOrders
        notAcceptingOrdersReason
        imageUrl
        hidden
        showWarningDialog
        warningDialogDescription
        warningDialogTimeout
        warningDialogTitle
      }
    }
  }
`;

export function useSearchLocationsByBoundingBoxQuery(
  options: Omit<
    Urql.UseQueryArgs<SearchLocationsByBoundingBoxQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    SearchLocationsByBoundingBoxQuery,
    SearchLocationsByBoundingBoxQueryVariables
  >({ query: SearchLocationsByBoundingBoxDocument, ...options });
}
export const SearchLocationsByStringDocument = gql`
  query SearchLocationsByString($searchString: String!, $showHidden: Boolean) {
    searchLocationsByString(
      searchString: $searchString
      showHidden: $showHidden
    ) {
      score
      location {
        id
        name
        lat: latitude
        lng: longitude
        restaurantSlug: slug
        address
        city
        state
        zipCode
        isOutpost
        phone
        storeHours
        flexMessage
        enabled
        acceptingOrders
        notAcceptingOrdersReason
        imageUrl
        hidden
        showWarningDialog
        warningDialogDescription
        warningDialogTimeout
        warningDialogTitle
      }
    }
  }
`;

export function useSearchLocationsByStringQuery(
  options: Omit<
    Urql.UseQueryArgs<SearchLocationsByStringQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    SearchLocationsByStringQuery,
    SearchLocationsByStringQueryVariables
  >({ query: SearchLocationsByStringDocument, ...options });
}
export const LogInCustomerDocument = gql`
  mutation LogInCustomer($input: LoginInput!) {
    login(input: $input) {
      __typename
      ...LogInCustomerSuccessfulLoginFields
      ...LogInCustomerInvalidCredentialsFields
      ...ValidationErrorFields
    }
  }
  ${LogInCustomerSuccessfulLoginFieldsFragmentDoc}
  ${LogInCustomerInvalidCredentialsFieldsFragmentDoc}
  ${ValidationErrorFieldsFragmentDoc}
`;

export function useLogInCustomerMutation() {
  return Urql.useMutation<
    LogInCustomerMutation,
    LogInCustomerMutationVariables
  >(LogInCustomerDocument);
}
export const MenuCollectionDocument = gql`
  query MenuCollection($collectionId: ID!) {
    menuCollection(id: $collectionId) {
      id
      color
      primaryImageUrl
      primaryTitle
      primaryDescription
      products {
        ...MenuCollectionProduct
      }
    }
  }
  ${MenuCollectionProductFragmentDoc}
`;

export function useMenuCollectionQuery(
  options: Omit<Urql.UseQueryArgs<MenuCollectionQueryVariables>, 'query'>,
) {
  return Urql.useQuery<MenuCollectionQuery, MenuCollectionQueryVariables>({
    query: MenuCollectionDocument,
    ...options,
  });
}
export const MenuCartDocument = gql`
  query MenuCart {
    cart {
      id
      lineItems {
        id
      }
      restaurant {
        id
      }
    }
  }
`;

export function useMenuCartQuery(
  options?: Omit<Urql.UseQueryArgs<MenuCartQueryVariables>, 'query'>,
) {
  return Urql.useQuery<MenuCartQuery, MenuCartQueryVariables>({
    query: MenuCartDocument,
    ...options,
  });
}
export const RestaurantDocument = gql`
  query Restaurant($id: ID!) {
    restaurant(id: $id) {
      ...RestaurantMenu
    }
  }
  ${RestaurantMenuFragmentDoc}
`;

export function useRestaurantQuery(
  options: Omit<Urql.UseQueryArgs<RestaurantQueryVariables>, 'query'>,
) {
  return Urql.useQuery<RestaurantQuery, RestaurantQueryVariables>({
    query: RestaurantDocument,
    ...options,
  });
}
export const MenuRedirectDocument = gql`
  query MenuRedirect($id: ID!) {
    restaurant(id: $id) {
      id
    }
  }
`;

export function useMenuRedirectQuery(
  options: Omit<Urql.UseQueryArgs<MenuRedirectQueryVariables>, 'query'>,
) {
  return Urql.useQuery<MenuRedirectQuery, MenuRedirectQueryVariables>({
    query: MenuRedirectDocument,
    ...options,
  });
}
export const BaseProductDocument = gql`
  query BaseProduct($slug: String!) {
    baseProduct(slug: $slug) {
      __typename
      ...BaseProductData
    }
  }
  ${BaseProductDataFragmentDoc}
`;

export function useBaseProductQuery(
  options: Omit<Urql.UseQueryArgs<BaseProductQueryVariables>, 'query'>,
) {
  return Urql.useQuery<BaseProductQuery, BaseProductQueryVariables>({
    query: BaseProductDocument,
    ...options,
  });
}
export const OrderProductRestaurantDocument = gql`
  query OrderProductRestaurant($id: ID!) {
    restaurant(id: $id) {
      ...OrderProductRestaurantData
    }
  }
  ${OrderProductRestaurantDataFragmentDoc}
`;

export function useOrderProductRestaurantQuery(
  options: Omit<
    Urql.UseQueryArgs<OrderProductRestaurantQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    OrderProductRestaurantQuery,
    OrderProductRestaurantQueryVariables
  >({ query: OrderProductRestaurantDocument, ...options });
}
export const ProductForRestaurantDocument = gql`
  query ProductForRestaurant(
    $baseProductSlug: String!
    $restaurantId: String!
  ) {
    productForRestaurant(
      baseProductSlug: $baseProductSlug
      restaurantId: $restaurantId
    ) {
      id
      slug
    }
  }
`;

export function useProductForRestaurantQuery(
  options: Omit<Urql.UseQueryArgs<ProductForRestaurantQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    ProductForRestaurantQuery,
    ProductForRestaurantQueryVariables
  >({ query: ProductForRestaurantDocument, ...options });
}
export const OrderStatusDocument = gql`
  query OrderStatus($id: ID!) {
    orderStatus(orderId: $id) {
      __typename
      ... on OrderStatus {
        gravyStatus
        gravyUpdatedAt
        orderOccasion
        orderStatus
        flattenedOrderStatus
        courierDetails {
          name
          phone
          latitude
          longitude
        }
        order {
          id
          description
          dropoffLocation
          orderType
          total
          canTrackOrderStatus
          isPendingFeedback
          wantedTime
          vendorId
          restaurant {
            id
            city
            state
            zipCode
            name
            address
            slug
            latitude
            longitude
            isOutpost
            phone
            availableDropOffLocations {
              id
              name
            }
          }
          ledger {
            ...CartLedger
          }
          lineItems {
            calories
            ...CartLineItem
          }
          deliveryOrderDetail {
            ...DeliveryOrderDetail
          }
        }
      }
      ... on InvalidOrder {
        message
      }
    }
  }
  ${CartLedgerFragmentDoc}
  ${CartLineItemFragmentDoc}
  ${DeliveryOrderDetailFragmentDoc}
`;

export function useOrderStatusQuery(
  options: Omit<Urql.UseQueryArgs<OrderStatusQueryVariables>, 'query'>,
) {
  return Urql.useQuery<OrderStatusQuery, OrderStatusQueryVariables>({
    query: OrderStatusDocument,
    ...options,
  });
}
export const OrderStatusPollingDocument = gql`
  query OrderStatusPolling($id: ID!) {
    orderStatus(orderId: $id) {
      __typename
      ... on OrderStatus {
        flattenedOrderStatus
        courierDetails {
          name
          phone
          latitude
          longitude
        }
        order {
          id
          wantedTime
        }
      }
      ... on InvalidOrder {
        message
      }
    }
  }
`;

export function useOrderStatusPollingQuery(
  options: Omit<Urql.UseQueryArgs<OrderStatusPollingQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    OrderStatusPollingQuery,
    OrderStatusPollingQueryVariables
  >({ query: OrderStatusPollingDocument, ...options });
}
export const FavoriteLineItemDocument = gql`
  mutation FavoriteLineItem($input: FavoriteLineItemInput!) {
    favoriteLineItem(input: $input) {
      id
      favorited
    }
  }
`;

export function useFavoriteLineItemMutation() {
  return Urql.useMutation<
    FavoriteLineItemMutation,
    FavoriteLineItemMutationVariables
  >(FavoriteLineItemDocument);
}
export const OrderHistoryDocument = gql`
  query orderHistory($input: OrdersInput!) {
    orders(input: $input) {
      __typename
      ... on OrdersResponseSuccess {
        orders {
          id
          orderType
          wantedTime
          description
          total
          lineItems {
            id
            customName
            isCustom
            product {
              id
              name
              isCustom
              categoryName
            }
          }
          asset {
            url
          }
          restaurant {
            id
            name
            isOutpost
          }
          deliveryOrderDetail {
            id
            address {
              id
              name
            }
          }
        }
      }
      ...ValidationErrorFields
    }
  }
  ${ValidationErrorFieldsFragmentDoc}
`;

export function useOrderHistoryQuery(
  options: Omit<Urql.UseQueryArgs<OrderHistoryQueryVariables>, 'query'>,
) {
  return Urql.useQuery<OrderHistoryQuery, OrderHistoryQueryVariables>({
    query: OrderHistoryDocument,
    ...options,
  });
}
export const GetLineItemDocument = gql`
  query GetLineItem($input: LineItemInput!) {
    getLineItem: lineItem(input: $input) {
      __typename
      ...LineItemSuccessFields
      ...LineItemNotFoundFields
      ...ValidationErrorFields
    }
  }
  ${LineItemSuccessFieldsFragmentDoc}
  ${LineItemNotFoundFieldsFragmentDoc}
  ${ValidationErrorFieldsFragmentDoc}
`;

export function useGetLineItemQuery(
  options: Omit<Urql.UseQueryArgs<GetLineItemQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetLineItemQuery, GetLineItemQueryVariables>({
    query: GetLineItemDocument,
    ...options,
  });
}
export const GetProductDocument = gql`
  query GetProduct($id: ID!) {
    product(id: $id) {
      ...ProductDetails
    }
  }
  ${ProductDetailsFragmentDoc}
`;

export function useGetProductQuery(
  options: Omit<Urql.UseQueryArgs<GetProductQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetProductQuery, GetProductQueryVariables>({
    query: GetProductDocument,
    ...options,
  });
}
export const UpdateCustomerProfileDocument = gql`
  mutation UpdateCustomerProfile($input: UpdateCustomerInput!) {
    updateCustomer(input: $input) {
      customer {
        id
        firstName
        lastName
        email
        phoneNumber
        birthday
        __typename
      }
    }
  }
`;

export function useUpdateCustomerProfileMutation() {
  return Urql.useMutation<
    UpdateCustomerProfileMutation,
    UpdateCustomerProfileMutationVariables
  >(UpdateCustomerProfileDocument);
}
export const CustomerProfileFieldsDocument = gql`
  query CustomerProfileFields {
    currentCustomer {
      id
      firstName
      lastName
      email
      phoneNumber
      birthday
      __typename
    }
  }
`;

export function useCustomerProfileFieldsQuery(
  options?: Omit<
    Urql.UseQueryArgs<CustomerProfileFieldsQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    CustomerProfileFieldsQuery,
    CustomerProfileFieldsQueryVariables
  >({ query: CustomerProfileFieldsDocument, ...options });
}
export const FeedbackQuestionsDocument = gql`
  query feedbackQuestions($orderId: ID!) {
    feedbackQuestions(orderId: $orderId) {
      id
      text
      slug
      responses {
        id
        text
      }
    }
  }
`;

export function useFeedbackQuestionsQuery(
  options: Omit<Urql.UseQueryArgs<FeedbackQuestionsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<FeedbackQuestionsQuery, FeedbackQuestionsQueryVariables>(
    { query: FeedbackQuestionsDocument, ...options },
  );
}
export const InStoreFeedbackQuestionsDocument = gql`
  query inStoreFeedbackQuestions($orderId: ID!) {
    inStoreFeedbackQuestions(orderId: $orderId) {
      id
      text
      slug
      responses {
        id
        text
      }
    }
  }
`;

export function useInStoreFeedbackQuestionsQuery(
  options: Omit<
    Urql.UseQueryArgs<InStoreFeedbackQuestionsQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    InStoreFeedbackQuestionsQuery,
    InStoreFeedbackQuestionsQueryVariables
  >({ query: InStoreFeedbackQuestionsDocument, ...options });
}
export const FeedbackOrderStatusDocument = gql`
  query feedbackOrderStatus($orderId: ID!) {
    orderStatus(orderId: $orderId) {
      __typename
      ... on OrderStatus {
        order {
          id
          orderType
          wantedTime
          description
          restaurant {
            id
            slug
            name
          }
          lineItems {
            id
            quantity
            customName
            product {
              id
              name
              slug
            }
          }
        }
      }
    }
  }
`;

export function useFeedbackOrderStatusQuery(
  options: Omit<Urql.UseQueryArgs<FeedbackOrderStatusQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    FeedbackOrderStatusQuery,
    FeedbackOrderStatusQueryVariables
  >({ query: FeedbackOrderStatusDocument, ...options });
}
export const SubmitFeedbackDocument = gql`
  mutation submitFeedback($input: FeedbackInput!) {
    submitFeedback(input: $input) {
      success
    }
  }
`;

export function useSubmitFeedbackMutation() {
  return Urql.useMutation<
    SubmitFeedbackMutation,
    SubmitFeedbackMutationVariables
  >(SubmitFeedbackDocument);
}
export const SubmitInStoreFeedbackDocument = gql`
  mutation submitInStoreFeedback($input: FeedbackInput!) {
    submitInStoreFeedback(input: $input) {
      success
    }
  }
`;

export function useSubmitInStoreFeedbackMutation() {
  return Urql.useMutation<
    SubmitInStoreFeedbackMutation,
    SubmitInStoreFeedbackMutationVariables
  >(SubmitInStoreFeedbackDocument);
}
export const ReferralShareUrlDocument = gql`
  query referralShareUrl {
    currentCustomer {
      id
      referralShareUrlEmail
    }
  }
`;

export function useReferralShareUrlQuery(
  options?: Omit<Urql.UseQueryArgs<ReferralShareUrlQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ReferralShareUrlQuery, ReferralShareUrlQueryVariables>({
    query: ReferralShareUrlDocument,
    ...options,
  });
}
export const ReorderOrderDocument = gql`
  mutation reorderOrder($input: ReorderInput!) {
    reorderOrder(input: $input) {
      __typename
      ... on ReorderSuccess {
        ...ReorderSuccessResponse
      }
      ... on ReorderConflict {
        ...ReorderConflictResponse
      }
      ... on RestaurantMaxDeliveryQuantityExceeded {
        ...RestaurantMaxDeliveryQuantityExceededResponse
      }
      ... on RestaurantMaxQuantityExceeded {
        ...RestaurantMaxQuantityExceededResponse
      }
      ... on CanNotReorder {
        ...CanNotReorderResponse
      }
      ... on ValidationError {
        ...ValidationErrorResponse
      }
    }
  }
  ${ReorderSuccessResponseFragmentDoc}
  ${ReorderConflictResponseFragmentDoc}
  ${RestaurantMaxDeliveryQuantityExceededResponseFragmentDoc}
  ${RestaurantMaxQuantityExceededResponseFragmentDoc}
  ${CanNotReorderResponseFragmentDoc}
  ${ValidationErrorResponseFragmentDoc}
`;

export function useReorderOrderMutation() {
  return Urql.useMutation<ReorderOrderMutation, ReorderOrderMutationVariables>(
    ReorderOrderDocument,
  );
}
export const ReorderLineItemDocument = gql`
  mutation reorderLineItem($input: ReorderInput!) {
    reorderLineItem(input: $input) {
      __typename
      ... on ReorderSuccess {
        ...ReorderSuccessResponse
      }
      ... on ReorderConflict {
        ...ReorderConflictResponse
      }
      ... on RestaurantMaxDeliveryQuantityExceeded {
        ...RestaurantMaxDeliveryQuantityExceededResponse
      }
      ... on RestaurantMaxQuantityExceeded {
        ...RestaurantMaxQuantityExceededResponse
      }
      ... on CanNotReorder {
        ...CanNotReorderResponse
      }
      ... on ValidationError {
        ...ValidationErrorResponse
      }
    }
  }
  ${ReorderSuccessResponseFragmentDoc}
  ${ReorderConflictResponseFragmentDoc}
  ${RestaurantMaxDeliveryQuantityExceededResponseFragmentDoc}
  ${RestaurantMaxQuantityExceededResponseFragmentDoc}
  ${CanNotReorderResponseFragmentDoc}
  ${ValidationErrorResponseFragmentDoc}
`;

export function useReorderLineItemMutation() {
  return Urql.useMutation<
    ReorderLineItemMutation,
    ReorderLineItemMutationVariables
  >(ReorderLineItemDocument);
}
export const ReorderRestaurantDocument = gql`
  query ReorderRestaurant($id: ID!) {
    restaurant(id: $id) {
      ...ReorderRestaurantRequiredData
    }
  }
  ${ReorderRestaurantRequiredDataFragmentDoc}
`;

export function useReorderRestaurantQuery(
  options: Omit<Urql.UseQueryArgs<ReorderRestaurantQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ReorderRestaurantQuery, ReorderRestaurantQueryVariables>(
    { query: ReorderRestaurantDocument, ...options },
  );
}
export const ReorderRestaurantDataDocument = gql`
  query ReorderRestaurantData($id: ID!) {
    restaurant(id: $id) {
      id
      slug
      name
      isOutpost
      deliveryFee
    }
  }
`;

export function useReorderRestaurantDataQuery(
  options: Omit<
    Urql.UseQueryArgs<ReorderRestaurantDataQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    ReorderRestaurantDataQuery,
    ReorderRestaurantDataQueryVariables
  >({ query: ReorderRestaurantDataDocument, ...options });
}
export const ReorderDeliveryRestaurantDataDocument = gql`
  query ReorderDeliveryRestaurantData($input: LocationByAddressInput!) {
    locationByAddress(input: $input) {
      __typename
      ... on Location {
        restaurant {
          id
          slug
          name
          isOutpost
          deliveryFee
        }
        vendor {
          name
          restaurantId
        }
      }
    }
  }
`;

export function useReorderDeliveryRestaurantDataQuery(
  options: Omit<
    Urql.UseQueryArgs<ReorderDeliveryRestaurantDataQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    ReorderDeliveryRestaurantDataQuery,
    ReorderDeliveryRestaurantDataQueryVariables
  >({ query: ReorderDeliveryRestaurantDataDocument, ...options });
}
export const ReorderDeliveryAddressDataDocument = gql`
  query ReorderDeliveryAddressData($addressId: ID!) {
    address(addressId: $addressId) {
      id
      name
    }
  }
`;

export function useReorderDeliveryAddressDataQuery(
  options: Omit<
    Urql.UseQueryArgs<ReorderDeliveryAddressDataQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    ReorderDeliveryAddressDataQuery,
    ReorderDeliveryAddressDataQueryVariables
  >({ query: ReorderDeliveryAddressDataDocument, ...options });
}
export const ScanToPayBillingAccountsDocument = gql`
  query scanToPayBillingAccounts {
    currentCustomer {
      id
      billingAccounts {
        id
        description
        nickname
        isDefault
        cardType
        expirationState
      }
    }
  }
`;

export function useScanToPayBillingAccountsQuery(
  options?: Omit<
    Urql.UseQueryArgs<ScanToPayBillingAccountsQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    ScanToPayBillingAccountsQuery,
    ScanToPayBillingAccountsQueryVariables
  >({ query: ScanToPayBillingAccountsDocument, ...options });
}
export const CustomerPassDocument = gql`
  query customerPass {
    customerPass {
      authenticationToken
      url
    }
  }
`;

export function useCustomerPassQuery(
  options?: Omit<Urql.UseQueryArgs<CustomerPassQueryVariables>, 'query'>,
) {
  return Urql.useQuery<CustomerPassQuery, CustomerPassQueryVariables>({
    query: CustomerPassDocument,
    ...options,
  });
}
export const GetSharedLineItemDocument = gql`
  query GetSharedLineItem($input: LineItemBySlugInput!) {
    lineItemBySlug(input: $input) {
      __typename
      ... on LineItemSuccess {
        lineItem {
          id
          slug
          quantity
          customName
          customerName
          isCustom
          product {
            id
            name
            calories
            cost
            isCustom
            label {
              id
              name
            }
            description
            asset {
              url
            }
            dietaryProperties {
              id
              name
            }
            restaurant {
              id
              slug
              name
            }
          }
          dressingMode
        }
      }
      ...LineItemNotFoundFields
      ...ValidationErrorFields
    }
  }
  ${LineItemNotFoundFieldsFragmentDoc}
  ${ValidationErrorFieldsFragmentDoc}
`;

export function useGetSharedLineItemQuery(
  options: Omit<Urql.UseQueryArgs<GetSharedLineItemQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetSharedLineItemQuery, GetSharedLineItemQueryVariables>(
    { query: GetSharedLineItemDocument, ...options },
  );
}
export const GetBillingHistoryDocument = gql`
  query GetBillingHistory {
    getSubscriptions {
      id
      status
      nextBillingDate
      paidThroughDate
      billingHistory {
        id
        creditCard {
          id
          cardType
          lastFour
        }
        date
        amount
        refund
      }
    }
  }
`;

export function useGetBillingHistoryQuery(
  options?: Omit<Urql.UseQueryArgs<GetBillingHistoryQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetBillingHistoryQuery, GetBillingHistoryQueryVariables>(
    { query: GetBillingHistoryDocument, ...options },
  );
}
export const AddSubscriptionPaymentMethodDocument = gql`
  mutation AddSubscriptionPaymentMethod($nonce: String!) {
    addSubscriptionPaymentMethod(paymentNonce: $nonce) {
      ... on AddSubscriptionPaymentMethodSuccessResponse {
        paymentMethodToken
        creditCard {
          id
          cardType
          lastFour
          expirationMonth
          expirationYear
          isActive
        }
        __typename
      }
      ... on PaymentMethodAlreadyExistsError {
        errorMessage
        __typename
      }
      ... on UnknownUserError {
        errorMessage
        __typename
      }
      ... on UserError {
        errorMessage
        __typename
      }
    }
  }
`;

export function useAddSubscriptionPaymentMethodMutation() {
  return Urql.useMutation<
    AddSubscriptionPaymentMethodMutation,
    AddSubscriptionPaymentMethodMutationVariables
  >(AddSubscriptionPaymentMethodDocument);
}
export const RemoveSubscriptionPaymentMethodDocument = gql`
  mutation RemoveSubscriptionPaymentMethod($paymentMethodId: String!) {
    removeSubscriptionPaymentMethod(paymentMethodId: $paymentMethodId) {
      __typename
      ... on DeleteSubscriptionPaymentMethodSuccess {
        creditCards {
          id
          cardType
          lastFour
          __typename
        }
      }
      ... on ActivePaymentMethodError {
        errorMessage
        __typename
      }
      ... on UnknownUserError {
        errorMessage
        __typename
      }
      ... on UserError {
        errorMessage
        __typename
      }
    }
  }
`;

export function useRemoveSubscriptionPaymentMethodMutation() {
  return Urql.useMutation<
    RemoveSubscriptionPaymentMethodMutation,
    RemoveSubscriptionPaymentMethodMutationVariables
  >(RemoveSubscriptionPaymentMethodDocument);
}
export const GetPaymentSubscriptionProfileDocument = gql`
  query getPaymentSubscriptionProfile {
    paymentSubscriptionProfile {
      id
      creditCards {
        id
        cardType
        lastFour
      }
    }
  }
`;

export function useGetPaymentSubscriptionProfileQuery(
  options?: Omit<
    Urql.UseQueryArgs<GetPaymentSubscriptionProfileQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    GetPaymentSubscriptionProfileQuery,
    GetPaymentSubscriptionProfileQueryVariables
  >({ query: GetPaymentSubscriptionProfileDocument, ...options });
}
export const SubscribeDocument = gql`
  mutation Subscribe($token: String, $planId: String!, $paymentId: String) {
    createSubscription(token: $token, planId: $planId, paymentId: $paymentId) {
      id
      trialDuration
      status
      firstBillingDate
      subscriptionAmount
    }
  }
`;

export function useSubscribeMutation() {
  return Urql.useMutation<SubscribeMutation, SubscribeMutationVariables>(
    SubscribeDocument,
  );
}
export const CancelSubscriptionAtCycleEndDocument = gql`
  mutation CancelSubscriptionAtCycleEnd($subscriptionId: String!) {
    cancelSubscriptionAtCycleEnd(subscriptionId: $subscriptionId) {
      ... on CancelSubscriptionAtCycleEndSuccessResponse {
        subscription {
          id
          paidThroughDate
        }
      }
    }
  }
`;

export function useCancelSubscriptionAtCycleEndMutation() {
  return Urql.useMutation<
    CancelSubscriptionAtCycleEndMutation,
    CancelSubscriptionAtCycleEndMutationVariables
  >(CancelSubscriptionAtCycleEndDocument);
}
export const GetSweetpassMembershipDocument = gql`
  query GetSweetpassMembership {
    loyaltyProfile {
      customerId
      joinDate
      hasPaidTierHistory
      tierStatus {
        id
        name
      }
      tier {
        id
        name
        nextTier {
          id
          name
        }
      }
    }
    getSubscriptions(status: [ACTIVE]) {
      id
      paidThroughDate
      nextBillingDate
      nextBillingPeriodAmount
    }
    paymentSubscriptionProfile {
      id
      creditCards {
        id
        cardType
        lastFour
        expirationMonth
        expirationYear
        isActive
      }
    }
  }
`;

export function useGetSweetpassMembershipQuery(
  options?: Omit<
    Urql.UseQueryArgs<GetSweetpassMembershipQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    GetSweetpassMembershipQuery,
    GetSweetpassMembershipQueryVariables
  >({ query: GetSweetpassMembershipDocument, ...options });
}
export const RejoinSubscriptionDocument = gql`
  mutation RejoinSubscription($subscriptionId: String!) {
    rejoinSubscription(subscriptionId: $subscriptionId) {
      __typename
      ... on RejoinSubscriptionSuccessResponse {
        subscription {
          id
          status
        }
      }
      ... on SubscriptionCannotBeReactivatedError {
        errorMessage
      }
      ... on UnknownUserError {
        errorMessage
      }
    }
  }
`;

export function useRejoinSubscriptionMutation() {
  return Urql.useMutation<
    RejoinSubscriptionMutation,
    RejoinSubscriptionMutationVariables
  >(RejoinSubscriptionDocument);
}
export const UpdateSubscriptionPaymentMethodDocument = gql`
  mutation UpdateSubscriptionPaymentMethod(
    $subscriptionId: String!
    $paymentMethodId: String!
  ) {
    updateSubscriptionPaymentMethod(
      subscriptionId: $subscriptionId
      paymentMethodId: $paymentMethodId
    ) {
      __typename
      ... on UpdateSubscriptionPaymentMethodSuccessResponse {
        subscription {
          id
        }
      }
    }
  }
`;

export function useUpdateSubscriptionPaymentMethodMutation() {
  return Urql.useMutation<
    UpdateSubscriptionPaymentMethodMutation,
    UpdateSubscriptionPaymentMethodMutationVariables
  >(UpdateSubscriptionPaymentMethodDocument);
}
export const GetSubscriptionPaymentMethodDocument = gql`
  query GetSubscriptionPaymentMethod {
    getSubscriptions(status: [ACTIVE]) {
      id
    }
    paymentSubscriptionProfile {
      id
      creditCards {
        id
        cardType
        lastFour
        expirationYear
        expirationMonth
        isActive
      }
    }
  }
`;

export function useGetSubscriptionPaymentMethodQuery(
  options?: Omit<
    Urql.UseQueryArgs<GetSubscriptionPaymentMethodQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    GetSubscriptionPaymentMethodQuery,
    GetSubscriptionPaymentMethodQueryVariables
  >({ query: GetSubscriptionPaymentMethodDocument, ...options });
}
export const FetchPlansByTierIdDocument = gql`
  query FetchPlansByTierId($tierId: ID!) {
    fetchPlansByTierId(tierId: $tierId) {
      braintreePlanId
    }
  }
`;

export function useFetchPlansByTierIdQuery(
  options: Omit<Urql.UseQueryArgs<FetchPlansByTierIdQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    FetchPlansByTierIdQuery,
    FetchPlansByTierIdQueryVariables
  >({ query: FetchPlansByTierIdDocument, ...options });
}
export const OptInUserDocument = gql`
  mutation OptInUser {
    optInFreeTier
  }
`;

export function useOptInUserMutation() {
  return Urql.useMutation<OptInUserMutation, OptInUserMutationVariables>(
    OptInUserDocument,
  );
}
export type WithTypename<T extends { __typename?: any }> = Partial<T> & {
  __typename: NonNullable<T['__typename']>;
};

export type GraphCacheKeysConfig = {
  AccountLocked?: (data: WithTypename<AccountLocked>) => null | string;
  ActivePaymentMethodError?: (
    data: WithTypename<ActivePaymentMethodError>,
  ) => null | string;
  AddAddressSuccess?: (data: WithTypename<AddAddressSuccess>) => null | string;
  AddLineItemToCartSuccess?: (
    data: WithTypename<AddLineItemToCartSuccess>,
  ) => null | string;
  AddSubscriptionPaymentMethodSuccessResponse?: (
    data: WithTypename<AddSubscriptionPaymentMethodSuccessResponse>,
  ) => null | string;
  Addons?: (data: WithTypename<Addons>) => null | string;
  Address?: (data: WithTypename<Address>) => null | string;
  ApplyRewardSuccess?: (
    data: WithTypename<ApplyRewardSuccess>,
  ) => null | string;
  Asset?: (data: WithTypename<Asset>) => null | string;
  AvailableWantedTime?: (
    data: WithTypename<AvailableWantedTime>,
  ) => null | string;
  BaseProduct?: (data: WithTypename<BaseProduct>) => null | string;
  BillingAccount?: (data: WithTypename<BillingAccount>) => null | string;
  CanNotReorder?: (data: WithTypename<CanNotReorder>) => null | string;
  CancelSubscriptionAtCycleEndSuccessResponse?: (
    data: WithTypename<CancelSubscriptionAtCycleEndSuccessResponse>,
  ) => null | string;
  CancelSubscriptionForCustomerSuccessResponse?: (
    data: WithTypename<CancelSubscriptionForCustomerSuccessResponse>,
  ) => null | string;
  CancelSubscriptionSuccessResponse?: (
    data: WithTypename<CancelSubscriptionSuccessResponse>,
  ) => null | string;
  Challenge?: (data: WithTypename<Challenge>) => null | string;
  ChallengeCelebration?: (
    data: WithTypename<ChallengeCelebration>,
  ) => null | string;
  ChallengeReward?: (data: WithTypename<ChallengeReward>) => null | string;
  CourierDetails?: (data: WithTypename<CourierDetails>) => null | string;
  CreateLoyaltyProfileResult?: (
    data: WithTypename<CreateLoyaltyProfileResult>,
  ) => null | string;
  CreateSubscriptionResult?: (
    data: WithTypename<CreateSubscriptionResult>,
  ) => null | string;
  Credit?: (data: WithTypename<Credit>) => null | string;
  Customer?: (data: WithTypename<Customer>) => null | string;
  CustomerPass?: (data: WithTypename<CustomerPass>) => null | string;
  DeleteAddressSuccess?: (
    data: WithTypename<DeleteAddressSuccess>,
  ) => null | string;
  DeleteBillingAccountResponse?: (
    data: WithTypename<DeleteBillingAccountResponse>,
  ) => null | string;
  DeleteSubscriptionPaymentMethodSuccess?: (
    data: WithTypename<DeleteSubscriptionPaymentMethodSuccess>,
  ) => null | string;
  DeliveryAlreadyInFlight?: (
    data: WithTypename<DeliveryAlreadyInFlight>,
  ) => null | string;
  DeliveryOrderDetail?: (
    data: WithTypename<DeliveryOrderDetail>,
  ) => null | string;
  DeliverySpecifyAddress?: (
    data: WithTypename<DeliverySpecifyAddress>,
  ) => null | string;
  DietaryProperty?: (data: WithTypename<DietaryProperty>) => null | string;
  Discount?: (data: WithTypename<Discount>) => null | string;
  DropOffLocation?: (data: WithTypename<DropOffLocation>) => null | string;
  EditLineItemInCartSuccess?: (
    data: WithTypename<EditLineItemInCartSuccess>,
  ) => null | string;
  EstimateRange?: (data: WithTypename<EstimateRange>) => null | string;
  FeedbackQuestion?: (data: WithTypename<FeedbackQuestion>) => null | string;
  FeedbackResponse?: (data: WithTypename<FeedbackResponse>) => null | string;
  FeedbackSuccess?: (data: WithTypename<FeedbackSuccess>) => null | string;
  FieldValidationError?: (
    data: WithTypename<FieldValidationError>,
  ) => null | string;
  ForgotPasswordSuccess?: (
    data: WithTypename<ForgotPasswordSuccess>,
  ) => null | string;
  Guest?: (data: WithTypename<Guest>) => null | string;
  HasUnseenChallenges?: (
    data: WithTypename<HasUnseenChallenges>,
  ) => null | string;
  InStoreOrder?: (data: WithTypename<InStoreOrder>) => null | string;
  Ingredient?: (data: WithTypename<Ingredient>) => null | string;
  IngredientModification?: (
    data: WithTypename<IngredientModification>,
  ) => null | string;
  IngredientModificationKind?: (
    data: WithTypename<IngredientModificationKind>,
  ) => null | string;
  IngredientModifications?: (
    data: WithTypename<IngredientModifications>,
  ) => null | string;
  InvalidAddress?: (data: WithTypename<InvalidAddress>) => null | string;
  InvalidBillingAccount?: (
    data: WithTypename<InvalidBillingAccount>,
  ) => null | string;
  InvalidCredentials?: (
    data: WithTypename<InvalidCredentials>,
  ) => null | string;
  InvalidCustomerPhone?: (
    data: WithTypename<InvalidCustomerPhone>,
  ) => null | string;
  InvalidInput?: (data: WithTypename<InvalidInput>) => null | string;
  InvalidOrder?: (data: WithTypename<InvalidOrder>) => null | string;
  InvalidPostalCode?: (data: WithTypename<InvalidPostalCode>) => null | string;
  InvalidPromoCode?: (data: WithTypename<InvalidPromoCode>) => null | string;
  InvalidRegistrationCode?: (
    data: WithTypename<InvalidRegistrationCode>,
  ) => null | string;
  InvalidSubmittedBillingAccount?: (
    data: WithTypename<InvalidSubmittedBillingAccount>,
  ) => null | string;
  Kustomer?: (data: WithTypename<Kustomer>) => null | string;
  Ledger?: (data: WithTypename<Ledger>) => null | string;
  LedgerItem?: (data: WithTypename<LedgerItem>) => null | string;
  LineItem?: (data: WithTypename<LineItem>) => null | string;
  LineItemNotFound?: (data: WithTypename<LineItemNotFound>) => null | string;
  LineItemSuccess?: (data: WithTypename<LineItemSuccess>) => null | string;
  Location?: (data: WithTypename<Location>) => null | string;
  LocationSearchResult?: (
    data: WithTypename<LocationSearchResult>,
  ) => null | string;
  LoginSuccess?: (data: WithTypename<LoginSuccess>) => null | string;
  LogoutSuccess?: (data: WithTypename<LogoutSuccess>) => null | string;
  LoyaltyProfile?: (data: WithTypename<LoyaltyProfile>) => null | string;
  MaxModificationsExceeded?: (
    data: WithTypename<MaxModificationsExceeded>,
  ) => null | string;
  Menu?: (data: WithTypename<Menu>) => null | string;
  MenuCategory?: (data: WithTypename<MenuCategory>) => null | string;
  MenuCollection?: (data: WithTypename<MenuCollection>) => null | string;
  MinimumDeliverySubtotalNotMet?: (
    data: WithTypename<MinimumDeliverySubtotalNotMet>,
  ) => null | string;
  MixedDressingDetails?: (
    data: WithTypename<MixedDressingDetails>,
  ) => null | string;
  NoValidRestaurants?: (
    data: WithTypename<NoValidRestaurants>,
  ) => null | string;
  Order?: (data: WithTypename<Order>) => null | string;
  OrderConflict?: (data: WithTypename<OrderConflict>) => null | string;
  OrderStatus?: (data: WithTypename<OrderStatus>) => null | string;
  OrdersResponseSuccess?: (
    data: WithTypename<OrdersResponseSuccess>,
  ) => null | string;
  Pagination?: (data: WithTypename<Pagination>) => null | string;
  PaymentMethodAlreadyExistsError?: (
    data: WithTypename<PaymentMethodAlreadyExistsError>,
  ) => null | string;
  PaymentPlan?: (data: WithTypename<PaymentPlan>) => null | string;
  PaymentSubscription?: (
    data: WithTypename<PaymentSubscription>,
  ) => null | string;
  PaymentSubscriptionProfile?: (
    data: WithTypename<PaymentSubscriptionProfile>,
  ) => null | string;
  Product?: (data: WithTypename<Product>) => null | string;
  ProductLabel?: (data: WithTypename<ProductLabel>) => null | string;
  ProductUnavailable?: (
    data: WithTypename<ProductUnavailable>,
  ) => null | string;
  RegisterGuestFailed?: (
    data: WithTypename<RegisterGuestFailed>,
  ) => null | string;
  RegisterGuestSuccess?: (
    data: WithTypename<RegisterGuestSuccess>,
  ) => null | string;
  RegisterSuccess?: (data: WithTypename<RegisterSuccess>) => null | string;
  RejoinSubscriptionSuccessResponse?: (
    data: WithTypename<RejoinSubscriptionSuccessResponse>,
  ) => null | string;
  RemoveFromCartSuccess?: (
    data: WithTypename<RemoveFromCartSuccess>,
  ) => null | string;
  RemoveRewardSuccess?: (
    data: WithTypename<RemoveRewardSuccess>,
  ) => null | string;
  ReorderConflict?: (data: WithTypename<ReorderConflict>) => null | string;
  ReorderSuccess?: (data: WithTypename<ReorderSuccess>) => null | string;
  RequestAccountDeletionFailed?: (
    data: WithTypename<RequestAccountDeletionFailed>,
  ) => null | string;
  RequestAccountDeletionSuccess?: (
    data: WithTypename<RequestAccountDeletionSuccess>,
  ) => null | string;
  ResendVerificationCodeSuccess?: (
    data: WithTypename<ResendVerificationCodeSuccess>,
  ) => null | string;
  Restaurant?: (data: WithTypename<Restaurant>) => null | string;
  RestaurantCapacity?: (
    data: WithTypename<RestaurantCapacity>,
  ) => null | string;
  RestaurantCapacitySlot?: (
    data: WithTypename<RestaurantCapacitySlot>,
  ) => null | string;
  RestaurantHours?: (data: WithTypename<RestaurantHours>) => null | string;
  RestaurantIsNotAcceptingOrders?: (
    data: WithTypename<RestaurantIsNotAcceptingOrders>,
  ) => null | string;
  RestaurantMaxDeliveryQuantityExceeded?: (
    data: WithTypename<RestaurantMaxDeliveryQuantityExceeded>,
  ) => null | string;
  RestaurantMaxQuantityExceeded?: (
    data: WithTypename<RestaurantMaxQuantityExceeded>,
  ) => null | string;
  Reward?: (data: WithTypename<Reward>) => null | string;
  RewardNotApplied?: (data: WithTypename<RewardNotApplied>) => null | string;
  RewardNotRemoved?: (data: WithTypename<RewardNotRemoved>) => null | string;
  RewardNotValidated?: (
    data: WithTypename<RewardNotValidated>,
  ) => null | string;
  Session?: (data: WithTypename<Session>) => null | string;
  StoreLocation?: (data: WithTypename<StoreLocation>) => null | string;
  SubmitBraintreeBillingAccountSuccessResponse?: (
    data: WithTypename<SubmitBraintreeBillingAccountSuccessResponse>,
  ) => null | string;
  SubmitGiftCardCodeSuccess?: (
    data: WithTypename<SubmitGiftCardCodeSuccess>,
  ) => null | string;
  SubmitOrderUsingBillingAccountSuccess?: (
    data: WithTypename<SubmitOrderUsingBillingAccountSuccess>,
  ) => null | string;
  SubmitOrderWithPaymentMethodSuccess?: (
    data: WithTypename<SubmitOrderWithPaymentMethodSuccess>,
  ) => null | string;
  SubmitPromoCodeSuccess?: (
    data: WithTypename<SubmitPromoCodeSuccess>,
  ) => null | string;
  SubmitPromoCodeSuccessV2?: (
    data: WithTypename<SubmitPromoCodeSuccessV2>,
  ) => null | string;
  SubscriptionCannotBeReactivatedError?: (
    data: WithTypename<SubscriptionCannotBeReactivatedError>,
  ) => null | string;
  SubscriptionCreditCard?: (
    data: WithTypename<SubscriptionCreditCard>,
  ) => null | string;
  SubscriptionPlan?: (data: WithTypename<SubscriptionPlan>) => null | string;
  SubscriptionTransactions?: (
    data: WithTypename<SubscriptionTransactions>,
  ) => null | string;
  Tier?: (data: WithTypename<Tier>) => null | string;
  TierGroup?: (data: WithTypename<TierGroup>) => null | string;
  TierStatus?: (data: WithTypename<TierStatus>) => null | string;
  TimeslotUnavailable?: (
    data: WithTypename<TimeslotUnavailable>,
  ) => null | string;
  TooManyRequests?: (data: WithTypename<TooManyRequests>) => null | string;
  UnknownUserError?: (data: WithTypename<UnknownUserError>) => null | string;
  UpdateAddressSuccess?: (
    data: WithTypename<UpdateAddressSuccess>,
  ) => null | string;
  UpdateBillingAccountResponse?: (
    data: WithTypename<UpdateBillingAccountResponse>,
  ) => null | string;
  UpdateCustomerResponse?: (
    data: WithTypename<UpdateCustomerResponse>,
  ) => null | string;
  UpdateKioskCustomerResponse?: (
    data: WithTypename<UpdateKioskCustomerResponse>,
  ) => null | string;
  UpdateSubscriptionPaymentMethodSuccessResponse?: (
    data: WithTypename<UpdateSubscriptionPaymentMethodSuccessResponse>,
  ) => null | string;
  UpdateUseCreditResponse?: (
    data: WithTypename<UpdateUseCreditResponse>,
  ) => null | string;
  ValidationError?: (data: WithTypename<ValidationError>) => null | string;
  Vendor?: (data: WithTypename<Vendor>) => null | string;
  VerifyRegistrationSuccess?: (
    data: WithTypename<VerifyRegistrationSuccess>,
  ) => null | string;
};

export type GraphCacheResolvers = {
  Query?: {
    addons?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<Addons> | string
    >;
    address?: GraphCacheResolver<
      WithTypename<Query>,
      QueryAddressArgs,
      WithTypename<Address> | string
    >;
    allLocations?: GraphCacheResolver<
      WithTypename<Query>,
      QueryAllLocationsArgs,
      Array<WithTypename<LocationSearchResult> | string>
    >;
    baseProduct?: GraphCacheResolver<
      WithTypename<Query>,
      QueryBaseProductArgs,
      WithTypename<BaseProduct> | string
    >;
    cart?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<Order> | string
    >;
    challengeCelebration?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<ChallengeCelebration> | string
    >;
    challengeRewards?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      Array<WithTypename<ChallengeReward> | string>
    >;
    challenges?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      Array<WithTypename<Challenge> | string>
    >;
    currentCustomer?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<Customer> | string
    >;
    customerPass?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<CustomerPass> | string
    >;
    favoritedLineItems?: GraphCacheResolver<
      WithTypename<Query>,
      QueryFavoritedLineItemsArgs,
      Array<WithTypename<LineItem> | string>
    >;
    feedbackQuestions?: GraphCacheResolver<
      WithTypename<Query>,
      QueryFeedbackQuestionsArgs,
      Array<WithTypename<FeedbackQuestion> | string>
    >;
    fetchPlansByTierId?: GraphCacheResolver<
      WithTypename<Query>,
      QueryFetchPlansByTierIdArgs,
      Array<WithTypename<PaymentPlan> | string>
    >;
    getSubscriptions?: GraphCacheResolver<
      WithTypename<Query>,
      QueryGetSubscriptionsArgs,
      Array<WithTypename<PaymentSubscription> | string>
    >;
    hasUnseenChallenges?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<HasUnseenChallenges> | string
    >;
    inStoreFeedbackQuestions?: GraphCacheResolver<
      WithTypename<Query>,
      QueryInStoreFeedbackQuestionsArgs,
      Array<WithTypename<FeedbackQuestion> | string>
    >;
    inStoreOrderLastPendingFeedback?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<InStoreOrder> | string
    >;
    kustomerToken?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<Kustomer> | string
    >;
    lineItem?: GraphCacheResolver<
      WithTypename<Query>,
      QueryLineItemArgs,
      WithTypename<LineItemResponseUnion> | string
    >;
    lineItemBySlug?: GraphCacheResolver<
      WithTypename<Query>,
      QueryLineItemBySlugArgs,
      WithTypename<LineItemResponseUnion> | string
    >;
    locationByAddress?: GraphCacheResolver<
      WithTypename<Query>,
      QueryLocationByAddressArgs,
      WithTypename<LocationByAddressResponseUnion> | string
    >;
    loyaltyProfile?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<LoyaltyProfile> | string
    >;
    menuCollection?: GraphCacheResolver<
      WithTypename<Query>,
      QueryMenuCollectionArgs,
      WithTypename<MenuCollection> | string
    >;
    menuCollections?: GraphCacheResolver<
      WithTypename<Query>,
      QueryMenuCollectionsArgs,
      Array<WithTypename<MenuCollection> | string>
    >;
    order?: GraphCacheResolver<
      WithTypename<Query>,
      QueryOrderArgs,
      WithTypename<Order> | string
    >;
    orderLastPendingFeedback?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<Order> | string
    >;
    orderStatus?: GraphCacheResolver<
      WithTypename<Query>,
      QueryOrderStatusArgs,
      WithTypename<OrderStatusResponseUnion> | string
    >;
    orders?: GraphCacheResolver<
      WithTypename<Query>,
      QueryOrdersArgs,
      WithTypename<OrdersResponseUnion> | string
    >;
    paymentSubscriptionProfile?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<PaymentSubscriptionProfile> | string
    >;
    product?: GraphCacheResolver<
      WithTypename<Query>,
      QueryProductArgs,
      WithTypename<Product> | string
    >;
    productForRestaurant?: GraphCacheResolver<
      WithTypename<Query>,
      QueryProductForRestaurantArgs,
      WithTypename<Product> | string
    >;
    restaurant?: GraphCacheResolver<
      WithTypename<Query>,
      QueryRestaurantArgs,
      WithTypename<Restaurant> | string
    >;
    restaurantCapacity?: GraphCacheResolver<
      WithTypename<Query>,
      QueryRestaurantCapacityArgs,
      WithTypename<RestaurantCapacity> | string
    >;
    rewards?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      Array<WithTypename<Reward> | string>
    >;
    searchLocationsByBoundingBox?: GraphCacheResolver<
      WithTypename<Query>,
      QuerySearchLocationsByBoundingBoxArgs,
      Array<WithTypename<LocationSearchResult> | string>
    >;
    searchLocationsByEntityId?: GraphCacheResolver<
      WithTypename<Query>,
      QuerySearchLocationsByEntityIdArgs,
      Array<WithTypename<LocationSearchResult> | string>
    >;
    searchLocationsByString?: GraphCacheResolver<
      WithTypename<Query>,
      QuerySearchLocationsByStringArgs,
      Array<WithTypename<LocationSearchResult> | string>
    >;
    searchLocationsInKilometerRadius?: GraphCacheResolver<
      WithTypename<Query>,
      QuerySearchLocationsInKilometerRadiusArgs,
      Array<WithTypename<LocationSearchResult> | string>
    >;
    searchLocationsInMeterRadius?: GraphCacheResolver<
      WithTypename<Query>,
      QuerySearchLocationsInMeterRadiusArgs,
      Array<WithTypename<LocationSearchResult> | string>
    >;
    searchLocationsInMileRadius?: GraphCacheResolver<
      WithTypename<Query>,
      QuerySearchLocationsInMileRadiusArgs,
      Array<WithTypename<LocationSearchResult> | string>
    >;
    session?: GraphCacheResolver<
      WithTypename<Query>,
      Record<string, never>,
      WithTypename<Session> | string
    >;
    subscriptionPlanByBillingFrequency?: GraphCacheResolver<
      WithTypename<Query>,
      QuerySubscriptionPlanByBillingFrequencyArgs,
      WithTypename<SubscriptionPlan> | string
    >;
    subscriptionPlanById?: GraphCacheResolver<
      WithTypename<Query>,
      QuerySubscriptionPlanByIdArgs,
      WithTypename<SubscriptionPlan> | string
    >;
    subscriptionPlansByIds?: GraphCacheResolver<
      WithTypename<Query>,
      QuerySubscriptionPlansByIdsArgs,
      Array<WithTypename<SubscriptionPlan> | string>
    >;
  };
  AccountLocked?: {
    message?: GraphCacheResolver<
      WithTypename<AccountLocked>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<AccountLocked>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
  };
  ActivePaymentMethodError?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<ActivePaymentMethodError>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  AddAddressSuccess?: {
    address?: GraphCacheResolver<
      WithTypename<AddAddressSuccess>,
      Record<string, never>,
      WithTypename<Address> | string
    >;
  };
  AddLineItemToCartSuccess?: {
    cart?: GraphCacheResolver<
      WithTypename<AddLineItemToCartSuccess>,
      Record<string, never>,
      WithTypename<Order> | string
    >;
  };
  AddSubscriptionPaymentMethodSuccessResponse?: {
    creditCard?: GraphCacheResolver<
      WithTypename<AddSubscriptionPaymentMethodSuccessResponse>,
      Record<string, never>,
      WithTypename<SubscriptionCreditCard> | string
    >;
    paymentMethodToken?: GraphCacheResolver<
      WithTypename<AddSubscriptionPaymentMethodSuccessResponse>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  Addons?: {
    products?: GraphCacheResolver<
      WithTypename<Addons>,
      Record<string, never>,
      Array<WithTypename<Product> | string>
    >;
  };
  Address?: {
    city?: GraphCacheResolver<
      WithTypename<Address>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    country?: GraphCacheResolver<
      WithTypename<Address>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    deliveryPreference?: GraphCacheResolver<
      WithTypename<Address>,
      Record<string, never>,
      DeliveryPreferenceType | string
    >;
    googlePlaceId?: GraphCacheResolver<
      WithTypename<Address>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<Address>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    latitude?: GraphCacheResolver<
      WithTypename<Address>,
      Record<string, never>,
      Scalars['Float'] | string
    >;
    longitude?: GraphCacheResolver<
      WithTypename<Address>,
      Record<string, never>,
      Scalars['Float'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<Address>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    notes?: GraphCacheResolver<
      WithTypename<Address>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    secondaryStreet?: GraphCacheResolver<
      WithTypename<Address>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    state?: GraphCacheResolver<
      WithTypename<Address>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    street?: GraphCacheResolver<
      WithTypename<Address>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    zipCode?: GraphCacheResolver<
      WithTypename<Address>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  ApplyRewardSuccess?: {
    order?: GraphCacheResolver<
      WithTypename<ApplyRewardSuccess>,
      Record<string, never>,
      WithTypename<Order> | string
    >;
  };
  Asset?: {
    url?: GraphCacheResolver<
      WithTypename<Asset>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  AvailableWantedTime?: {
    time?: GraphCacheResolver<
      WithTypename<AvailableWantedTime>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  BaseProduct?: {
    asset?: GraphCacheResolver<
      WithTypename<BaseProduct>,
      Record<string, never>,
      WithTypename<Asset> | string
    >;
    description?: GraphCacheResolver<
      WithTypename<BaseProduct>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    heading?: GraphCacheResolver<
      WithTypename<BaseProduct>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<BaseProduct>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    isDeepLinkingEnabled?: GraphCacheResolver<
      WithTypename<BaseProduct>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
    isSeasonal?: GraphCacheResolver<
      WithTypename<BaseProduct>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<BaseProduct>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    slug?: GraphCacheResolver<
      WithTypename<BaseProduct>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    subheading?: GraphCacheResolver<
      WithTypename<BaseProduct>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  BillingAccount?: {
    cardType?: GraphCacheResolver<
      WithTypename<BillingAccount>,
      Record<string, never>,
      CardType | string
    >;
    description?: GraphCacheResolver<
      WithTypename<BillingAccount>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    expirationState?: GraphCacheResolver<
      WithTypename<BillingAccount>,
      Record<string, never>,
      ExpirationState | string
    >;
    id?: GraphCacheResolver<
      WithTypename<BillingAccount>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    isDefault?: GraphCacheResolver<
      WithTypename<BillingAccount>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
    nickname?: GraphCacheResolver<
      WithTypename<BillingAccount>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  CanNotReorder?: {
    conflicts?: GraphCacheResolver<
      WithTypename<CanNotReorder>,
      Record<string, never>,
      Array<WithTypename<OrderConflict> | string>
    >;
    message?: GraphCacheResolver<
      WithTypename<CanNotReorder>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<CanNotReorder>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
  };
  CancelSubscriptionAtCycleEndSuccessResponse?: {
    subscription?: GraphCacheResolver<
      WithTypename<CancelSubscriptionAtCycleEndSuccessResponse>,
      Record<string, never>,
      WithTypename<PaymentSubscription> | string
    >;
  };
  CancelSubscriptionForCustomerSuccessResponse?: {
    success?: GraphCacheResolver<
      WithTypename<CancelSubscriptionForCustomerSuccessResponse>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
  };
  CancelSubscriptionSuccessResponse?: {
    subscription?: GraphCacheResolver<
      WithTypename<CancelSubscriptionSuccessResponse>,
      Record<string, never>,
      WithTypename<PaymentSubscription> | string
    >;
  };
  Challenge?: {
    achieved?: GraphCacheResolver<
      WithTypename<Challenge>,
      Record<string, never>,
      Scalars['Float'] | string
    >;
    celebrationCopy?: GraphCacheResolver<
      WithTypename<Challenge>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    descriptiveTitle?: GraphCacheResolver<
      WithTypename<Challenge>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    expirationDate?: GraphCacheResolver<
      WithTypename<Challenge>,
      Record<string, never>,
      Scalars['DateTime'] | string
    >;
    goal?: GraphCacheResolver<
      WithTypename<Challenge>,
      Record<string, never>,
      Scalars['Float'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<Challenge>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    legalTerms?: GraphCacheResolver<
      WithTypename<Challenge>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    percentageCompleted?: GraphCacheResolver<
      WithTypename<Challenge>,
      Record<string, never>,
      Scalars['Float'] | string
    >;
    permalink?: GraphCacheResolver<
      WithTypename<Challenge>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    progress?: GraphCacheResolver<
      WithTypename<Challenge>,
      Record<string, never>,
      Scalars['Float'] | string
    >;
    progressCopy?: GraphCacheResolver<
      WithTypename<Challenge>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<Challenge>,
      Record<string, never>,
      ChallengeStatus | string
    >;
    title?: GraphCacheResolver<
      WithTypename<Challenge>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  ChallengeCelebration?: {
    celebrationCopy?: GraphCacheResolver<
      WithTypename<ChallengeCelebration>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    challengesIds?: GraphCacheResolver<
      WithTypename<ChallengeCelebration>,
      Record<string, never>,
      Array<Scalars['String'] | string>
    >;
    expirationDate?: GraphCacheResolver<
      WithTypename<ChallengeCelebration>,
      Record<string, never>,
      Scalars['DateTime'] | string
    >;
    rewardUsageDisclaimer?: GraphCacheResolver<
      WithTypename<ChallengeCelebration>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    title?: GraphCacheResolver<
      WithTypename<ChallengeCelebration>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  ChallengeReward?: {
    expiresAt?: GraphCacheResolver<
      WithTypename<ChallengeReward>,
      Record<string, never>,
      Scalars['DateTime'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<ChallengeReward>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<ChallengeReward>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    redeemable?: GraphCacheResolver<
      WithTypename<ChallengeReward>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
    redeemableAt?: GraphCacheResolver<
      WithTypename<ChallengeReward>,
      Record<string, never>,
      Scalars['DateTime'] | string
    >;
    rewardType?: GraphCacheResolver<
      WithTypename<ChallengeReward>,
      Record<string, never>,
      RewardType | string
    >;
    terms?: GraphCacheResolver<
      WithTypename<ChallengeReward>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  CourierDetails?: {
    latitude?: GraphCacheResolver<
      WithTypename<CourierDetails>,
      Record<string, never>,
      Scalars['Float'] | string
    >;
    longitude?: GraphCacheResolver<
      WithTypename<CourierDetails>,
      Record<string, never>,
      Scalars['Float'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<CourierDetails>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    phone?: GraphCacheResolver<
      WithTypename<CourierDetails>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  CreateLoyaltyProfileResult?: {
    id?: GraphCacheResolver<
      WithTypename<CreateLoyaltyProfileResult>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
  };
  CreateSubscriptionResult?: {
    firstBillingDate?: GraphCacheResolver<
      WithTypename<CreateSubscriptionResult>,
      Record<string, never>,
      Scalars['DateTime'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<CreateSubscriptionResult>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<CreateSubscriptionResult>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    subscriptionAmount?: GraphCacheResolver<
      WithTypename<CreateSubscriptionResult>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    trialDuration?: GraphCacheResolver<
      WithTypename<CreateSubscriptionResult>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
  };
  Credit?: {
    amount?: GraphCacheResolver<
      WithTypename<Credit>,
      Record<string, never>,
      Scalars['Float'] | string
    >;
    createdAt?: GraphCacheResolver<
      WithTypename<Credit>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    description?: GraphCacheResolver<
      WithTypename<Credit>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    expiresAt?: GraphCacheResolver<
      WithTypename<Credit>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<Credit>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    remainingAmount?: GraphCacheResolver<
      WithTypename<Credit>,
      Record<string, never>,
      Scalars['Float'] | string
    >;
    title?: GraphCacheResolver<
      WithTypename<Credit>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  Customer?: {
    addresses?: GraphCacheResolver<
      WithTypename<Customer>,
      Record<string, never>,
      Array<WithTypename<Address> | string>
    >;
    availableCredit?: GraphCacheResolver<
      WithTypename<Customer>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
    billingAccounts?: GraphCacheResolver<
      WithTypename<Customer>,
      Record<string, never>,
      Array<WithTypename<BillingAccount> | string>
    >;
    birthday?: GraphCacheResolver<
      WithTypename<Customer>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    credits?: GraphCacheResolver<
      WithTypename<Customer>,
      Record<string, never>,
      Array<WithTypename<Credit> | string>
    >;
    email?: GraphCacheResolver<
      WithTypename<Customer>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    firstName?: GraphCacheResolver<
      WithTypename<Customer>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<Customer>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    lastName?: GraphCacheResolver<
      WithTypename<Customer>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    phoneNumber?: GraphCacheResolver<
      WithTypename<Customer>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    qrCode?: GraphCacheResolver<
      WithTypename<Customer>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    referralShareUrlEmail?: GraphCacheResolver<
      WithTypename<Customer>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    trackingUuid?: GraphCacheResolver<
      WithTypename<Customer>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    useCredit?: GraphCacheResolver<
      WithTypename<Customer>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
  };
  CustomerPass?: {
    authenticationToken?: GraphCacheResolver<
      WithTypename<CustomerPass>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    url?: GraphCacheResolver<
      WithTypename<CustomerPass>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  DeleteAddressSuccess?: {
    success?: GraphCacheResolver<
      WithTypename<DeleteAddressSuccess>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
  };
  DeleteBillingAccountResponse?: {
    success?: GraphCacheResolver<
      WithTypename<DeleteBillingAccountResponse>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
  };
  DeleteSubscriptionPaymentMethodSuccess?: {
    creditCards?: GraphCacheResolver<
      WithTypename<DeleteSubscriptionPaymentMethodSuccess>,
      Record<string, never>,
      Array<WithTypename<SubscriptionCreditCard> | string>
    >;
  };
  DeliveryAlreadyInFlight?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<DeliveryAlreadyInFlight>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  DeliveryOrderDetail?: {
    address?: GraphCacheResolver<
      WithTypename<DeliveryOrderDetail>,
      Record<string, never>,
      WithTypename<Address> | string
    >;
    deliveryFee?: GraphCacheResolver<
      WithTypename<DeliveryOrderDetail>,
      Record<string, never>,
      Scalars['Float'] | string
    >;
    estimatedDeliveryTime?: GraphCacheResolver<
      WithTypename<DeliveryOrderDetail>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<DeliveryOrderDetail>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    orderId?: GraphCacheResolver<
      WithTypename<DeliveryOrderDetail>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    tip?: GraphCacheResolver<
      WithTypename<DeliveryOrderDetail>,
      Record<string, never>,
      Scalars['Float'] | string
    >;
    vendor?: GraphCacheResolver<
      WithTypename<DeliveryOrderDetail>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    vendorRestaurantId?: GraphCacheResolver<
      WithTypename<DeliveryOrderDetail>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  DeliverySpecifyAddress?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<DeliverySpecifyAddress>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  DietaryProperty?: {
    id?: GraphCacheResolver<
      WithTypename<DietaryProperty>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<DietaryProperty>,
      Record<string, never>,
      DietaryPropertyKind | string
    >;
  };
  Discount?: {
    amount?: GraphCacheResolver<
      WithTypename<Discount>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    description?: GraphCacheResolver<
      WithTypename<Discount>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<Discount>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<Discount>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
  };
  DropOffLocation?: {
    id?: GraphCacheResolver<
      WithTypename<DropOffLocation>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<DropOffLocation>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  EditLineItemInCartSuccess?: {
    cart?: GraphCacheResolver<
      WithTypename<EditLineItemInCartSuccess>,
      Record<string, never>,
      WithTypename<Order> | string
    >;
  };
  EstimateRange?: {
    end?: GraphCacheResolver<
      WithTypename<EstimateRange>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
    start?: GraphCacheResolver<
      WithTypename<EstimateRange>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
  };
  FeedbackQuestion?: {
    id?: GraphCacheResolver<
      WithTypename<FeedbackQuestion>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    responses?: GraphCacheResolver<
      WithTypename<FeedbackQuestion>,
      Record<string, never>,
      Array<WithTypename<FeedbackResponse> | string>
    >;
    slug?: GraphCacheResolver<
      WithTypename<FeedbackQuestion>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    text?: GraphCacheResolver<
      WithTypename<FeedbackQuestion>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  FeedbackResponse?: {
    id?: GraphCacheResolver<
      WithTypename<FeedbackResponse>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    text?: GraphCacheResolver<
      WithTypename<FeedbackResponse>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  FeedbackSuccess?: {
    success?: GraphCacheResolver<
      WithTypename<FeedbackSuccess>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
  };
  FieldValidationError?: {
    field?: GraphCacheResolver<
      WithTypename<FieldValidationError>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<FieldValidationError>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  ForgotPasswordSuccess?: {
    success?: GraphCacheResolver<
      WithTypename<ForgotPasswordSuccess>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
  };
  Guest?: {
    email?: GraphCacheResolver<
      WithTypename<Guest>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    firstName?: GraphCacheResolver<
      WithTypename<Guest>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<Guest>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    lastName?: GraphCacheResolver<
      WithTypename<Guest>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  HasUnseenChallenges?: {
    hasUnseenChallenges?: GraphCacheResolver<
      WithTypename<HasUnseenChallenges>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
  };
  InStoreOrder?: {
    id?: GraphCacheResolver<
      WithTypename<InStoreOrder>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    wantedTime?: GraphCacheResolver<
      WithTypename<InStoreOrder>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  Ingredient?: {
    asset?: GraphCacheResolver<
      WithTypename<Ingredient>,
      Record<string, never>,
      WithTypename<Asset> | string
    >;
    dietaryProperties?: GraphCacheResolver<
      WithTypename<Ingredient>,
      Record<string, never>,
      Array<WithTypename<DietaryProperty> | string>
    >;
    id?: GraphCacheResolver<
      WithTypename<Ingredient>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    kind?: GraphCacheResolver<
      WithTypename<Ingredient>,
      Record<string, never>,
      IngredientKind | string
    >;
    name?: GraphCacheResolver<
      WithTypename<Ingredient>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  IngredientModification?: {
    additionCost?: GraphCacheResolver<
      WithTypename<IngredientModification>,
      Record<string, never>,
      Scalars['Float'] | string
    >;
    calories?: GraphCacheResolver<
      WithTypename<IngredientModification>,
      Record<string, never>,
      Scalars['Float'] | string
    >;
    ingredient?: GraphCacheResolver<
      WithTypename<IngredientModification>,
      Record<string, never>,
      WithTypename<Ingredient> | string
    >;
    isGrain?: GraphCacheResolver<
      WithTypename<IngredientModification>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
    kind?: GraphCacheResolver<
      WithTypename<IngredientModification>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    mixable?: GraphCacheResolver<
      WithTypename<IngredientModification>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
    outOfStock?: GraphCacheResolver<
      WithTypename<IngredientModification>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
    removalCost?: GraphCacheResolver<
      WithTypename<IngredientModification>,
      Record<string, never>,
      Scalars['Float'] | string
    >;
    subKind?: GraphCacheResolver<
      WithTypename<IngredientModification>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    substitutionCost?: GraphCacheResolver<
      WithTypename<IngredientModification>,
      Record<string, never>,
      Scalars['Float'] | string
    >;
  };
  IngredientModificationKind?: {
    allowMultipleQuantity?: GraphCacheResolver<
      WithTypename<IngredientModificationKind>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
    freeAggregateQuantity?: GraphCacheResolver<
      WithTypename<IngredientModificationKind>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
    maxAggregateQuantity?: GraphCacheResolver<
      WithTypename<IngredientModificationKind>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
    minAggregateQuantity?: GraphCacheResolver<
      WithTypename<IngredientModificationKind>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
    modifications?: GraphCacheResolver<
      WithTypename<IngredientModificationKind>,
      Record<string, never>,
      Array<WithTypename<IngredientModification> | string>
    >;
  };
  IngredientModifications?: {
    bases?: GraphCacheResolver<
      WithTypename<IngredientModifications>,
      Record<string, never>,
      WithTypename<IngredientModificationKind> | string
    >;
    bread?: GraphCacheResolver<
      WithTypename<IngredientModifications>,
      Record<string, never>,
      WithTypename<IngredientModificationKind> | string
    >;
    dressings?: GraphCacheResolver<
      WithTypename<IngredientModifications>,
      Record<string, never>,
      WithTypename<IngredientModificationKind> | string
    >;
    premiums?: GraphCacheResolver<
      WithTypename<IngredientModifications>,
      Record<string, never>,
      WithTypename<IngredientModificationKind> | string
    >;
    toppings?: GraphCacheResolver<
      WithTypename<IngredientModifications>,
      Record<string, never>,
      WithTypename<IngredientModificationKind> | string
    >;
  };
  InvalidAddress?: {
    message?: GraphCacheResolver<
      WithTypename<InvalidAddress>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<InvalidAddress>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
  };
  InvalidBillingAccount?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<InvalidBillingAccount>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<InvalidBillingAccount>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<InvalidBillingAccount>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
  };
  InvalidCredentials?: {
    message?: GraphCacheResolver<
      WithTypename<InvalidCredentials>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<InvalidCredentials>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
  };
  InvalidCustomerPhone?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<InvalidCustomerPhone>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  InvalidInput?: {
    message?: GraphCacheResolver<
      WithTypename<InvalidInput>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<InvalidInput>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
  };
  InvalidOrder?: {
    message?: GraphCacheResolver<
      WithTypename<InvalidOrder>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<InvalidOrder>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
  };
  InvalidPostalCode?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<InvalidPostalCode>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  InvalidPromoCode?: {
    message?: GraphCacheResolver<
      WithTypename<InvalidPromoCode>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<InvalidPromoCode>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
  };
  InvalidRegistrationCode?: {
    message?: GraphCacheResolver<
      WithTypename<InvalidRegistrationCode>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<InvalidRegistrationCode>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
  };
  InvalidSubmittedBillingAccount?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<InvalidSubmittedBillingAccount>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  Kustomer?: {
    token?: GraphCacheResolver<
      WithTypename<Kustomer>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  Ledger?: {
    credits?: GraphCacheResolver<
      WithTypename<Ledger>,
      Record<string, never>,
      Array<WithTypename<LedgerItem> | string>
    >;
    creditsTotal?: GraphCacheResolver<
      WithTypename<Ledger>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
    discounts?: GraphCacheResolver<
      WithTypename<Ledger>,
      Record<string, never>,
      Array<WithTypename<LedgerItem> | string>
    >;
    discountsTotal?: GraphCacheResolver<
      WithTypename<Ledger>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
    fees?: GraphCacheResolver<
      WithTypename<Ledger>,
      Record<string, never>,
      Array<WithTypename<LedgerItem> | string>
    >;
    feesTotal?: GraphCacheResolver<
      WithTypename<Ledger>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
    subtotal?: GraphCacheResolver<
      WithTypename<Ledger>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
    tax?: GraphCacheResolver<
      WithTypename<Ledger>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
    tip?: GraphCacheResolver<
      WithTypename<Ledger>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
  };
  LedgerItem?: {
    amount?: GraphCacheResolver<
      WithTypename<LedgerItem>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
    description?: GraphCacheResolver<
      WithTypename<LedgerItem>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<LedgerItem>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  LineItem?: {
    addedIngredients?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      Array<WithTypename<Ingredient> | string>
    >;
    calories?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
    cost?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
    customName?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    customerName?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    dressingMode?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      DressingMode | string
    >;
    favorited?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    ingredients?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      Array<WithTypename<Ingredient> | string>
    >;
    isCustom?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
    mixedDressingDetails?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      Array<WithTypename<MixedDressingDetails> | string>
    >;
    perItemCost?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
    product?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      WithTypename<Product> | string
    >;
    quantity?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
    removedIngredients?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      Array<WithTypename<Ingredient> | string>
    >;
    slug?: GraphCacheResolver<
      WithTypename<LineItem>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
  };
  LineItemNotFound?: {
    message?: GraphCacheResolver<
      WithTypename<LineItemNotFound>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<LineItemNotFound>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
  };
  LineItemSuccess?: {
    lineItem?: GraphCacheResolver<
      WithTypename<LineItemSuccess>,
      Record<string, never>,
      WithTypename<LineItem> | string
    >;
  };
  Location?: {
    estimateRange?: GraphCacheResolver<
      WithTypename<Location>,
      Record<string, never>,
      WithTypename<EstimateRange> | string
    >;
    restaurant?: GraphCacheResolver<
      WithTypename<Location>,
      Record<string, never>,
      WithTypename<Restaurant> | string
    >;
    status?: GraphCacheResolver<
      WithTypename<Location>,
      Record<string, never>,
      LocationStatus | string
    >;
    vendor?: GraphCacheResolver<
      WithTypename<Location>,
      Record<string, never>,
      WithTypename<Vendor> | string
    >;
  };
  LocationSearchResult?: {
    location?: GraphCacheResolver<
      WithTypename<LocationSearchResult>,
      Record<string, never>,
      WithTypename<StoreLocation> | string
    >;
    score?: GraphCacheResolver<
      WithTypename<LocationSearchResult>,
      Record<string, never>,
      Scalars['Float'] | string
    >;
  };
  LoginSuccess?: {
    csrf?: GraphCacheResolver<
      WithTypename<LoginSuccess>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  LogoutSuccess?: {
    csrf?: GraphCacheResolver<
      WithTypename<LogoutSuccess>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  LoyaltyProfile?: {
    customerId?: GraphCacheResolver<
      WithTypename<LoyaltyProfile>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    hasPaidTierHistory?: GraphCacheResolver<
      WithTypename<LoyaltyProfile>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
    joinDate?: GraphCacheResolver<
      WithTypename<LoyaltyProfile>,
      Record<string, never>,
      Scalars['DateTime'] | string
    >;
    tier?: GraphCacheResolver<
      WithTypename<LoyaltyProfile>,
      Record<string, never>,
      WithTypename<Tier> | string
    >;
    tierStatus?: GraphCacheResolver<
      WithTypename<LoyaltyProfile>,
      Record<string, never>,
      WithTypename<TierStatus> | string
    >;
  };
  MaxModificationsExceeded?: {
    message?: GraphCacheResolver<
      WithTypename<MaxModificationsExceeded>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<MaxModificationsExceeded>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
  };
  Menu?: {
    categories?: GraphCacheResolver<
      WithTypename<Menu>,
      Record<string, never>,
      Array<WithTypename<MenuCategory> | string>
    >;
    id?: GraphCacheResolver<
      WithTypename<Menu>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  MenuCategory?: {
    id?: GraphCacheResolver<
      WithTypename<MenuCategory>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    isCustom?: GraphCacheResolver<
      WithTypename<MenuCategory>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<MenuCategory>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    products?: GraphCacheResolver<
      WithTypename<MenuCategory>,
      Record<string, never>,
      Array<WithTypename<Product> | string>
    >;
  };
  MenuCollection?: {
    color?: GraphCacheResolver<
      WithTypename<MenuCollection>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<MenuCollection>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    primaryDescription?: GraphCacheResolver<
      WithTypename<MenuCollection>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    primaryImageUrl?: GraphCacheResolver<
      WithTypename<MenuCollection>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    primaryTitle?: GraphCacheResolver<
      WithTypename<MenuCollection>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    products?: GraphCacheResolver<
      WithTypename<MenuCollection>,
      Record<string, never>,
      Array<WithTypename<Product> | string>
    >;
    secondaryDescription?: GraphCacheResolver<
      WithTypename<MenuCollection>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    secondaryTitle?: GraphCacheResolver<
      WithTypename<MenuCollection>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  MinimumDeliverySubtotalNotMet?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<MinimumDeliverySubtotalNotMet>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<MinimumDeliverySubtotalNotMet>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<MinimumDeliverySubtotalNotMet>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
  };
  MixedDressingDetails?: {
    ingredientId?: GraphCacheResolver<
      WithTypename<MixedDressingDetails>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    weight?: GraphCacheResolver<
      WithTypename<MixedDressingDetails>,
      Record<string, never>,
      DressingWeight | string
    >;
  };
  NoValidRestaurants?: {
    message?: GraphCacheResolver<
      WithTypename<NoValidRestaurants>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<NoValidRestaurants>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
  };
  Order?: {
    asset?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      WithTypename<Asset> | string
    >;
    availableWantedTimes?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      Array<WithTypename<AvailableWantedTime> | string>
    >;
    canTrackOrderStatus?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
    deliveryOrderDetail?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      WithTypename<DeliveryOrderDetail> | string
    >;
    description?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    dropoffLocation?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    includeUtensils?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
    isInFlight?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
    isInFlightDelivery?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
    isPendingFeedback?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
    ledger?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      WithTypename<Ledger> | string
    >;
    lineItems?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      Array<WithTypename<LineItem> | string>
    >;
    orderType?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      OrderType | string
    >;
    restaurant?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      WithTypename<Restaurant> | string
    >;
    total?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
    vendorId?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    wantedTime?: GraphCacheResolver<
      WithTypename<Order>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  OrderConflict?: {
    product?: GraphCacheResolver<
      WithTypename<OrderConflict>,
      Record<string, never>,
      WithTypename<Product> | string
    >;
    type?: GraphCacheResolver<
      WithTypename<OrderConflict>,
      Record<string, never>,
      ConflictType | string
    >;
    unavailableIngredients?: GraphCacheResolver<
      WithTypename<OrderConflict>,
      Record<string, never>,
      Array<WithTypename<Ingredient> | string>
    >;
  };
  OrderStatus?: {
    courierDetails?: GraphCacheResolver<
      WithTypename<OrderStatus>,
      Record<string, never>,
      WithTypename<CourierDetails> | string
    >;
    customerId?: GraphCacheResolver<
      WithTypename<OrderStatus>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    flattenedOrderStatus?: GraphCacheResolver<
      WithTypename<OrderStatus>,
      Record<string, never>,
      FlattenedOrderStatuses | string
    >;
    gravyStatus?: GraphCacheResolver<
      WithTypename<OrderStatus>,
      Record<string, never>,
      GravyStatusType | string
    >;
    gravyUpdatedAt?: GraphCacheResolver<
      WithTypename<OrderStatus>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    order?: GraphCacheResolver<
      WithTypename<OrderStatus>,
      Record<string, never>,
      WithTypename<Order> | string
    >;
    orderOccasion?: GraphCacheResolver<
      WithTypename<OrderStatus>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    orderStatus?: GraphCacheResolver<
      WithTypename<OrderStatus>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  OrdersResponseSuccess?: {
    orders?: GraphCacheResolver<
      WithTypename<OrdersResponseSuccess>,
      Record<string, never>,
      Array<WithTypename<Order> | string>
    >;
    pagination?: GraphCacheResolver<
      WithTypename<OrdersResponseSuccess>,
      Record<string, never>,
      WithTypename<Pagination> | string
    >;
  };
  Pagination?: {
    last?: GraphCacheResolver<
      WithTypename<Pagination>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
    page?: GraphCacheResolver<
      WithTypename<Pagination>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
    take?: GraphCacheResolver<
      WithTypename<Pagination>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
    total?: GraphCacheResolver<
      WithTypename<Pagination>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
  };
  PaymentMethodAlreadyExistsError?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<PaymentMethodAlreadyExistsError>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  PaymentPlan?: {
    braintreePlanId?: GraphCacheResolver<
      WithTypename<PaymentPlan>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    tier?: GraphCacheResolver<
      WithTypename<PaymentPlan>,
      Record<string, never>,
      WithTypename<Tier> | string
    >;
  };
  PaymentSubscription?: {
    balance?: GraphCacheResolver<
      WithTypename<PaymentSubscription>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    billingHistory?: GraphCacheResolver<
      WithTypename<PaymentSubscription>,
      Record<string, never>,
      Array<WithTypename<SubscriptionTransactions> | string>
    >;
    billingPeriodEndDate?: GraphCacheResolver<
      WithTypename<PaymentSubscription>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    billingPeriodStartDate?: GraphCacheResolver<
      WithTypename<PaymentSubscription>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    createdAt?: GraphCacheResolver<
      WithTypename<PaymentSubscription>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<PaymentSubscription>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    nextBillingDate?: GraphCacheResolver<
      WithTypename<PaymentSubscription>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    nextBillingPeriodAmount?: GraphCacheResolver<
      WithTypename<PaymentSubscription>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    paidThroughDate?: GraphCacheResolver<
      WithTypename<PaymentSubscription>,
      Record<string, never>,
      Scalars['DateTime'] | string
    >;
    planId?: GraphCacheResolver<
      WithTypename<PaymentSubscription>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    price?: GraphCacheResolver<
      WithTypename<PaymentSubscription>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<PaymentSubscription>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  PaymentSubscriptionProfile?: {
    creditCards?: GraphCacheResolver<
      WithTypename<PaymentSubscriptionProfile>,
      Record<string, never>,
      Array<WithTypename<SubscriptionCreditCard> | string>
    >;
    id?: GraphCacheResolver<
      WithTypename<PaymentSubscriptionProfile>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
  };
  Product?: {
    asset?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      WithTypename<Asset> | string
    >;
    calories?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
    categoryId?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    categoryName?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    cost?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
    customType?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      CustomProductType | string
    >;
    description?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    dietaryProperties?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Array<WithTypename<DietaryProperty> | string>
    >;
    id?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    ingredientModifications?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      WithTypename<IngredientModifications> | string
    >;
    ingredients?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Array<WithTypename<Ingredient> | string>
    >;
    isCustom?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
    isModifiable?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
    isSalad?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
    label?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      WithTypename<ProductLabel> | string
    >;
    maxModifications?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    outOfStock?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
    restaurant?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      WithTypename<Restaurant> | string
    >;
    restaurantId?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    slug?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    throttleItem?: GraphCacheResolver<
      WithTypename<Product>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
  };
  ProductLabel?: {
    id?: GraphCacheResolver<
      WithTypename<ProductLabel>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<ProductLabel>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  ProductUnavailable?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<ProductUnavailable>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<ProductUnavailable>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<ProductUnavailable>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
  };
  RegisterGuestFailed?: {
    message?: GraphCacheResolver<
      WithTypename<RegisterGuestFailed>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<RegisterGuestFailed>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
  };
  RegisterGuestSuccess?: {
    csrf?: GraphCacheResolver<
      WithTypename<RegisterGuestSuccess>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    guest?: GraphCacheResolver<
      WithTypename<RegisterGuestSuccess>,
      Record<string, never>,
      WithTypename<Guest> | string
    >;
  };
  RegisterSuccess?: {
    success?: GraphCacheResolver<
      WithTypename<RegisterSuccess>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
  };
  RejoinSubscriptionSuccessResponse?: {
    subscription?: GraphCacheResolver<
      WithTypename<RejoinSubscriptionSuccessResponse>,
      Record<string, never>,
      WithTypename<PaymentSubscription> | string
    >;
  };
  RemoveFromCartSuccess?: {
    cart?: GraphCacheResolver<
      WithTypename<RemoveFromCartSuccess>,
      Record<string, never>,
      WithTypename<Order> | string
    >;
    success?: GraphCacheResolver<
      WithTypename<RemoveFromCartSuccess>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
  };
  RemoveRewardSuccess?: {
    order?: GraphCacheResolver<
      WithTypename<RemoveRewardSuccess>,
      Record<string, never>,
      WithTypename<Order> | string
    >;
  };
  ReorderConflict?: {
    conflicts?: GraphCacheResolver<
      WithTypename<ReorderConflict>,
      Record<string, never>,
      Array<WithTypename<OrderConflict> | string>
    >;
    isNothingAvailable?: GraphCacheResolver<
      WithTypename<ReorderConflict>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
  };
  ReorderSuccess?: {
    cart?: GraphCacheResolver<
      WithTypename<ReorderSuccess>,
      Record<string, never>,
      WithTypename<Order> | string
    >;
    isMixingSupported?: GraphCacheResolver<
      WithTypename<ReorderSuccess>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
  };
  RequestAccountDeletionFailed?: {
    message?: GraphCacheResolver<
      WithTypename<RequestAccountDeletionFailed>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<RequestAccountDeletionFailed>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
  };
  RequestAccountDeletionSuccess?: {
    success?: GraphCacheResolver<
      WithTypename<RequestAccountDeletionSuccess>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
  };
  ResendVerificationCodeSuccess?: {
    success?: GraphCacheResolver<
      WithTypename<ResendVerificationCodeSuccess>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
  };
  Restaurant?: {
    address?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    asset?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      WithTypename<Asset> | string
    >;
    availableDropOffLocations?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Array<WithTypename<DropOffLocation> | string>
    >;
    city?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    deliveryFee?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
    deliveryMinSubtotal?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['Float'] | string
    >;
    flexMessage?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    hours?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      WithTypename<RestaurantHours> | string
    >;
    id?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    isAcceptingOrders?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
    isOutpost?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
    latitude?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['Float'] | string
    >;
    longitude?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['Float'] | string
    >;
    menu?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      WithTypename<Menu> | string
    >;
    name?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    notAcceptingOrdersReason?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    phone?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    slug?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    state?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    zipCode?: GraphCacheResolver<
      WithTypename<Restaurant>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  RestaurantCapacity?: {
    availableWantedTimes?: GraphCacheResolver<
      WithTypename<RestaurantCapacity>,
      Record<string, never>,
      Array<WithTypename<RestaurantCapacitySlot> | string>
    >;
    restaurantAddress?: GraphCacheResolver<
      WithTypename<RestaurantCapacity>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    restaurantHours?: GraphCacheResolver<
      WithTypename<RestaurantCapacity>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    restaurantId?: GraphCacheResolver<
      WithTypename<RestaurantCapacity>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
  };
  RestaurantCapacitySlot?: {
    availableLineItems?: GraphCacheResolver<
      WithTypename<RestaurantCapacitySlot>,
      Record<string, never>,
      Scalars['Float'] | string
    >;
    formatted?: GraphCacheResolver<
      WithTypename<RestaurantCapacitySlot>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    maxLineItems?: GraphCacheResolver<
      WithTypename<RestaurantCapacitySlot>,
      Record<string, never>,
      Scalars['Float'] | string
    >;
    original?: GraphCacheResolver<
      WithTypename<RestaurantCapacitySlot>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  RestaurantHours?: {
    formatted?: GraphCacheResolver<
      WithTypename<RestaurantHours>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  RestaurantIsNotAcceptingOrders?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<RestaurantIsNotAcceptingOrders>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<RestaurantIsNotAcceptingOrders>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<RestaurantIsNotAcceptingOrders>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
  };
  RestaurantMaxDeliveryQuantityExceeded?: {
    conflicts?: GraphCacheResolver<
      WithTypename<RestaurantMaxDeliveryQuantityExceeded>,
      Record<string, never>,
      Array<WithTypename<OrderConflict> | string>
    >;
    message?: GraphCacheResolver<
      WithTypename<RestaurantMaxDeliveryQuantityExceeded>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<RestaurantMaxDeliveryQuantityExceeded>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
  };
  RestaurantMaxQuantityExceeded?: {
    conflicts?: GraphCacheResolver<
      WithTypename<RestaurantMaxQuantityExceeded>,
      Record<string, never>,
      Array<WithTypename<OrderConflict> | string>
    >;
    message?: GraphCacheResolver<
      WithTypename<RestaurantMaxQuantityExceeded>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<RestaurantMaxQuantityExceeded>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
  };
  Reward?: {
    expirationDate?: GraphCacheResolver<
      WithTypename<Reward>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<Reward>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<Reward>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    redeemable?: GraphCacheResolver<
      WithTypename<Reward>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
    redeemableAt?: GraphCacheResolver<
      WithTypename<Reward>,
      Record<string, never>,
      Scalars['DateTime'] | string
    >;
    rewardType?: GraphCacheResolver<
      WithTypename<Reward>,
      Record<string, never>,
      RewardType | string
    >;
  };
  RewardNotApplied?: {
    failureCode?: GraphCacheResolver<
      WithTypename<RewardNotApplied>,
      Record<string, never>,
      ApplyRewardFailureCode | string
    >;
    message?: GraphCacheResolver<
      WithTypename<RewardNotApplied>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<RewardNotApplied>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
  };
  RewardNotRemoved?: {
    failureCode?: GraphCacheResolver<
      WithTypename<RewardNotRemoved>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<RewardNotRemoved>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<RewardNotRemoved>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
  };
  RewardNotValidated?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<RewardNotValidated>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    failureCode?: GraphCacheResolver<
      WithTypename<RewardNotValidated>,
      Record<string, never>,
      ValidateRewardFailureCode | string
    >;
    message?: GraphCacheResolver<
      WithTypename<RewardNotValidated>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<RewardNotValidated>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
  };
  Session?: {
    cart?: GraphCacheResolver<
      WithTypename<Session>,
      Record<string, never>,
      WithTypename<Order> | string
    >;
    csrf?: GraphCacheResolver<
      WithTypename<Session>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    inFlightDeliveryOrderId?: GraphCacheResolver<
      WithTypename<Session>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    inFlightOrderId?: GraphCacheResolver<
      WithTypename<Session>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    isLoggedIn?: GraphCacheResolver<
      WithTypename<Session>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
  };
  StoreLocation?: {
    acceptingOrders?: GraphCacheResolver<
      WithTypename<StoreLocation>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
    address?: GraphCacheResolver<
      WithTypename<StoreLocation>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    city?: GraphCacheResolver<
      WithTypename<StoreLocation>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    comingSoon?: GraphCacheResolver<
      WithTypename<StoreLocation>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
    crossStreet?: GraphCacheResolver<
      WithTypename<StoreLocation>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    enabled?: GraphCacheResolver<
      WithTypename<StoreLocation>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
    entityId?: GraphCacheResolver<
      WithTypename<StoreLocation>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    flexMessage?: GraphCacheResolver<
      WithTypename<StoreLocation>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    hidden?: GraphCacheResolver<
      WithTypename<StoreLocation>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<StoreLocation>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    imageUrl?: GraphCacheResolver<
      WithTypename<StoreLocation>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    isOutpost?: GraphCacheResolver<
      WithTypename<StoreLocation>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
    latitude?: GraphCacheResolver<
      WithTypename<StoreLocation>,
      Record<string, never>,
      Scalars['Float'] | string
    >;
    longitude?: GraphCacheResolver<
      WithTypename<StoreLocation>,
      Record<string, never>,
      Scalars['Float'] | string
    >;
    menuId?: GraphCacheResolver<
      WithTypename<StoreLocation>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<StoreLocation>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    notAcceptingOrdersReason?: GraphCacheResolver<
      WithTypename<StoreLocation>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    oloId?: GraphCacheResolver<
      WithTypename<StoreLocation>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    phone?: GraphCacheResolver<
      WithTypename<StoreLocation>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    pickupInstructions?: GraphCacheResolver<
      WithTypename<StoreLocation>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    regionId?: GraphCacheResolver<
      WithTypename<StoreLocation>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    showWarningDialog?: GraphCacheResolver<
      WithTypename<StoreLocation>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
    slug?: GraphCacheResolver<
      WithTypename<StoreLocation>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    state?: GraphCacheResolver<
      WithTypename<StoreLocation>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    storeHours?: GraphCacheResolver<
      WithTypename<StoreLocation>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    warningDialogDescription?: GraphCacheResolver<
      WithTypename<StoreLocation>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    warningDialogTimeout?: GraphCacheResolver<
      WithTypename<StoreLocation>,
      Record<string, never>,
      Scalars['Float'] | string
    >;
    warningDialogTitle?: GraphCacheResolver<
      WithTypename<StoreLocation>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    zipCode?: GraphCacheResolver<
      WithTypename<StoreLocation>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  SubmitBraintreeBillingAccountSuccessResponse?: {
    billingAccount?: GraphCacheResolver<
      WithTypename<SubmitBraintreeBillingAccountSuccessResponse>,
      Record<string, never>,
      WithTypename<BillingAccount> | string
    >;
  };
  SubmitGiftCardCodeSuccess?: {
    totalCredit?: GraphCacheResolver<
      WithTypename<SubmitGiftCardCodeSuccess>,
      Record<string, never>,
      Scalars['Float'] | string
    >;
  };
  SubmitOrderUsingBillingAccountSuccess?: {
    customer?: GraphCacheResolver<
      WithTypename<SubmitOrderUsingBillingAccountSuccess>,
      Record<string, never>,
      WithTypename<Customer> | string
    >;
    order?: GraphCacheResolver<
      WithTypename<SubmitOrderUsingBillingAccountSuccess>,
      Record<string, never>,
      WithTypename<Order> | string
    >;
  };
  SubmitOrderWithPaymentMethodSuccess?: {
    order?: GraphCacheResolver<
      WithTypename<SubmitOrderWithPaymentMethodSuccess>,
      Record<string, never>,
      WithTypename<Order> | string
    >;
  };
  SubmitPromoCodeSuccess?: {
    loyaltyId?: GraphCacheResolver<
      WithTypename<SubmitPromoCodeSuccess>,
      Record<string, never>,
      Scalars['Float'] | string
    >;
  };
  SubmitPromoCodeSuccessV2?: {
    placeholder?: GraphCacheResolver<
      WithTypename<SubmitPromoCodeSuccessV2>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
  };
  SubscriptionCannotBeReactivatedError?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<SubscriptionCannotBeReactivatedError>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  SubscriptionCreditCard?: {
    cardType?: GraphCacheResolver<
      WithTypename<SubscriptionCreditCard>,
      Record<string, never>,
      BraintreeCardType | string
    >;
    expirationMonth?: GraphCacheResolver<
      WithTypename<SubscriptionCreditCard>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    expirationYear?: GraphCacheResolver<
      WithTypename<SubscriptionCreditCard>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<SubscriptionCreditCard>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    isActive?: GraphCacheResolver<
      WithTypename<SubscriptionCreditCard>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
    lastFour?: GraphCacheResolver<
      WithTypename<SubscriptionCreditCard>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  SubscriptionPlan?: {
    billingDayOfMonth?: GraphCacheResolver<
      WithTypename<SubscriptionPlan>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    billingFrequency?: GraphCacheResolver<
      WithTypename<SubscriptionPlan>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    createdAt?: GraphCacheResolver<
      WithTypename<SubscriptionPlan>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    currencyIsoCode?: GraphCacheResolver<
      WithTypename<SubscriptionPlan>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    description?: GraphCacheResolver<
      WithTypename<SubscriptionPlan>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    discounts?: GraphCacheResolver<
      WithTypename<SubscriptionPlan>,
      Record<string, never>,
      Array<WithTypename<Discount> | string>
    >;
    id?: GraphCacheResolver<
      WithTypename<SubscriptionPlan>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<SubscriptionPlan>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    price?: GraphCacheResolver<
      WithTypename<SubscriptionPlan>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  SubscriptionTransactions?: {
    amount?: GraphCacheResolver<
      WithTypename<SubscriptionTransactions>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    creditCard?: GraphCacheResolver<
      WithTypename<SubscriptionTransactions>,
      Record<string, never>,
      WithTypename<SubscriptionCreditCard> | string
    >;
    date?: GraphCacheResolver<
      WithTypename<SubscriptionTransactions>,
      Record<string, never>,
      Scalars['DateTime'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<SubscriptionTransactions>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    refund?: GraphCacheResolver<
      WithTypename<SubscriptionTransactions>,
      Record<string, never>,
      Scalars['Boolean'] | string
    >;
  };
  Tier?: {
    displayName?: GraphCacheResolver<
      WithTypename<Tier>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<Tier>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<Tier>,
      Record<string, never>,
      TierName | string
    >;
    nextTier?: GraphCacheResolver<
      WithTypename<Tier>,
      Record<string, never>,
      WithTypename<Tier> | string
    >;
    tierGroup?: GraphCacheResolver<
      WithTypename<Tier>,
      Record<string, never>,
      WithTypename<TierGroup> | string
    >;
  };
  TierGroup?: {
    id?: GraphCacheResolver<
      WithTypename<TierGroup>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<TierGroup>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
  };
  TierStatus?: {
    id?: GraphCacheResolver<
      WithTypename<TierStatus>,
      Record<string, never>,
      Scalars['ID'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<TierStatus>,
      Record<string, never>,
      TierStatusName | string
    >;
  };
  TimeslotUnavailable?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<TimeslotUnavailable>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    message?: GraphCacheResolver<
      WithTypename<TimeslotUnavailable>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<TimeslotUnavailable>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
  };
  TooManyRequests?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<TooManyRequests>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  UnknownUserError?: {
    errorMessage?: GraphCacheResolver<
      WithTypename<UnknownUserError>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  UpdateAddressSuccess?: {
    address?: GraphCacheResolver<
      WithTypename<UpdateAddressSuccess>,
      Record<string, never>,
      WithTypename<Address> | string
    >;
  };
  UpdateBillingAccountResponse?: {
    billingAccount?: GraphCacheResolver<
      WithTypename<UpdateBillingAccountResponse>,
      Record<string, never>,
      WithTypename<BillingAccount> | string
    >;
  };
  UpdateCustomerResponse?: {
    customer?: GraphCacheResolver<
      WithTypename<UpdateCustomerResponse>,
      Record<string, never>,
      WithTypename<Customer> | string
    >;
  };
  UpdateKioskCustomerResponse?: {
    customer?: GraphCacheResolver<
      WithTypename<UpdateKioskCustomerResponse>,
      Record<string, never>,
      WithTypename<Customer> | string
    >;
  };
  UpdateSubscriptionPaymentMethodSuccessResponse?: {
    subscription?: GraphCacheResolver<
      WithTypename<UpdateSubscriptionPaymentMethodSuccessResponse>,
      Record<string, never>,
      WithTypename<PaymentSubscription> | string
    >;
  };
  UpdateUseCreditResponse?: {
    customer?: GraphCacheResolver<
      WithTypename<UpdateUseCreditResponse>,
      Record<string, never>,
      WithTypename<Customer> | string
    >;
  };
  ValidationError?: {
    fieldErrors?: GraphCacheResolver<
      WithTypename<ValidationError>,
      Record<string, never>,
      Array<WithTypename<FieldValidationError> | string>
    >;
    message?: GraphCacheResolver<
      WithTypename<ValidationError>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<ValidationError>,
      Record<string, never>,
      Scalars['Int'] | string
    >;
  };
  Vendor?: {
    name?: GraphCacheResolver<
      WithTypename<Vendor>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    restaurantId?: GraphCacheResolver<
      WithTypename<Vendor>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  VerifyRegistrationSuccess?: {
    csrf?: GraphCacheResolver<
      WithTypename<VerifyRegistrationSuccess>,
      Record<string, never>,
      Scalars['String'] | string
    >;
    customer?: GraphCacheResolver<
      WithTypename<VerifyRegistrationSuccess>,
      Record<string, never>,
      WithTypename<Customer> | string
    >;
  };
};

export type GraphCacheOptimisticUpdaters = {
  addAddress?: GraphCacheOptimisticMutationResolver<
    MutationAddAddressArgs,
    WithTypename<AddAddressResponseUnion>
  >;
  addLineItemBatchToCart?: GraphCacheOptimisticMutationResolver<
    MutationAddLineItemBatchToCartArgs,
    WithTypename<AddLineItemToCartResponseUnion>
  >;
  addLineItemToCart?: GraphCacheOptimisticMutationResolver<
    MutationAddLineItemToCartArgs,
    WithTypename<AddLineItemToCartResponseUnion>
  >;
  addSubscriptionPaymentMethod?: GraphCacheOptimisticMutationResolver<
    MutationAddSubscriptionPaymentMethodArgs,
    WithTypename<AddSubscriptionPaymentMethodResponseUnion>
  >;
  applyReward?: GraphCacheOptimisticMutationResolver<
    MutationApplyRewardArgs,
    WithTypename<ApplyRewardResponseUnion>
  >;
  cancelSubscription?: GraphCacheOptimisticMutationResolver<
    MutationCancelSubscriptionArgs,
    WithTypename<CancelSubscriptionResponseUnion>
  >;
  cancelSubscriptionAtCycleEnd?: GraphCacheOptimisticMutationResolver<
    MutationCancelSubscriptionAtCycleEndArgs,
    WithTypename<CancelSubscriptionAtCycleEndResponseUnion>
  >;
  cancelSubscriptionForCustomer?: GraphCacheOptimisticMutationResolver<
    MutationCancelSubscriptionForCustomerArgs,
    WithTypename<CancelSubscriptionForCustomerResponseUnion>
  >;
  challengeOptIn?: GraphCacheOptimisticMutationResolver<
    MutationChallengeOptInArgs,
    WithTypename<Challenge>
  >;
  createLoyaltyProfile?: GraphCacheOptimisticMutationResolver<
    MutationCreateLoyaltyProfileArgs,
    WithTypename<CreateLoyaltyProfileResult>
  >;
  createPaymentSubscriptionProfile?: GraphCacheOptimisticMutationResolver<
    Record<string, never>,
    WithTypename<PaymentSubscriptionProfile>
  >;
  createSubscription?: GraphCacheOptimisticMutationResolver<
    MutationCreateSubscriptionArgs,
    WithTypename<CreateSubscriptionResult>
  >;
  deleteAddress?: GraphCacheOptimisticMutationResolver<
    MutationDeleteAddressArgs,
    WithTypename<DeleteAddressResponseUnion>
  >;
  deleteBillingAccount?: GraphCacheOptimisticMutationResolver<
    MutationDeleteBillingAccountArgs,
    WithTypename<DeleteBillingAccountResponse>
  >;
  editLineItemInCart?: GraphCacheOptimisticMutationResolver<
    MutationEditLineItemInCartArgs,
    WithTypename<EditLineItemInCartResponseUnion>
  >;
  favoriteLineItem?: GraphCacheOptimisticMutationResolver<
    MutationFavoriteLineItemArgs,
    WithTypename<LineItem>
  >;
  forgotPassword?: GraphCacheOptimisticMutationResolver<
    MutationForgotPasswordArgs,
    WithTypename<ForgotPasswordResponseUnion>
  >;
  login?: GraphCacheOptimisticMutationResolver<
    MutationLoginArgs,
    WithTypename<LoginResponseUnion>
  >;
  logout?: GraphCacheOptimisticMutationResolver<
    MutationLogoutArgs,
    WithTypename<LogoutResponseUnion>
  >;
  optInFreeTier?: GraphCacheOptimisticMutationResolver<
    Record<string, never>,
    Scalars['Boolean']
  >;
  optOutLoyalty?: GraphCacheOptimisticMutationResolver<
    Record<string, never>,
    Scalars['Boolean']
  >;
  optOutLoyaltyForCustomer?: GraphCacheOptimisticMutationResolver<
    MutationOptOutLoyaltyForCustomerArgs,
    Scalars['Boolean']
  >;
  register?: GraphCacheOptimisticMutationResolver<
    MutationRegisterArgs,
    WithTypename<RegisterResponseUnion>
  >;
  registerGuest?: GraphCacheOptimisticMutationResolver<
    MutationRegisterGuestArgs,
    Maybe<WithTypename<RegisterGuestResponseUnion>>
  >;
  rejoinSubscription?: GraphCacheOptimisticMutationResolver<
    MutationRejoinSubscriptionArgs,
    WithTypename<RejoinSubscriptionResponseUnion>
  >;
  removeFromCart?: GraphCacheOptimisticMutationResolver<
    MutationRemoveFromCartArgs,
    WithTypename<RemoveFromCartResponseUnion>
  >;
  removeReward?: GraphCacheOptimisticMutationResolver<
    MutationRemoveRewardArgs,
    WithTypename<RemoveRewardResponseUnion>
  >;
  removeSubscriptionPaymentMethod?: GraphCacheOptimisticMutationResolver<
    MutationRemoveSubscriptionPaymentMethodArgs,
    WithTypename<DeleteSubscriptionPaymentMethodResponseUnion>
  >;
  reorder?: GraphCacheOptimisticMutationResolver<
    MutationReorderArgs,
    WithTypename<ReorderResponseUnion>
  >;
  reorderLineItem?: GraphCacheOptimisticMutationResolver<
    MutationReorderLineItemArgs,
    WithTypename<ReorderResponseUnion>
  >;
  reorderOrder?: GraphCacheOptimisticMutationResolver<
    MutationReorderOrderArgs,
    WithTypename<ReorderResponseUnion>
  >;
  requestAccountDeletion?: GraphCacheOptimisticMutationResolver<
    Record<string, never>,
    Maybe<WithTypename<RequestAccountDeletionResponseUnion>>
  >;
  resendVerificationCode?: GraphCacheOptimisticMutationResolver<
    MutationResendVerificationCodeArgs,
    WithTypename<ResendVerificationCodeResponseUnion>
  >;
  submitBraintreeBillingAccount?: GraphCacheOptimisticMutationResolver<
    MutationSubmitBraintreeBillingAccountArgs,
    WithTypename<SubmitBraintreeBillingAccountResponseUnion>
  >;
  submitFeedback?: GraphCacheOptimisticMutationResolver<
    MutationSubmitFeedbackArgs,
    WithTypename<FeedbackSuccess>
  >;
  submitInStoreFeedback?: GraphCacheOptimisticMutationResolver<
    MutationSubmitInStoreFeedbackArgs,
    WithTypename<FeedbackSuccess>
  >;
  submitOrderUsingBillingAccount?: GraphCacheOptimisticMutationResolver<
    MutationSubmitOrderUsingBillingAccountArgs,
    WithTypename<SubmitOrderUsingBillingAccountResponseUnion>
  >;
  submitOrderWithPaymentMethod?: GraphCacheOptimisticMutationResolver<
    MutationSubmitOrderWithPaymentMethodArgs,
    WithTypename<SubmitOrderWithPaymentMethodResponseUnion>
  >;
  submitPromoCode?: GraphCacheOptimisticMutationResolver<
    MutationSubmitPromoCodeArgs,
    WithTypename<SubmitPromoCodeResponseUnion>
  >;
  submitPromoOrGiftCardCode?: GraphCacheOptimisticMutationResolver<
    MutationSubmitPromoOrGiftCardCodeArgs,
    WithTypename<SubmitPromoCodeOrGiftCardResponseUnion>
  >;
  updateAddress?: GraphCacheOptimisticMutationResolver<
    MutationUpdateAddressArgs,
    WithTypename<UpdateAddressResponseUnion>
  >;
  updateBillingAccount?: GraphCacheOptimisticMutationResolver<
    MutationUpdateBillingAccountArgs,
    WithTypename<UpdateBillingAccountResponse>
  >;
  updateCustomer?: GraphCacheOptimisticMutationResolver<
    MutationUpdateCustomerArgs,
    Maybe<WithTypename<UpdateCustomerResponse>>
  >;
  updateKioskCustomer?: GraphCacheOptimisticMutationResolver<
    MutationUpdateKioskCustomerArgs,
    Maybe<WithTypename<UpdateKioskCustomerResponse>>
  >;
  updateSubscriptionPaymentMethod?: GraphCacheOptimisticMutationResolver<
    MutationUpdateSubscriptionPaymentMethodArgs,
    WithTypename<UpdateSubscriptionPaymentMethodSuccessResponse>
  >;
  updateUseCredit?: GraphCacheOptimisticMutationResolver<
    MutationUpdateUseCreditArgs,
    WithTypename<UpdateUseCreditResponse>
  >;
  verifyRegistration?: GraphCacheOptimisticMutationResolver<
    MutationVerifyRegistrationArgs,
    WithTypename<VerifyRegistrationUnion>
  >;
};

export type GraphCacheUpdaters = {
  Mutation?: {
    addAddress?: GraphCacheUpdateResolver<
      { addAddress: WithTypename<AddAddressResponseUnion> },
      MutationAddAddressArgs
    >;
    addLineItemBatchToCart?: GraphCacheUpdateResolver<
      { addLineItemBatchToCart: WithTypename<AddLineItemToCartResponseUnion> },
      MutationAddLineItemBatchToCartArgs
    >;
    addLineItemToCart?: GraphCacheUpdateResolver<
      { addLineItemToCart: WithTypename<AddLineItemToCartResponseUnion> },
      MutationAddLineItemToCartArgs
    >;
    addSubscriptionPaymentMethod?: GraphCacheUpdateResolver<
      {
        addSubscriptionPaymentMethod: WithTypename<AddSubscriptionPaymentMethodResponseUnion>;
      },
      MutationAddSubscriptionPaymentMethodArgs
    >;
    applyReward?: GraphCacheUpdateResolver<
      { applyReward: WithTypename<ApplyRewardResponseUnion> },
      MutationApplyRewardArgs
    >;
    cancelSubscription?: GraphCacheUpdateResolver<
      { cancelSubscription: WithTypename<CancelSubscriptionResponseUnion> },
      MutationCancelSubscriptionArgs
    >;
    cancelSubscriptionAtCycleEnd?: GraphCacheUpdateResolver<
      {
        cancelSubscriptionAtCycleEnd: WithTypename<CancelSubscriptionAtCycleEndResponseUnion>;
      },
      MutationCancelSubscriptionAtCycleEndArgs
    >;
    cancelSubscriptionForCustomer?: GraphCacheUpdateResolver<
      {
        cancelSubscriptionForCustomer: WithTypename<CancelSubscriptionForCustomerResponseUnion>;
      },
      MutationCancelSubscriptionForCustomerArgs
    >;
    challengeOptIn?: GraphCacheUpdateResolver<
      { challengeOptIn: WithTypename<Challenge> },
      MutationChallengeOptInArgs
    >;
    createLoyaltyProfile?: GraphCacheUpdateResolver<
      { createLoyaltyProfile: WithTypename<CreateLoyaltyProfileResult> },
      MutationCreateLoyaltyProfileArgs
    >;
    createPaymentSubscriptionProfile?: GraphCacheUpdateResolver<
      {
        createPaymentSubscriptionProfile: WithTypename<PaymentSubscriptionProfile>;
      },
      Record<string, never>
    >;
    createSubscription?: GraphCacheUpdateResolver<
      { createSubscription: WithTypename<CreateSubscriptionResult> },
      MutationCreateSubscriptionArgs
    >;
    deleteAddress?: GraphCacheUpdateResolver<
      { deleteAddress: WithTypename<DeleteAddressResponseUnion> },
      MutationDeleteAddressArgs
    >;
    deleteBillingAccount?: GraphCacheUpdateResolver<
      { deleteBillingAccount: WithTypename<DeleteBillingAccountResponse> },
      MutationDeleteBillingAccountArgs
    >;
    editLineItemInCart?: GraphCacheUpdateResolver<
      { editLineItemInCart: WithTypename<EditLineItemInCartResponseUnion> },
      MutationEditLineItemInCartArgs
    >;
    favoriteLineItem?: GraphCacheUpdateResolver<
      { favoriteLineItem: WithTypename<LineItem> },
      MutationFavoriteLineItemArgs
    >;
    forgotPassword?: GraphCacheUpdateResolver<
      { forgotPassword: WithTypename<ForgotPasswordResponseUnion> },
      MutationForgotPasswordArgs
    >;
    login?: GraphCacheUpdateResolver<
      { login: WithTypename<LoginResponseUnion> },
      MutationLoginArgs
    >;
    logout?: GraphCacheUpdateResolver<
      { logout: WithTypename<LogoutResponseUnion> },
      MutationLogoutArgs
    >;
    optInFreeTier?: GraphCacheUpdateResolver<
      { optInFreeTier: Scalars['Boolean'] },
      Record<string, never>
    >;
    optOutLoyalty?: GraphCacheUpdateResolver<
      { optOutLoyalty: Scalars['Boolean'] },
      Record<string, never>
    >;
    optOutLoyaltyForCustomer?: GraphCacheUpdateResolver<
      { optOutLoyaltyForCustomer: Scalars['Boolean'] },
      MutationOptOutLoyaltyForCustomerArgs
    >;
    register?: GraphCacheUpdateResolver<
      { register: WithTypename<RegisterResponseUnion> },
      MutationRegisterArgs
    >;
    registerGuest?: GraphCacheUpdateResolver<
      { registerGuest: Maybe<WithTypename<RegisterGuestResponseUnion>> },
      MutationRegisterGuestArgs
    >;
    rejoinSubscription?: GraphCacheUpdateResolver<
      { rejoinSubscription: WithTypename<RejoinSubscriptionResponseUnion> },
      MutationRejoinSubscriptionArgs
    >;
    removeFromCart?: GraphCacheUpdateResolver<
      { removeFromCart: WithTypename<RemoveFromCartResponseUnion> },
      MutationRemoveFromCartArgs
    >;
    removeReward?: GraphCacheUpdateResolver<
      { removeReward: WithTypename<RemoveRewardResponseUnion> },
      MutationRemoveRewardArgs
    >;
    removeSubscriptionPaymentMethod?: GraphCacheUpdateResolver<
      {
        removeSubscriptionPaymentMethod: WithTypename<DeleteSubscriptionPaymentMethodResponseUnion>;
      },
      MutationRemoveSubscriptionPaymentMethodArgs
    >;
    reorder?: GraphCacheUpdateResolver<
      { reorder: WithTypename<ReorderResponseUnion> },
      MutationReorderArgs
    >;
    reorderLineItem?: GraphCacheUpdateResolver<
      { reorderLineItem: WithTypename<ReorderResponseUnion> },
      MutationReorderLineItemArgs
    >;
    reorderOrder?: GraphCacheUpdateResolver<
      { reorderOrder: WithTypename<ReorderResponseUnion> },
      MutationReorderOrderArgs
    >;
    requestAccountDeletion?: GraphCacheUpdateResolver<
      {
        requestAccountDeletion: Maybe<
          WithTypename<RequestAccountDeletionResponseUnion>
        >;
      },
      Record<string, never>
    >;
    resendVerificationCode?: GraphCacheUpdateResolver<
      {
        resendVerificationCode: WithTypename<ResendVerificationCodeResponseUnion>;
      },
      MutationResendVerificationCodeArgs
    >;
    submitBraintreeBillingAccount?: GraphCacheUpdateResolver<
      {
        submitBraintreeBillingAccount: WithTypename<SubmitBraintreeBillingAccountResponseUnion>;
      },
      MutationSubmitBraintreeBillingAccountArgs
    >;
    submitFeedback?: GraphCacheUpdateResolver<
      { submitFeedback: WithTypename<FeedbackSuccess> },
      MutationSubmitFeedbackArgs
    >;
    submitInStoreFeedback?: GraphCacheUpdateResolver<
      { submitInStoreFeedback: WithTypename<FeedbackSuccess> },
      MutationSubmitInStoreFeedbackArgs
    >;
    submitOrderUsingBillingAccount?: GraphCacheUpdateResolver<
      {
        submitOrderUsingBillingAccount: WithTypename<SubmitOrderUsingBillingAccountResponseUnion>;
      },
      MutationSubmitOrderUsingBillingAccountArgs
    >;
    submitOrderWithPaymentMethod?: GraphCacheUpdateResolver<
      {
        submitOrderWithPaymentMethod: WithTypename<SubmitOrderWithPaymentMethodResponseUnion>;
      },
      MutationSubmitOrderWithPaymentMethodArgs
    >;
    submitPromoCode?: GraphCacheUpdateResolver<
      { submitPromoCode: WithTypename<SubmitPromoCodeResponseUnion> },
      MutationSubmitPromoCodeArgs
    >;
    submitPromoOrGiftCardCode?: GraphCacheUpdateResolver<
      {
        submitPromoOrGiftCardCode: WithTypename<SubmitPromoCodeOrGiftCardResponseUnion>;
      },
      MutationSubmitPromoOrGiftCardCodeArgs
    >;
    updateAddress?: GraphCacheUpdateResolver<
      { updateAddress: WithTypename<UpdateAddressResponseUnion> },
      MutationUpdateAddressArgs
    >;
    updateBillingAccount?: GraphCacheUpdateResolver<
      { updateBillingAccount: WithTypename<UpdateBillingAccountResponse> },
      MutationUpdateBillingAccountArgs
    >;
    updateCustomer?: GraphCacheUpdateResolver<
      { updateCustomer: Maybe<WithTypename<UpdateCustomerResponse>> },
      MutationUpdateCustomerArgs
    >;
    updateKioskCustomer?: GraphCacheUpdateResolver<
      { updateKioskCustomer: Maybe<WithTypename<UpdateKioskCustomerResponse>> },
      MutationUpdateKioskCustomerArgs
    >;
    updateSubscriptionPaymentMethod?: GraphCacheUpdateResolver<
      {
        updateSubscriptionPaymentMethod: WithTypename<UpdateSubscriptionPaymentMethodSuccessResponse>;
      },
      MutationUpdateSubscriptionPaymentMethodArgs
    >;
    updateUseCredit?: GraphCacheUpdateResolver<
      { updateUseCredit: WithTypename<UpdateUseCreditResponse> },
      MutationUpdateUseCreditArgs
    >;
    verifyRegistration?: GraphCacheUpdateResolver<
      { verifyRegistration: WithTypename<VerifyRegistrationUnion> },
      MutationVerifyRegistrationArgs
    >;
  };
  Subscription?: {};
};

export type GraphCacheConfig = {
  schema?: IntrospectionData;
  updates?: GraphCacheUpdaters;
  keys?: GraphCacheKeysConfig;
  optimistic?: GraphCacheOptimisticUpdaters;
  resolvers?: GraphCacheResolvers;
  storage?: GraphCacheStorageAdapter;
};

export type Operations = {
  query: {
    CustomerName: CustomerNameQuery;
    Cart: CartQuery;
    Addons: AddonsQuery;
    ChallengeCelebration: ChallengeCelebrationQuery;
    PickupOutpostRestaurantName: PickupOutpostRestaurantNameQuery;
    ActiveCartDeliveryDetails: ActiveCartDeliveryDetailsQuery;
    CustomerAddresses: CustomerAddressesQuery;
    DeliveryLocationByAddress: DeliveryLocationByAddressQuery;
    LastPlacedOrderDeliveryDetails: LastPlacedOrderDeliveryDetailsQuery;
    LocationsSearchByArea: LocationsSearchByAreaQuery;
    LocationsSearchBySearchString: LocationsSearchBySearchStringQuery;
    MenuCollections: MenuCollectionsQuery;
    SweetpassInfoForAccountDeletion: SweetpassInfoForAccountDeletionQuery;
    Customer: CustomerQuery;
    ChallengeRewards: ChallengeRewardsQuery;
    Challenges: ChallengesQuery;
    HasUnseenChallenges: HasUnseenChallengesQuery;
    Rewards: RewardsQuery;
    CurrentCustomer: CurrentCustomerQuery;
    Orders: OrdersQuery;
    CreateLoyaltyProfile: CreateLoyaltyProfileQuery;
    GetCustomerCredit: GetCustomerCreditQuery;
    DeliveryInFlight: DeliveryInFlightQuery;
    InStoreOrderLastPendingFeedback: InStoreOrderLastPendingFeedbackQuery;
    GetSession: GetSessionQuery;
    GetSweetpassTier: GetSweetpassTierQuery;
    KustomerToken: KustomerTokenQuery;
    GetAvailableWantedTimes: GetAvailableWantedTimesQuery;
    DeliveryEstimate: DeliveryEstimateQuery;
    Address: AddressQuery;
    DeliveryRestaurant: DeliveryRestaurantQuery;
    Favorites: FavoritesQuery;
    GetOrderStatus: GetOrderStatusQuery;
    LocationByAddress: LocationByAddressQuery;
    SearchLocationsByBoundingBox: SearchLocationsByBoundingBoxQuery;
    SearchLocationsByString: SearchLocationsByStringQuery;
    MenuCollection: MenuCollectionQuery;
    MenuCart: MenuCartQuery;
    Restaurant: RestaurantQuery;
    MenuRedirect: MenuRedirectQuery;
    BaseProduct: BaseProductQuery;
    OrderProductRestaurant: OrderProductRestaurantQuery;
    ProductForRestaurant: ProductForRestaurantQuery;
    OrderStatus: OrderStatusQuery;
    OrderStatusPolling: OrderStatusPollingQuery;
    OrderHistory: OrderHistoryQuery;
    GetLineItem: GetLineItemQuery;
    GetProduct: GetProductQuery;
    CustomerProfileFields: CustomerProfileFieldsQuery;
    FeedbackQuestions: FeedbackQuestionsQuery;
    InStoreFeedbackQuestions: InStoreFeedbackQuestionsQuery;
    FeedbackOrderStatus: FeedbackOrderStatusQuery;
    ReferralShareUrl: ReferralShareUrlQuery;
    ReorderRestaurant: ReorderRestaurantQuery;
    ReorderRestaurantData: ReorderRestaurantDataQuery;
    ReorderDeliveryRestaurantData: ReorderDeliveryRestaurantDataQuery;
    ReorderDeliveryAddressData: ReorderDeliveryAddressDataQuery;
    ScanToPayBillingAccounts: ScanToPayBillingAccountsQuery;
    CustomerPass: CustomerPassQuery;
    GetSharedLineItem: GetSharedLineItemQuery;
    GetBillingHistory: GetBillingHistoryQuery;
    GetPaymentSubscriptionProfile: GetPaymentSubscriptionProfileQuery;
    GetSweetpassMembership: GetSweetpassMembershipQuery;
    GetSubscriptionPaymentMethod: GetSubscriptionPaymentMethodQuery;
    FetchPlansByTierId: FetchPlansByTierIdQuery;
  };
  mutation: {
    AddAddress: AddAddressMutation;
    UpdateAddress: UpdateAddressMutation;
    DeleteAddress: DeleteAddressMutation;
    AddLineItemToCart: AddLineItemToCartMutation;
    EditLineItemInCart: EditLineItemInCartMutation;
    RemoveFromCart: RemoveFromCartMutation;
    SubmitBraintreeBillingAccount: SubmitBraintreeBillingAccountMutation;
    UpdateBillingAccount: UpdateBillingAccountMutation;
    DeleteBillingAccount: DeleteBillingAccountMutation;
    AddDeliveryAddress: AddDeliveryAddressMutation;
    RequestAccountDeletion: RequestAccountDeletionMutation;
    ChallengeOptIn: ChallengeOptInMutation;
    ApplyReward: ApplyRewardMutation;
    RemoveReward: RemoveRewardMutation;
    UpdateUseCredit: UpdateUseCreditMutation;
    ForgotPassword: ForgotPasswordMutation;
    Login: LoginMutation;
    Logout: LogoutMutation;
    Register: RegisterMutation;
    ResendVerificationCode: ResendVerificationCodeMutation;
    VerifyRegistration: VerifyRegistrationMutation;
    SubmitPromoCode: SubmitPromoCodeMutation;
    SubmitPromoOrGiftCardCode: SubmitPromoOrGiftCardCodeMutation;
    SubmitOrder: SubmitOrderMutation;
    LogInCustomer: LogInCustomerMutation;
    FavoriteLineItem: FavoriteLineItemMutation;
    UpdateCustomerProfile: UpdateCustomerProfileMutation;
    SubmitFeedback: SubmitFeedbackMutation;
    SubmitInStoreFeedback: SubmitInStoreFeedbackMutation;
    ReorderOrder: ReorderOrderMutation;
    ReorderLineItem: ReorderLineItemMutation;
    AddSubscriptionPaymentMethod: AddSubscriptionPaymentMethodMutation;
    RemoveSubscriptionPaymentMethod: RemoveSubscriptionPaymentMethodMutation;
    Subscribe: SubscribeMutation;
    CancelSubscriptionAtCycleEnd: CancelSubscriptionAtCycleEndMutation;
    RejoinSubscription: RejoinSubscriptionMutation;
    UpdateSubscriptionPaymentMethod: UpdateSubscriptionPaymentMethodMutation;
    OptInUser: OptInUserMutation;
  };
  subscription: {};
};
